// // // // // // // // // import React, { useState, useEffect } from "react";
// // // // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // // // import { FiEye, FiDownload, FiShare2, FiEdit, FiTrash } from "react-icons/fi";

// // // // // // // // // // Shipment and payment modes
// // // // // // // // // type ShipmentStatus = "pending" | "in_transit" | "delivered" | "draft";
// // // // // // // // // type PaymentMode = "paid" | "to_pay" | "credit";
// // // // // // // // // type FilterOption = "all" | ShipmentStatus;

// // // // // // // // // const API_BASE = process.env.REACT_APP_API_URL;

// // // // // // // // // // APIConsignment interface according to the API response sample
// // // // // // // // // interface APIConsignment {
// // // // // // // // //   id: number;
// // // // // // // // //   sender: number; // Consignor id
// // // // // // // // //   company: number;
// // // // // // // // //   receiver: number; // Consignee id
// // // // // // // // //   transporter: number;
// // // // // // // // //   driver: number;
// // // // // // // // //   vehicles: number;
// // // // // // // // //   payment: string;
// // // // // // // // //   source: string;
// // // // // // // // //   destination: string;
// // // // // // // // //   receiverAmountStatatus: string; // intentional typo, matches API
// // // // // // // // //   senderAmountStatatus: string;
// // // // // // // // //   transporterAmountStatatus: string;
// // // // // // // // //   paymentStatus: PaymentMode;
// // // // // // // // //   paymentPayableConsignor: number;
// // // // // // // // //   ItemsDescription: string;
// // // // // // // // //   ["InvoiceNo"]?: string;
// // // // // // // // //   ["InvoiceNo."]?: string;
// // // // // // // // //   EWAYBILLNO: string;
// // // // // // // // //   subjects: string;
// // // // // // // // //   link?: string;
// // // // // // // // //   status?: ShipmentStatus; // Not present in sample, but kept for filtering fallback
// // // // // // // // //   biltyNo?: string;    // Custom field - fallback to InvoiceNo if not exists
// // // // // // // // //   truckNo?: string;    // Custom field for truck number/vehicle number
// // // // // // // // //   created_at?: string;       // Custom field for date -- fallback to created_at if not exists
// // // // // // // // //   weight?: number;     // Custom field for weight
// // // // // // // // //   biltyRate?: number;  // Custom field for bilty rate
// // // // // // // // //   totalamount?: number;     // Total amount
// // // // // // // // //   // The following fields are mostly placeholders - map from data if available
// // // // // // // // //   consignorName?: string;
// // // // // // // // //   consigneeName?: string;
// // // // // // // // // }

// // // // // // // // // const getInvoiceNo = (consignment: APIConsignment): string =>
// // // // // // // // //   consignment.InvoiceNo ||
// // // // // // // // //   //@ts-ignore
// // // // // // // // //   consignment["InvoiceNo."] ||
// // // // // // // // //   "";

// // // // // // // // // const getConsignmentStatus = (consignment: APIConsignment): ShipmentStatus => {
// // // // // // // // //   if (consignment.status) return consignment.status;
// // // // // // // // //   if (consignment.paymentStatus === "to_pay" || consignment.paymentStatus === "credit") return "pending";
// // // // // // // // //   if (consignment.paymentStatus === "paid") return "delivered";
// // // // // // // // //   return "pending";
// // // // // // // // // };

// // // // // // // // // const FILTER_OPTIONS: { key: FilterOption; label: string }[] = [
// // // // // // // // //   { key: "all",       label: "All"        },
// // // // // // // // //   { key: "pending",   label: "Pending"    },
// // // // // // // // //   { key: "in_transit",label: "In transit" },
// // // // // // // // //   { key: "delivered", label: "Delivered"  },
// // // // // // // // //   { key: "draft",     label: "Draft"      },
// // // // // // // // // ];

// // // // // // // // // const STATUS_STYLES: Record<string, string> = {
// // // // // // // // //   pending:    "bg-amber-100 text-amber-800",
// // // // // // // // //   in_transit: "bg-blue-100 text-blue-800",
// // // // // // // // //   delivered:  "bg-green-100 text-green-800",
// // // // // // // // //   draft:      "bg-slate-100 text-slate-500",
// // // // // // // // //   created:    "bg-slate-100 text-slate-900",
// // // // // // // // //   dispatched: "bg-amber-100 text-amber-800",
// // // // // // // // //   cancelled:  "bg-red-100 text-red-800",
// // // // // // // // // };

// // // // // // // // // const STATUS_LABELS: Record<string, string> = {
// // // // // // // // //   pending:    "Pending",
// // // // // // // // //   in_transit: "In transit",
// // // // // // // // //   delivered:  "Delivered",
// // // // // // // // //   draft:      "Draft",
// // // // // // // // //   created:    "Created",
// // // // // // // // //   dispatched: "Dispatched",
// // // // // // // // //   cancelled:  "Cancelled",
// // // // // // // // // };

// // // // // // // // // const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
// // // // // // // // //   <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${STATUS_STYLES[status] || "bg-slate-100 text-slate-900"}`}>
// // // // // // // // //     {STATUS_LABELS[status] || status}
// // // // // // // // //   </span>
// // // // // // // // // );

// // // // // // // // // const DashboardStatCard: React.FC<{ label: string; value: number; color: string }> = ({ label, value, color }) => (
// // // // // // // // //   <div className="rounded-xl bg-slate-50 p-4 flex flex-col justify-center items-center">
// // // // // // // // //     <span className="text-[26px] font-semibold mb-1" style={{ color }}>{value}</span>
// // // // // // // // //     <span className="text-xs font-medium text-slate-500">{label}</span>
// // // // // // // // //   </div>
// // // // // // // // // );

// // // // // // // // // const InvoiceActions: React.FC<{ consignment: APIConsignment }> = ({ consignment }) => {
// // // // // // // // //   const link = consignment.link;
// // // // // // // // //   const invoiceLabel = getInvoiceNo(consignment) || consignment.EWAYBILLNO || "";

// // // // // // // // //   const getDownloadUrl = () => {
// // // // // // // // //     if (!link) return "";
// // // // // // // // //     if (link.startsWith("http")) return link;
// // // // // // // // //     if (API_BASE && link.startsWith("/")) return `${API_BASE}${link}`;
// // // // // // // // //     return link;
// // // // // // // // //   };

// // // // // // // // //   const downloadUrl = getDownloadUrl();

// // // // // // // // //   const handleView = () => {
// // // // // // // // //     if (downloadUrl) window.open(downloadUrl, "_blank");
// // // // // // // // //   };
// // // // // // // // //   const handleDownload = () => {
// // // // // // // // //     if (downloadUrl) {
// // // // // // // // //       const a = document.createElement("a");
// // // // // // // // //       a.href = downloadUrl;
// // // // // // // // //       a.download = invoiceLabel ? `Invoice_${invoiceLabel}` : "Invoice";
// // // // // // // // //       document.body.appendChild(a);
// // // // // // // // //       a.click();
// // // // // // // // //       document.body.removeChild(a);
// // // // // // // // //     }
// // // // // // // // //   };
// // // // // // // // //   const handleShare = () => {
// // // // // // // // //     if (navigator.share && downloadUrl) {
// // // // // // // // //       navigator.share({ title: `Invoice ${invoiceLabel}`, url: downloadUrl });
// // // // // // // // //     } else if (downloadUrl) {
// // // // // // // // //       navigator.clipboard.writeText(downloadUrl);
// // // // // // // // //       alert("Invoice link copied!");
// // // // // // // // //     }
// // // // // // // // //   };
// // // // // // // // //   if (!link) {
// // // // // // // // //     return <span className="text-slate-400">No invoice</span>;
// // // // // // // // //   }
// // // // // // // // //   return (
// // // // // // // // //     <div className="flex items-center gap-2">
// // // // // // // // //       <button className="hover:bg-slate-100 rounded p-1" title="View Invoice" onClick={handleView}>
// // // // // // // // //         <FiEye className="w-4 h-4 text-blue-700" />
// // // // // // // // //       </button>
// // // // // // // // //       <button className="hover:bg-slate-100 rounded p-1" title="Download Invoice" onClick={handleDownload}>
// // // // // // // // //         <FiDownload className="w-4 h-4 text-green-700" />
// // // // // // // // //       </button>
// // // // // // // // //       <button className="hover:bg-slate-100 rounded p-1" title="Share Invoice" onClick={handleShare}>
// // // // // // // // //         <FiShare2 className="w-4 h-4 text-purple-600" />
// // // // // // // // //       </button>
// // // // // // // // //     </div>
// // // // // // // // //   );
// // // // // // // // // };

// // // // // // // // // const RowActions: React.FC<{
// // // // // // // // //   consignment: APIConsignment;
// // // // // // // // //   onEdit: (id: number) => void;
// // // // // // // // //   onDelete: (id: number) => void;
// // // // // // // // // }> = ({ consignment, onEdit, onDelete }) => (
// // // // // // // // //   <div className="flex items-center gap-2">
// // // // // // // // //     <button className="hover:bg-slate-100 rounded p-1" title="Edit" onClick={() => onEdit(consignment.id)}>
// // // // // // // // //       <FiEdit className="w-4 h-4 text-amber-600" />
// // // // // // // // //     </button>
// // // // // // // // //     <button className="hover:bg-slate-100 rounded p-1" title="Delete" onClick={() => onDelete(consignment.id)}>
// // // // // // // // //       <FiTrash className="w-4 h-4 text-red-700" />
// // // // // // // // //     </button>
// // // // // // // // //   </div>
// // // // // // // // // );

// // // // // // // // // // Optional: Fake lists for Consignor/Consignee/Truck - in real app, fetch those and map by id
// // // // // // // // // const FAKE_CONSIGNOR = (id: number) => `Consignor#${id}`;
// // // // // // // // // const FAKE_CONSIGNEE = (id: number) => `Consignee#${id}`;
// // // // // // // // // const FAKE_TRUCK = (id: number) => `Truck#${id}`;

// // // // // // // // // const ConsignorDashboard: React.FC = () => {
// // // // // // // // //   const [consignments, setConsignments] = useState<APIConsignment[]>([]);
// // // // // // // // //   const [loading, setLoading] = useState(false);
// // // // // // // // //   const [error, setError] = useState<string | null>(null);
// // // // // // // // //   const [activeFilter, setActiveFilter] = useState<FilterOption>("all");
// // // // // // // // //   const navigate = useNavigate();

// // // // // // // // //   useEffect(() => {
// // // // // // // // //     setLoading(true);
// // // // // // // // //     setError(null);
// // // // // // // // //     fetch(`${API_BASE}/invoiceapi/invoice`)
// // // // // // // // //       .then((res) => res.json())
// // // // // // // // //       .then((data) => {
// // // // // // // // //         if (Array.isArray(data)) {
// // // // // // // // //           setConsignments(
// // // // // // // // //             data.map((c: any) => {
// // // // // // // // //               let invoiceNo = c["InvoiceNo"] ?? c["InvoiceNo."] ?? "";
// // // // // // // // //               // Pull date, truck number, weight, bilty rate, amount from API if available
// // // // // // // // //               // This is an example; you should map the right fields per your real API structure
// // // // // // // // //               return {
// // // // // // // // //                 id: c.id,
// // // // // // // // //                 sender: c.sender,
// // // // // // // // //                 company: c.company,
// // // // // // // // //                 receiver: c.receiver,
// // // // // // // // //                 transporter: c.transporter,
// // // // // // // // //                 driver: c.driver,
// // // // // // // // //                 vehicles: c.vehicles,
// // // // // // // // //                 payment: c.payment,
// // // // // // // // //                 source: c.source,
// // // // // // // // //                 destination: c.destination,
// // // // // // // // //                 receiverAmountStatatus: c.receiverAmountStatatus,
// // // // // // // // //                 senderAmountStatatus: c.senderAmountStatatus,
// // // // // // // // //                 transporterAmountStatatus: c.transporterAmountStatatus,
// // // // // // // // //                 paymentStatus: c.paymentStatus,
// // // // // // // // //                 paymentPayableConsignor: c.paymentPayableConsignor,
// // // // // // // // //                 ItemsDescription: c.ItemsDescription,
// // // // // // // // //                 InvoiceNo: invoiceNo,
// // // // // // // // //                 "InvoiceNo.": c["InvoiceNo."],
// // // // // // // // //                 EWAYBILLNO: c.EWAYBILLNO,
// // // // // // // // //                 subjects: c.subjects,
// // // // // // // // //                 link: c.link ?? c.invoiceLink,
// // // // // // // // //                 status: c.status ?? undefined,
// // // // // // // // //                 biltyNo: c.biltyNo ?? invoiceNo,
// // // // // // // // //                 truckNo: c.truckNo ?? c.vehicles ?? "",
// // // // // // // // //                 date: c.date ?? c.created_at ?? "",
// // // // // // // // //                 weight: c.weight ?? "",
// // // // // // // // //                 biltyRate: c.biltyRate ?? "",
// // // // // // // // //                 amount: c.amount ?? c.paymentPayableConsignor ?? c.payment ?? "",
// // // // // // // // //                 consignorName: c.consignorName || (c.sender ? FAKE_CONSIGNOR(c.sender) : ""),
// // // // // // // // //                 consigneeName: c.consigneeName || (c.receiver ? FAKE_CONSIGNEE(c.receiver) : ""),
// // // // // // // // //               };
// // // // // // // // //             })
// // // // // // // // //           );
// // // // // // // // //         } else {
// // // // // // // // //           setConsignments([]);
// // // // // // // // //         }
// // // // // // // // //       })
// // // // // // // // //       .catch(() => setError("Unable to fetch consignments"))
// // // // // // // // //       .finally(() => setLoading(false));
// // // // // // // // //   }, []);

// // // // // // // // //   const filtered = activeFilter === "all"
// // // // // // // // //     ? consignments
// // // // // // // // //     : consignments.filter((c) => getConsignmentStatus(c) === activeFilter);

// // // // // // // // //   const handleEdit = (id: number) => navigate(`/consignor/consignments/edit/${id}`);

// // // // // // // // //   const handleDelete = (id: number) => {
// // // // // // // // //     if (
// // // // // // // // //       !window.confirm("Are you sure you want to delete this consignment? This action cannot be undone.")
// // // // // // // // //     ) return;
// // // // // // // // //     setConsignments(prev => prev.filter(c => c.id !== id));
// // // // // // // // //   };

// // // // // // // // //   const stats = [
// // // // // // // // //     {
// // // // // // // // //       label: "Total",
// // // // // // // // //       value: consignments.length,
// // // // // // // // //       color: "#185FA5"
// // // // // // // // //     },
// // // // // // // // //     {
// // // // // // // // //       label: "Pending",
// // // // // // // // //       value: consignments.filter((c) => getConsignmentStatus(c) === "pending").length,
// // // // // // // // //       color: "#854F0B"
// // // // // // // // //     },
// // // // // // // // //     {
// // // // // // // // //       label: "In transit",
// // // // // // // // //       value: consignments.filter((c) => getConsignmentStatus(c) === "in_transit").length,
// // // // // // // // //       color: "#534AB7"
// // // // // // // // //     },
// // // // // // // // //     {
// // // // // // // // //       label: "Delivered",
// // // // // // // // //       value: consignments.filter((c) => getConsignmentStatus(c) === "delivered").length,
// // // // // // // // //       color: "#3B6D11"
// // // // // // // // //     }
// // // // // // // // //   ];

// // // // // // // // //   return (
// // // // // // // // //     <div className="p-4 md:p-6 space-y-4">
// // // // // // // // //       {/* Stats */}
// // // // // // // // //       <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
// // // // // // // // //         {stats.map(stat => (
// // // // // // // // //           <DashboardStatCard key={stat.label} {...stat} />
// // // // // // // // //         ))}
// // // // // // // // //       </div>
// // // // // // // // //       {/* Panel/Table */}
// // // // // // // // //       <div className="bg-white border border-slate-100 rounded-2xl p-4">
// // // // // // // // //         <div className="flex items-center justify-between mb-3">
// // // // // // // // //           <div>
// // // // // // // // //             <h2 className="text-[16px] font-medium text-slate-900">My Consignments</h2>
// // // // // // // // //             <p className="text-xs text-slate-400">View and manage your consignments & invoices</p>
// // // // // // // // //           </div>
// // // // // // // // //           <button
// // // // // // // // //             className="text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
// // // // // // // // //             onClick={() => navigate("/consignor/consignments/create")}
// // // // // // // // //           >
// // // // // // // // //             + New Consignment
// // // // // // // // //           </button>
// // // // // // // // //         </div>
// // // // // // // // //         <div className="flex flex-wrap gap-1.5 mb-4">
// // // // // // // // //           {FILTER_OPTIONS.map(({ key, label }) => (
// // // // // // // // //             <button
// // // // // // // // //               key={key}
// // // // // // // // //               onClick={() => setActiveFilter(key)}
// // // // // // // // //               className={`text-xs px-3 py-1 rounded-full border transition-colors ${
// // // // // // // // //                 activeFilter === key
// // // // // // // // //                   ? "bg-slate-900 text-white border-transparent"
// // // // // // // // //                   : "border-slate-200 text-slate-500 hover:bg-slate-50"
// // // // // // // // //               }`}
// // // // // // // // //             >
// // // // // // // // //               {label}
// // // // // // // // //             </button>
// // // // // // // // //           ))}
// // // // // // // // //         </div>
// // // // // // // // //         <div className="overflow-x-auto">
// // // // // // // // //           <table className="w-full min-w-[1200px] text-[13px]">
// // // // // // // // //             <thead>
// // // // // // // // //               <tr className="text-xs border-b border-slate-100">
// // // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Date</th>
// // // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Bilty No.</th>
// // // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Truck No.</th>
// // // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Consignor</th>
// // // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Consignee</th>
// // // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Weight</th>
// // // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Bilty Rate</th>
// // // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Amount</th>
// // // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap"></th>
// // // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Status</th>
// // // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Invoice</th>
// // // // // // // // //               </tr>
// // // // // // // // //             </thead>
// // // // // // // // //             <tbody>
// // // // // // // // //               {loading ? (
// // // // // // // // //                 <tr><td colSpan={11} className="py-6 text-center">Loading...</td></tr>
// // // // // // // // //               ) : error ? (
// // // // // // // // //                 <tr><td colSpan={11} className="py-6 text-center text-red-600">{error}</td></tr>
// // // // // // // // //               ) : filtered.length === 0 ? (
// // // // // // // // //                 <tr><td colSpan={11} className="py-8 text-center text-slate-400">No consignments found.</td></tr>
// // // // // // // // //               ) : (
// // // // // // // // //                 filtered.map((c) => (
// // // // // // // // //                   <tr key={c.id} className="border-b border-slate-100 hover:bg-slate-50 transition-all">
// // // // // // // // //                     <td className="py-2 px-3 text-slate-900">{c.created_at ? new Date(c.created_at).toLocaleDateString() : "-"}</td>
// // // // // // // // //                     <td className="py-2 px-3 text-slate-900 font-medium">{c.biltyNo || getInvoiceNo(c) || "-"}</td>
// // // // // // // // //                     <td className="py-2 px-3 text-slate-700">{c.truckNo || FAKE_TRUCK(c.vehicles) || "-"}</td>
// // // // // // // // //                     <td className="py-2 px-3 text-slate-700">{c.consignorName || (c.sender ? FAKE_CONSIGNOR(c.sender) : "-")}</td>
// // // // // // // // //                     <td className="py-2 px-3 text-slate-700">{c.consigneeName || (c.receiver ? FAKE_CONSIGNEE(c.receiver) : "-")}</td>
// // // // // // // // //                     <td className="py-2 px-3 text-slate-700">{c.weight ? c.weight : "-"}</td>
// // // // // // // // //                     <td className="py-2 px-3 text-slate-700">{c.biltyRate ? c.biltyRate : "-"}</td>
// // // // // // // // //                     <td className="py-2 px-3 text-slate-700">{c.totalamount ? c.totalamount : c.payment || "-"}</td>
// // // // // // // // //                     <td className="py-2 px-3 text-right">
// // // // // // // // //                       <RowActions
// // // // // // // // //                         consignment={c}
// // // // // // // // //                         onEdit={handleEdit}
// // // // // // // // //                         onDelete={handleDelete}
// // // // // // // // //                       />
// // // // // // // // //                     </td>
// // // // // // // // //                     <td className="py-2 px-3"><StatusBadge status={getConsignmentStatus(c)} /></td>
// // // // // // // // //                     <td className="py-2 px-3"><InvoiceActions consignment={c} /></td>
// // // // // // // // //                   </tr>
// // // // // // // // //                 ))
// // // // // // // // //               )}
// // // // // // // // //             </tbody>
// // // // // // // // //           </table>
// // // // // // // // //         </div>
// // // // // // // // //       </div>
// // // // // // // // //     </div>
// // // // // // // // //   );
// // // // // // // // // };

// // // // // // // // // export default ConsignorDashboard;


// // // // // // // // import React, { useState, useEffect } from "react";
// // // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // // import { FiEye, FiDownload, FiShare2, FiEdit, FiTrash } from "react-icons/fi";

// // // // // // // // // Shipment and payment modes
// // // // // // // // type ShipmentStatus = "pending" | "in_transit" | "delivered" | "draft";
// // // // // // // // type PaymentMode = "paid" | "to_pay" | "credit";
// // // // // // // // type FilterOption = "all" | ShipmentStatus;

// // // // // // // // const API_BASE = process.env.REACT_APP_API_URL;

// // // // // // // // // APIConsignment interface according to the API response sample
// // // // // // // // interface APIConsignment {
// // // // // // // //   id: number;
// // // // // // // //   sender: number;
// // // // // // // //   company: number;
// // // // // // // //   receiver: number;
// // // // // // // //   transporter: number;
// // // // // // // //   driver: number;
// // // // // // // //   vehicles: number;
// // // // // // // //   payment: string;
// // // // // // // //   source: string;
// // // // // // // //   destination: string;
// // // // // // // //   receiverAmountStatatus: string;
// // // // // // // //   senderAmountStatatus: string;
// // // // // // // //   transporterAmountStatatus: string;
// // // // // // // //   paymentStatus: PaymentMode;
// // // // // // // //   paymentPayableConsignor: number;
// // // // // // // //   ItemsDescription: string;
// // // // // // // //   ["InvoiceNo"]?: string;
// // // // // // // //   ["InvoiceNo."]?: string;
// // // // // // // //   EWAYBILLNO: string;
// // // // // // // //   subjects: string;
// // // // // // // //   link?: string;
// // // // // // // //   status?: ShipmentStatus;
// // // // // // // //   biltyNo?: string;
// // // // // // // //   truckNo?: string;
// // // // // // // //   created_at?: string;
// // // // // // // //   weight?: number;
// // // // // // // //   biltyRate?: number;
// // // // // // // //   totalamount?: number;
// // // // // // // //   consignorName?: string;
// // // // // // // //   consigneeName?: string;
// // // // // // // // }

// // // // // // // // const getInvoiceNo = (consignment: APIConsignment): string =>
// // // // // // // //   consignment.InvoiceNo ||
// // // // // // // //   //@ts-ignore
// // // // // // // //   consignment["InvoiceNo."] ||
// // // // // // // //   "";

// // // // // // // // const getConsignmentStatus = (consignment: APIConsignment): ShipmentStatus => {
// // // // // // // //   if (consignment.status) return consignment.status;
// // // // // // // //   if (
// // // // // // // //     consignment.paymentStatus === "to_pay" ||
// // // // // // // //     consignment.paymentStatus === "credit"
// // // // // // // //   )
// // // // // // // //     return "pending";
// // // // // // // //   if (consignment.paymentStatus === "paid") return "delivered";
// // // // // // // //   return "pending";
// // // // // // // // };

// // // // // // // // const FILTER_OPTIONS: { key: FilterOption; label: string }[] = [
// // // // // // // //   { key: "all", label: "All" },
// // // // // // // //   { key: "pending", label: "Pending" },
// // // // // // // //   { key: "in_transit", label: "In transit" },
// // // // // // // //   { key: "delivered", label: "Delivered" },
// // // // // // // //   { key: "draft", label: "Draft" },
// // // // // // // // ];

// // // // // // // // const STATUS_STYLES: Record<string, string> = {
// // // // // // // //   pending: "bg-amber-100 text-amber-800",
// // // // // // // //   in_transit: "bg-blue-100 text-blue-800",
// // // // // // // //   delivered: "bg-green-100 text-green-800",
// // // // // // // //   draft: "bg-slate-100 text-slate-500",
// // // // // // // //   created: "bg-slate-100 text-slate-900",
// // // // // // // //   dispatched: "bg-amber-100 text-amber-800",
// // // // // // // //   cancelled: "bg-red-100 text-red-800",
// // // // // // // // };

// // // // // // // // const STATUS_LABELS: Record<string, string> = {
// // // // // // // //   pending: "Pending",
// // // // // // // //   in_transit: "In transit",
// // // // // // // //   delivered: "Delivered",
// // // // // // // //   draft: "Draft",
// // // // // // // //   created: "Created",
// // // // // // // //   dispatched: "Dispatched",
// // // // // // // //   cancelled: "Cancelled",
// // // // // // // // };

// // // // // // // // const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
// // // // // // // //   <span
// // // // // // // //     className={`text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
// // // // // // // //       STATUS_STYLES[status] || "bg-slate-100 text-slate-900"
// // // // // // // //     }`}
// // // // // // // //   >
// // // // // // // //     {STATUS_LABELS[status] || status}
// // // // // // // //   </span>
// // // // // // // // );

// // // // // // // // const DashboardStatCard: React.FC<{
// // // // // // // //   label: string;
// // // // // // // //   value: number;
// // // // // // // //   color: string;
// // // // // // // // }> = ({ label, value, color }) => (
// // // // // // // //   <div className="rounded-xl bg-slate-50 p-4 flex flex-col justify-center items-center">
// // // // // // // //     <span className="text-[26px] font-semibold mb-1" style={{ color }}>
// // // // // // // //       {value}
// // // // // // // //     </span>
// // // // // // // //     <span className="text-xs font-medium text-slate-500">{label}</span>
// // // // // // // //   </div>
// // // // // // // // );

// // // // // // // // const InvoiceActions: React.FC<{ consignment: APIConsignment }> = ({
// // // // // // // //   consignment,
// // // // // // // // }) => {
// // // // // // // //   const link = consignment.link;
// // // // // // // //   const invoiceLabel =
// // // // // // // //     getInvoiceNo(consignment) || consignment.EWAYBILLNO || "";

// // // // // // // //   const getDownloadUrl = () => {
// // // // // // // //     if (!link) return "";
// // // // // // // //     if (link.startsWith("http")) return link;
// // // // // // // //     if (API_BASE && link.startsWith("/")) return `${API_BASE}${link}`;
// // // // // // // //     return link;
// // // // // // // //   };

// // // // // // // //   const downloadUrl = getDownloadUrl();

// // // // // // // //   const handleView = () => {
// // // // // // // //     if (downloadUrl) window.open(downloadUrl, "_blank");
// // // // // // // //   };

// // // // // // // //   const handleDownload = () => {
// // // // // // // //     if (downloadUrl) {
// // // // // // // //       const a = document.createElement("a");
// // // // // // // //       a.href = downloadUrl;
// // // // // // // //       a.download = invoiceLabel ? `Invoice_${invoiceLabel}` : "Invoice";
// // // // // // // //       document.body.appendChild(a);
// // // // // // // //       a.click();
// // // // // // // //       document.body.removeChild(a);
// // // // // // // //     }
// // // // // // // //   };

// // // // // // // //   const handleShare = () => {
// // // // // // // //     if (navigator.share && downloadUrl) {
// // // // // // // //       navigator.share({ title: `Invoice ${invoiceLabel}`, url: downloadUrl });
// // // // // // // //     } else if (downloadUrl) {
// // // // // // // //       navigator.clipboard.writeText(downloadUrl);
// // // // // // // //       alert("Invoice link copied!");
// // // // // // // //     }
// // // // // // // //   };

// // // // // // // //   if (!link) {
// // // // // // // //     return <span className="text-slate-400 text-xs">No invoice</span>;
// // // // // // // //   }

// // // // // // // //   return (
// // // // // // // //     <div className="flex items-center gap-2">
// // // // // // // //       <button
// // // // // // // //         className="hover:bg-slate-100 rounded p-1"
// // // // // // // //         title="View Invoice"
// // // // // // // //         onClick={handleView}
// // // // // // // //       >
// // // // // // // //         <FiEye className="w-4 h-4 text-blue-700" />
// // // // // // // //       </button>
// // // // // // // //       <button
// // // // // // // //         className="hover:bg-slate-100 rounded p-1"
// // // // // // // //         title="Download Invoice"
// // // // // // // //         onClick={handleDownload}
// // // // // // // //       >
// // // // // // // //         <FiDownload className="w-4 h-4 text-green-700" />
// // // // // // // //       </button>
// // // // // // // //       <button
// // // // // // // //         className="hover:bg-slate-100 rounded p-1"
// // // // // // // //         title="Share Invoice"
// // // // // // // //         onClick={handleShare}
// // // // // // // //       >
// // // // // // // //         <FiShare2 className="w-4 h-4 text-purple-600" />
// // // // // // // //       </button>
// // // // // // // //     </div>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // const RowActions: React.FC<{
// // // // // // // //   consignment: APIConsignment;
// // // // // // // //   onEdit: (id: number) => void;
// // // // // // // //   onDelete: (id: number) => void;
// // // // // // // // }> = ({ consignment, onEdit, onDelete }) => (
// // // // // // // //   <div className="flex items-center gap-2">
// // // // // // // //     <button
// // // // // // // //       className="hover:bg-slate-100 rounded p-1"
// // // // // // // //       title="Edit"
// // // // // // // //       onClick={() => onEdit(consignment.id)}
// // // // // // // //     >
// // // // // // // //       <FiEdit className="w-4 h-4 text-amber-600" />
// // // // // // // //     </button>
// // // // // // // //     <button
// // // // // // // //       className="hover:bg-slate-100 rounded p-1"
// // // // // // // //       title="Delete"
// // // // // // // //       onClick={() => onDelete(consignment.id)}
// // // // // // // //     >
// // // // // // // //       <FiTrash className="w-4 h-4 text-red-700" />
// // // // // // // //     </button>
// // // // // // // //   </div>
// // // // // // // // );

// // // // // // // // const FAKE_CONSIGNOR = (id: number) => `Consignor#${id}`;
// // // // // // // // const FAKE_CONSIGNEE = (id: number) => `Consignee#${id}`;
// // // // // // // // const FAKE_TRUCK = (id: number) => `Truck#${id}`;

// // // // // // // // const ConsignorDashboard: React.FC = () => {
// // // // // // // //   const [consignments, setConsignments] = useState<APIConsignment[]>([]);
// // // // // // // //   const [loading, setLoading] = useState(false);
// // // // // // // //   const [error, setError] = useState<string | null>(null);
// // // // // // // //   const [activeFilter, setActiveFilter] = useState<FilterOption>("all");
// // // // // // // //   const navigate = useNavigate();

// // // // // // // //   useEffect(() => {
// // // // // // // //     setLoading(true);
// // // // // // // //     setError(null);
// // // // // // // //     fetch(`${API_BASE}/invoiceapi/invoice`)
// // // // // // // //       .then((res) => res.json())
// // // // // // // //       .then((data) => {
// // // // // // // //         if (Array.isArray(data)) {
// // // // // // // //           setConsignments(
// // // // // // // //             data.map((c: any) => {
// // // // // // // //               let invoiceNo = c["InvoiceNo"] ?? c["InvoiceNo."] ?? "";
// // // // // // // //               return {
// // // // // // // //                 id: c.id,
// // // // // // // //                 sender: c.sender,
// // // // // // // //                 company: c.company,
// // // // // // // //                 receiver: c.receiver,
// // // // // // // //                 transporter: c.transporter,
// // // // // // // //                 driver: c.driver,
// // // // // // // //                 vehicles: c.vehicles,
// // // // // // // //                 payment: c.payment,
// // // // // // // //                 source: c.source,
// // // // // // // //                 destination: c.destination,
// // // // // // // //                 receiverAmountStatatus: c.receiverAmountStatatus,
// // // // // // // //                 senderAmountStatatus: c.senderAmountStatatus,
// // // // // // // //                 transporterAmountStatatus: c.transporterAmountStatatus,
// // // // // // // //                 paymentStatus: c.paymentStatus,
// // // // // // // //                 paymentPayableConsignor: c.paymentPayableConsignor,
// // // // // // // //                 ItemsDescription: c.ItemsDescription,
// // // // // // // //                 InvoiceNo: invoiceNo,
// // // // // // // //                 "InvoiceNo.": c["InvoiceNo."],
// // // // // // // //                 EWAYBILLNO: c.EWAYBILLNO,
// // // // // // // //                 subjects: c.subjects,
// // // // // // // //                 link: c.link ?? c.invoiceLink,
// // // // // // // //                 status: c.status ?? undefined,
// // // // // // // //                 biltyNo: c.biltyNo ?? invoiceNo,
// // // // // // // //                 truckNo: c.truckNo ?? c.vehicles ?? "",
// // // // // // // //                 created_at: c.created_at ?? "",
// // // // // // // //                 weight: c.weight ?? null,
// // // // // // // //                 biltyRate: c.biltyRate ?? null,
// // // // // // // //                 totalamount: c.totalamount ?? c.paymentPayableConsignor ?? null,
// // // // // // // //                 consignorName:
// // // // // // // //                   c.consignorName ||
// // // // // // // //                   (c.sender ? FAKE_CONSIGNOR(c.sender) : ""),
// // // // // // // //                 consigneeName:
// // // // // // // //                   c.consigneeName ||
// // // // // // // //                   (c.receiver ? FAKE_CONSIGNEE(c.receiver) : ""),
// // // // // // // //               };
// // // // // // // //             })
// // // // // // // //           );
// // // // // // // //         } else {
// // // // // // // //           setConsignments([]);
// // // // // // // //         }
// // // // // // // //       })
// // // // // // // //       .catch(() => setError("Unable to fetch consignments"))
// // // // // // // //       .finally(() => setLoading(false));
// // // // // // // //   }, []);

// // // // // // // //   const filtered =
// // // // // // // //     activeFilter === "all"
// // // // // // // //       ? consignments
// // // // // // // //       : consignments.filter((c) => getConsignmentStatus(c) === activeFilter);

// // // // // // // //   const handleEdit = (id: number) =>
// // // // // // // //     navigate(`/consignor/consignments/edit/${id}`);

// // // // // // // //   const handleDelete = (id: number) => {
// // // // // // // //     if (
// // // // // // // //       !window.confirm(
// // // // // // // //         "Are you sure you want to delete this consignment? This action cannot be undone."
// // // // // // // //       )
// // // // // // // //     )
// // // // // // // //       return;
// // // // // // // //     setConsignments((prev) => prev.filter((c) => c.id !== id));
// // // // // // // //   };

// // // // // // // //   const stats = [
// // // // // // // //     {
// // // // // // // //       label: "Total",
// // // // // // // //       value: consignments.length,
// // // // // // // //       color: "#185FA5",
// // // // // // // //     },
// // // // // // // //     {
// // // // // // // //       label: "Pending",
// // // // // // // //       value: consignments.filter((c) => getConsignmentStatus(c) === "pending")
// // // // // // // //         .length,
// // // // // // // //       color: "#854F0B",
// // // // // // // //     },
// // // // // // // //     {
// // // // // // // //       label: "In transit",
// // // // // // // //       value: consignments.filter(
// // // // // // // //         (c) => getConsignmentStatus(c) === "in_transit"
// // // // // // // //       ).length,
// // // // // // // //       color: "#534AB7",
// // // // // // // //     },
// // // // // // // //     {
// // // // // // // //       label: "Delivered",
// // // // // // // //       value: consignments.filter(
// // // // // // // //         (c) => getConsignmentStatus(c) === "delivered"
// // // // // // // //       ).length,
// // // // // // // //       color: "#3B6D11",
// // // // // // // //     },
// // // // // // // //   ];

// // // // // // // //   return (
// // // // // // // //     <div className="p-4 md:p-6 space-y-4">
// // // // // // // //       {/* Stats */}
// // // // // // // //       <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
// // // // // // // //         {stats.map((stat) => (
// // // // // // // //           <DashboardStatCard key={stat.label} {...stat} />
// // // // // // // //         ))}
// // // // // // // //       </div>

// // // // // // // //       {/* Panel / Table */}
// // // // // // // //       <div className="bg-white border border-slate-100 rounded-2xl p-4">
// // // // // // // //         {/* Header */}
// // // // // // // //         <div className="flex items-center justify-between mb-3">
// // // // // // // //           <div>
// // // // // // // //             <h2 className="text-[16px] font-medium text-slate-900">
// // // // // // // //               My Consignments
// // // // // // // //             </h2>
// // // // // // // //             <p className="text-xs text-slate-400">
// // // // // // // //               View and manage your consignments &amp; invoices
// // // // // // // //             </p>
// // // // // // // //           </div>
// // // // // // // //           <button
// // // // // // // //             className="text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
// // // // // // // //             onClick={() => navigate("/consignor/consignments/create")}
// // // // // // // //           >
// // // // // // // //             + New Consignment
// // // // // // // //           </button>
// // // // // // // //         </div>

// // // // // // // //         {/* Filter Pills */}
// // // // // // // //         <div className="flex flex-wrap gap-1.5 mb-4">
// // // // // // // //           {FILTER_OPTIONS.map(({ key, label }) => (
// // // // // // // //             <button
// // // // // // // //               key={key}
// // // // // // // //               onClick={() => setActiveFilter(key)}
// // // // // // // //               className={`text-xs px-3 py-1 rounded-full border transition-colors ${
// // // // // // // //                 activeFilter === key
// // // // // // // //                   ? "bg-slate-900 text-white border-transparent"
// // // // // // // //                   : "border-slate-200 text-slate-500 hover:bg-slate-50"
// // // // // // // //               }`}
// // // // // // // //             >
// // // // // // // //               {label}
// // // // // // // //             </button>
// // // // // // // //           ))}
// // // // // // // //         </div>

// // // // // // // //         {/* Table */}
// // // // // // // //         <div className="overflow-x-auto">
// // // // // // // //           <table className="w-full min-w-[1100px] text-[13px]">
// // // // // // // //             <thead>
// // // // // // // //               <tr className="text-xs border-b border-slate-100">
// // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// // // // // // // //                   Date
// // // // // // // //                 </th>
// // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// // // // // // // //                   Bilty No.
// // // // // // // //                 </th>
// // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// // // // // // // //                   Truck No.
// // // // // // // //                 </th>
// // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// // // // // // // //                   Consignor
// // // // // // // //                 </th>
// // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// // // // // // // //                   Consignee
// // // // // // // //                 </th>
// // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// // // // // // // //                   Weight
// // // // // // // //                 </th>
// // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// // // // // // // //                   Bilty Rate
// // // // // // // //                 </th>
// // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// // // // // // // //                   Amount
// // // // // // // //                 </th>
// // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// // // // // // // //                   Status
// // // // // // // //                 </th>
// // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// // // // // // // //                   Invoice
// // // // // // // //                 </th>
// // // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// // // // // // // //                   Actions
// // // // // // // //                 </th>
// // // // // // // //               </tr>
// // // // // // // //             </thead>
// // // // // // // //             <tbody>
// // // // // // // //               {loading ? (
// // // // // // // //                 <tr>
// // // // // // // //                   <td colSpan={11} className="py-6 text-center text-slate-400">
// // // // // // // //                     Loading...
// // // // // // // //                   </td>
// // // // // // // //                 </tr>
// // // // // // // //               ) : error ? (
// // // // // // // //                 <tr>
// // // // // // // //                   <td colSpan={11} className="py-6 text-center text-red-600">
// // // // // // // //                     {error}
// // // // // // // //                   </td>
// // // // // // // //                 </tr>
// // // // // // // //               ) : filtered.length === 0 ? (
// // // // // // // //                 <tr>
// // // // // // // //                   <td colSpan={11} className="py-8 text-center text-slate-400">
// // // // // // // //                     No consignments found.
// // // // // // // //                   </td>
// // // // // // // //                 </tr>
// // // // // // // //               ) : (
// // // // // // // //                 filtered.map((c) => (
// // // // // // // //                   <tr
// // // // // // // //                     key={c.id}
// // // // // // // //                     className="border-b border-slate-100 hover:bg-slate-50 transition-all"
// // // // // // // //                   >
// // // // // // // //                     {/* Date */}
// // // // // // // //                     <td className="py-2 px-3 text-slate-500 text-xs whitespace-nowrap">
// // // // // // // //                       {c.created_at
// // // // // // // //                         ? new Date(c.created_at).toLocaleDateString()
// // // // // // // //                         : "-"}
// // // // // // // //                     </td>

// // // // // // // //                     {/* Bilty No. */}
// // // // // // // //                     <td className="py-2 px-3 text-slate-900 font-medium whitespace-nowrap">
// // // // // // // //                       {c.biltyNo || getInvoiceNo(c) || "-"}
// // // // // // // //                     </td>

// // // // // // // //                     {/* Truck No. */}
// // // // // // // //                     <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// // // // // // // //                       {c.truckNo
// // // // // // // //                         ? c.truckNo
// // // // // // // //                         : c.vehicles
// // // // // // // //                         ? FAKE_TRUCK(c.vehicles)
// // // // // // // //                         : "-"}
// // // // // // // //                     </td>

// // // // // // // //                     {/* Consignor */}
// // // // // // // //                     <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// // // // // // // //                       {c.consignorName ||
// // // // // // // //                         (c.sender ? FAKE_CONSIGNOR(c.sender) : "-")}
// // // // // // // //                     </td>

// // // // // // // //                     {/* Consignee */}
// // // // // // // //                     <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// // // // // // // //                       {c.consigneeName ||
// // // // // // // //                         (c.receiver ? FAKE_CONSIGNEE(c.receiver) : "-")}
// // // // // // // //                     </td>

// // // // // // // //                     {/* Weight */}
// // // // // // // //                     <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// // // // // // // //                       {c.weight != null ? c.weight : "-"}
// // // // // // // //                     </td>

// // // // // // // //                     {/* Bilty Rate */}
// // // // // // // //                     <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// // // // // // // //                       {c.biltyRate != null ? c.biltyRate : "-"}
// // // // // // // //                     </td>

// // // // // // // //                     {/* Amount */}
// // // // // // // //                     <td className="py-2 px-3 text-slate-700 font-medium whitespace-nowrap">
// // // // // // // //                       {c.totalamount != null
// // // // // // // //                         ? c.totalamount
// // // // // // // //                         : c.payment || "-"}
// // // // // // // //                     </td>

// // // // // // // //                     {/* Status */}
// // // // // // // //                     <td className="py-2 px-3 whitespace-nowrap">
// // // // // // // //                       <StatusBadge status={getConsignmentStatus(c)} />
// // // // // // // //                     </td>

// // // // // // // //                     {/* Invoice */}
// // // // // // // //                     <td className="py-2 px-3 whitespace-nowrap">
// // // // // // // //                       <InvoiceActions consignment={c} />
// // // // // // // //                     </td>

// // // // // // // //                     {/* Actions */}
// // // // // // // //                     <td className="py-2 px-3 whitespace-nowrap">
// // // // // // // //                       <RowActions
// // // // // // // //                         consignment={c}
// // // // // // // //                         onEdit={handleEdit}
// // // // // // // //                         onDelete={handleDelete}
// // // // // // // //                       />
// // // // // // // //                     </td>
// // // // // // // //                   </tr>
// // // // // // // //                 ))
// // // // // // // //               )}
// // // // // // // //             </tbody>
// // // // // // // //           </table>
// // // // // // // //         </div>
// // // // // // // //       </div>
// // // // // // // //     </div>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default ConsignorDashboard;

// // // // // // // import React, { useState, useEffect, useCallback } from "react";
// // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // import { FiEye, FiDownload, FiShare2, FiEdit, FiTrash } from "react-icons/fi";

// // // // // // // type ShipmentStatus = "pending" | "in_transit" | "delivered" | "draft";
// // // // // // // type PaymentMode = "paid" | "to_pay" | "credit";
// // // // // // // type FilterOption = "all" | ShipmentStatus;

// // // // // // // const API_BASE = process.env.REACT_APP_API_URL;

// // // // // // // interface APIConsignment {
// // // // // // //   id: number;
// // // // // // //   sender: number;
// // // // // // //   company: number;
// // // // // // //   receiver: number;
// // // // // // //   transporter: number;
// // // // // // //   driver: number;
// // // // // // //   vehicles: number;
// // // // // // //   payment: string;
// // // // // // //   source: string;
// // // // // // //   destination: string;
// // // // // // //   receiverAmountStatatus: string;
// // // // // // //   senderAmountStatatus: string;
// // // // // // //   transporterAmountStatatus: string;
// // // // // // //   paymentStatus: PaymentMode;
// // // // // // //   paymentPayableConsignor: number;
// // // // // // //   ItemsDescription: string;
// // // // // // //   ["InvoiceNo"]?: string;
// // // // // // //   ["InvoiceNo."]?: string;
// // // // // // //   EWAYBILLNO: string;
// // // // // // //   subjects: string;
// // // // // // //   link?: string;
// // // // // // //   status?: ShipmentStatus;
// // // // // // //   biltyNo?: string;
// // // // // // //   truckNo?: string;
// // // // // // //   created_at?: string;
// // // // // // //   weight?: number;
// // // // // // //   biltyRate?: number;
// // // // // // //   totalamount?: number;
// // // // // // //   consignorName?: string;
// // // // // // //   consigneeName?: string;
// // // // // // // }

// // // // // // // // Cache maps to avoid duplicate API calls for the same id
// // // // // // // const userCache: Record<number, string> = {};
// // // // // // // const vehicleCache: Record<number, string> = {};

// // // // // // // async function fetchUserName(id: number): Promise<string> {
// // // // // // //   if (userCache[id]) return userCache[id];
// // // // // // //   try {
// // // // // // //     const res = await fetch(`${API_BASE}/auth/user/${id}`);
// // // // // // //     if (!res.ok) throw new Error();
// // // // // // //     const data = await res.json();
// // // // // // //     const name = data.name || `User#${id}`;
// // // // // // //     userCache[id] = name;
// // // // // // //     return name;
// // // // // // //   } catch {
// // // // // // //     return `User#${id}`;
// // // // // // //   }
// // // // // // // }

// // // // // // // async function fetchVehicleNumber(id: number): Promise<string> {
// // // // // // //   if (vehicleCache[id]) return vehicleCache[id];
// // // // // // //   try {
// // // // // // //     const res = await fetch(`${API_BASE}/auth/vehicles/${id}`);
// // // // // // //     if (!res.ok) throw new Error();
// // // // // // //     const data = await res.json();
// // // // // // //     // registration_number is the truck plate number
// // // // // // //     const reg = data.registration_number || data.vehicle_number || `Vehicle#${id}`;
// // // // // // //     vehicleCache[id] = reg;
// // // // // // //     return reg;
// // // // // // //   } catch {
// // // // // // //     return `Vehicle#${id}`;
// // // // // // //   }
// // // // // // // }

// // // // // // // const getInvoiceNo = (consignment: APIConsignment): string =>
// // // // // // //   consignment.InvoiceNo ||
// // // // // // //   //@ts-ignore
// // // // // // //   consignment["InvoiceNo."] ||
// // // // // // //   "";

// // // // // // // const getConsignmentStatus = (consignment: APIConsignment): ShipmentStatus => {
// // // // // // //   if (consignment.status) return consignment.status;
// // // // // // //   if (
// // // // // // //     consignment.paymentStatus === "to_pay" ||
// // // // // // //     consignment.paymentStatus === "credit"
// // // // // // //   )
// // // // // // //     return "pending";
// // // // // // //   if (consignment.paymentStatus === "paid") return "delivered";
// // // // // // //   return "pending";
// // // // // // // };

// // // // // // // const FILTER_OPTIONS: { key: FilterOption; label: string }[] = [
// // // // // // //   { key: "all", label: "All" },
// // // // // // //   { key: "pending", label: "Pending" },
// // // // // // //   { key: "in_transit", label: "In transit" },
// // // // // // //   { key: "delivered", label: "Delivered" },
// // // // // // //   { key: "draft", label: "Draft" },
// // // // // // // ];

// // // // // // // const STATUS_STYLES: Record<string, string> = {
// // // // // // //   pending: "bg-amber-100 text-amber-800",
// // // // // // //   in_transit: "bg-blue-100 text-blue-800",
// // // // // // //   delivered: "bg-green-100 text-green-800",
// // // // // // //   draft: "bg-slate-100 text-slate-500",
// // // // // // //   created: "bg-slate-100 text-slate-900",
// // // // // // //   dispatched: "bg-amber-100 text-amber-800",
// // // // // // //   cancelled: "bg-red-100 text-red-800",
// // // // // // // };

// // // // // // // const STATUS_LABELS: Record<string, string> = {
// // // // // // //   pending: "Pending",
// // // // // // //   in_transit: "In transit",
// // // // // // //   delivered: "Delivered",
// // // // // // //   draft: "Draft",
// // // // // // //   created: "Created",
// // // // // // //   dispatched: "Dispatched",
// // // // // // //   cancelled: "Cancelled",
// // // // // // // };

// // // // // // // const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
// // // // // // //   <span
// // // // // // //     className={`text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
// // // // // // //       STATUS_STYLES[status] || "bg-slate-100 text-slate-900"
// // // // // // //     }`}
// // // // // // //   >
// // // // // // //     {STATUS_LABELS[status] || status}
// // // // // // //   </span>
// // // // // // // );

// // // // // // // const DashboardStatCard: React.FC<{
// // // // // // //   label: string;
// // // // // // //   value: number;
// // // // // // //   color: string;
// // // // // // // }> = ({ label, value, color }) => (
// // // // // // //   <div className="rounded-xl bg-slate-50 p-4 flex flex-col justify-center items-center">
// // // // // // //     <span className="text-[26px] font-semibold mb-1" style={{ color }}>
// // // // // // //       {value}
// // // // // // //     </span>
// // // // // // //     <span className="text-xs font-medium text-slate-500">{label}</span>
// // // // // // //   </div>
// // // // // // // );

// // // // // // // const InvoiceActions: React.FC<{ consignment: APIConsignment }> = ({
// // // // // // //   consignment,
// // // // // // // }) => {
// // // // // // //   const link = consignment.link;
// // // // // // //   const invoiceLabel = getInvoiceNo(consignment) || consignment.EWAYBILLNO || "";

// // // // // // //   const getDownloadUrl = () => {
// // // // // // //     if (!link) return "";
// // // // // // //     if (link.startsWith("http")) return link;
// // // // // // //     if (API_BASE && link.startsWith("/")) return `${API_BASE}${link}`;
// // // // // // //     return link;
// // // // // // //   };

// // // // // // //   const downloadUrl = getDownloadUrl();

// // // // // // //   const handleView = () => {
// // // // // // //     if (downloadUrl) window.open(downloadUrl, "_blank");
// // // // // // //   };

// // // // // // //   const handleDownload = () => {
// // // // // // //     if (downloadUrl) {
// // // // // // //       const a = document.createElement("a");
// // // // // // //       a.href = downloadUrl;
// // // // // // //       a.download = invoiceLabel ? `Invoice_${invoiceLabel}` : "Invoice";
// // // // // // //       document.body.appendChild(a);
// // // // // // //       a.click();
// // // // // // //       document.body.removeChild(a);
// // // // // // //     }
// // // // // // //   };

// // // // // // //   const handleShare = () => {
// // // // // // //     if (navigator.share && downloadUrl) {
// // // // // // //       navigator.share({ title: `Invoice ${invoiceLabel}`, url: downloadUrl });
// // // // // // //     } else if (downloadUrl) {
// // // // // // //       navigator.clipboard.writeText(downloadUrl);
// // // // // // //       alert("Invoice link copied!");
// // // // // // //     }
// // // // // // //   };

// // // // // // //   if (!link) {
// // // // // // //     return <span className="text-slate-400 text-xs">No invoice</span>;
// // // // // // //   }

// // // // // // //   return (
// // // // // // //     <div className="flex items-center gap-2">
// // // // // // //       <button
// // // // // // //         className="hover:bg-slate-100 rounded p-1"
// // // // // // //         title="View Invoice"
// // // // // // //         onClick={handleView}
// // // // // // //       >
// // // // // // //         <FiEye className="w-4 h-4 text-blue-700" />
// // // // // // //       </button>
// // // // // // //       <button
// // // // // // //         className="hover:bg-slate-100 rounded p-1"
// // // // // // //         title="Download Invoice"
// // // // // // //         onClick={handleDownload}
// // // // // // //       >
// // // // // // //         <FiDownload className="w-4 h-4 text-green-700" />
// // // // // // //       </button>
// // // // // // //       <button
// // // // // // //         className="hover:bg-slate-100 rounded p-1"
// // // // // // //         title="Share Invoice"
// // // // // // //         onClick={handleShare}
// // // // // // //       >
// // // // // // //         <FiShare2 className="w-4 h-4 text-purple-600" />
// // // // // // //       </button>
// // // // // // //     </div>
// // // // // // //   );
// // // // // // // };

// // // // // // // const RowActions: React.FC<{
// // // // // // //   consignment: APIConsignment;
// // // // // // //   onEdit: (id: number) => void;
// // // // // // //   onDelete: (id: number) => void;
// // // // // // // }> = ({ consignment, onEdit, onDelete }) => (
// // // // // // //   <div className="flex items-center gap-2">
// // // // // // //     <button
// // // // // // //       className="hover:bg-slate-100 rounded p-1"
// // // // // // //       title="Edit"
// // // // // // //       onClick={() => onEdit(consignment.id)}
// // // // // // //     >
// // // // // // //       <FiEdit className="w-4 h-4 text-amber-600" />
// // // // // // //     </button>
// // // // // // //     <button
// // // // // // //       className="hover:bg-slate-100 rounded p-1"
// // // // // // //       title="Delete"
// // // // // // //       onClick={() => onDelete(consignment.id)}
// // // // // // //     >
// // // // // // //       <FiTrash className="w-4 h-4 text-red-700" />
// // // // // // //     </button>
// // // // // // //   </div>
// // // // // // // );

// // // // // // // // Resolved display names for a single row
// // // // // // // interface ResolvedNames {
// // // // // // //   consignorName: string;
// // // // // // //   consigneeName: string;
// // // // // // //   truckNo: string;
// // // // // // // }

// // // // // // // const ConsignorDashboard: React.FC = () => {
// // // // // // //   const [consignments, setConsignments] = useState<APIConsignment[]>([]);
// // // // // // //   const [loading, setLoading] = useState(false);
// // // // // // //   const [error, setError] = useState<string | null>(null);
// // // // // // //   const [activeFilter, setActiveFilter] = useState<FilterOption>("all");

// // // // // // //   // Map of consignment id → resolved names (populated asynchronously)
// // // // // // //   const [resolvedNames, setResolvedNames] = useState<
// // // // // // //     Record<number, ResolvedNames>
// // // // // // //   >({});

// // // // // // //   const navigate = useNavigate();

// // // // // // //   // After consignments load, resolve unique sender/receiver/vehicle ids
// // // // // // //   const resolveNames = useCallback(async (list: APIConsignment[]) => {
// // // // // // //     // Collect unique ids
// // // // // // //     const senderIds = [...new Set(list.map((c) => c.sender).filter(Boolean))];
// // // // // // //     const receiverIds = [...new Set(list.map((c) => c.receiver).filter(Boolean))];
// // // // // // //     const vehicleIds = [...new Set(list.map((c) => c.vehicles).filter(Boolean))];

// // // // // // //     // Fetch all in parallel
// // // // // // //     await Promise.all([
// // // // // // //       ...senderIds.map(fetchUserName),
// // // // // // //       ...receiverIds.map(fetchUserName),
// // // // // // //       ...vehicleIds.map(fetchVehicleNumber),
// // // // // // //     ]);

// // // // // // //     // Build per-consignment resolved names from the now-populated caches
// // // // // // //     const resolved: Record<number, ResolvedNames> = {};
// // // // // // //     for (const c of list) {
// // // // // // //       resolved[c.id] = {
// // // // // // //         consignorName: c.sender ? userCache[c.sender] || `User#${c.sender}` : "-",
// // // // // // //         consigneeName: c.receiver ? userCache[c.receiver] || `User#${c.receiver}` : "-",
// // // // // // //         truckNo: c.vehicles
// // // // // // //           ? vehicleCache[c.vehicles] || `Vehicle#${c.vehicles}`
// // // // // // //           : "-",
// // // // // // //       };
// // // // // // //     }
// // // // // // //     setResolvedNames(resolved);
// // // // // // //   }, []);

// // // // // // //   useEffect(() => {
// // // // // // //     setLoading(true);
// // // // // // //     setError(null);
// // // // // // //     fetch(`${API_BASE}/invoiceapi/invoice`)
// // // // // // //       .then((res) => res.json())
// // // // // // //       .then((data) => {
// // // // // // //         if (Array.isArray(data)) {
// // // // // // //           const mapped: APIConsignment[] = data.map((c: any) => {
// // // // // // //             const invoiceNo = c["InvoiceNo"] ?? c["InvoiceNo."] ?? "";
// // // // // // //             return {
// // // // // // //               id: c.id,
// // // // // // //               sender: c.sender,
// // // // // // //               company: c.company,
// // // // // // //               receiver: c.receiver,
// // // // // // //               transporter: c.transporter,
// // // // // // //               driver: c.driver,
// // // // // // //               vehicles: c.vehicles,
// // // // // // //               payment: c.payment,
// // // // // // //               source: c.source,
// // // // // // //               destination: c.destination,
// // // // // // //               receiverAmountStatatus: c.receiverAmountStatatus,
// // // // // // //               senderAmountStatatus: c.senderAmountStatatus,
// // // // // // //               transporterAmountStatatus: c.transporterAmountStatatus,
// // // // // // //               paymentStatus: c.paymentStatus,
// // // // // // //               paymentPayableConsignor: c.paymentPayableConsignor,
// // // // // // //               ItemsDescription: c.ItemsDescription,
// // // // // // //               InvoiceNo: invoiceNo,
// // // // // // //               "InvoiceNo.": c["InvoiceNo."],
// // // // // // //               EWAYBILLNO: c.EWAYBILLNO,
// // // // // // //               subjects: c.subjects,
// // // // // // //               link: c.link ?? c.invoiceLink,
// // // // // // //               status: c.status ?? undefined,
// // // // // // //               biltyNo: c.biltyNo ?? invoiceNo,
// // // // // // //               created_at: c.created_at ?? "",
// // // // // // //               weight: c.weight ?? null,
// // // // // // //               biltyRate: c.biltyRate ?? null,
// // // // // // //               totalamount: c.totalamount ?? c.paymentPayableConsignor ?? null,
// // // // // // //             };
// // // // // // //           });
// // // // // // //           setConsignments(mapped);
// // // // // // //           resolveNames(mapped);
// // // // // // //         } else {
// // // // // // //           setConsignments([]);
// // // // // // //         }
// // // // // // //       })
// // // // // // //       .catch(() => setError("Unable to fetch consignments"))
// // // // // // //       .finally(() => setLoading(false));
// // // // // // //   }, [resolveNames]);

// // // // // // //   const filtered =
// // // // // // //     activeFilter === "all"
// // // // // // //       ? consignments
// // // // // // //       : consignments.filter((c) => getConsignmentStatus(c) === activeFilter);

// // // // // // //   const handleEdit = (id: number) =>
// // // // // // //     navigate(`/consignor/consignments/edit/${id}`);

// // // // // // //   const handleDelete = (id: number) => {
// // // // // // //     if (
// // // // // // //       !window.confirm(
// // // // // // //         "Are you sure you want to delete this consignment? This action cannot be undone."
// // // // // // //       )
// // // // // // //     )
// // // // // // //       return;
// // // // // // //     setConsignments((prev) => prev.filter((c) => c.id !== id));
// // // // // // //   };

// // // // // // //   const stats = [
// // // // // // //     { label: "Total", value: consignments.length, color: "#185FA5" },
// // // // // // //     {
// // // // // // //       label: "Pending",
// // // // // // //       value: consignments.filter((c) => getConsignmentStatus(c) === "pending")
// // // // // // //         .length,
// // // // // // //       color: "#854F0B",
// // // // // // //     },
// // // // // // //     {
// // // // // // //       label: "In transit",
// // // // // // //       value: consignments.filter(
// // // // // // //         (c) => getConsignmentStatus(c) === "in_transit"
// // // // // // //       ).length,
// // // // // // //       color: "#534AB7",
// // // // // // //     },
// // // // // // //     {
// // // // // // //       label: "Delivered",
// // // // // // //       value: consignments.filter(
// // // // // // //         (c) => getConsignmentStatus(c) === "delivered"
// // // // // // //       ).length,
// // // // // // //       color: "#3B6D11",
// // // // // // //     },
// // // // // // //   ];

// // // // // // //   return (
// // // // // // //     <div className="p-4 md:p-6 space-y-4">
// // // // // // //       {/* Stats */}
// // // // // // //       <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
// // // // // // //         {stats.map((stat) => (
// // // // // // //           <DashboardStatCard key={stat.label} {...stat} />
// // // // // // //         ))}
// // // // // // //       </div>

// // // // // // //       {/* Panel / Table */}
// // // // // // //       <div className="bg-white border border-slate-100 rounded-2xl p-4">
// // // // // // //         {/* Header */}
// // // // // // //         <div className="flex items-center justify-between mb-3">
// // // // // // //           <div>
// // // // // // //             <h2 className="text-[16px] font-medium text-slate-900">
// // // // // // //               My Consignments
// // // // // // //             </h2>
// // // // // // //             <p className="text-xs text-slate-400">
// // // // // // //               View and manage your consignments &amp; invoices
// // // // // // //             </p>
// // // // // // //           </div>
// // // // // // //           <button
// // // // // // //             className="text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
// // // // // // //             onClick={() => navigate("/consignor/consignments/create")}
// // // // // // //           >
// // // // // // //             + New Consignment
// // // // // // //           </button>
// // // // // // //         </div>

// // // // // // //         {/* Filter Pills */}
// // // // // // //         <div className="flex flex-wrap gap-1.5 mb-4">
// // // // // // //           {FILTER_OPTIONS.map(({ key, label }) => (
// // // // // // //             <button
// // // // // // //               key={key}
// // // // // // //               onClick={() => setActiveFilter(key)}
// // // // // // //               className={`text-xs px-3 py-1 rounded-full border transition-colors ${
// // // // // // //                 activeFilter === key
// // // // // // //                   ? "bg-slate-900 text-white border-transparent"
// // // // // // //                   : "border-slate-200 text-slate-500 hover:bg-slate-50"
// // // // // // //               }`}
// // // // // // //             >
// // // // // // //               {label}
// // // // // // //             </button>
// // // // // // //           ))}
// // // // // // //         </div>

// // // // // // //         {/* Table */}
// // // // // // //         <div className="overflow-x-auto">
// // // // // // //           <table className="w-full min-w-[1100px] text-[13px]">
// // // // // // //             <thead>
// // // // // // //               <tr className="text-xs border-b border-slate-100">
// // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
// // // // // // //                   Date
// // // // // // //                 </th>
// // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
// // // // // // //                   Bilty No.
// // // // // // //                 </th>
// // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
// // // // // // //                   Truck No.
// // // // // // //                 </th>
// // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
// // // // // // //                   Consignor
// // // // // // //                 </th>
// // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
// // // // // // //                   Consignee
// // // // // // //                 </th>
// // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
// // // // // // //                   Weight
// // // // // // //                 </th>
// // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
// // // // // // //                   Bilty Rate
// // // // // // //                 </th>
// // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
// // // // // // //                   Amount
// // // // // // //                 </th>
// // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
// // // // // // //                   Status
// // // // // // //                 </th>
// // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
// // // // // // //                   Invoice
// // // // // // //                 </th>
// // // // // // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
// // // // // // //                   Actions
// // // // // // //                 </th>
// // // // // // //               </tr>
// // // // // // //             </thead>
// // // // // // //             <tbody>
// // // // // // //               {loading ? (
// // // // // // //                 <tr>
// // // // // // //                   <td
// // // // // // //                     colSpan={11}
// // // // // // //                     className="py-6 text-center text-slate-400"
// // // // // // //                   >
// // // // // // //                     Loading...
// // // // // // //                   </td>
// // // // // // //                 </tr>
// // // // // // //               ) : error ? (
// // // // // // //                 <tr>
// // // // // // //                   <td colSpan={11} className="py-6 text-center text-red-600">
// // // // // // //                     {error}
// // // // // // //                   </td>
// // // // // // //                 </tr>
// // // // // // //               ) : filtered.length === 0 ? (
// // // // // // //                 <tr>
// // // // // // //                   <td
// // // // // // //                     colSpan={11}
// // // // // // //                     className="py-8 text-center text-slate-400"
// // // // // // //                   >
// // // // // // //                     No consignments found.
// // // // // // //                   </td>
// // // // // // //                 </tr>
// // // // // // //               ) : (
// // // // // // //                 filtered.map((c) => {
// // // // // // //                   const names = resolvedNames[c.id];
// // // // // // //                   return (
// // // // // // //                     <tr
// // // // // // //                       key={c.id}
// // // // // // //                       className="border-b border-slate-100 hover:bg-slate-50 transition-all"
// // // // // // //                     >
// // // // // // //                       {/* Date */}
// // // // // // //                       <td className="py-2 px-3 text-slate-500 text-xs whitespace-nowrap">
// // // // // // //                         {c.created_at
// // // // // // //                           ? new Date(c.created_at).toLocaleDateString()
// // // // // // //                           : "-"}
// // // // // // //                       </td>

// // // // // // //                       {/* Bilty No. */}
// // // // // // //                       <td className="py-2 px-3 text-slate-900 font-medium whitespace-nowrap">
// // // // // // //                         {c.biltyNo || getInvoiceNo(c) || "-"}
// // // // // // //                       </td>

// // // // // // //                       {/* Truck No. — from vehicle API */}
// // // // // // //                       <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// // // // // // //                         {names ? (
// // // // // // //                           names.truckNo
// // // // // // //                         ) : (
// // // // // // //                           <span className="text-slate-300 animate-pulse">
// // // // // // //                             Loading…
// // // // // // //                           </span>
// // // // // // //                         )}
// // // // // // //                       </td>

// // // // // // //                       {/* Consignor — from user API */}
// // // // // // //                       <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// // // // // // //                         {names ? (
// // // // // // //                           names.consignorName
// // // // // // //                         ) : (
// // // // // // //                           <span className="text-slate-300 animate-pulse">
// // // // // // //                             Loading…
// // // // // // //                           </span>
// // // // // // //                         )}
// // // // // // //                       </td>

// // // // // // //                       {/* Consignee — from user API */}
// // // // // // //                       <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// // // // // // //                         {names ? (
// // // // // // //                           names.consigneeName
// // // // // // //                         ) : (
// // // // // // //                           <span className="text-slate-300 animate-pulse">
// // // // // // //                             Loading…
// // // // // // //                           </span>
// // // // // // //                         )}
// // // // // // //                       </td>

// // // // // // //                       {/* Weight */}
// // // // // // //                       <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// // // // // // //                         {c.weight != null ? c.weight : "-"}
// // // // // // //                       </td>

// // // // // // //                       {/* Bilty Rate */}
// // // // // // //                       <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// // // // // // //                         {c.biltyRate != null ? c.biltyRate : "-"}
// // // // // // //                       </td>

// // // // // // //                       {/* Amount */}
// // // // // // //                       <td className="py-2 px-3 text-slate-700 font-medium whitespace-nowrap">
// // // // // // //                         {c.totalamount != null
// // // // // // //                           ? c.totalamount
// // // // // // //                           : c.payment || "-"}
// // // // // // //                       </td>

// // // // // // //                       {/* Status */}
// // // // // // //                       <td className="py-2 px-3 whitespace-nowrap">
// // // // // // //                         <StatusBadge status={getConsignmentStatus(c)} />
// // // // // // //                       </td>

// // // // // // //                       {/* Invoice */}
// // // // // // //                       <td className="py-2 px-3 whitespace-nowrap">
// // // // // // //                         <InvoiceActions consignment={c} />
// // // // // // //                       </td>

// // // // // // //                       {/* Actions */}
// // // // // // //                       <td className="py-2 px-3 whitespace-nowrap">
// // // // // // //                         <RowActions
// // // // // // //                           consignment={c}
// // // // // // //                           onEdit={handleEdit}
// // // // // // //                           onDelete={handleDelete}
// // // // // // //                         />
// // // // // // //                       </td>
// // // // // // //                     </tr>
// // // // // // //                   );
// // // // // // //                 })
// // // // // // //               )}
// // // // // // //             </tbody>
// // // // // // //           </table>
// // // // // // //         </div>
// // // // // // //       </div>
// // // // // // //     </div>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default ConsignorDashboard;

// // // // // // // import React, { useState, useEffect, useCallback } from "react";
// // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // import { FiEye, FiDownload, FiShare2, FiEdit, FiTrash } from "react-icons/fi";

// // // // // // // type ShipmentStatus = "pending" | "in_transit" | "delivered" | "draft";
// // // // // // // type PaymentMode = "paid" | "to_pay" | "credit";
// // // // // // // type FilterOption = "all" | ShipmentStatus;

// // // // // // // const API_BASE = process.env.REACT_APP_API_URL;

// // // // // // // interface APIConsignment {
// // // // // // //   id: number;
// // // // // // //   sender: number;
// // // // // // //   company: number;
// // // // // // //   receiver: number;
// // // // // // //   transporter: number;
// // // // // // //   driver: number;
// // // // // // //   vehicles: number;
// // // // // // //   payment: string;
// // // // // // //   source: string;
// // // // // // //   destination: string;
// // // // // // //   receiverAmountStatatus: string;
// // // // // // //   senderAmountStatatus: string;
// // // // // // //   transporterAmountStatatus: string;
// // // // // // //   paymentStatus: PaymentMode;
// // // // // // //   paymentPayableConsignor: number;
// // // // // // //   ItemsDescription: string;
// // // // // // //   ["InvoiceNo"]?: string;
// // // // // // //   ["InvoiceNo."]?: string;
// // // // // // //   EWAYBILLNO: string;
// // // // // // //   subjects: string;
// // // // // // //   link?: string;
// // // // // // //   status?: ShipmentStatus;
// // // // // // //   biltyNo?: string;
// // // // // // //   created_at?: string;
// // // // // // //   totalamount?: number;
// // // // // // //   consignorName?: string;
// // // // // // //   consigneeName?: string;
// // // // // // //   truckNo?: string;
// // // // // // //   totalWeight?: number | null;
// // // // // // //   biltyRate?: number | null;
// // // // // // //   totalItemAmount?: number | null;
// // // // // // // }

// // // // // // // interface InvoiceItem {
// // // // // // //   rate: number;
// // // // // // //   id: number;
// // // // // // //   invoiceId: string;
// // // // // // //   description: string;
// // // // // // //   hsm_code: string;
// // // // // // //   uom: string;
// // // // // // //   qty: number;
// // // // // // //   amount: number;
// // // // // // // }

// // // // // // // const userCache: Record<number, string> = {};
// // // // // // // const vehicleCache: Record<number, string> = {};
// // // // // // // const itemsCache: Record<string, InvoiceItem[]> = {};

// // // // // // // async function fetchUserName(id: number): Promise<string> {
// // // // // // //   if (userCache[id]) return userCache[id];
// // // // // // //   try {
// // // // // // //     const res = await fetch(`${API_BASE}/auth/user/${id}`);
// // // // // // //     if (!res.ok) throw new Error();
// // // // // // //     const data = await res.json();
// // // // // // //     const name = data.name || `User#${id}`;
// // // // // // //     userCache[id] = name;
// // // // // // //     return name;
// // // // // // //   } catch {
// // // // // // //     userCache[id] = `User#${id}`;
// // // // // // //     return userCache[id];
// // // // // // //   }
// // // // // // // }

// // // // // // // async function fetchVehicleNumber(id: number): Promise<string> {
// // // // // // //   if (vehicleCache[id]) return vehicleCache[id];
// // // // // // //   try {
// // // // // // //     const res = await fetch(`${API_BASE}/auth/vehicles/${id}`);
// // // // // // //     if (!res.ok) throw new Error();
// // // // // // //     const data = await res.json();
// // // // // // //     const reg = data.registration_number || data.vehicle_number || `Vehicle#${id}`;
// // // // // // //     vehicleCache[id] = reg;
// // // // // // //     return reg;
// // // // // // //   } catch {
// // // // // // //     vehicleCache[id] = `Vehicle#${id}`;
// // // // // // //     return vehicleCache[id];
// // // // // // //   }
// // // // // // // }

// // // // // // // async function fetchInvoiceItems(invoiceDbId: string): Promise<InvoiceItem[]> {
// // // // // // //   if (itemsCache[invoiceDbId]) return itemsCache[invoiceDbId];
// // // // // // //   try {
// // // // // // //     const res = await fetch(
// // // // // // //       `${API_BASE}/invoiceapi/invoice_items/invoice-db/${invoiceDbId}`
// // // // // // //     );
// // // // // // //     if (!res.ok) throw new Error();
// // // // // // //     const data: InvoiceItem[] = await res.json();
// // // // // // //     itemsCache[invoiceDbId] = Array.isArray(data) ? data : [];
// // // // // // //     return itemsCache[invoiceDbId];
// // // // // // //   } catch {
// // // // // // //     itemsCache[invoiceDbId] = [];
// // // // // // //     return [];
// // // // // // //   }
// // // // // // // }

// // // // // // // function computeItemStats(items: InvoiceItem[]) {
// // // // // // //   if (!items.length) return { totalWeight: null, biltyRate: null, totalItemAmount: null };
// // // // // // //   const totalWeight = items.reduce((sum, i) => sum + Number(i.qty || 0), 0);
// // // // // // //   const totalAmount = items.reduce((sum, i) => sum + Number(i.amount || 0), 0);
// // // // // // //   const totalrates = items.reduce((sum, i) => sum + Number(i.rate || 0), 0);
// // // // // // //   // const biltyRate = totalWeight > 0 ? totalAmount / totalWeight : null;
// // // // // // //   return {
// // // // // // //     totalWeight,
// // // // // // //     biltyRate: totalrates !== null ? totalrates : null,
// // // // // // //     totalItemAmount: totalAmount,
// // // // // // //   };
// // // // // // // }

// // // // // // // function fmt(val: number | null | undefined, decimals = 2): string {
// // // // // // //   if (val == null) return "-";
// // // // // // //   return val % 1 === 0 ? String(val) : val.toFixed(decimals);
// // // // // // // }

// // // // // // // const getInvoiceNo = (c: APIConsignment): string =>
// // // // // // //   c.InvoiceNo || (c as any)["InvoiceNo."] || "";

// // // // // // // const getConsignmentStatus = (c: APIConsignment): ShipmentStatus => {
// // // // // // //   if (c.status) return c.status;
// // // // // // //   if (c.paymentStatus === "to_pay" || c.paymentStatus === "credit") return "pending";
// // // // // // //   if (c.paymentStatus === "paid") return "delivered";
// // // // // // //   return "pending";
// // // // // // // };

// // // // // // // const FILTER_OPTIONS: { key: FilterOption; label: string }[] = [
// // // // // // //   { key: "all", label: "All" },
// // // // // // //   { key: "pending", label: "Pending" },
// // // // // // //   { key: "in_transit", label: "In transit" },
// // // // // // //   { key: "delivered", label: "Delivered" },
// // // // // // //   { key: "draft", label: "Draft" },
// // // // // // // ];

// // // // // // // const STATUS_STYLES: Record<string, string> = {
// // // // // // //   pending: "bg-amber-100 text-amber-800",
// // // // // // //   in_transit: "bg-blue-100 text-blue-800",
// // // // // // //   delivered: "bg-green-100 text-green-800",
// // // // // // //   draft: "bg-slate-100 text-slate-500",
// // // // // // //   created: "bg-slate-100 text-slate-900",
// // // // // // //   dispatched: "bg-amber-100 text-amber-800",
// // // // // // //   cancelled: "bg-red-100 text-red-800",
// // // // // // // };

// // // // // // // const STATUS_LABELS: Record<string, string> = {
// // // // // // //   pending: "Pending",
// // // // // // //   in_transit: "In transit",
// // // // // // //   delivered: "Delivered",
// // // // // // //   draft: "Draft",
// // // // // // //   created: "Created",
// // // // // // //   dispatched: "Dispatched",
// // // // // // //   cancelled: "Cancelled",
// // // // // // // };

// // // // // // // const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
// // // // // // //   <span
// // // // // // //     className={`text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
// // // // // // //       STATUS_STYLES[status] || "bg-slate-100 text-slate-900"
// // // // // // //     }`}
// // // // // // //   >
// // // // // // //     {STATUS_LABELS[status] || status}
// // // // // // //   </span>
// // // // // // // );

// // // // // // // const DashboardStatCard: React.FC<{
// // // // // // //   label: string;
// // // // // // //   value: number;
// // // // // // //   color: string;
// // // // // // // }> = ({ label, value, color }) => (
// // // // // // //   <div className="rounded-xl bg-slate-50 p-4 flex flex-col justify-center items-center">
// // // // // // //     <span className="text-[26px] font-semibold mb-1" style={{ color }}>
// // // // // // //       {value}
// // // // // // //     </span>
// // // // // // //     <span className="text-xs font-medium text-slate-500">{label}</span>
// // // // // // //   </div>
// // // // // // // );

// // // // // // // const LoadingCell = () => (
// // // // // // //   <span className="text-slate-300 animate-pulse text-xs">Loading…</span>
// // // // // // // );

// // // // // // // const InvoiceActions: React.FC<{ consignment: APIConsignment }> = ({ consignment }) => {
// // // // // // //   const link = consignment.link;
// // // // // // //   const invoiceLabel = getInvoiceNo(consignment) || consignment.EWAYBILLNO || "";

// // // // // // //   const getDownloadUrl = () => {
// // // // // // //     if (!link) return "";
// // // // // // //     if (link.startsWith("http")) return link;
// // // // // // //     if (API_BASE && link.startsWith("/")) return `${API_BASE}${link}`;
// // // // // // //     return link;
// // // // // // //   };
// // // // // // //   const downloadUrl = getDownloadUrl();

// // // // // // //   const handleView = () => { if (downloadUrl) window.open(downloadUrl, "_blank"); };
// // // // // // //   const handleDownload = () => {
// // // // // // //     if (!downloadUrl) return;
// // // // // // //     const a = document.createElement("a");
// // // // // // //     a.href = downloadUrl;
// // // // // // //     a.download = invoiceLabel ? `Invoice_${invoiceLabel}` : "Invoice";
// // // // // // //     document.body.appendChild(a);
// // // // // // //     a.click();
// // // // // // //     document.body.removeChild(a);
// // // // // // //   };
// // // // // // //   const handleShare = () => {
// // // // // // //     if (navigator.share && downloadUrl) {
// // // // // // //       navigator.share({ title: `Invoice ${invoiceLabel}`, url: downloadUrl });
// // // // // // //     } else if (downloadUrl) {
// // // // // // //       navigator.clipboard.writeText(downloadUrl);
// // // // // // //       alert("Invoice link copied!");
// // // // // // //     }
// // // // // // //   };

// // // // // // //   if (!link) return <span className="text-slate-400 text-xs">No invoice</span>;

// // // // // // //   return (
// // // // // // //     <div className="flex items-center gap-2">
// // // // // // //       <button className="hover:bg-slate-100 rounded p-1" title="View Invoice" onClick={handleView}>
// // // // // // //         <FiEye className="w-4 h-4 text-blue-700" />
// // // // // // //       </button>
// // // // // // //       <button className="hover:bg-slate-100 rounded p-1" title="Download Invoice" onClick={handleDownload}>
// // // // // // //         <FiDownload className="w-4 h-4 text-green-700" />
// // // // // // //       </button>
// // // // // // //       <button className="hover:bg-slate-100 rounded p-1" title="Share Invoice" onClick={handleShare}>
// // // // // // //         <FiShare2 className="w-4 h-4 text-purple-600" />
// // // // // // //       </button>
// // // // // // //     </div>
// // // // // // //   );
// // // // // // // };

// // // // // // // const RowActions: React.FC<{
// // // // // // //   consignment: APIConsignment;
// // // // // // //   onEdit: (id: number) => void;
// // // // // // //   onDelete: (id: number) => void;
// // // // // // // }> = ({ consignment, onEdit, onDelete }) => (
// // // // // // //   <div className="flex items-center gap-2">
// // // // // // //     <button className="hover:bg-slate-100 rounded p-1" title="Edit" onClick={() => window.location.href=`/admin/edit/consignments/${consignment.id}`}>
// // // // // // //       <FiEdit className="w-4 h-4 text-amber-600" />
// // // // // // //     </button>
// // // // // // //     <button className="hover:bg-slate-100 rounded p-1" title="Delete" onClick={() => onDelete(consignment.id)}>
// // // // // // //       <FiTrash className="w-4 h-4 text-red-700" />
// // // // // // //     </button>
// // // // // // //   </div>
// // // // // // // );

// // // // // // // interface ResolvedRow {
// // // // // // //   consignorName: string;
// // // // // // //   consigneeName: string;
// // // // // // //   truckNo: string;
// // // // // // //   companyName: string;
// // // // // // //   totalWeight: number | null;
// // // // // // //   biltyRate: number | null;
// // // // // // //   totalItemAmount: number | null;
// // // // // // // }

// // // // // // // type FiltersState = {
// // // // // // //   company: string;
// // // // // // //   biltyNo: string;
// // // // // // //   truckNo: string;
// // // // // // //   consignor: string;
// // // // // // //   consignee: string;
// // // // // // //   dateFrom: string;
// // // // // // //   dateTo: string;
// // // // // // // };

// // // // // // // const AdvancedFilters: React.FC<{
// // // // // // //   filters: FiltersState;
// // // // // // //   onChange: (f: FiltersState) => void;
// // // // // // //   companyOptions: string[];
// // // // // // //   biltyOptions: string[];
// // // // // // //   truckOptions: string[];
// // // // // // //   consignorOptions: string[];
// // // // // // //   consigneeOptions: string[];
// // // // // // // }> = ({
// // // // // // //   filters,
// // // // // // //   onChange,
// // // // // // //   companyOptions,
// // // // // // //   biltyOptions,
// // // // // // //   truckOptions,
// // // // // // //   consignorOptions,
// // // // // // //   consigneeOptions,
// // // // // // // }) => (
// // // // // // //   <div className="flex flex-wrap gap-3 mb-4">
// // // // // // //     {/* Company Dropdown */}
// // // // // // //     <div>
// // // // // // //       <label className="block text-xs text-slate-500 mb-1">Company</label>
// // // // // // //       <select
// // // // // // //         className="border rounded px-2 py-1 text-xs w-[160px]"
// // // // // // //         value={filters.company}
// // // // // // //         onChange={e => onChange({ ...filters, company: e.target.value })}
// // // // // // //       >
// // // // // // //         <option value="">All Companies</option>
// // // // // // //         {companyOptions.map(v => (
// // // // // // //           <option value={v} key={v}>{v}</option>
// // // // // // //         ))}
// // // // // // //       </select>
// // // // // // //     </div>
// // // // // // //     {/* Bilty Dropdown */}
// // // // // // //     <div>
// // // // // // //       <label className="block text-xs text-slate-500 mb-1">Bilty No.</label>
// // // // // // //       <select
// // // // // // //         className="border rounded px-2 py-1 text-xs w-[140px]"
// // // // // // //         value={filters.biltyNo}
// // // // // // //         onChange={e => onChange({ ...filters, biltyNo: e.target.value })}
// // // // // // //       >
// // // // // // //         <option value="">All Bilty Nos</option>
// // // // // // //         {biltyOptions.map(v => (
// // // // // // //           <option value={v} key={v}>{v}</option>
// // // // // // //         ))}
// // // // // // //       </select>
// // // // // // //       <input
// // // // // // //         className="border rounded px-2 py-1 text-xs mt-1 block w-[140px]"
// // // // // // //         placeholder="Search bilty"
// // // // // // //         value={filters.biltyNo}
// // // // // // //         onChange={e => onChange({ ...filters, biltyNo: e.target.value })}
// // // // // // //         style={{ marginTop: 4 }}
// // // // // // //       />
// // // // // // //     </div>
// // // // // // //     {/* Truck Dropdown */}
// // // // // // //     <div>
// // // // // // //       <label className="block text-xs text-slate-500 mb-1">Truck No.</label>
// // // // // // //       <select
// // // // // // //         className="border rounded px-2 py-1 text-xs w-[130px]"
// // // // // // //         value={filters.truckNo}
// // // // // // //         onChange={e => onChange({ ...filters, truckNo: e.target.value })}
// // // // // // //       >
// // // // // // //         <option value="">All Trucks</option>
// // // // // // //         {truckOptions.map(v => (
// // // // // // //           <option value={v} key={v}>{v}</option>
// // // // // // //         ))}
// // // // // // //       </select>
// // // // // // //       <input
// // // // // // //         className="border rounded px-2 py-1 text-xs mt-1 block w-[130px]"
// // // // // // //         placeholder="Search truck"
// // // // // // //         value={filters.truckNo}
// // // // // // //         onChange={e => onChange({ ...filters, truckNo: e.target.value })}
// // // // // // //         style={{ marginTop: 4 }}
// // // // // // //       />
// // // // // // //     </div>
// // // // // // //     {/* Consignor */}
// // // // // // //     <div>
// // // // // // //       <label className="block text-xs text-slate-500 mb-1">Consignor</label>
// // // // // // //       <select
// // // // // // //         className="border rounded px-2 py-1 text-xs w-[130px]"
// // // // // // //         value={filters.consignor}
// // // // // // //         onChange={e => onChange({ ...filters, consignor: e.target.value })}
// // // // // // //       >
// // // // // // //         <option value="">All Consignors</option>
// // // // // // //         {consignorOptions.map(v => (
// // // // // // //           <option value={v} key={v}>{v}</option>
// // // // // // //         ))}
// // // // // // //       </select>
// // // // // // //       <input
// // // // // // //         className="border rounded px-2 py-1 text-xs mt-1 block w-[130px]"
// // // // // // //         placeholder="Search consignor"
// // // // // // //         value={filters.consignor}
// // // // // // //         onChange={e => onChange({ ...filters, consignor: e.target.value })}
// // // // // // //         style={{ marginTop: 4 }}
// // // // // // //       />
// // // // // // //     </div>
// // // // // // //     {/* Consignee */}
// // // // // // //     <div>
// // // // // // //       <label className="block text-xs text-slate-500 mb-1">Consignee</label>
// // // // // // //       <select
// // // // // // //         className="border rounded px-2 py-1 text-xs w-[130px]"
// // // // // // //         value={filters.consignee}
// // // // // // //         onChange={e => onChange({ ...filters, consignee: e.target.value })}
// // // // // // //       >
// // // // // // //         <option value="">All Consignees</option>
// // // // // // //         {consigneeOptions.map(v => (
// // // // // // //           <option value={v} key={v}>{v}</option>
// // // // // // //         ))}
// // // // // // //       </select>
// // // // // // //       <input
// // // // // // //         className="border rounded px-2 py-1 text-xs mt-1 block w-[130px]"
// // // // // // //         placeholder="Search consignee"
// // // // // // //         value={filters.consignee}
// // // // // // //         onChange={e => onChange({ ...filters, consignee: e.target.value })}
// // // // // // //         style={{ marginTop: 4 }}
// // // // // // //       />
// // // // // // //     </div>
// // // // // // //     {/* Date range */}
// // // // // // //     <div>
// // // // // // //       <label className="block text-xs text-slate-500 mb-1">Date From</label>
// // // // // // //       <input
// // // // // // //         type="date"
// // // // // // //         className="border rounded px-2 py-1 text-xs"
// // // // // // //         value={filters.dateFrom}
// // // // // // //         onChange={e => onChange({ ...filters, dateFrom: e.target.value })}
// // // // // // //       />
// // // // // // //     </div>
// // // // // // //     <div>
// // // // // // //       <label className="block text-xs text-slate-500 mb-1">Date To</label>
// // // // // // //       <input
// // // // // // //         type="date"
// // // // // // //         className="border rounded px-2 py-1 text-xs"
// // // // // // //         value={filters.dateTo}
// // // // // // //         onChange={e => onChange({ ...filters, dateTo: e.target.value })}
// // // // // // //       />
// // // // // // //     </div>
// // // // // // //     {/* Reset */}
// // // // // // //     <div className="flex items-end">
// // // // // // //       <button
// // // // // // //         className="text-xs px-3 py-1 border rounded bg-slate-50 text-slate-600"
// // // // // // //         onClick={() =>
// // // // // // //           onChange({
// // // // // // //             company: "",
// // // // // // //             biltyNo: "",
// // // // // // //             truckNo: "",
// // // // // // //             consignor: "",
// // // // // // //             consignee: "",
// // // // // // //             dateFrom: "",
// // // // // // //             dateTo: ""
// // // // // // //           })
// // // // // // //         }
// // // // // // //       >
// // // // // // //         Clear
// // // // // // //       </button>
// // // // // // //     </div>
// // // // // // //   </div>
// // // // // // // );

// // // // // // // const ConsignorDashboard: React.FC = () => {
// // // // // // //   const [consignments, setConsignments] = useState<APIConsignment[]>([]);
// // // // // // //   const [loading, setLoading] = useState(false);
// // // // // // //   const [error, setError] = useState<string | null>(null);
// // // // // // //   const [activeFilter, setActiveFilter] = useState<FilterOption>("all");
// // // // // // //   const [resolvedRows, setResolvedRows] = useState<Record<number, ResolvedRow>>({});
// // // // // // //   const companyCache: Record<number, string> = {};

// // // // // // //   const [filters, setFilters] = useState<FiltersState>({
// // // // // // //     company: "",
// // // // // // //     biltyNo: "",
// // // // // // //     truckNo: "",
// // // // // // //     consignor: "",
// // // // // // //     consignee: "",
// // // // // // //     dateFrom: "",
// // // // // // //     dateTo: ""
// // // // // // //   });

// // // // // // //   async function fetchCompanyName(id: number): Promise<string> {
// // // // // // //     if (companyCache[id]) return companyCache[id];
// // // // // // //     try {
// // // // // // //       const res = await fetch(`${API_BASE}/companyauth/company/${id}`);
// // // // // // //       if (!res.ok) throw new Error();
// // // // // // //       const data = await res.json();
// // // // // // //       const name = data.name || data.company_name || `Company#${id}`;
// // // // // // //       companyCache[id] = name;
// // // // // // //       return name;
// // // // // // //     } catch {
// // // // // // //       companyCache[id] = `Company#${id}`;
// // // // // // //       return companyCache[id];
// // // // // // //     }
// // // // // // //   }
// // // // // // //   const navigate = useNavigate();

// // // // // // //   useEffect(() => {
// // // // // // //     setLoading(true);
// // // // // // //     setError(null);

// // // // // // //     fetch(`${API_BASE}/invoiceapi/invoice`)
// // // // // // //       .then((res) => res.json())
// // // // // // //       .then(async (data) => {
// // // // // // //         if (!Array.isArray(data)) { setConsignments([]); return; }
// // // // // // //         const mapped: APIConsignment[] = data.map((c: any) => {
// // // // // // //           const invoiceNo = c["InvoiceNo"] ?? c["InvoiceNo."] ?? "";
// // // // // // //           return {
// // // // // // //             id: c.id,
// // // // // // //             sender: c.sender,
// // // // // // //             company: c.company,
// // // // // // //             receiver: c.receiver,
// // // // // // //             transporter: c.transporter,
// // // // // // //             driver: c.driver,
// // // // // // //             vehicles: c.vehicles,
// // // // // // //             payment: c.payment,
// // // // // // //             source: c.source,
// // // // // // //             destination: c.destination,
// // // // // // //             receiverAmountStatatus: c.receiverAmountStatatus,
// // // // // // //             senderAmountStatatus: c.senderAmountStatatus,
// // // // // // //             transporterAmountStatatus: c.transporterAmountStatatus,
// // // // // // //             paymentStatus: c.paymentStatus,
// // // // // // //             paymentPayableConsignor: c.paymentPayableConsignor,
// // // // // // //             ItemsDescription: c.ItemsDescription,
// // // // // // //             InvoiceNo: invoiceNo,
// // // // // // //             "InvoiceNo.": c["InvoiceNo."],
// // // // // // //             EWAYBILLNO: c.EWAYBILLNO,
// // // // // // //             subjects: c.subjects,
// // // // // // //             link: c.link ?? c.invoiceLink,
// // // // // // //             status: c.status ?? undefined,
// // // // // // //             biltyNo: c.biltyNo ?? invoiceNo,
// // // // // // //             created_at: c.created_at ?? "",
// // // // // // //             totalamount: c.totalamount ?? null,
// // // // // // //           };
// // // // // // //         });
// // // // // // //         const senderIds = [...new Set(mapped.map((c) => c.sender).filter(Boolean))];
// // // // // // //         const receiverIds = [...new Set(mapped.map((c) => c.receiver).filter(Boolean))];
// // // // // // //         const vehicleIds = [...new Set(mapped.map((c) => c.vehicles).filter(Boolean))];
// // // // // // //         const invoiceNos = [...new Set(mapped.map(getInvoiceNo).filter(Boolean))];
// // // // // // //         const invoiceDbIds = [...new Set(mapped.map(c => String(c.id)).filter(Boolean))];
// // // // // // //         const companyIds = [...new Set(mapped.map((c) => c.company).filter(Boolean))];

// // // // // // //         await Promise.allSettled([
// // // // // // //           ...senderIds.map(fetchUserName),
// // // // // // //           ...receiverIds.map(fetchUserName),
// // // // // // //           ...vehicleIds.map(fetchVehicleNumber),
// // // // // // //           ...companyIds.map(fetchCompanyName),
// // // // // // //           ...invoiceDbIds.map(fetchInvoiceItems),
// // // // // // //         ]);

// // // // // // //         const resolved: Record<number, ResolvedRow> = {};
// // // // // // //         for (const c of mapped) {
// // // // // // //           const items = itemsCache[String(c.id)] ?? [];
// // // // // // //           // console.log("items ",items)
// // // // // // //           const { totalWeight, biltyRate, totalItemAmount } = computeItemStats(items);
// // // // // // //           resolved[c.id] = {
// // // // // // //             consignorName: c.sender ? userCache[c.sender] || `User#${c.sender}` : "-",
// // // // // // //             consigneeName: c.receiver ? userCache[c.receiver] || `User#${c.receiver}` : "-",
// // // // // // //             truckNo: c.vehicles ? vehicleCache[c.vehicles] || `Vehicle#${c.vehicles}` : "-",
// // // // // // //             companyName: c.company ? companyCache[c.company] || `Company#${c.company}` : "-",
// // // // // // //             totalWeight,
// // // // // // //             biltyRate,
// // // // // // //             totalItemAmount,
// // // // // // //           };
// // // // // // //         }

// // // // // // //         setResolvedRows(resolved);
// // // // // // //         setConsignments(mapped);
// // // // // // //       })
// // // // // // //       .catch(() => setError("Unable to fetch consignments"))
// // // // // // //       .finally(() => setLoading(false));
// // // // // // //   }, []);

// // // // // // //   // Dropdown options (from loaded data)
// // // // // // //   const companyOptions = Array.from(
// // // // // // //     new Set(
// // // // // // //       Object.values(resolvedRows)
// // // // // // //         .map(row => row.companyName)
// // // // // // //         .filter(v => v && v !== "-")
// // // // // // //     )
// // // // // // //   );
// // // // // // //   const biltyOptions = Array.from(
// // // // // // //     new Set(
// // // // // // //       consignments.map(c => c.biltyNo || getInvoiceNo(c)).filter(v => v && v !== "-")
// // // // // // //     )
// // // // // // //   );
// // // // // // //   const truckOptions = Array.from(
// // // // // // //     new Set(
// // // // // // //       Object.values(resolvedRows)
// // // // // // //         .map(row => row.truckNo)
// // // // // // //         .filter(v => v && v !== "-")
// // // // // // //     )
// // // // // // //   );
// // // // // // //   const consignorOptions = Array.from(
// // // // // // //     new Set(
// // // // // // //       Object.values(resolvedRows)
// // // // // // //         .map(row => row.consignorName)
// // // // // // //         .filter(v => v && v !== "-")
// // // // // // //     )
// // // // // // //   );
// // // // // // //   const consigneeOptions = Array.from(
// // // // // // //     new Set(
// // // // // // //       Object.values(resolvedRows)
// // // // // // //         .map(row => row.consigneeName)
// // // // // // //         .filter(v => v && v !== "-")
// // // // // // //     )
// // // // // // //   );

// // // // // // //   // Filtering logic (includes advanced filters and status pill)
// // // // // // //   // Filtering and then sorting: by biltyNo, then by created_at (earliest date first)
// // // // // // //   const filtered = consignments
// // // // // // //     .filter((c) => {
// // // // // // //       const row = resolvedRows[c.id];
// // // // // // //       if (activeFilter !== "all" && getConsignmentStatus(c) !== activeFilter) return false;
// // // // // // //       if (filters.company && row) {
// // // // // // //         if (row.companyName !== filters.company) return false;
// // // // // // //       }
// // // // // // //       if (filters.biltyNo && c.biltyNo && filters.biltyNo !== "") {
// // // // // // //         if (
// // // // // // //           filters.biltyNo !== c.biltyNo &&
// // // // // // //           (getInvoiceNo(c) ? filters.biltyNo !== getInvoiceNo(c) : true) &&
// // // // // // //           !String(c.biltyNo).toLowerCase().includes(filters.biltyNo.toLowerCase()) &&
// // // // // // //           !(getInvoiceNo(c) || '').toLowerCase().includes(filters.biltyNo.toLowerCase())
// // // // // // //         ) {
// // // // // // //           return false;
// // // // // // //         }
// // // // // // //       }
// // // // // // //       if (filters.truckNo && row) {
// // // // // // //         if (
// // // // // // //           filters.truckNo !== row.truckNo &&
// // // // // // //           !String(row.truckNo || "")
// // // // // // //             .toLowerCase()
// // // // // // //             .includes(filters.truckNo.toLowerCase())
// // // // // // //         ) {
// // // // // // //           return false;
// // // // // // //         }
// // // // // // //       }
// // // // // // //       if (filters.consignor && row) {
// // // // // // //         if (
// // // // // // //           filters.consignor !== row.consignorName &&
// // // // // // //           !String(row.consignorName || "")
// // // // // // //             .toLowerCase()
// // // // // // //             .includes(filters.consignor.toLowerCase())
// // // // // // //         ) {
// // // // // // //           return false;
// // // // // // //         }
// // // // // // //       }
// // // // // // //       if (filters.consignee && row) {
// // // // // // //         if (
// // // // // // //           filters.consignee !== row.consigneeName &&
// // // // // // //           !String(row.consigneeName || "")
// // // // // // //             .toLowerCase()
// // // // // // //             .includes(filters.consignee.toLowerCase())
// // // // // // //         ) {
// // // // // // //           return false;
// // // // // // //         }
// // // // // // //       }
// // // // // // //       // Date range
// // // // // // //       if (filters.dateFrom) {
// // // // // // //         if (!c.created_at) return false;
// // // // // // //         const dayStr = new Date(c.created_at).toISOString().slice(0, 10);
// // // // // // //         if (dayStr < filters.dateFrom) return false;
// // // // // // //       }
// // // // // // //       if (filters.dateTo) {
// // // // // // //         if (!c.created_at) return false;
// // // // // // //         const dayStr = new Date(c.created_at).toISOString().slice(0, 10);
// // // // // // //         if (dayStr > filters.dateTo) return false;
// // // // // // //       }
// // // // // // //       return true;
// // // // // // //     })
// // // // // // //     .sort((a, b) => {
// // // // // // //       // Sort by biltyNo (treat as string, fallback to empty string)
// // // // // // //       const biltyA = (a.biltyNo || getInvoiceNo(a) || "").toString().toLowerCase();
// // // // // // //       const biltyB = (b.biltyNo || getInvoiceNo(b) || "").toString().toLowerCase();
// // // // // // //       if (biltyA < biltyB) return -1;
// // // // // // //       if (biltyA > biltyB) return 1;

// // // // // // //       // Same bilty number: sort by date (earliest first)
// // // // // // //       const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
// // // // // // //       const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
// // // // // // //       return dateA - dateB;
// // // // // // //     });

// // // // // // //   const handleEdit = (id: number) => navigate(`/consignor/consignments/edit/${id}`);
// // // // // // //   const handleDelete = async (id: number) => {
// // // // // // //     if (
// // // // // // //       !window.confirm(
// // // // // // //         "Are you sure you want to delete this consignment? This action cannot be undone."
// // // // // // //       )
// // // // // // //     )
// // // // // // //       return;

// // // // // // //     try {
// // // // // // //       const res = await fetch(`${API_BASE}/invoiceapi/invoice/${id}`, {
// // // // // // //         method: "DELETE",
// // // // // // //       });

// // // // // // //       if (res.ok) {
// // // // // // //         setConsignments((prev) => prev.filter((c) => c.id !== id));
// // // // // // //       } else if (res.status === 404) {
// // // // // // //         alert("Consignment not found (already deleted).");
// // // // // // //         setConsignments((prev) => prev.filter((c) => c.id !== id));
// // // // // // //       } else {
// // // // // // //         const err = await res.json();
// // // // // // //         alert(`Failed to delete consignment: ${err.error || "Unknown error"}`);
// // // // // // //       }
// // // // // // //     } catch (error: any) {
// // // // // // //       alert(`Failed to delete consignment: ${error?.message || error}`);
// // // // // // //     }
// // // // // // //   };

// // // // // // //   const stats = [
// // // // // // //     { label: "Total", value: consignments.length, color: "#185FA5" },
// // // // // // //     {
// // // // // // //       label: "Pending",
// // // // // // //       value: consignments.filter((c) => getConsignmentStatus(c) === "pending").length,
// // // // // // //       color: "#854F0B",
// // // // // // //     },
// // // // // // //     {
// // // // // // //       label: "In transit",
// // // // // // //       value: consignments.filter((c) => getConsignmentStatus(c) === "in_transit").length,
// // // // // // //       color: "#534AB7",
// // // // // // //     },
// // // // // // //     {
// // // // // // //       label: "Delivered",
// // // // // // //       value: consignments.filter((c) => getConsignmentStatus(c) === "delivered").length,
// // // // // // //       color: "#3B6D11",
// // // // // // //     },
// // // // // // //   ];

// // // // // // //   return (
// // // // // // //     <div className="p-4 md:p-6 space-y-4">
// // // // // // //       {/* Stats */}
// // // // // // //       <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
// // // // // // //         {stats.map((stat) => (
// // // // // // //           <DashboardStatCard key={stat.label} {...stat} />
// // // // // // //         ))}
// // // // // // //       </div>

// // // // // // //       {/* Panel */}
// // // // // // //       <div className="bg-white border border-slate-100 rounded-2xl p-4">
// // // // // // //         <div className="flex items-center justify-between mb-3">
// // // // // // //           <div>
// // // // // // //             <h2 className="text-[16px] font-medium text-slate-900">My Consignments</h2>
// // // // // // //             <p className="text-xs text-slate-400">
// // // // // // //               View and manage your consignments &amp; invoices
// // // // // // //             </p>
// // // // // // //           </div>
// // // // // // //           <button
// // // // // // //             className="text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
// // // // // // //             onClick={() => navigate("/admin/add/consignments")}
// // // // // // //           >
// // // // // // //             + New Consignment
// // // // // // //           </button>
// // // // // // //         </div>

// // // // // // //         {/* Filter pills */}
// // // // // // //         <div className="flex flex-wrap gap-1.5 mb-4">
// // // // // // //           {FILTER_OPTIONS.map(({ key, label }) => (
// // // // // // //             <button
// // // // // // //               key={key}
// // // // // // //               onClick={() => setActiveFilter(key)}
// // // // // // //               className={`text-xs px-3 py-1 rounded-full border transition-colors ${
// // // // // // //                 activeFilter === key
// // // // // // //                   ? "bg-slate-900 text-white border-transparent"
// // // // // // //                   : "border-slate-200 text-slate-500 hover:bg-slate-50"
// // // // // // //               }`}
// // // // // // //             >
// // // // // // //               {label}
// // // // // // //             </button>
// // // // // // //           ))}
// // // // // // //         </div>

// // // // // // //         <AdvancedFilters
// // // // // // //           filters={filters}
// // // // // // //           onChange={setFilters}
// // // // // // //           companyOptions={companyOptions}
// // // // // // //           biltyOptions={biltyOptions}
// // // // // // //           truckOptions={truckOptions}
// // // // // // //           consignorOptions={consignorOptions}
// // // // // // //           consigneeOptions={consigneeOptions}
// // // // // // //         />

// // // // // // //         {/* Table */}
// // // // // // //         <div className="overflow-x-auto">
// // // // // // //           {/* 
// // // // // // //             Only sort filtered data by Bilty No ASC (alphanumeric/natural sort), 
// // // // // // //             so that Bilty No. is shown in serial order, regardless of date.
// // // // // // //           */}
// // // // // // //           <table className="w-full min-w-[1100px] text-[13px]">
// // // // // // //             <thead>
// // // // // // //               <tr className="text-xs border-b border-slate-100">
// // // // // // //                 {[
// // // // // // //                   "Sr. No.",
// // // // // // //                   "Date",
// // // // // // //                   "Company",
// // // // // // //                   "Bilty No.",
// // // // // // //                   "Truck No.",
// // // // // // //                   "Consignor",
// // // // // // //                   "Consignee",
// // // // // // //                   "Weight (qty)",
// // // // // // //                   "Bilty Rate (amt/qty)",
// // // // // // //                   "Amount",
// // // // // // //                   "Status",
// // // // // // //                   "Invoice",
// // // // // // //                   "Actions",
// // // // // // //                 ].map((h) => (
// // // // // // //                   <th
// // // // // // //                     key={h}
// // // // // // //                     className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap"
// // // // // // //                   >
// // // // // // //                     {h}
// // // // // // //                   </th>
// // // // // // //                 ))}
// // // // // // //               </tr>
// // // // // // //             </thead>
// // // // // // //             <tbody>
// // // // // // //               {loading ? (
// // // // // // //                 <tr>
// // // // // // //                   <td colSpan={12} className="py-6 text-center text-slate-400">
// // // // // // //                     Loading...
// // // // // // //                   </td>
// // // // // // //                 </tr>
// // // // // // //               ) : error ? (
// // // // // // //                 <tr>
// // // // // // //                   <td colSpan={12} className="py-6 text-center text-red-600">
// // // // // // //                     {error}
// // // // // // //                   </td>
// // // // // // //                 </tr>
// // // // // // //               ) : filtered.length === 0 ? (
// // // // // // //                 <tr>
// // // // // // //                   <td colSpan={12} className="py-8 text-center text-slate-400">
// // // // // // //                     No consignments found.
// // // // // // //                   </td>
// // // // // // //                 </tr>
// // // // // // //               ) : (
// // // // // // //                 // Sort filtered data by biltyNo (alphanumeric/natural sort)
// // // // // // //                 [...filtered]
// // // // // // //                   .sort((a, b) => {
// // // // // // //                     const biltyA = (a.biltyNo || getInvoiceNo(a) || "").toString();
// // // // // // //                     const biltyB = (b.biltyNo || getInvoiceNo(b) || "").toString();
// // // // // // //                     // Natural sort for bilty numbers (handles "01", "2", "10", etc. properly)
// // // // // // //                     return biltyA.localeCompare(biltyB, undefined, { numeric: true, sensitivity: 'base' });
// // // // // // //                   })
// // // // // // //                   .map((c, idx) => {
// // // // // // //                     const row = resolvedRows[c.id];
// // // // // // //                     return (
// // // // // // //                       <tr
// // // // // // //                         key={c.id}
// // // // // // //                         className="border-b border-slate-100 hover:bg-slate-50 transition-all"
// // // // // // //                       >
// // // // // // //                         {/* Sr. No. */}
// // // // // // //                         <td className="py-2 px-3 text-slate-500 text-xs whitespace-nowrap">
// // // // // // //                           {idx + 1}
// // // // // // //                         </td>
// // // // // // //                         {/* Date */}
// // // // // // //                         <td className="py-2 px-3 text-slate-500 text-xs whitespace-nowrap">
// // // // // // //                           {c.created_at
// // // // // // //                             ? new Date(c.created_at).toLocaleDateString()
// // // // // // //                             : "-"}
// // // // // // //                         </td>
// // // // // // //                         {/* Company */}
// // // // // // //                         <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// // // // // // //                           {row ? row.companyName : <LoadingCell />}
// // // // // // //                         </td>
// // // // // // //                         {/* Bilty No. */}
// // // // // // //                         <td className="py-2 px-3 text-slate-900 font-medium whitespace-nowrap">
// // // // // // //                           {c.biltyNo || getInvoiceNo(c) || "-"}
// // // // // // //                         </td>
// // // // // // //                         {/* Truck No. */}
// // // // // // //                         <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// // // // // // //                           {row ? row.truckNo : <LoadingCell />}
// // // // // // //                         </td>
// // // // // // //                         {/* Consignor */}
// // // // // // //                         <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// // // // // // //                           {row ? row.consignorName : <LoadingCell />}
// // // // // // //                         </td>
// // // // // // //                         {/* Consignee */}
// // // // // // //                         <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// // // // // // //                           {row ? row.consigneeName : <LoadingCell />}
// // // // // // //                         </td>
// // // // // // //                         {/* Weight = sum of qty from invoice_items */}
// // // // // // //                         <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// // // // // // //                           {row ? fmt(row.totalWeight) : <LoadingCell />}
// // // // // // //                         </td>
// // // // // // //                         {/* Bilty Rate = totalAmount / totalWeight */}
// // // // // // //                         <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// // // // // // //                           {row ? "₹ " +fmt(row.biltyRate, 2)+" /-" : <LoadingCell />}
                     
// // // // // // //                         </td>
// // // // // // //                         {/* Amount = sum of amount from invoice_items (fallback to payment field) */}
// // // // // // //                         <td className="py-2 px-3 text-slate-700 font-medium whitespace-nowrap">
// // // // // // //                           {row
// // // // // // //                             ? row.totalItemAmount != null
// // // // // // //                               ? "₹ " + fmt(row.totalItemAmount, 0) + " /-"
// // // // // // //                               : c.totalamount != null
// // // // // // //                               ? "₹ " + fmt(c.totalamount, 0) + " /-"
// // // // // // //                               : (c.payment ? "₹ " + fmt(Number(c.payment), 0) + " /-" : "-")
// // // // // // //                             : <LoadingCell />}
                       
// // // // // // //                         </td>
// // // // // // //                         {/* Status */}
// // // // // // //                         <td className="py-2 px-3 whitespace-nowrap">
// // // // // // //                           <StatusBadge status={getConsignmentStatus(c)} />
// // // // // // //                         </td>
// // // // // // //                         {/* Invoice */}
// // // // // // //                         <td className="py-2 px-3 whitespace-nowrap">
// // // // // // //                           <InvoiceActions consignment={c} />
// // // // // // //                         </td>
// // // // // // //                         {/* Actions */}
// // // // // // //                         <td className="py-2 px-3 whitespace-nowrap">
// // // // // // //                           <RowActions
// // // // // // //                             consignment={c}
// // // // // // //                             onEdit={handleEdit}
// // // // // // //                             onDelete={handleDelete}
// // // // // // //                           />
// // // // // // //                         </td>
// // // // // // //                       </tr>
// // // // // // //                     );
// // // // // // //                   })
// // // // // // //               )}
// // // // // // //             </tbody>
// // // // // // //           </table>
// // // // // // //         </div>
// // // // // // //       </div>
// // // // // // //     </div>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default ConsignorDashboard;


// // // // // // import React, { useState, useEffect, useRef, useCallback } from "react";
// // // // // // import { useNavigate } from "react-router-dom";

// // // // // // // ─── Types ────────────────────────────────────────────────────────────────────

// // // // // // type ShipmentStatus = "pending" | "in_transit" | "delivered" | "draft" | "created" | "dispatched" | "cancelled";
// // // // // // type FilterOption = "all" | ShipmentStatus;

// // // // // // const API_BASE = process.env.REACT_APP_API_URL;

// // // // // // interface APIConsignment {
// // // // // //   id: number;
// // // // // //   sender: number;
// // // // // //   company: number;
// // // // // //   receiver: number;
// // // // // //   transporter: number;
// // // // // //   driver: number;
// // // // // //   vehicles: number;
// // // // // //   payment: string;
// // // // // //   source: string;
// // // // // //   destination: string;
// // // // // //   receiverAmountStatatus: string;
// // // // // //   senderAmountStatatus: string;
// // // // // //   transporterAmountStatatus: string;
// // // // // //   paymentStatus: string;
// // // // // //   paymentPayableConsignor: number;
// // // // // //   ItemsDescription: string;
// // // // // //   "InvoiceNo"?: string;
// // // // // //   "InvoiceNo."?: string;
// // // // // //   EWAYBILLNO: string;
// // // // // //   subjects: string;
// // // // // //   link?: string;
// // // // // //   status?: ShipmentStatus;
// // // // // //   biltyNo?: string;
// // // // // //   created_at?: string;
// // // // // //   totalamount?: number;
// // // // // // }

// // // // // // interface InvoiceItem {
// // // // // //   rate: number;
// // // // // //   id: number;
// // // // // //   invoiceId: string;
// // // // // //   description: string;
// // // // // //   hsm_code: string;
// // // // // //   uom: string;
// // // // // //   qty: number;
// // // // // //   amount: number;
// // // // // // }

// // // // // // interface ResolvedRow {
// // // // // //   consignorName: string;
// // // // // //   consigneeName: string;
// // // // // //   truckNo: string;
// // // // // //   companyName: string;
// // // // // //   totalWeight: number | null;
// // // // // //   biltyRate: number | null;
// // // // // //   totalItemAmount: number | null;
// // // // // // }

// // // // // // type FiltersState = {
// // // // // //   company: string;
// // // // // //   biltyNo: string;
// // // // // //   truckNo: string;
// // // // // //   consignor: string;
// // // // // //   consignee: string;
// // // // // //   dateFrom: string;
// // // // // //   dateTo: string;
// // // // // // };

// // // // // // // ─── Caches ───────────────────────────────────────────────────────────────────

// // // // // // const userCache: Record<number, string> = {};
// // // // // // const vehicleCache: Record<number, string> = {};
// // // // // // const itemsCache: Record<string, InvoiceItem[]> = {};

// // // // // // // ─── Helpers ──────────────────────────────────────────────────────────────────

// // // // // // async function fetchUserName(id: number): Promise<string> {
// // // // // //   if (userCache[id]) return userCache[id];
// // // // // //   try {
// // // // // //     const res = await fetch(`${API_BASE}/auth/user/${id}`);
// // // // // //     if (!res.ok) throw new Error();
// // // // // //     const data = await res.json();
// // // // // //     userCache[id] = data.name || `User#${id}`;
// // // // // //   } catch {
// // // // // //     userCache[id] = `User#${id}`;
// // // // // //   }
// // // // // //   return userCache[id];
// // // // // // }

// // // // // // async function fetchVehicleNumber(id: number): Promise<string> {
// // // // // //   if (vehicleCache[id]) return vehicleCache[id];
// // // // // //   try {
// // // // // //     const res = await fetch(`${API_BASE}/auth/vehicles/${id}`);
// // // // // //     if (!res.ok) throw new Error();
// // // // // //     const data = await res.json();
// // // // // //     vehicleCache[id] = data.registration_number || data.vehicle_number || `Vehicle#${id}`;
// // // // // //   } catch {
// // // // // //     vehicleCache[id] = `Vehicle#${id}`;
// // // // // //   }
// // // // // //   return vehicleCache[id];
// // // // // // }

// // // // // // async function fetchInvoiceItems(invoiceDbId: string): Promise<InvoiceItem[]> {
// // // // // //   if (itemsCache[invoiceDbId]) return itemsCache[invoiceDbId];
// // // // // //   try {
// // // // // //     const res = await fetch(`${API_BASE}/invoiceapi/invoice_items/invoice-db/${invoiceDbId}`);
// // // // // //     if (!res.ok) throw new Error();
// // // // // //     const data: InvoiceItem[] = await res.json();
// // // // // //     itemsCache[invoiceDbId] = Array.isArray(data) ? data : [];
// // // // // //   } catch {
// // // // // //     itemsCache[invoiceDbId] = [];
// // // // // //   }
// // // // // //   return itemsCache[invoiceDbId];
// // // // // // }

// // // // // // function computeItemStats(items: InvoiceItem[]) {
// // // // // //   if (!items.length) return { totalWeight: null, biltyRate: null, totalItemAmount: null };
// // // // // //   const totalWeight = items.reduce((s, i) => s + Number(i.qty || 0), 0);
// // // // // //   const totalAmount = items.reduce((s, i) => s + Number(i.amount || 0), 0);
// // // // // //   const totalRates = items.reduce((s, i) => s + Number(i.rate || 0), 0);
// // // // // //   return { totalWeight, biltyRate: totalRates, totalItemAmount: totalAmount };
// // // // // // }

// // // // // // function fmt(val: number | null | undefined, decimals = 2): string {
// // // // // //   if (val == null) return "-";
// // // // // //   return val % 1 === 0 ? String(val) : val.toFixed(decimals);
// // // // // // }

// // // // // // const getInvoiceNo = (c: APIConsignment): string =>
// // // // // //   c.InvoiceNo || (c as any)["InvoiceNo."] || "";

// // // // // // const getConsignmentStatus = (c: APIConsignment): ShipmentStatus => {
// // // // // //   if (c.status) return c.status;
// // // // // //   if (c.paymentStatus === "to_pay" || c.paymentStatus === "credit") return "pending";
// // // // // //   if (c.paymentStatus === "paid") return "delivered";
// // // // // //   return "pending";
// // // // // // };

// // // // // // /** Generate a short abbreviation from a company name, e.g. "Amit Traders & Co." → "ATC" */
// // // // // // function companyAbbr(name: string): string {
// // // // // //   const NOISE = /^(pvt|ltd|co|inc|corp|private|limited|and|the|of|&)$/i;
// // // // // //   const words = name.split(/[\s&,\.]+/).filter(Boolean);
// // // // // //   const meaningful = words.filter((w) => w.length > 1 && !NOISE.test(w));
// // // // // //   const src = meaningful.length >= 2 ? meaningful : words;
// // // // // //   return src
// // // // // //     .map((w) => w[0].toUpperCase())
// // // // // //     .slice(0, 3)
// // // // // //     .join("");
// // // // // // }

// // // // // // /** Assign a stable palette color to a company id */
// // // // // // const PALETTE_KEYS = ["blue", "teal", "amber", "coral", "purple", "pink"] as const;
// // // // // // type PaletteKey = typeof PALETTE_KEYS[number];

// // // // // // const PALETTE: Record<PaletteKey, { bg: string; text: string; row: string }> = {
// // // // // //   blue:   { bg: "#E6F1FB", text: "#0C447C", row: "rgba(55,138,221,0.05)" },
// // // // // //   teal:   { bg: "#E1F5EE", text: "#085041", row: "rgba(29,158,117,0.05)" },
// // // // // //   amber:  { bg: "#FAEEDA", text: "#633806", row: "rgba(186,117,23,0.06)" },
// // // // // //   coral:  { bg: "#FAECE7", text: "#712B13", row: "rgba(216,90,48,0.05)" },
// // // // // //   purple: { bg: "#EEEDFE", text: "#3C3489", row: "rgba(83,74,183,0.05)" },
// // // // // //   pink:   { bg: "#FBEAF0", text: "#72243E", row: "rgba(212,83,126,0.05)" },
// // // // // // };

// // // // // // function paletteForCompany(companyId: number): PaletteKey {
// // // // // //   return PALETTE_KEYS[companyId % PALETTE_KEYS.length];
// // // // // // }

// // // // // // // ─── Constants ────────────────────────────────────────────────────────────────

// // // // // // const FILTER_OPTIONS: { key: FilterOption; label: string }[] = [
// // // // // //   { key: "all", label: "All" },
// // // // // //   { key: "pending", label: "Pending" },
// // // // // //   { key: "in_transit", label: "In transit" },
// // // // // //   { key: "delivered", label: "Delivered" },
// // // // // //   { key: "draft", label: "Draft" },
// // // // // // ];

// // // // // // const STATUS_STYLES: Record<string, string> = {
// // // // // //   pending:    "bg-amber-100 text-amber-900",
// // // // // //   in_transit: "bg-blue-100 text-blue-900",
// // // // // //   delivered:  "bg-green-100 text-green-900",
// // // // // //   draft:      "bg-slate-100 text-slate-600",
// // // // // //   created:    "bg-slate-100 text-slate-900",
// // // // // //   dispatched: "bg-amber-100 text-amber-800",
// // // // // //   cancelled:  "bg-red-100 text-red-900",
// // // // // // };

// // // // // // const STATUS_LABELS: Record<string, string> = {
// // // // // //   pending: "Pending", in_transit: "In transit", delivered: "Delivered",
// // // // // //   draft: "Draft", created: "Created", dispatched: "Dispatched", cancelled: "Cancelled",
// // // // // // };

// // // // // // // ─── Sub-components ───────────────────────────────────────────────────────────

// // // // // // const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
// // // // // //   <span className={`text-[9px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${STATUS_STYLES[status] || "bg-slate-100 text-slate-900"}`}>
// // // // // //     {STATUS_LABELS[status] || status}
// // // // // //   </span>
// // // // // // );

// // // // // // const DashboardStatCard: React.FC<{ label: string; value: number; color: string }> = ({ label, value, color }) => (
// // // // // //   <div className="rounded-xl bg-slate-50 p-4 flex flex-col justify-center items-center">
// // // // // //     <span className="text-[26px] font-semibold mb-1" style={{ color }}>{value}</span>
// // // // // //     <span className="text-xs font-medium text-slate-500">{label}</span>
// // // // // //   </div>
// // // // // // );

// // // // // // const LoadingCell = () => (
// // // // // //   <span className="text-slate-300 animate-pulse text-xs">Loading…</span>
// // // // // // );

// // // // // // // ─── Company Tag ──────────────────────────────────────────────────────────────

// // // // // // const CompanyTag: React.FC<{ companyId: number; companyName: string }> = ({ companyId, companyName }) => {
// // // // // //   const key = paletteForCompany(companyId);
// // // // // //   const pal = PALETTE[key];
// // // // // //   const abbr = companyAbbr(companyName);
// // // // // //   return (
// // // // // //     <span
// // // // // //       title={companyName}
// // // // // //       className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold cursor-default whitespace-nowrap"
// // // // // //       style={{ background: pal.bg, color: pal.text }}
// // // // // //     >
// // // // // //       {abbr}
// // // // // //     </span>
// // // // // //   );
// // // // // // };

// // // // // // // ─── Action Dropdown ──────────────────────────────────────────────────────────

// // // // // // interface ActionMenuProps {
// // // // // //   consignment: APIConsignment;
// // // // // //   hasInvoice: boolean;
// // // // // //   onEdit: (id: number) => void;
// // // // // //   onDelete: (id: number) => void;
// // // // // //   onViewInvoice: (c: APIConsignment) => void;
// // // // // //   onDownloadInvoice: (c: APIConsignment) => void;
// // // // // //   onShareInvoice: (c: APIConsignment) => void;
// // // // // // }

// // // // // // const ActionMenu: React.FC<ActionMenuProps> = ({
// // // // // //   consignment, hasInvoice, onEdit, onDelete, onViewInvoice, onDownloadInvoice, onShareInvoice,
// // // // // // }) => {
// // // // // //   const [open, setOpen] = useState(false);
// // // // // //   const ref = useRef<HTMLDivElement>(null);

// // // // // //   // Close on outside click
// // // // // //   useEffect(() => {
// // // // // //     if (!open) return;
// // // // // //     const handler = (e: MouseEvent) => {
// // // // // //       if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
// // // // // //     };
// // // // // //     document.addEventListener("mousedown", handler);
// // // // // //     return () => document.removeEventListener("mousedown", handler);
// // // // // //   }, [open]);

// // // // // //   const invoiceDisabled = !hasInvoice;

// // // // // //   const btnCls =
// // // // // //     "flex items-center gap-2 w-full px-3 py-[7px] text-[12px] text-left hover:bg-slate-50 transition-colors whitespace-nowrap";
// // // // // //   const disabledCls = "opacity-40 cursor-not-allowed pointer-events-none";

// // // // // //   return (
// // // // // //     <div ref={ref} className="relative inline-block">
// // // // // //       <button
// // // // // //         onClick={() => setOpen((v) => !v)}
// // // // // //         className="inline-flex items-center gap-1.5 text-[11px] px-2.5 py-1 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-600 transition-colors"
// // // // // //       >
// // // // // //         <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
// // // // // //           <circle cx="8" cy="3" r="1.4"/><circle cx="8" cy="8" r="1.4"/><circle cx="8" cy="13" r="1.4"/>
// // // // // //         </svg>
// // // // // //         Actions
// // // // // //         <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" className="opacity-50">
// // // // // //           <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
// // // // // //         </svg>
// // // // // //       </button>

// // // // // //       {open && (
// // // // // //         <div className="absolute right-0 top-[calc(100%+4px)] z-50 bg-white border border-slate-200 rounded-xl overflow-hidden min-w-[176px] shadow-sm">
// // // // // //           {/* Invoice section */}
// // // // // //           <div className="border-b border-slate-100 py-1">
// // // // // //             <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1">Invoice</p>
// // // // // //             <button
// // // // // //               className={`${btnCls} text-blue-800 ${invoiceDisabled ? disabledCls : ""}`}
// // // // // //               disabled={invoiceDisabled}
// // // // // //               onClick={() => { setOpen(false); onViewInvoice(consignment); }}
// // // // // //             >
// // // // // //               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
// // // // // //               View invoice
// // // // // //               {invoiceDisabled && <span className="ml-auto text-[9px] text-slate-400">No file</span>}
// // // // // //             </button>
// // // // // //             <button
// // // // // //               className={`${btnCls} text-green-800 ${invoiceDisabled ? disabledCls : ""}`}
// // // // // //               disabled={invoiceDisabled}
// // // // // //               onClick={() => { setOpen(false); onDownloadInvoice(consignment); }}
// // // // // //             >
// // // // // //               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
// // // // // //               Download PDF
// // // // // //             </button>
// // // // // //             <button
// // // // // //               className={`${btnCls} text-purple-800 ${invoiceDisabled ? disabledCls : ""}`}
// // // // // //               disabled={invoiceDisabled}
// // // // // //               onClick={() => { setOpen(false); onShareInvoice(consignment); }}
// // // // // //             >
// // // // // //               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
// // // // // //               Share link
// // // // // //             </button>
// // // // // //           </div>
// // // // // //           {/* Consignment section */}
// // // // // //           <div className="py-1">
// // // // // //             <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1">Consignment</p>
// // // // // //             <button
// // // // // //               className={`${btnCls} text-amber-800`}
// // // // // //               onClick={() => { setOpen(false); onEdit(consignment.id); }}
// // // // // //             >
// // // // // //               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
// // // // // //               Edit
// // // // // //             </button>
// // // // // //             <button
// // // // // //               className={`${btnCls} text-red-800 hover:!bg-red-50`}
// // // // // //               onClick={() => { setOpen(false); onDelete(consignment.id); }}
// // // // // //             >
// // // // // //               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
// // // // // //               Delete
// // // // // //             </button>
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       )}
// // // // // //     </div>
// // // // // //   );
// // // // // // };

// // // // // // // ─── Advanced Filters ─────────────────────────────────────────────────────────

// // // // // // const AdvancedFilters: React.FC<{
// // // // // //   filters: FiltersState;
// // // // // //   onChange: (f: FiltersState) => void;
// // // // // //   companyOptions: string[];
// // // // // //   biltyOptions: string[];
// // // // // //   truckOptions: string[];
// // // // // //   consignorOptions: string[];
// // // // // //   consigneeOptions: string[];
// // // // // // }> = ({ filters, onChange, companyOptions, biltyOptions, truckOptions, consignorOptions, consigneeOptions }) => {
// // // // // //   const sel = "border rounded px-2 py-1 text-xs";
// // // // // //   const inp = "border rounded px-2 py-1 text-xs mt-1 block";

// // // // // //   return (
// // // // // //     <div className="flex flex-wrap gap-3 mb-4">
// // // // // //       <div>
// // // // // //         <label className="block text-xs text-slate-500 mb-1">Company</label>
// // // // // //         <select className={`${sel} w-[160px]`} value={filters.company} onChange={e => onChange({ ...filters, company: e.target.value })}>
// // // // // //           <option value="">All companies</option>
// // // // // //           {companyOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // // // // //         </select>
// // // // // //       </div>
// // // // // //       <div>
// // // // // //         <label className="block text-xs text-slate-500 mb-1">Bilty no.</label>
// // // // // //         <select className={`${sel} w-[140px]`} value={filters.biltyNo} onChange={e => onChange({ ...filters, biltyNo: e.target.value })}>
// // // // // //           <option value="">All bilty nos.</option>
// // // // // //           {biltyOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // // // // //         </select>
// // // // // //         <input className={`${inp} w-[140px]`} placeholder="Search bilty" value={filters.biltyNo} onChange={e => onChange({ ...filters, biltyNo: e.target.value })} />
// // // // // //       </div>
// // // // // //       <div>
// // // // // //         <label className="block text-xs text-slate-500 mb-1">Truck no.</label>
// // // // // //         <select className={`${sel} w-[130px]`} value={filters.truckNo} onChange={e => onChange({ ...filters, truckNo: e.target.value })}>
// // // // // //           <option value="">All trucks</option>
// // // // // //           {truckOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // // // // //         </select>
// // // // // //         <input className={`${inp} w-[130px]`} placeholder="Search truck" value={filters.truckNo} onChange={e => onChange({ ...filters, truckNo: e.target.value })} />
// // // // // //       </div>
// // // // // //       <div>
// // // // // //         <label className="block text-xs text-slate-500 mb-1">Consignor</label>
// // // // // //         <select className={`${sel} w-[130px]`} value={filters.consignor} onChange={e => onChange({ ...filters, consignor: e.target.value })}>
// // // // // //           <option value="">All consignors</option>
// // // // // //           {consignorOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // // // // //         </select>
// // // // // //         <input className={`${inp} w-[130px]`} placeholder="Search consignor" value={filters.consignor} onChange={e => onChange({ ...filters, consignor: e.target.value })} />
// // // // // //       </div>
// // // // // //       <div>
// // // // // //         <label className="block text-xs text-slate-500 mb-1">Consignee</label>
// // // // // //         <select className={`${sel} w-[130px]`} value={filters.consignee} onChange={e => onChange({ ...filters, consignee: e.target.value })}>
// // // // // //           <option value="">All consignees</option>
// // // // // //           {consigneeOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // // // // //         </select>
// // // // // //         <input className={`${inp} w-[130px]`} placeholder="Search consignee" value={filters.consignee} onChange={e => onChange({ ...filters, consignee: e.target.value })} />
// // // // // //       </div>
// // // // // //       <div>
// // // // // //         <label className="block text-xs text-slate-500 mb-1">Date from</label>
// // // // // //         <input type="date" className={`${sel}`} value={filters.dateFrom} onChange={e => onChange({ ...filters, dateFrom: e.target.value })} />
// // // // // //       </div>
// // // // // //       <div>
// // // // // //         <label className="block text-xs text-slate-500 mb-1">Date to</label>
// // // // // //         <input type="date" className={`${sel}`} value={filters.dateTo} onChange={e => onChange({ ...filters, dateTo: e.target.value })} />
// // // // // //       </div>
// // // // // //       <div className="flex items-end">
// // // // // //         <button
// // // // // //           className="text-xs px-3 py-1 border rounded bg-slate-50 text-slate-600"
// // // // // //           onClick={() => onChange({ company: "", biltyNo: "", truckNo: "", consignor: "", consignee: "", dateFrom: "", dateTo: "" })}
// // // // // //         >
// // // // // //           Clear
// // // // // //         </button>
// // // // // //       </div>
// // // // // //     </div>
// // // // // //   );
// // // // // // };

// // // // // // // ─── Delete Confirm Modal ─────────────────────────────────────────────────────

// // // // // // const DeleteConfirmModal: React.FC<{
// // // // // //   id: number | null;
// // // // // //   bilty: string;
// // // // // //   onConfirm: () => void;
// // // // // //   onCancel: () => void;
// // // // // // }> = ({ id, bilty, onConfirm, onCancel }) => {
// // // // // //   if (id === null) return null;
// // // // // //   return (
// // // // // //     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
// // // // // //       <div className="bg-white rounded-2xl border border-slate-200 p-6 w-[340px] shadow-lg">
// // // // // //         <h3 className="text-[15px] font-medium text-slate-900 mb-2">Delete consignment?</h3>
// // // // // //         <p className="text-xs text-slate-500 mb-5 leading-relaxed">
// // // // // //           You are about to permanently delete <strong>{bilty}</strong>. This action cannot be undone and all associated data will be removed.
// // // // // //         </p>
// // // // // //         <div className="flex gap-3 justify-end">
// // // // // //           <button onClick={onCancel} className="text-xs px-4 py-1.5 border border-slate-200 rounded-lg text-slate-600 hover:bg-slate-50 transition-colors">
// // // // // //             Cancel
// // // // // //           </button>
// // // // // //           <button onClick={onConfirm} className="text-xs px-4 py-1.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
// // // // // //             Delete
// // // // // //           </button>
// // // // // //         </div>
// // // // // //       </div>
// // // // // //     </div>
// // // // // //   );
// // // // // // };

// // // // // // // ─── Main Dashboard ───────────────────────────────────────────────────────────

// // // // // // const ConsignorDashboard: React.FC = () => {
// // // // // //   const navigate = useNavigate();
// // // // // //   const [consignments, setConsignments] = useState<APIConsignment[]>([]);
// // // // // //   const [loading, setLoading] = useState(false);
// // // // // //   const [error, setError] = useState<string | null>(null);
// // // // // //   const [activeFilter, setActiveFilter] = useState<FilterOption>("all");
// // // // // //   const [resolvedRows, setResolvedRows] = useState<Record<number, ResolvedRow>>({});
// // // // // //   const [deleteTarget, setDeleteTarget] = useState<{ id: number; bilty: string } | null>(null);
// // // // // //   const companyCache: Record<number, string> = {};

// // // // // //   const [filters, setFilters] = useState<FiltersState>({
// // // // // //     company: "", biltyNo: "", truckNo: "", consignor: "", consignee: "", dateFrom: "", dateTo: "",
// // // // // //   });

// // // // // //   async function fetchCompanyName(id: number): Promise<string> {
// // // // // //     if (companyCache[id]) return companyCache[id];
// // // // // //     try {
// // // // // //       const res = await fetch(`${API_BASE}/companyauth/company/${id}`);
// // // // // //       if (!res.ok) throw new Error();
// // // // // //       const data = await res.json();
// // // // // //       companyCache[id] = data.name || data.company_name || `Company#${id}`;
// // // // // //     } catch {
// // // // // //       companyCache[id] = `Company#${id}`;
// // // // // //     }
// // // // // //     return companyCache[id];
// // // // // //   }

// // // // // //   useEffect(() => {
// // // // // //     setLoading(true);
// // // // // //     setError(null);

// // // // // //     fetch(`${API_BASE}/invoiceapi/invoice`)
// // // // // //       .then((res) => res.json())
// // // // // //       .then(async (data) => {
// // // // // //         if (!Array.isArray(data)) { setConsignments([]); return; }

// // // // // //         const mapped: APIConsignment[] = data.map((c: any) => ({
// // // // // //           id: c.id,
// // // // // //           sender: c.sender,
// // // // // //           company: c.company,
// // // // // //           receiver: c.receiver,
// // // // // //           transporter: c.transporter,
// // // // // //           driver: c.driver,
// // // // // //           vehicles: c.vehicles,
// // // // // //           payment: c.payment,
// // // // // //           source: c.source,
// // // // // //           destination: c.destination,
// // // // // //           receiverAmountStatatus: c.receiverAmountStatatus,
// // // // // //           senderAmountStatatus: c.senderAmountStatatus,
// // // // // //           transporterAmountStatatus: c.transporterAmountStatatus,
// // // // // //           paymentStatus: c.paymentStatus,
// // // // // //           paymentPayableConsignor: c.paymentPayableConsignor,
// // // // // //           ItemsDescription: c.ItemsDescription,
// // // // // //           InvoiceNo: c["InvoiceNo"] ?? c["InvoiceNo."] ?? "",
// // // // // //           "InvoiceNo.": c["InvoiceNo."],
// // // // // //           EWAYBILLNO: c.EWAYBILLNO,
// // // // // //           subjects: c.subjects,
// // // // // //           link: c.link ?? c.invoiceLink,
// // // // // //           status: c.status ?? undefined,
// // // // // //           biltyNo: c.biltyNo ?? c["InvoiceNo"] ?? c["InvoiceNo."] ?? "",
// // // // // //           created_at: c.created_at ?? "",
// // // // // //           totalamount: c.totalamount ?? null,
// // // // // //         }));

// // // // // //         const senderIds   = [...new Set(mapped.map(c => c.sender).filter(Boolean))];
// // // // // //         const receiverIds = [...new Set(mapped.map(c => c.receiver).filter(Boolean))];
// // // // // //         const vehicleIds  = [...new Set(mapped.map(c => c.vehicles).filter(Boolean))];
// // // // // //         const companyIds  = [...new Set(mapped.map(c => c.company).filter(Boolean))];
// // // // // //         const invoiceDbIds = [...new Set(mapped.map(c => String(c.id)).filter(Boolean))];

// // // // // //         await Promise.allSettled([
// // // // // //           ...senderIds.map(fetchUserName),
// // // // // //           ...receiverIds.map(fetchUserName),
// // // // // //           ...vehicleIds.map(fetchVehicleNumber),
// // // // // //           ...companyIds.map(fetchCompanyName),
// // // // // //           ...invoiceDbIds.map(fetchInvoiceItems),
// // // // // //         ]);

// // // // // //         const resolved: Record<number, ResolvedRow> = {};
// // // // // //         for (const c of mapped) {
// // // // // //           const items = itemsCache[String(c.id)] ?? [];
// // // // // //           const { totalWeight, biltyRate, totalItemAmount } = computeItemStats(items);
// // // // // //           resolved[c.id] = {
// // // // // //             consignorName: c.sender ? userCache[c.sender] || `User#${c.sender}` : "-",
// // // // // //             consigneeName: c.receiver ? userCache[c.receiver] || `User#${c.receiver}` : "-",
// // // // // //             truckNo: c.vehicles ? vehicleCache[c.vehicles] || `Vehicle#${c.vehicles}` : "-",
// // // // // //             companyName: c.company ? companyCache[c.company] || `Company#${c.company}` : "-",
// // // // // //             totalWeight,
// // // // // //             biltyRate,
// // // // // //             totalItemAmount,
// // // // // //           };
// // // // // //         }
// // // // // //         setResolvedRows(resolved);
// // // // // //         setConsignments(mapped);
// // // // // //       })
// // // // // //       .catch(() => setError("Unable to fetch consignments"))
// // // // // //       .finally(() => setLoading(false));
// // // // // //   }, []);

// // // // // //   // ── Invoice action handlers ──
// // // // // //   const handleViewInvoice = useCallback((c: APIConsignment) => {
// // // // // //     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
// // // // // //     if (url) window.open(url, "_blank");
// // // // // //   }, []);

// // // // // //   const handleDownloadInvoice = useCallback((c: APIConsignment) => {
// // // // // //     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
// // // // // //     if (!url) return;
// // // // // //     const a = document.createElement("a");
// // // // // //     a.href = url;
// // // // // //     a.download = `Invoice_${getInvoiceNo(c) || c.EWAYBILLNO || c.id}`;
// // // // // //     document.body.appendChild(a);
// // // // // //     a.click();
// // // // // //     document.body.removeChild(a);
// // // // // //   }, []);

// // // // // //   const handleShareInvoice = useCallback((c: APIConsignment) => {
// // // // // //     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
// // // // // //     if (!url) return;
// // // // // //     if (navigator.share) {
// // // // // //       navigator.share({ title: `Invoice ${getInvoiceNo(c)}`, url });
// // // // // //     } else {
// // // // // //       navigator.clipboard.writeText(url);
// // // // // //       alert("Invoice link copied!");
// // // // // //     }
// // // // // //   }, []);

// // // // // //   const handleEdit = useCallback((id: number) => {
// // // // // //     navigate(`/admin/edit/consignments/${id}`);
// // // // // //   }, [navigate]);

// // // // // //   const handleDeleteRequest = useCallback((id: number) => {
// // // // // //     const c = consignments.find(x => x.id === id);
// // // // // //     setDeleteTarget({ id, bilty: c?.biltyNo || getInvoiceNo(c!) || String(id) });
// // // // // //   }, [consignments]);

// // // // // //   const handleDeleteConfirm = useCallback(async () => {
// // // // // //     if (!deleteTarget) return;
// // // // // //     const { id } = deleteTarget;
// // // // // //     setDeleteTarget(null);
// // // // // //     try {
// // // // // //       const res = await fetch(`${API_BASE}/invoiceapi/invoice/${id}`, { method: "DELETE" });
// // // // // //       if (res.ok || res.status === 404) {
// // // // // //         setConsignments(prev => prev.filter(c => c.id !== id));
// // // // // //       } else {
// // // // // //         const err = await res.json();
// // // // // //         alert(`Failed to delete: ${err.error || "Unknown error"}`);
// // // // // //       }
// // // // // //     } catch (e: any) {
// // // // // //       alert(`Failed to delete: ${e?.message || e}`);
// // // // // //     }
// // // // // //   }, [deleteTarget]);

// // // // // //   // ── Dropdown options ──
// // // // // //   const companyOptions = [...new Set(Object.values(resolvedRows).map(r => r.companyName).filter(v => v && v !== "-"))];
// // // // // //   const biltyOptions = [...new Set(consignments.map(c => c.biltyNo || getInvoiceNo(c)).filter(Boolean))];
// // // // // //   const truckOptions = [...new Set(Object.values(resolvedRows).map(r => r.truckNo).filter(v => v && v !== "-"))];
// // // // // //   const consignorOptions = [...new Set(Object.values(resolvedRows).map(r => r.consignorName).filter(v => v && v !== "-"))];
// // // // // //   const consigneeOptions = [...new Set(Object.values(resolvedRows).map(r => r.consigneeName).filter(v => v && v !== "-"))];

// // // // // //   // ── Filtering + sorting ──
// // // // // //   const filtered = consignments
// // // // // //     .filter((c) => {
// // // // // //       const row = resolvedRows[c.id];
// // // // // //       if (activeFilter !== "all" && getConsignmentStatus(c) !== activeFilter) return false;
// // // // // //       if (filters.company && row && row.companyName !== filters.company) return false;
// // // // // //       if (filters.biltyNo) {
// // // // // //         const q = filters.biltyNo.toLowerCase();
// // // // // //         const bn = (c.biltyNo || getInvoiceNo(c) || "").toLowerCase();
// // // // // //         if (!bn.includes(q)) return false;
// // // // // //       }
// // // // // //       if (filters.truckNo && row) {
// // // // // //         if (!String(row.truckNo || "").toLowerCase().includes(filters.truckNo.toLowerCase())) return false;
// // // // // //       }
// // // // // //       if (filters.consignor && row) {
// // // // // //         if (!String(row.consignorName || "").toLowerCase().includes(filters.consignor.toLowerCase())) return false;
// // // // // //       }
// // // // // //       if (filters.consignee && row) {
// // // // // //         if (!String(row.consigneeName || "").toLowerCase().includes(filters.consignee.toLowerCase())) return false;
// // // // // //       }
// // // // // //       if (filters.dateFrom && c.created_at) {
// // // // // //         if (new Date(c.created_at).toISOString().slice(0, 10) < filters.dateFrom) return false;
// // // // // //       }
// // // // // //       if (filters.dateTo && c.created_at) {
// // // // // //         if (new Date(c.created_at).toISOString().slice(0, 10) > filters.dateTo) return false;
// // // // // //       }
// // // // // //       return true;
// // // // // //     })
// // // // // //     .sort((a, b) => {
// // // // // //       const ba = (a.biltyNo || getInvoiceNo(a) || "").toString();
// // // // // //       const bb = (b.biltyNo || getInvoiceNo(b) || "").toString();
// // // // // //       const cmp = ba.localeCompare(bb, undefined, { numeric: true, sensitivity: "base" });
// // // // // //       if (cmp !== 0) return cmp;
// // // // // //       return (a.created_at ? new Date(a.created_at).getTime() : 0) -
// // // // // //              (b.created_at ? new Date(b.created_at).getTime() : 0);
// // // // // //     });

// // // // // //   const stats = [
// // // // // //     { label: "Total",      value: consignments.length,                                              color: "#185FA5" },
// // // // // //     { label: "Pending",    value: consignments.filter(c => getConsignmentStatus(c) === "pending").length,    color: "#854F0B" },
// // // // // //     { label: "In transit", value: consignments.filter(c => getConsignmentStatus(c) === "in_transit").length, color: "#534AB7" },
// // // // // //     { label: "Delivered",  value: consignments.filter(c => getConsignmentStatus(c) === "delivered").length,  color: "#3B6D11" },
// // // // // //   ];

// // // // // //   // ── Table column headers ──
// // // // // //   const HEADERS = ["#", "Date · Bilty", "Company", "Route", "Parties", "Truck", "Wt / Rate / Amt", "Status", "Actions"];

// // // // // //   return (
// // // // // //     <div className="p-4 md:p-6 space-y-4">
// // // // // //       {/* Stats */}
// // // // // //       <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
// // // // // //         {stats.map(s => <DashboardStatCard key={s.label} {...s} />)}
// // // // // //       </div>

// // // // // //       {/* Panel */}
// // // // // //       <div className="bg-white border border-slate-100 rounded-2xl p-4">
// // // // // //         <div className="flex items-center justify-between mb-3">
// // // // // //           <div>
// // // // // //             <h2 className="text-[16px] font-medium text-slate-900">My Consignments</h2>
// // // // // //             <p className="text-xs text-slate-400">View and manage your consignments &amp; invoices</p>
// // // // // //           </div>
// // // // // //           <button
// // // // // //             className="text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
// // // // // //             onClick={() => navigate("/admin/add/consignments")}
// // // // // //           >
// // // // // //             + New Consignment
// // // // // //           </button>
// // // // // //         </div>

// // // // // //         {/* Status pills */}
// // // // // //         <div className="flex flex-wrap gap-1.5 mb-4">
// // // // // //           {FILTER_OPTIONS.map(({ key, label }) => (
// // // // // //             <button
// // // // // //               key={key}
// // // // // //               onClick={() => setActiveFilter(key)}
// // // // // //               className={`text-xs px-3 py-1 rounded-full border transition-colors ${
// // // // // //                 activeFilter === key
// // // // // //                   ? "bg-slate-900 text-white border-transparent"
// // // // // //                   : "border-slate-200 text-slate-500 hover:bg-slate-50"
// // // // // //               }`}
// // // // // //             >
// // // // // //               {label}
// // // // // //             </button>
// // // // // //           ))}
// // // // // //         </div>

// // // // // //         <AdvancedFilters
// // // // // //           filters={filters}
// // // // // //           onChange={setFilters}
// // // // // //           companyOptions={companyOptions}
// // // // // //           biltyOptions={biltyOptions}
// // // // // //           truckOptions={truckOptions}
// // // // // //           consignorOptions={consignorOptions}
// // // // // //           consigneeOptions={consigneeOptions}
// // // // // //         />

// // // // // //         {/* Table */}
// // // // // //         <div className="overflow-x-auto">
// // // // // //           <table className="w-full text-[12px]" style={{ minWidth: 820 }}>
// // // // // //             <thead>
// // // // // //               <tr className="border-b border-slate-100">
// // // // // //                 {HEADERS.map(h => (
// // // // // //                   <th key={h} className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap text-[10px]">{h}</th>
// // // // // //                 ))}
// // // // // //               </tr>
// // // // // //             </thead>
// // // // // //             <tbody>
// // // // // //               {loading ? (
// // // // // //                 <tr><td colSpan={9} className="py-6 text-center text-slate-400">Loading…</td></tr>
// // // // // //               ) : error ? (
// // // // // //                 <tr><td colSpan={9} className="py-6 text-center text-red-600">{error}</td></tr>
// // // // // //               ) : filtered.length === 0 ? (
// // // // // //                 <tr><td colSpan={9} className="py-8 text-center text-slate-400">No consignments found.</td></tr>
// // // // // //               ) : (
// // // // // //                 filtered.map((c, idx) => {
// // // // // //                   const row = resolvedRows[c.id];
// // // // // //                   const palKey = paletteForCompany(c.company);
// // // // // //                   const pal = PALETTE[palKey];
// // // // // //                   const hasInvoice = !!c.link;

// // // // // //                   return (
// // // // // //                     <tr
// // // // // //                       key={c.id}
// // // // // //                       className="border-b border-slate-100 transition-all"
// // // // // //                       style={{ background: pal.row }}
// // // // // //                     >
// // // // // //                       {/* # */}
// // // // // //                       <td className="py-2 px-3 text-slate-400 text-[11px]">{idx + 1}</td>

// // // // // //                       {/* Date · Bilty */}
// // // // // //                       <td className="py-2 px-3">
// // // // // //                         <div className="flex flex-col gap-0.5">
// // // // // //                           <span className="text-slate-900 font-medium">{c.biltyNo || getInvoiceNo(c) || "-"}</span>
// // // // // //                           <span className="text-[10px] text-slate-400">
// // // // // //                             {c.created_at ? new Date(c.created_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "2-digit" }) : "-"}
// // // // // //                           </span>
// // // // // //                         </div>
// // // // // //                       </td>

// // // // // //                       {/* Company */}
// // // // // //                       <td className="py-2 px-3">
// // // // // //                         {row
// // // // // //                           ? <CompanyTag companyId={c.company} companyName={row.companyName} />
// // // // // //                           : <LoadingCell />}
// // // // // //                       </td>

// // // // // //                       {/* Route */}
// // // // // //                       <td className="py-2 px-3">
// // // // // //                         <div className="flex flex-col gap-0.5">
// // // // // //                           <span className="text-slate-800 text-[11px]">{c.source || "-"}</span>
// // // // // //                           <span className="text-[10px] text-slate-400">→ {c.destination || "-"}</span>
// // // // // //                         </div>
// // // // // //                       </td>

// // // // // //                       {/* Parties */}
// // // // // //                       <td className="py-2 px-3">
// // // // // //                         {row ? (
// // // // // //                           <div className="flex flex-col gap-0.5">
// // // // // //                             <span className="text-slate-800 text-[11px]">{row.consignorName}</span>
// // // // // //                             <span className="text-[10px] text-slate-400">→ {row.consigneeName}</span>
// // // // // //                           </div>
// // // // // //                         ) : <LoadingCell />}
// // // // // //                       </td>

// // // // // //                       {/* Truck */}
// // // // // //                       <td className="py-2 px-3 text-slate-500 text-[11px] whitespace-nowrap">
// // // // // //                         {row ? row.truckNo : <LoadingCell />}
// // // // // //                       </td>

// // // // // //                       {/* Wt / Rate / Amt */}
// // // // // //                       <td className="py-2 px-3">
// // // // // //                         {row ? (
// // // // // //                           <div className="flex flex-col gap-0.5">
// // // // // //                             <span className="text-[10px] text-slate-400">
// // // // // //                               {fmt(row.totalWeight)} TON &nbsp;@&nbsp; ₹{fmt(row.biltyRate, 2)}/TON
// // // // // //                             </span>
// // // // // //                             <span className="text-slate-900 font-medium">
// // // // // //                               {row.totalItemAmount != null
// // // // // //                                 ? `₹ ${fmt(row.totalItemAmount, 0)} /-`
// // // // // //                                 : c.totalamount != null
// // // // // //                                 ? `₹ ${fmt(c.totalamount, 0)} /-`
// // // // // //                                 : c.payment
// // // // // //                                 ? `₹ ${fmt(Number(c.payment), 0)} /-`
// // // // // //                                 : "-"}
// // // // // //                             </span>
// // // // // //                           </div>
// // // // // //                         ) : <LoadingCell />}
// // // // // //                       </td>

// // // // // //                       {/* Status */}
// // // // // //                       <td className="py-2 px-3 whitespace-nowrap">
// // // // // //                         <StatusBadge status={getConsignmentStatus(c)} />
// // // // // //                       </td>

// // // // // //                       {/* Actions — single dropdown */}
// // // // // //                       <td className="py-2 px-3 whitespace-nowrap">
// // // // // //                         <ActionMenu
// // // // // //                           consignment={c}
// // // // // //                           hasInvoice={hasInvoice}
// // // // // //                           onEdit={handleEdit}
// // // // // //                           onDelete={handleDeleteRequest}
// // // // // //                           onViewInvoice={handleViewInvoice}
// // // // // //                           onDownloadInvoice={handleDownloadInvoice}
// // // // // //                           onShareInvoice={handleShareInvoice}
// // // // // //                         />
// // // // // //                       </td>
// // // // // //                     </tr>
// // // // // //                   );
// // // // // //                 })
// // // // // //               )}
// // // // // //             </tbody>
// // // // // //           </table>
// // // // // //         </div>
// // // // // //       </div>

// // // // // //       {/* Delete confirm modal */}
// // // // // //       <DeleteConfirmModal
// // // // // //         id={deleteTarget?.id ?? null}
// // // // // //         bilty={deleteTarget?.bilty ?? ""}
// // // // // //         onConfirm={handleDeleteConfirm}
// // // // // //         onCancel={() => setDeleteTarget(null)}
// // // // // //       />
// // // // // //     </div>
// // // // // //   );
// // // // // // };

// // // // // // export default ConsignorDashboard;

// // // // // import React, { useState, useEffect, useRef, useCallback } from "react";
// // // // // import ReactDOM from "react-dom";
// // // // // import { useNavigate } from "react-router-dom";

// // // // // // ─── Types ────────────────────────────────────────────────────────────────────

// // // // // type ShipmentStatus = "pending" | "in_transit" | "delivered" | "draft" | "created" | "dispatched" | "cancelled";
// // // // // type FilterOption = "all" | ShipmentStatus;

// // // // // const API_BASE = process.env.REACT_APP_API_URL;

// // // // // interface APIConsignment {
// // // // //   id: number;
// // // // //   sender: number;
// // // // //   company: number;
// // // // //   receiver: number;
// // // // //   transporter: number;
// // // // //   driver: number;
// // // // //   vehicles: number;
// // // // //   payment: string;
// // // // //   source: string;
// // // // //   destination: string;
// // // // //   receiverAmountStatatus: string;
// // // // //   senderAmountStatatus: string;
// // // // //   transporterAmountStatatus: string;
// // // // //   paymentStatus: string;
// // // // //   paymentPayableConsignor: number;
// // // // //   ItemsDescription: string;
// // // // //   "InvoiceNo"?: string;
// // // // //   "InvoiceNo."?: string;
// // // // //   EWAYBILLNO: string;
// // // // //   subjects: string;
// // // // //   link?: string;
// // // // //   status?: ShipmentStatus;
// // // // //   biltyNo?: string;
// // // // //   created_at?: string;
// // // // //   totalamount?: number;
// // // // // }

// // // // // interface InvoiceItem {
// // // // //   rate: number;
// // // // //   id: number;
// // // // //   invoiceId: string;
// // // // //   description: string;
// // // // //   hsm_code: string;
// // // // //   uom: string;
// // // // //   qty: number;
// // // // //   amount: number;
// // // // // }

// // // // // interface ResolvedRow {
// // // // //   consignorName: string;
// // // // //   consigneeName: string;
// // // // //   truckNo: string;
// // // // //   companyName: string;
// // // // //   totalWeight: number | null;
// // // // //   biltyRate: number | null;
// // // // //   totalItemAmount: number | null;
// // // // // }

// // // // // type FiltersState = {
// // // // //   company: string;
// // // // //   biltyNo: string;
// // // // //   truckNo: string;
// // // // //   consignor: string;
// // // // //   consignee: string;
// // // // //   dateFrom: string;
// // // // //   dateTo: string;
// // // // // };

// // // // // // ─── Caches ───────────────────────────────────────────────────────────────────

// // // // // const userCache: Record<number, string> = {};
// // // // // const vehicleCache: Record<number, string> = {};
// // // // // const itemsCache: Record<string, InvoiceItem[]> = {};

// // // // // // ─── Helpers ──────────────────────────────────────────────────────────────────

// // // // // async function fetchUserName(id: number): Promise<string> {
// // // // //   if (userCache[id]) return userCache[id];
// // // // //   try {
// // // // //     const res = await fetch(`${API_BASE}/auth/user/${id}`);
// // // // //     if (!res.ok) throw new Error();
// // // // //     const data = await res.json();
// // // // //     userCache[id] = data.name || `User#${id}`;
// // // // //   } catch {
// // // // //     userCache[id] = `User#${id}`;
// // // // //   }
// // // // //   return userCache[id];
// // // // // }

// // // // // async function fetchVehicleNumber(id: number): Promise<string> {
// // // // //   if (vehicleCache[id]) return vehicleCache[id];
// // // // //   try {
// // // // //     const res = await fetch(`${API_BASE}/auth/vehicles/${id}`);
// // // // //     if (!res.ok) throw new Error();
// // // // //     const data = await res.json();
// // // // //     vehicleCache[id] = data.registration_number || data.vehicle_number || `Vehicle#${id}`;
// // // // //   } catch {
// // // // //     vehicleCache[id] = `Vehicle#${id}`;
// // // // //   }
// // // // //   return vehicleCache[id];
// // // // // }

// // // // // async function fetchInvoiceItems(invoiceDbId: string): Promise<InvoiceItem[]> {
// // // // //   if (itemsCache[invoiceDbId]) return itemsCache[invoiceDbId];
// // // // //   try {
// // // // //     const res = await fetch(`${API_BASE}/invoiceapi/invoice_items/invoice-db/${invoiceDbId}`);
// // // // //     if (!res.ok) throw new Error();
// // // // //     const data: InvoiceItem[] = await res.json();
// // // // //     itemsCache[invoiceDbId] = Array.isArray(data) ? data : [];
// // // // //   } catch {
// // // // //     itemsCache[invoiceDbId] = [];
// // // // //   }
// // // // //   return itemsCache[invoiceDbId];
// // // // // }

// // // // // function computeItemStats(items: InvoiceItem[]) {
// // // // //   if (!items.length) return { totalWeight: null, biltyRate: null, totalItemAmount: null };
// // // // //   const totalWeight = items.reduce((s, i) => s + Number(i.qty || 0), 0);
// // // // //   const totalAmount = items.reduce((s, i) => s + Number(i.amount || 0), 0);
// // // // //   const totalRates = items.reduce((s, i) => s + Number(i.rate || 0), 0);
// // // // //   return { totalWeight, biltyRate: totalRates, totalItemAmount: totalAmount };
// // // // // }

// // // // // function fmt(val: number | null | undefined, decimals = 2): string {
// // // // //   if (val == null) return "-";
// // // // //   return val % 1 === 0 ? String(val) : val.toFixed(decimals);
// // // // // }

// // // // // const getInvoiceNo = (c: APIConsignment): string =>
// // // // //   c.InvoiceNo || (c as any)["InvoiceNo."] || "";

// // // // // const getConsignmentStatus = (c: APIConsignment): ShipmentStatus => {
// // // // //   if (c.status) return c.status;
// // // // //   if (c.paymentStatus === "to_pay" || c.paymentStatus === "credit") return "pending";
// // // // //   if (c.paymentStatus === "paid") return "delivered";
// // // // //   return "pending";
// // // // // };

// // // // // /** Generate a short abbreviation from a company name, e.g. "Amit Traders & Co." → "ATC" */
// // // // // function companyAbbr(name: string): string {
// // // // //   const NOISE = /^(pvt|ltd|co|inc|corp|private|limited|and|the|of|&)$/i;
// // // // //   const words = name.split(/[\s&,\.]+/).filter(Boolean);
// // // // //   const meaningful = words.filter((w) => w.length > 1 && !NOISE.test(w));
// // // // //   const src = meaningful.length >= 2 ? meaningful : words;
// // // // //   return src
// // // // //     .map((w) => w[0].toUpperCase())
// // // // //     .slice(0, 3)
// // // // //     .join("");
// // // // // }

// // // // // /** Assign a stable palette color to a company id */
// // // // // const PALETTE_KEYS = ["blue", "teal", "amber", "coral", "purple", "pink"] as const;
// // // // // type PaletteKey = typeof PALETTE_KEYS[number];

// // // // // const PALETTE: Record<PaletteKey, { bg: string; text: string; row: string }> = {
// // // // //   blue:   { bg: "#E3F2FD", text: "#1565C0", row: "rgba(21, 101, 192, 0.07)" },
// // // // //   teal:   { bg: "#E0F2F1", text: "#00897B", row: "rgba(0, 137, 123, 0.08)" },
// // // // //   amber:  { bg: "#FFF8E1", text: "#FF8F00", row: "rgba(255, 143, 0, 0.08)" },
// // // // //   coral:  { bg: "#FFCCBC", text: "#D84315", row: "rgba(216, 67, 21, 0.08)" },
// // // // //   purple: { bg: "#F3E5F5", text: "#7C4DFF", row: "rgba(124, 77, 255, 0.07)" },
// // // // //   pink:   { bg: "#FCE4EC", text: "#C2185B", row: "rgba(194, 24, 91, 0.09)" },
// // // // // };

// // // // // function paletteForCompany(companyId: number): PaletteKey {
// // // // //   return PALETTE_KEYS[companyId % PALETTE_KEYS.length];
// // // // // }

// // // // // // ─── Constants ────────────────────────────────────────────────────────────────

// // // // // const FILTER_OPTIONS: { key: FilterOption; label: string }[] = [
// // // // //   { key: "all", label: "All" },
// // // // //   { key: "pending", label: "Pending" },
// // // // //   { key: "in_transit", label: "In transit" },
// // // // //   { key: "delivered", label: "Delivered" },
// // // // //   { key: "draft", label: "Draft" },
// // // // // ];

// // // // // const STATUS_STYLES: Record<string, string> = {
// // // // //   pending:    "bg-amber-100 text-amber-900",
// // // // //   in_transit: "bg-blue-100 text-blue-900",
// // // // //   delivered:  "bg-green-100 text-green-900",
// // // // //   draft:      "bg-slate-100 text-slate-600",
// // // // //   created:    "bg-slate-100 text-slate-900",
// // // // //   dispatched: "bg-amber-100 text-amber-800",
// // // // //   cancelled:  "bg-red-100 text-red-900",
// // // // // };

// // // // // const STATUS_LABELS: Record<string, string> = {
// // // // //   pending: "Pending", in_transit: "In transit", delivered: "Delivered",
// // // // //   draft: "Draft", created: "Created", dispatched: "Dispatched", cancelled: "Cancelled",
// // // // // };

// // // // // // ─── Sub-components ───────────────────────────────────────────────────────────

// // // // // const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
// // // // //   <span className={`text-[9px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${STATUS_STYLES[status] || "bg-slate-100 text-slate-900"}`}>
// // // // //     {STATUS_LABELS[status] || status}
// // // // //   </span>
// // // // // );

// // // // // const DashboardStatCard: React.FC<{ label: string; value: number; color: string }> = ({ label, value, color }) => (
// // // // //   <div className="rounded-xl bg-slate-50 p-4 flex flex-col justify-center items-center">
// // // // //     <span className="text-[26px] font-semibold mb-1" style={{ color }}>{value}</span>
// // // // //     <span className="text-xs font-medium text-slate-500">{label}</span>
// // // // //   </div>
// // // // // );

// // // // // const LoadingCell = () => (
// // // // //   <span className="text-slate-300 animate-pulse text-xs">Loading…</span>
// // // // // );

// // // // // // ─── Company Tag ──────────────────────────────────────────────────────────────

// // // // // const CompanyTag: React.FC<{ companyId: number; companyName: string }> = ({ companyId, companyName }) => {
// // // // //   const key = paletteForCompany(companyId);
// // // // //   const pal = PALETTE[key];
// // // // //   const abbr = companyAbbr(companyName);
// // // // //   return (
// // // // //     <span
// // // // //       title={companyName}
// // // // //       className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold cursor-default whitespace-nowrap"
// // // // //       style={{ background: pal.bg, color: pal.text }}
// // // // //     >
// // // // //       {abbr}
// // // // //     </span>
// // // // //   );
// // // // // };

// // // // // // ─── Action Dropdown (portal-based — escapes overflow:auto clipping) ──────────

// // // // // interface ActionMenuProps {
// // // // //   consignment: APIConsignment;
// // // // //   hasInvoice: boolean;
// // // // //   onEdit: (id: number) => void;
// // // // //   onDelete: (id: number) => void;
// // // // //   onViewInvoice: (c: APIConsignment) => void;
// // // // //   onDownloadInvoice: (c: APIConsignment) => void;
// // // // //   onShareInvoice: (c: APIConsignment) => void;
// // // // // }

// // // // // /**
// // // // //  * Measures the trigger button's position and renders the dropdown menu
// // // // //  * via a React portal into document.body — so it is never clipped by
// // // // //  * overflow:auto / overflow:hidden ancestors (e.g. the table scroll wrapper).
// // // // //  * The menu auto-flips above the button when it would overflow the viewport bottom.
// // // // //  */
// // // // // const ActionMenu: React.FC<ActionMenuProps> = ({
// // // // //   consignment, hasInvoice, onEdit, onDelete, onViewInvoice, onDownloadInvoice, onShareInvoice,
// // // // // }) => {
// // // // //   const [open, setOpen] = useState(false);
// // // // //   const [menuStyle, setMenuStyle] = useState<React.CSSProperties>({});
// // // // //   const triggerRef = useRef<HTMLButtonElement>(null);
// // // // //   const menuRef = useRef<HTMLDivElement>(null);

// // // // //   const MENU_WIDTH = 184;
// // // // //   const MENU_HEIGHT_APPROX = 230; // used only for flip detection before actual render

// // // // //   const reposition = useCallback(() => {
// // // // //     if (!triggerRef.current) return;
// // // // //     const r = triggerRef.current.getBoundingClientRect();
// // // // //     const spaceBelow = window.innerHeight - r.bottom;
// // // // //     const flipUp = spaceBelow < MENU_HEIGHT_APPROX && r.top > MENU_HEIGHT_APPROX;

// // // // //     // Align right edge of menu with right edge of trigger; clamp to viewport left
// // // // //     const right = window.innerWidth - r.right;
// // // // //     setMenuStyle({
// // // // //       position: "fixed",
// // // // //       top: flipUp ? r.top - 4 : r.bottom + 4,
// // // // //       right,
// // // // //       width: MENU_WIDTH,
// // // // //       transform: flipUp ? "translateY(-100%)" : "none",
// // // // //       zIndex: 9999,
// // // // //     });
// // // // //   }, []);

// // // // //   const toggleOpen = () => {
// // // // //     if (!open) reposition();
// // // // //     setOpen((v) => !v);
// // // // //   };

// // // // //   // Close on outside click or scroll
// // // // //   useEffect(() => {
// // // // //     if (!open) return;
// // // // //     const close = (e: MouseEvent) => {
// // // // //       if (
// // // // //         menuRef.current && !menuRef.current.contains(e.target as Node) &&
// // // // //         triggerRef.current && !triggerRef.current.contains(e.target as Node)
// // // // //       ) setOpen(false);
// // // // //     };
// // // // //     const onScroll = () => {
// // // // //       reposition();
// // // // //     };
// // // // //     document.addEventListener("mousedown", close);
// // // // //     window.addEventListener("scroll", onScroll, true); // capture phase catches nested scrollers
// // // // //     return () => {
// // // // //       document.removeEventListener("mousedown", close);
// // // // //       window.removeEventListener("scroll", onScroll, true);
// // // // //     };
// // // // //   }, [open, reposition]);

// // // // //   const invoiceDisabled = !hasInvoice;
// // // // //   const btnCls = "flex items-center gap-2 w-full px-3 py-[7px] text-[12px] text-left hover:bg-slate-50 transition-colors whitespace-nowrap";
// // // // //   const disabledCls = "opacity-40 cursor-not-allowed pointer-events-none";

// // // // //   const menu = open ? (
// // // // //     <div
// // // // //       ref={menuRef}
// // // // //       style={menuStyle}
// // // // //       className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-md"
// // // // //     >
// // // // //       {/* Invoice section */}
// // // // //       <div className="border-b border-slate-100 py-1">
// // // // //         <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1">Invoice</p>
// // // // //         <button
// // // // //           className={`${btnCls} text-blue-800 ${invoiceDisabled ? disabledCls : ""}`}
// // // // //           disabled={invoiceDisabled}
// // // // //           onClick={() => { setOpen(false); onViewInvoice(consignment); }}
// // // // //         >
// // // // //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
// // // // //           View invoice
// // // // //           {invoiceDisabled && <span className="ml-auto text-[9px] text-slate-400">No file</span>}
// // // // //         </button>
// // // // //         <button
// // // // //           className={`${btnCls} text-green-800 ${invoiceDisabled ? disabledCls : ""}`}
// // // // //           disabled={invoiceDisabled}
// // // // //           onClick={() => { setOpen(false); onDownloadInvoice(consignment); }}
// // // // //         >
// // // // //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
// // // // //           Download PDF
// // // // //         </button>
// // // // //         <button
// // // // //           className={`${btnCls} text-purple-800 ${invoiceDisabled ? disabledCls : ""}`}
// // // // //           disabled={invoiceDisabled}
// // // // //           onClick={() => { setOpen(false); onShareInvoice(consignment); }}
// // // // //         >
// // // // //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
// // // // //           Share link
// // // // //         </button>
// // // // //       </div>
// // // // //       {/* Consignment section */}
// // // // //       <div className="py-1">
// // // // //         <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1">Consignment</p>
// // // // //         <button
// // // // //           className={`${btnCls} text-amber-800`}
// // // // //           onClick={() => { setOpen(false); onEdit(consignment.id); }}
// // // // //         >
// // // // //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
// // // // //           Edit
// // // // //         </button>
// // // // //         <button
// // // // //           className={`${btnCls} text-red-800 hover:!bg-red-50`}
// // // // //           onClick={() => { setOpen(false); onDelete(consignment.id); }}
// // // // //         >
// // // // //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
// // // // //           Delete
// // // // //         </button>
// // // // //       </div>
// // // // //     </div>
// // // // //   ) : null;

// // // // //   return (
// // // // //     <>
// // // // //       <button
// // // // //         ref={triggerRef}
// // // // //         onClick={toggleOpen}
// // // // //         className="inline-flex items-center gap-1.5 text-[11px] px-2.5 py-1 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-600 transition-colors"
// // // // //       >
// // // // //         <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
// // // // //           <circle cx="8" cy="3" r="1.4"/><circle cx="8" cy="8" r="1.4"/><circle cx="8" cy="13" r="1.4"/>
// // // // //         </svg>
// // // // //         Actions
// // // // //         <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" className="opacity-50">
// // // // //           <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
// // // // //         </svg>
// // // // //       </button>
// // // // //       {ReactDOM.createPortal(menu, document.body)}
// // // // //     </>
// // // // //   );
// // // // // };

// // // // // // ─── Advanced Filters ─────────────────────────────────────────────────────────

// // // // // const AdvancedFilters: React.FC<{
// // // // //   filters: FiltersState;
// // // // //   onChange: (f: FiltersState) => void;
// // // // //   companyOptions: string[];
// // // // //   biltyOptions: string[];
// // // // //   truckOptions: string[];
// // // // //   consignorOptions: string[];
// // // // //   consigneeOptions: string[];
// // // // // }> = ({ filters, onChange, companyOptions, biltyOptions, truckOptions, consignorOptions, consigneeOptions }) => {
// // // // //   const sel = "border rounded px-2 py-1 text-xs";
// // // // //   const inp = "border rounded px-2 py-1 text-xs mt-1 block";

// // // // //   return (
// // // // //     <div className="flex flex-wrap gap-3 mb-4">
// // // // //       <div>
// // // // //         <label className="block text-xs text-slate-500 mb-1">Company</label>
// // // // //         <select className={`${sel} w-[160px]`} value={filters.company} onChange={e => onChange({ ...filters, company: e.target.value })}>
// // // // //           <option value="">All companies</option>
// // // // //           {companyOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // // // //         </select>
// // // // //       </div>
// // // // //       <div>
// // // // //         <label className="block text-xs text-slate-500 mb-1">Bilty no.</label>
// // // // //         <select className={`${sel} w-[140px]`} value={filters.biltyNo} onChange={e => onChange({ ...filters, biltyNo: e.target.value })}>
// // // // //           <option value="">All bilty nos.</option>
// // // // //           {biltyOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // // // //         </select>
// // // // //         <input className={`${inp} w-[140px]`} placeholder="Search bilty" value={filters.biltyNo} onChange={e => onChange({ ...filters, biltyNo: e.target.value })} />
// // // // //       </div>
// // // // //       <div>
// // // // //         <label className="block text-xs text-slate-500 mb-1">Truck no.</label>
// // // // //         <select className={`${sel} w-[130px]`} value={filters.truckNo} onChange={e => onChange({ ...filters, truckNo: e.target.value })}>
// // // // //           <option value="">All trucks</option>
// // // // //           {truckOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // // // //         </select>
// // // // //         <input className={`${inp} w-[130px]`} placeholder="Search truck" value={filters.truckNo} onChange={e => onChange({ ...filters, truckNo: e.target.value })} />
// // // // //       </div>
// // // // //       <div>
// // // // //         <label className="block text-xs text-slate-500 mb-1">Consignor</label>
// // // // //         <select className={`${sel} w-[130px]`} value={filters.consignor} onChange={e => onChange({ ...filters, consignor: e.target.value })}>
// // // // //           <option value="">All consignors</option>
// // // // //           {consignorOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // // // //         </select>
// // // // //         <input className={`${inp} w-[130px]`} placeholder="Search consignor" value={filters.consignor} onChange={e => onChange({ ...filters, consignor: e.target.value })} />
// // // // //       </div>
// // // // //       <div>
// // // // //         <label className="block text-xs text-slate-500 mb-1">Consignee</label>
// // // // //         <select className={`${sel} w-[130px]`} value={filters.consignee} onChange={e => onChange({ ...filters, consignee: e.target.value })}>
// // // // //           <option value="">All consignees</option>
// // // // //           {consigneeOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // // // //         </select>
// // // // //         <input className={`${inp} w-[130px]`} placeholder="Search consignee" value={filters.consignee} onChange={e => onChange({ ...filters, consignee: e.target.value })} />
// // // // //       </div>
// // // // //       <div>
// // // // //         <label className="block text-xs text-slate-500 mb-1">Date from</label>
// // // // //         <input type="date" className={`${sel}`} value={filters.dateFrom} onChange={e => onChange({ ...filters, dateFrom: e.target.value })} />
// // // // //       </div>
// // // // //       <div>
// // // // //         <label className="block text-xs text-slate-500 mb-1">Date to</label>
// // // // //         <input type="date" className={`${sel}`} value={filters.dateTo} onChange={e => onChange({ ...filters, dateTo: e.target.value })} />
// // // // //       </div>
// // // // //       <div className="flex items-end">
// // // // //         <button
// // // // //           className="text-xs px-3 py-1 border rounded bg-slate-50 text-slate-600"
// // // // //           onClick={() => onChange({ company: "", biltyNo: "", truckNo: "", consignor: "", consignee: "", dateFrom: "", dateTo: "" })}
// // // // //         >
// // // // //           Clear
// // // // //         </button>
// // // // //       </div>
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // // ─── Delete Confirm Modal ─────────────────────────────────────────────────────

// // // // // const DeleteConfirmModal: React.FC<{
// // // // //   id: number | null;
// // // // //   bilty: string;
// // // // //   onConfirm: () => void;
// // // // //   onCancel: () => void;
// // // // // }> = ({ id, bilty, onConfirm, onCancel }) => {
// // // // //   if (id === null) return null;
// // // // //   return (
// // // // //     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
// // // // //       <div className="bg-white rounded-2xl border border-slate-200 p-6 w-[340px] shadow-lg">
// // // // //         <h3 className="text-[15px] font-medium text-slate-900 mb-2">Delete consignment?</h3>
// // // // //         <p className="text-xs text-slate-500 mb-5 leading-relaxed">
// // // // //           You are about to permanently delete <strong>{bilty}</strong>. This action cannot be undone and all associated data will be removed.
// // // // //         </p>
// // // // //         <div className="flex gap-3 justify-end">
// // // // //           <button onClick={onCancel} className="text-xs px-4 py-1.5 border border-slate-200 rounded-lg text-slate-600 hover:bg-slate-50 transition-colors">
// // // // //             Cancel
// // // // //           </button>
// // // // //           <button onClick={onConfirm} className="text-xs px-4 py-1.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
// // // // //             Delete
// // // // //           </button>
// // // // //         </div>
// // // // //       </div>
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // // ─── Main Dashboard ───────────────────────────────────────────────────────────

// // // // // const ConsignorDashboard: React.FC = () => {
// // // // //   const navigate = useNavigate();
// // // // //   const [consignments, setConsignments] = useState<APIConsignment[]>([]);
// // // // //   const [loading, setLoading] = useState(false);
// // // // //   const [error, setError] = useState<string | null>(null);
// // // // //   const [activeFilter, setActiveFilter] = useState<FilterOption>("all");
// // // // //   const [resolvedRows, setResolvedRows] = useState<Record<number, ResolvedRow>>({});
// // // // //   const [deleteTarget, setDeleteTarget] = useState<{ id: number; bilty: string } | null>(null);
// // // // //   const companyCache: Record<number, string> = {};

// // // // //   const [filters, setFilters] = useState<FiltersState>({
// // // // //     company: "", biltyNo: "", truckNo: "", consignor: "", consignee: "", dateFrom: "", dateTo: "",
// // // // //   });

// // // // //   async function fetchCompanyName(id: number): Promise<string> {
// // // // //     if (companyCache[id]) return companyCache[id];
// // // // //     try {
// // // // //       const res = await fetch(`${API_BASE}/companyauth/company/${id}`);
// // // // //       if (!res.ok) throw new Error();
// // // // //       const data = await res.json();
// // // // //       companyCache[id] = data.name || data.company_name || `Company#${id}`;
// // // // //     } catch {
// // // // //       companyCache[id] = `Company#${id}`;
// // // // //     }
// // // // //     return companyCache[id];
// // // // //   }

// // // // //   useEffect(() => {
// // // // //     setLoading(true);
// // // // //     setError(null);

// // // // //     fetch(`${API_BASE}/invoiceapi/invoice`)
// // // // //       .then((res) => res.json())
// // // // //       .then(async (data) => {
// // // // //         if (!Array.isArray(data)) { setConsignments([]); return; }

// // // // //         const mapped: APIConsignment[] = data.map((c: any) => ({
// // // // //           id: c.id,
// // // // //           sender: c.sender,
// // // // //           company: c.company,
// // // // //           receiver: c.receiver,
// // // // //           transporter: c.transporter,
// // // // //           driver: c.driver,
// // // // //           vehicles: c.vehicles,
// // // // //           payment: c.payment,
// // // // //           source: c.source,
// // // // //           destination: c.destination,
// // // // //           receiverAmountStatatus: c.receiverAmountStatatus,
// // // // //           senderAmountStatatus: c.senderAmountStatatus,
// // // // //           transporterAmountStatatus: c.transporterAmountStatatus,
// // // // //           paymentStatus: c.paymentStatus,
// // // // //           paymentPayableConsignor: c.paymentPayableConsignor,
// // // // //           ItemsDescription: c.ItemsDescription,
// // // // //           InvoiceNo: c["InvoiceNo"] ?? c["InvoiceNo."] ?? "",
// // // // //           "InvoiceNo.": c["InvoiceNo."],
// // // // //           EWAYBILLNO: c.EWAYBILLNO,
// // // // //           subjects: c.subjects,
// // // // //           link: c.link ?? c.invoiceLink,
// // // // //           status: c.status ?? undefined,
// // // // //           biltyNo: c.biltyNo ?? c["InvoiceNo"] ?? c["InvoiceNo."] ?? "",
// // // // //           created_at: c.created_at ?? "",
// // // // //           totalamount: c.totalamount ?? null,
// // // // //         }));

// // // // //         const senderIds   = [...new Set(mapped.map(c => c.sender).filter(Boolean))];
// // // // //         const receiverIds = [...new Set(mapped.map(c => c.receiver).filter(Boolean))];
// // // // //         const vehicleIds  = [...new Set(mapped.map(c => c.vehicles).filter(Boolean))];
// // // // //         const companyIds  = [...new Set(mapped.map(c => c.company).filter(Boolean))];
// // // // //         const invoiceDbIds = [...new Set(mapped.map(c => String(c.id)).filter(Boolean))];

// // // // //         await Promise.allSettled([
// // // // //           ...senderIds.map(fetchUserName),
// // // // //           ...receiverIds.map(fetchUserName),
// // // // //           ...vehicleIds.map(fetchVehicleNumber),
// // // // //           ...companyIds.map(fetchCompanyName),
// // // // //           ...invoiceDbIds.map(fetchInvoiceItems),
// // // // //         ]);

// // // // //         const resolved: Record<number, ResolvedRow> = {};
// // // // //         for (const c of mapped) {
// // // // //           const items = itemsCache[String(c.id)] ?? [];
// // // // //           const { totalWeight, biltyRate, totalItemAmount } = computeItemStats(items);
// // // // //           resolved[c.id] = {
// // // // //             consignorName: c.sender ? userCache[c.sender] || `User#${c.sender}` : "-",
// // // // //             consigneeName: c.receiver ? userCache[c.receiver] || `User#${c.receiver}` : "-",
// // // // //             truckNo: c.vehicles ? vehicleCache[c.vehicles] || `Vehicle#${c.vehicles}` : "-",
// // // // //             companyName: c.company ? companyCache[c.company] || `Company#${c.company}` : "-",
// // // // //             totalWeight,
// // // // //             biltyRate,
// // // // //             totalItemAmount,
// // // // //           };
// // // // //         }
// // // // //         setResolvedRows(resolved);
// // // // //         setConsignments(mapped);
// // // // //       })
// // // // //       .catch(() => setError("Unable to fetch consignments"))
// // // // //       .finally(() => setLoading(false));
// // // // //   }, []);

// // // // //   // ── Invoice action handlers ──
// // // // //   const handleViewInvoice = useCallback((c: APIConsignment) => {
// // // // //     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
// // // // //     if (url) window.open(url, "_blank");
// // // // //   }, []);

// // // // //   const handleDownloadInvoice = useCallback((c: APIConsignment) => {
// // // // //     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
// // // // //     if (!url) return;
// // // // //     const a = document.createElement("a");
// // // // //     a.href = url;
// // // // //     a.download = `Invoice_${getInvoiceNo(c) || c.EWAYBILLNO || c.id}`;
// // // // //     document.body.appendChild(a);
// // // // //     a.click();
// // // // //     document.body.removeChild(a);
// // // // //   }, []);

// // // // //   const handleShareInvoice = useCallback((c: APIConsignment) => {
// // // // //     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
// // // // //     if (!url) return;
// // // // //     if (navigator.share) {
// // // // //       navigator.share({ title: `Invoice ${getInvoiceNo(c)}`, url });
// // // // //     } else {
// // // // //       navigator.clipboard.writeText(url);
// // // // //       alert("Invoice link copied!");
// // // // //     }
// // // // //   }, []);

// // // // //   const handleEdit = useCallback((id: number) => {
// // // // //     navigate(`/admin/edit/consignments/${id}`);
// // // // //   }, [navigate]);

// // // // //   const handleDeleteRequest = useCallback((id: number) => {
// // // // //     const c = consignments.find(x => x.id === id);
// // // // //     setDeleteTarget({ id, bilty: c?.biltyNo || getInvoiceNo(c!) || String(id) });
// // // // //   }, [consignments]);

// // // // //   const handleDeleteConfirm = useCallback(async () => {
// // // // //     if (!deleteTarget) return;
// // // // //     const { id } = deleteTarget;
// // // // //     setDeleteTarget(null);
// // // // //     try {
// // // // //       const res = await fetch(`${API_BASE}/invoiceapi/invoice/${id}`, { method: "DELETE" });
// // // // //       if (res.ok || res.status === 404) {
// // // // //         setConsignments(prev => prev.filter(c => c.id !== id));
// // // // //       } else {
// // // // //         const err = await res.json();
// // // // //         alert(`Failed to delete: ${err.error || "Unknown error"}`);
// // // // //       }
// // // // //     } catch (e: any) {
// // // // //       alert(`Failed to delete: ${e?.message || e}`);
// // // // //     }
// // // // //   }, [deleteTarget]);

// // // // //   // ── Dropdown options ──
// // // // //   const companyOptions = [...new Set(Object.values(resolvedRows).map(r => r.companyName).filter(v => v && v !== "-"))];
// // // // //   const biltyOptions = [...new Set(consignments.map(c => c.biltyNo || getInvoiceNo(c)).filter(Boolean))];
// // // // //   const truckOptions = [...new Set(Object.values(resolvedRows).map(r => r.truckNo).filter(v => v && v !== "-"))];
// // // // //   const consignorOptions = [...new Set(Object.values(resolvedRows).map(r => r.consignorName).filter(v => v && v !== "-"))];
// // // // //   const consigneeOptions = [...new Set(Object.values(resolvedRows).map(r => r.consigneeName).filter(v => v && v !== "-"))];

// // // // //   // ── Filtering + sorting ──
// // // // //   const filtered = consignments
// // // // //     .filter((c) => {
// // // // //       const row = resolvedRows[c.id];
// // // // //       if (activeFilter !== "all" && getConsignmentStatus(c) !== activeFilter) return false;
// // // // //       if (filters.company && row && row.companyName !== filters.company) return false;
// // // // //       if (filters.biltyNo) {
// // // // //         const q = filters.biltyNo.toLowerCase();
// // // // //         const bn = (c.biltyNo || getInvoiceNo(c) || "").toLowerCase();
// // // // //         if (!bn.includes(q)) return false;
// // // // //       }
// // // // //       if (filters.truckNo && row) {
// // // // //         if (!String(row.truckNo || "").toLowerCase().includes(filters.truckNo.toLowerCase())) return false;
// // // // //       }
// // // // //       if (filters.consignor && row) {
// // // // //         if (!String(row.consignorName || "").toLowerCase().includes(filters.consignor.toLowerCase())) return false;
// // // // //       }
// // // // //       if (filters.consignee && row) {
// // // // //         if (!String(row.consigneeName || "").toLowerCase().includes(filters.consignee.toLowerCase())) return false;
// // // // //       }
// // // // //       if (filters.dateFrom && c.created_at) {
// // // // //         if (new Date(c.created_at).toISOString().slice(0, 10) < filters.dateFrom) return false;
// // // // //       }
// // // // //       if (filters.dateTo && c.created_at) {
// // // // //         if (new Date(c.created_at).toISOString().slice(0, 10) > filters.dateTo) return false;
// // // // //       }
// // // // //       return true;
// // // // //     })
// // // // //     .sort((a, b) => {
// // // // //       const ba = (a.biltyNo || getInvoiceNo(a) || "").toString();
// // // // //       const bb = (b.biltyNo || getInvoiceNo(b) || "").toString();
// // // // //       const cmp = ba.localeCompare(bb, undefined, { numeric: true, sensitivity: "base" });
// // // // //       if (cmp !== 0) return cmp;
// // // // //       return (a.created_at ? new Date(a.created_at).getTime() : 0) -
// // // // //              (b.created_at ? new Date(b.created_at).getTime() : 0);
// // // // //     });

// // // // //   const stats = [
// // // // //     { label: "Total",      value: consignments.length,                                              color: "#185FA5" },
// // // // //     { label: "Pending",    value: consignments.filter(c => getConsignmentStatus(c) === "pending").length,    color: "#854F0B" },
// // // // //     { label: "In transit", value: consignments.filter(c => getConsignmentStatus(c) === "in_transit").length, color: "#534AB7" },
// // // // //     { label: "Delivered",  value: consignments.filter(c => getConsignmentStatus(c) === "delivered").length,  color: "#3B6D11" },
// // // // //   ];

// // // // //   // ── Table column headers ──
// // // // //   const HEADERS = ["#", "Date · Bilty", "Company", "Route", "Parties", "Truck", "Wt / Rate / Amt", "Status", "Actions"];

// // // // //   return (
// // // // //     <div className="p-4 md:p-6 space-y-4">
// // // // //       {/* Stats */}
// // // // //       <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
// // // // //         {stats.map(s => <DashboardStatCard key={s.label} {...s} />)}
// // // // //       </div>

// // // // //       {/* Panel */}
// // // // //       <div className="bg-white border border-slate-100 rounded-2xl p-4">
// // // // //         <div className="flex items-center justify-between mb-3">
// // // // //           <div>
// // // // //             <h2 className="text-[16px] font-medium text-slate-900">My Consignments</h2>
// // // // //             <p className="text-xs text-slate-400">View and manage your consignments &amp; invoices</p>
// // // // //           </div>
// // // // //           <button
// // // // //             className="text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
// // // // //             onClick={() => navigate("/admin/add/consignments")}
// // // // //           >
// // // // //             + New Consignment
// // // // //           </button>
// // // // //         </div>

// // // // //         {/* Status pills */}
// // // // //         <div className="flex flex-wrap gap-1.5 mb-4">
// // // // //           {FILTER_OPTIONS.map(({ key, label }) => (
// // // // //             <button
// // // // //               key={key}
// // // // //               onClick={() => setActiveFilter(key)}
// // // // //               className={`text-xs px-3 py-1 rounded-full border transition-colors ${
// // // // //                 activeFilter === key
// // // // //                   ? "bg-slate-900 text-white border-transparent"
// // // // //                   : "border-slate-200 text-slate-500 hover:bg-slate-50"
// // // // //               }`}
// // // // //             >
// // // // //               {label}
// // // // //             </button>
// // // // //           ))}
// // // // //         </div>

// // // // //         <AdvancedFilters
// // // // //           filters={filters}
// // // // //           onChange={setFilters}
// // // // //           companyOptions={companyOptions}
// // // // //           biltyOptions={biltyOptions}
// // // // //           truckOptions={truckOptions}
// // // // //           consignorOptions={consignorOptions}
// // // // //           consigneeOptions={consigneeOptions}
// // // // //         />

// // // // //         {/* Table */}
// // // // //         <div className="overflow-x-auto">
// // // // //           <table className="w-full text-[12px]" style={{ minWidth: 820 }}>
// // // // //             <thead>
// // // // //               <tr className="border-b border-slate-100">
// // // // //                 {HEADERS.map(h => (
// // // // //                   <th key={h} className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap text-[10px]">{h}</th>
// // // // //                 ))}
// // // // //               </tr>
// // // // //             </thead>
// // // // //             <tbody>
// // // // //               {loading ? (
// // // // //                 <tr><td colSpan={9} className="py-6 text-center text-slate-400">Loading…</td></tr>
// // // // //               ) : error ? (
// // // // //                 <tr><td colSpan={9} className="py-6 text-center text-red-600">{error}</td></tr>
// // // // //               ) : filtered.length === 0 ? (
// // // // //                 <tr><td colSpan={9} className="py-8 text-center text-slate-400">No consignments found.</td></tr>
// // // // //               ) : (
// // // // //                 filtered.map((c, idx) => {
// // // // //                   const row = resolvedRows[c.id];
// // // // //                   const palKey = paletteForCompany(c.company);
// // // // //                   const pal = PALETTE[palKey];
// // // // //                   const hasInvoice = !!c.link;

// // // // //                   return (
// // // // //                     <tr
// // // // //                       key={c.id}
// // // // //                       className="border-b border-slate-100 transition-all"
// // // // //                       style={{ background: pal.row }}
// // // // //                     >
// // // // //                       {/* # */}
// // // // //                       <td className="py-2 px-3 text-slate-400 text-[11px]">{idx + 1}</td>

// // // // //                       {/* Date · Bilty */}
// // // // //                       <td className="py-2 px-3">
// // // // //                         <div className="flex flex-col gap-0.5">
// // // // //                           <span className="text-slate-900 font-medium">{c.biltyNo || getInvoiceNo(c) || "-"}</span>
// // // // //                           <span className="text-[10px] text-slate-400">
// // // // //                             {c.created_at ? new Date(c.created_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "2-digit" }) : "-"}
// // // // //                           </span>
// // // // //                         </div>
// // // // //                       </td>

// // // // //                       {/* Company */}
// // // // //                       <td className="py-2 px-3">
// // // // //                         {row
// // // // //                           ? <CompanyTag companyId={c.company} companyName={row.companyName} />
// // // // //                           : <LoadingCell />}
// // // // //                       </td>

// // // // //                       {/* Route */}
// // // // //                       <td className="py-2 px-3">
// // // // //                         <div className="flex flex-col gap-0.5">
// // // // //                           <span className="text-slate-800 text-[11px]">{c.source || "-"}</span>
// // // // //                           <span className="text-[10px] text-slate-400">→ {c.destination || "-"}</span>
// // // // //                         </div>
// // // // //                       </td>

// // // // //                       {/* Parties */}
// // // // //                       <td className="py-2 px-3">
// // // // //                         {row ? (
// // // // //                           <div className="flex flex-col gap-0.5">
// // // // //                             <span className="text-slate-800 text-[11px]">{row.consignorName}</span>
// // // // //                             <span className="text-[10px] text-slate-400">→ {row.consigneeName}</span>
// // // // //                           </div>
// // // // //                         ) : <LoadingCell />}
// // // // //                       </td>

// // // // //                       {/* Truck */}
// // // // //                       <td className="py-2 px-3 text-slate-500 text-[11px] whitespace-nowrap">
// // // // //                         {row ? row.truckNo : <LoadingCell />}
// // // // //                       </td>

// // // // //                       {/* Wt / Rate / Amt */}
// // // // //                       <td className="py-2 px-3">
// // // // //                         {row ? (
// // // // //                           <div className="flex flex-col gap-0.5">
// // // // //                             <span className="text-[10px] text-slate-400">
// // // // //                               {fmt(row.totalWeight)} kg &nbsp;@&nbsp; ₹{fmt(row.biltyRate, 2)}/kg
// // // // //                             </span>
// // // // //                             <span className="text-slate-900 font-medium">
// // // // //                               {row.totalItemAmount != null
// // // // //                                 ? `₹ ${fmt(row.totalItemAmount, 0)} /-`
// // // // //                                 : c.totalamount != null
// // // // //                                 ? `₹ ${fmt(c.totalamount, 0)} /-`
// // // // //                                 : c.payment
// // // // //                                 ? `₹ ${fmt(Number(c.payment), 0)} /-`
// // // // //                                 : "-"}
// // // // //                             </span>
// // // // //                           </div>
// // // // //                         ) : <LoadingCell />}
// // // // //                       </td>

// // // // //                       {/* Status */}
// // // // //                       <td className="py-2 px-3 whitespace-nowrap">
// // // // //                         <StatusBadge status={getConsignmentStatus(c)} />
// // // // //                       </td>

// // // // //                       {/* Actions — single dropdown */}
// // // // //                       <td className="py-2 px-3 whitespace-nowrap">
// // // // //                         <ActionMenu
// // // // //                           consignment={c}
// // // // //                           hasInvoice={hasInvoice}
// // // // //                           onEdit={handleEdit}
// // // // //                           onDelete={handleDeleteRequest}
// // // // //                           onViewInvoice={handleViewInvoice}
// // // // //                           onDownloadInvoice={handleDownloadInvoice}
// // // // //                           onShareInvoice={handleShareInvoice}
// // // // //                         />
// // // // //                       </td>
// // // // //                     </tr>
// // // // //                   );
// // // // //                 })
// // // // //               )}
// // // // //             </tbody>
// // // // //           </table>
// // // // //         </div>
// // // // //       </div>

// // // // //       {/* Delete confirm modal */}
// // // // //       <DeleteConfirmModal
// // // // //         id={deleteTarget?.id ?? null}
// // // // //         bilty={deleteTarget?.bilty ?? ""}
// // // // //         onConfirm={handleDeleteConfirm}
// // // // //         onCancel={() => setDeleteTarget(null)}
// // // // //       />
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default ConsignorDashboard;



// // // // import React, { useState, useEffect, useRef, useCallback } from "react";
// // // // import ReactDOM from "react-dom";
// // // // import { useNavigate } from "react-router-dom";

// // // // // ─── Types ────────────────────────────────────────────────────────────────────

// // // // type ShipmentStatus = "pending" | "in_transit" | "delivered" | "draft" | "created" | "dispatched" | "cancelled";
// // // // type FilterOption = "all" | ShipmentStatus;

// // // // const API_BASE = process.env.REACT_APP_API_URL;

// // // // interface APIConsignment {
// // // //   id: number;
// // // //   sender: number;
// // // //   company: number;
// // // //   receiver: number;
// // // //   transporter: number;
// // // //   driver: number;
// // // //   vehicles: number;
// // // //   payment: string;
// // // //   source: string;
// // // //   destination: string;
// // // //   receiverAmountStatatus: string;
// // // //   senderAmountStatatus: string;
// // // //   transporterAmountStatatus: string;
// // // //   paymentStatus: string;
// // // //   paymentPayableConsignor: number;
// // // //   ItemsDescription: string;
// // // //   "InvoiceNo"?: string;
// // // //   "InvoiceNo."?: string;
// // // //   EWAYBILLNO: string;
// // // //   subjects: string;
// // // //   link?: string;
// // // //   status?: ShipmentStatus;
// // // //   biltyNo?: string;
// // // //   created_at?: string;
// // // //   totalamount?: number;
// // // // }

// // // // interface InvoiceItem {
// // // //   rate: number;
// // // //   id: number;
// // // //   invoiceId: string;
// // // //   description: string;
// // // //   hsm_code: string;
// // // //   uom: string;
// // // //   qty: number;
// // // //   amount: number;
// // // // }

// // // // interface ResolvedRow {
// // // //   consignorName: string;
// // // //   consigneeName: string;
// // // //   truckNo: string;
// // // //   companyName: string;
// // // //   totalWeight: number | null;
// // // //   biltyRate: number | null;
// // // //   totalItemAmount: number | null;
// // // // }

// // // // type FiltersState = {
// // // //   company: string;
// // // //   biltyNo: string;
// // // //   truckNo: string;
// // // //   consignor: string;
// // // //   consignee: string;
// // // //   dateFrom: string;
// // // //   dateTo: string;
// // // // };

// // // // // ─── Caches ───────────────────────────────────────────────────────────────────

// // // // const userCache: Record<number, string> = {};
// // // // const vehicleCache: Record<number, string> = {};
// // // // const itemsCache: Record<string, InvoiceItem[]> = {};

// // // // // ─── Helpers ──────────────────────────────────────────────────────────────────

// // // // async function fetchUserName(id: number): Promise<string> {
// // // //   if (userCache[id]) return userCache[id];
// // // //   try {
// // // //     const res = await fetch(`${API_BASE}/auth/user/${id}`);
// // // //     if (!res.ok) throw new Error();
// // // //     const data = await res.json();
// // // //     userCache[id] = data.name || `User#${id}`;
// // // //   } catch {
// // // //     userCache[id] = `User#${id}`;
// // // //   }
// // // //   return userCache[id];
// // // // }

// // // // async function fetchVehicleNumber(id: number): Promise<string> {
// // // //   if (vehicleCache[id]) return vehicleCache[id];
// // // //   try {
// // // //     const res = await fetch(`${API_BASE}/auth/vehicles/${id}`);
// // // //     if (!res.ok) throw new Error();
// // // //     const data = await res.json();
// // // //     vehicleCache[id] = data.registration_number || data.vehicle_number || `Vehicle#${id}`;
// // // //   } catch {
// // // //     vehicleCache[id] = `Vehicle#${id}`;
// // // //   }
// // // //   return vehicleCache[id];
// // // // }

// // // // async function fetchInvoiceItems(invoiceDbId: string): Promise<InvoiceItem[]> {
// // // //   if (itemsCache[invoiceDbId]) return itemsCache[invoiceDbId];
// // // //   try {
// // // //     const res = await fetch(`${API_BASE}/invoiceapi/invoice_items/invoice-db/${invoiceDbId}`);
// // // //     if (!res.ok) throw new Error();
// // // //     const data: InvoiceItem[] = await res.json();
// // // //     itemsCache[invoiceDbId] = Array.isArray(data) ? data : [];
// // // //   } catch {
// // // //     itemsCache[invoiceDbId] = [];
// // // //   }
// // // //   return itemsCache[invoiceDbId];
// // // // }

// // // // function computeItemStats(items: InvoiceItem[]) {
// // // //   if (!items.length) return { totalWeight: null, biltyRate: null, totalItemAmount: null };
// // // //   const totalWeight = items.reduce((s, i) => s + Number(i.qty || 0), 0);
// // // //   const totalAmount = items.reduce((s, i) => s + Number(i.amount || 0), 0);
// // // //   const totalRates = items.reduce((s, i) => s + Number(i.rate || 0), 0);
// // // //   return { totalWeight, biltyRate: totalRates, totalItemAmount: totalAmount };
// // // // }

// // // // function fmt(val: number | null | undefined, decimals = 2): string {
// // // //   if (val == null) return "-";
// // // //   return val % 1 === 0 ? String(val) : val.toFixed(decimals);
// // // // }

// // // // const getInvoiceNo = (c: APIConsignment): string =>
// // // //   c.InvoiceNo || (c as any)["InvoiceNo."] || "";

// // // // const getConsignmentStatus = (c: APIConsignment): ShipmentStatus => {
// // // //   if (c.status) return c.status;
// // // //   if (c.paymentStatus === "to_pay" || c.paymentStatus === "credit") return "pending";
// // // //   if (c.paymentStatus === "paid") return "delivered";
// // // //   return "pending";
// // // // };

// // // // /** Generate a short abbreviation from a company name, e.g. "Amit Traders & Co." → "ATC" */
// // // // function companyAbbr(name: string): string {
// // // //   const NOISE = /^(pvt|ltd|co|inc|corp|private|limited|and|the|of|&)$/i;
// // // //   const words = name.split(/[\s&,\.]+/).filter(Boolean);
// // // //   const meaningful = words.filter((w) => w.length > 1 && !NOISE.test(w));
// // // //   const src = meaningful.length >= 2 ? meaningful : words;
// // // //   return src
// // // //     .map((w) => w[0].toUpperCase())
// // // //     .slice(0, 3)
// // // //     .join("");
// // // // }

// // // // // const PALETTE_KEYS = ["blue", "teal", "amber", "coral", "purple", "pink", "green", "red"] as const;
// // // // const PALETTE_KEYS = ["blue", "teal", "amber", "red", "purple", "green", 'coral','pink'] as const;

// // // // type PaletteKey = typeof PALETTE_KEYS[number];

// // // // // const PALETTE: Record<PaletteKey, { bg: string; text: string; row: string }> = {
// // // // //   blue:   { bg: "#E6F1FB", text: "#0C447C", row: "rgba(55,138,221,0.05)" },
// // // // //   teal:   { bg: "#E1F5EE", text: "#085041", row: "rgba(29,158,117,0.05)" },
// // // // //   amber:  { bg: "#FAEEDA", text: "#633806", row: "rgba(186,117,23,0.06)" },
// // // // //   coral:  { bg: "#FAECE7", text: "#712B13", row: "rgba(216,90,48,0.05)" },
// // // // //   purple: { bg: "#EEEDFE", text: "#3C3489", row: "rgba(83,74,183,0.05)" },
// // // // //   pink:   { bg: "#FBEAF0", text: "#72243E", row: "rgba(212,83,126,0.05)" },
// // // // //   green:  { bg: "#EAF3DE", text: "#27500A", row: "rgba(99,153,34,0.05)"  },
// // // // //   red:    { bg: "#FCEBEB", text: "#791F1F", row: "rgba(226,75,74,0.05)"  },
// // // // // };

// // // // // const PALETTE: Record<PaletteKey, { bg: string; text: string; row: string }> = {
// // // // //   blue:   { bg: "#E6F1FB", text: "#042C53", row: "rgba(55,138,221,0.05)"   },
// // // // //   teal:   { bg: "#E1F5EE", text: "#04342C", row: "rgba(29,158,117,0.05)"   },
// // // // //   amber:  { bg: "#FAEEDA", text: "#412402", row: "rgba(186,117,23,0.06)"   },
// // // // //   red:    { bg: "#FCEBEB", text: "#501313", row: "rgba(226,75,74,0.05)"    },
// // // // //   purple: { bg: "#EEEDFE", text: "#26215C", row: "rgba(83,74,183,0.05)"    },
// // // // //   green:  { bg: "#EAF3DE", text: "#173404", row: "rgba(99,153,34,0.05)"    },
// // // // //   // coral → replaced with orange (clearly warm but distinct from red & amber)
// // // // //   orange: { bg: "#FEF0E6", text: "#4D1E00", row: "rgba(234,120,40,0.05)"  },
// // // // //   // pink  → replaced with brown/slate (neutral-warm, far from everything)
// // // // //   brown:  { bg: "#F0EBE3", text: "#2C1A08", row: "rgba(140,90,40,0.05)"   },
// // // // // };
// // // // const PALETTE: Record<PaletteKey, { bg: string; text: string; row: string }> = {
// // // //   blue:   { bg: "#E6F1FB", text: "#042C53", row: "rgba(55,138,221,0.18)"  },
// // // //   teal:   { bg: "#E1F5EE", text: "#04342C", row: "rgba(29,158,117,0.18)"  },
// // // //   amber:  { bg: "#FAEEDA", text: "#412402", row: "rgba(186,117,23,0.18)"  },
// // // //   red:    { bg: "#FCEBEB", text: "#501313", row: "rgba(226,75,74,0.18)"   },
// // // //   purple: { bg: "#EEEDFE", text: "#26215C", row: "rgba(83,74,183,0.18)"   },
// // // //   green:  { bg: "#EAF3DE", text: "#173404", row: "rgba(99,153,34,0.18)"   },
// // // //   coral:  { bg: "#FEF0E6", text: "#ffffff", row: "rgba(234,120,40,0.18)"  },
// // // //   pink:   { bg: "#F0EBE3", text: "#ffffff", row: "rgba(140,90,40,0.18)"   },
// // // // };
// // // // /**
// // // //  * Assigns palette colors by the ORDER companies are first encountered,
// // // //  * not by their numeric ID. This guarantees every company gets a distinct
// // // //  * color regardless of ID gaps or clustering (e.g. IDs 1, 7, 13 would all
// // // //  * collide with % 6 but get unique slots here).
// // // //  * The registry is module-level so it persists across re-renders without
// // // //  * needing React state.
// // // //  */
// // // // const companyColorRegistry = new Map<number, PaletteKey>();

// // // // function paletteForCompany(companyId: number): PaletteKey {
// // // //   if (companyColorRegistry.has(companyId)) {
// // // //     return companyColorRegistry.get(companyId)!;
// // // //   }
// // // //   // Next unseen slot — cycle only after all 8 colors are used
// // // //   const idx = companyColorRegistry.size % PALETTE_KEYS.length;
// // // //   const key = PALETTE_KEYS[idx];
// // // //   companyColorRegistry.set(companyId, key);
// // // //   return key;
// // // // }

// // // // // ─── Constants ────────────────────────────────────────────────────────────────

// // // // const FILTER_OPTIONS: { key: FilterOption; label: string }[] = [
// // // //   { key: "all", label: "All" },
// // // //   { key: "pending", label: "Pending" },
// // // //   { key: "in_transit", label: "In transit" },
// // // //   { key: "delivered", label: "Delivered" },
// // // //   { key: "draft", label: "Draft" },
// // // // ];

// // // // const STATUS_STYLES: Record<string, string> = {
// // // //   pending:    "bg-amber-100 text-amber-900",
// // // //   in_transit: "bg-blue-100 text-blue-900",
// // // //   delivered:  "bg-green-100 text-green-900",
// // // //   draft:      "bg-slate-100 text-slate-600",
// // // //   created:    "bg-slate-100 text-slate-900",
// // // //   dispatched: "bg-amber-100 text-amber-800",
// // // //   cancelled:  "bg-red-100 text-red-900",
// // // // };

// // // // const STATUS_LABELS: Record<string, string> = {
// // // //   pending: "Pending", in_transit: "In transit", delivered: "Delivered",
// // // //   draft: "Draft", created: "Created", dispatched: "Dispatched", cancelled: "Cancelled",
// // // // };

// // // // // ─── Sub-components ───────────────────────────────────────────────────────────

// // // // const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
// // // //   <span className={`text-[9px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${STATUS_STYLES[status] || "bg-slate-100 text-slate-900"}`}>
// // // //     {STATUS_LABELS[status] || status}
// // // //   </span>
// // // // );

// // // // const DashboardStatCard: React.FC<{ label: string; value: number; color: string }> = ({ label, value, color }) => (
// // // //   <div className="rounded-xl bg-slate-50 p-4 flex flex-col justify-center items-center">
// // // //     <span className="text-[26px] font-semibold mb-1" style={{ color }}>{value}</span>
// // // //     <span className="text-xs font-medium text-slate-500">{label}</span>
// // // //   </div>
// // // // );

// // // // const LoadingCell = () => (
// // // //   <span className="text-slate-300 animate-pulse text-xs">Loading…</span>
// // // // );

// // // // // ─── Company Tag ──────────────────────────────────────────────────────────────

// // // // const TAG_SOLID: Record<PaletteKey, string> = {
// // // //   blue: "#185FA5",
// // // //   teal: "#0F6E56",
// // // //   amber: "#BA7517",
// // // //   red: "#A32D2D",
// // // //   purple: "#534AB7",
// // // //   green: "#3B6D11",
// // // //   coral: "#b85000",
// // // //   pink: "#5a3010",
 
// // // // };

// // // // const CompanyTag: React.FC<{ companyId: number; companyName: string }> = ({ companyId, companyName }) => {
// // // //   const key = paletteForCompany(companyId);
// // // //   const pal = PALETTE[key];
// // // //   const abbr = companyAbbr(companyName);
// // // //   return (
// // // //     <span
// // // //       title={companyName}
// // // //       className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold cursor-default whitespace-nowrap"
// // // //       style={{ background: TAG_SOLID[key], color: "#ffffff"  }}
// // // //     >
// // // //       {abbr}
// // // //     </span>
// // // //   );
// // // // };

// // // // // ─── Action Dropdown (portal-based — escapes overflow:auto clipping) ──────────

// // // // interface ActionMenuProps {
// // // //   consignment: APIConsignment;
// // // //   hasInvoice: boolean;
// // // //   onEdit: (id: number) => void;
// // // //   onDelete: (id: number) => void;
// // // //   onViewInvoice: (c: APIConsignment) => void;
// // // //   onDownloadInvoice: (c: APIConsignment) => void;
// // // //   onShareInvoice: (c: APIConsignment) => void;
// // // // }

// // // // /**
// // // //  * Measures the trigger button's position and renders the dropdown menu
// // // //  * via a React portal into document.body — so it is never clipped by
// // // //  * overflow:auto / overflow:hidden ancestors (e.g. the table scroll wrapper).
// // // //  * The menu auto-flips above the button when it would overflow the viewport bottom.
// // // //  */
// // // // const ActionMenu: React.FC<ActionMenuProps> = ({
// // // //   consignment, hasInvoice, onEdit, onDelete, onViewInvoice, onDownloadInvoice, onShareInvoice,
// // // // }) => {
// // // //   const [open, setOpen] = useState(false);
// // // //   const [menuStyle, setMenuStyle] = useState<React.CSSProperties>({});
// // // //   const triggerRef = useRef<HTMLButtonElement>(null);
// // // //   const menuRef = useRef<HTMLDivElement>(null);

// // // //   const MENU_WIDTH = 184;
// // // //   const MENU_HEIGHT_APPROX = 230; // used only for flip detection before actual render

// // // //   const reposition = useCallback(() => {
// // // //     if (!triggerRef.current) return;
// // // //     const r = triggerRef.current.getBoundingClientRect();
// // // //     const spaceBelow = window.innerHeight - r.bottom;
// // // //     const flipUp = spaceBelow < MENU_HEIGHT_APPROX && r.top > MENU_HEIGHT_APPROX;

// // // //     // Align right edge of menu with right edge of trigger; clamp to viewport left
// // // //     const right = window.innerWidth - r.right;
// // // //     setMenuStyle({
// // // //       position: "fixed",
// // // //       top: flipUp ? r.top - 4 : r.bottom + 4,
// // // //       right,
// // // //       width: MENU_WIDTH,
// // // //       transform: flipUp ? "translateY(-100%)" : "none",
// // // //       zIndex: 9999,
// // // //     });
// // // //   }, []);

// // // //   const toggleOpen = () => {
// // // //     if (!open) reposition();
// // // //     setOpen((v) => !v);
// // // //   };

// // // //   // Close on outside click or scroll
// // // //   useEffect(() => {
// // // //     if (!open) return;
// // // //     const close = (e: MouseEvent) => {
// // // //       if (
// // // //         menuRef.current && !menuRef.current.contains(e.target as Node) &&
// // // //         triggerRef.current && !triggerRef.current.contains(e.target as Node)
// // // //       ) setOpen(false);
// // // //     };
// // // //     const onScroll = () => {
// // // //       reposition();
// // // //     };
// // // //     document.addEventListener("mousedown", close);
// // // //     window.addEventListener("scroll", onScroll, true); // capture phase catches nested scrollers
// // // //     return () => {
// // // //       document.removeEventListener("mousedown", close);
// // // //       window.removeEventListener("scroll", onScroll, true);
// // // //     };
// // // //   }, [open, reposition]);

// // // //   const invoiceDisabled = !hasInvoice;
// // // //   const btnCls = "flex items-center gap-2 w-full px-3 py-[7px] text-[12px] text-left hover:bg-slate-50 transition-colors whitespace-nowrap";
// // // //   const disabledCls = "opacity-40 cursor-not-allowed pointer-events-none";

// // // //   const menu = open ? (
// // // //     <div
// // // //       ref={menuRef}
// // // //       style={menuStyle}
// // // //       className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-md"
// // // //     >
// // // //       {/* Invoice section */}
// // // //       <div className="border-b border-slate-100 py-1">
// // // //         <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1">Invoice</p>
// // // //         <button
// // // //           className={`${btnCls} text-blue-800 ${invoiceDisabled ? disabledCls : ""}`}
// // // //           disabled={invoiceDisabled}
// // // //           onClick={() => { setOpen(false); onViewInvoice(consignment); }}
// // // //         >
// // // //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
// // // //           View invoice
// // // //           {invoiceDisabled && <span className="ml-auto text-[9px] text-slate-400">No file</span>}
// // // //         </button>
// // // //         <button
// // // //           className={`${btnCls} text-green-800 ${invoiceDisabled ? disabledCls : ""}`}
// // // //           disabled={invoiceDisabled}
// // // //           onClick={() => { setOpen(false); onDownloadInvoice(consignment); }}
// // // //         >
// // // //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
// // // //           Download PDF
// // // //         </button>
// // // //         <button
// // // //           className={`${btnCls} text-purple-800 ${invoiceDisabled ? disabledCls : ""}`}
// // // //           disabled={invoiceDisabled}
// // // //           onClick={() => { setOpen(false); onShareInvoice(consignment); }}
// // // //         >
// // // //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
// // // //           Share link
// // // //         </button>
// // // //       </div>
// // // //       {/* Consignment section */}
// // // //       <div className="py-1">
// // // //         <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1">Consignment</p>
// // // //         <button
// // // //           className={`${btnCls} text-amber-800`}
// // // //           onClick={() => { setOpen(false); onEdit(consignment.id); }}
// // // //         >
// // // //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
// // // //           Edit
// // // //         </button>
// // // //         <button
// // // //           className={`${btnCls} text-red-800 hover:!bg-red-50`}
// // // //           onClick={() => { setOpen(false); onDelete(consignment.id); }}
// // // //         >
// // // //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
// // // //           Delete
// // // //         </button>
// // // //       </div>
// // // //     </div>
// // // //   ) : null;

// // // //   return (
// // // //     <>
// // // //       <button
// // // //         ref={triggerRef}
// // // //         onClick={toggleOpen}
// // // //         className="inline-flex items-center gap-1.5 text-[11px] px-2.5 py-1 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-600 transition-colors"
// // // //       >
// // // //         <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
// // // //           <circle cx="8" cy="3" r="1.4"/><circle cx="8" cy="8" r="1.4"/><circle cx="8" cy="13" r="1.4"/>
// // // //         </svg>
// // // //         Actions
// // // //         <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" className="opacity-50">
// // // //           <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
// // // //         </svg>
// // // //       </button>
// // // //       {ReactDOM.createPortal(menu, document.body)}
// // // //     </>
// // // //   );
// // // // };

// // // // // ─── Advanced Filters ─────────────────────────────────────────────────────────

// // // // const AdvancedFilters: React.FC<{
// // // //   filters: FiltersState;
// // // //   onChange: (f: FiltersState) => void;
// // // //   companyOptions: string[];
// // // //   biltyOptions: string[];
// // // //   truckOptions: string[];
// // // //   consignorOptions: string[];
// // // //   consigneeOptions: string[];
// // // // }> = ({ filters, onChange, companyOptions, biltyOptions, truckOptions, consignorOptions, consigneeOptions }) => {
// // // //   const sel = "border rounded px-2 py-1 text-xs";
// // // //   const inp = "border rounded px-2 py-1 text-xs mt-1 block";

// // // //   return (
// // // //     <div className="flex flex-wrap gap-3 mb-4">
// // // //       <div>
// // // //         <label className="block text-xs text-slate-500 mb-1">Company</label>
// // // //         <select className={`${sel} w-[160px]`} value={filters.company} onChange={e => onChange({ ...filters, company: e.target.value })}>
// // // //           <option value="">All companies</option>
// // // //           {companyOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // // //         </select>
// // // //       </div>
// // // //       <div>
// // // //         <label className="block text-xs text-slate-500 mb-1">Bilty no.</label>
// // // //         <select className={`${sel} w-[140px]`} value={filters.biltyNo} onChange={e => onChange({ ...filters, biltyNo: e.target.value })}>
// // // //           <option value="">All bilty nos.</option>
// // // //           {biltyOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // // //         </select>
// // // //         <input className={`${inp} w-[140px]`} placeholder="Search bilty" value={filters.biltyNo} onChange={e => onChange({ ...filters, biltyNo: e.target.value })} />
// // // //       </div>
// // // //       <div>
// // // //         <label className="block text-xs text-slate-500 mb-1">Truck no.</label>
// // // //         <select className={`${sel} w-[130px]`} value={filters.truckNo} onChange={e => onChange({ ...filters, truckNo: e.target.value })}>
// // // //           <option value="">All trucks</option>
// // // //           {truckOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // // //         </select>
// // // //         <input className={`${inp} w-[130px]`} placeholder="Search truck" value={filters.truckNo} onChange={e => onChange({ ...filters, truckNo: e.target.value })} />
// // // //       </div>
// // // //       <div>
// // // //         <label className="block text-xs text-slate-500 mb-1">Consignor</label>
// // // //         <select className={`${sel} w-[130px]`} value={filters.consignor} onChange={e => onChange({ ...filters, consignor: e.target.value })}>
// // // //           <option value="">All consignors</option>
// // // //           {consignorOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // // //         </select>
// // // //         <input className={`${inp} w-[130px]`} placeholder="Search consignor" value={filters.consignor} onChange={e => onChange({ ...filters, consignor: e.target.value })} />
// // // //       </div>
// // // //       <div>
// // // //         <label className="block text-xs text-slate-500 mb-1">Consignee</label>
// // // //         <select className={`${sel} w-[130px]`} value={filters.consignee} onChange={e => onChange({ ...filters, consignee: e.target.value })}>
// // // //           <option value="">All consignees</option>
// // // //           {consigneeOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // // //         </select>
// // // //         <input className={`${inp} w-[130px]`} placeholder="Search consignee" value={filters.consignee} onChange={e => onChange({ ...filters, consignee: e.target.value })} />
// // // //       </div>
// // // //       <div>
// // // //         <label className="block text-xs text-slate-500 mb-1">Date from</label>
// // // //         <input type="date" className={`${sel}`} value={filters.dateFrom} onChange={e => onChange({ ...filters, dateFrom: e.target.value })} />
// // // //       </div>
// // // //       <div>
// // // //         <label className="block text-xs text-slate-500 mb-1">Date to</label>
// // // //         <input type="date" className={`${sel}`} value={filters.dateTo} onChange={e => onChange({ ...filters, dateTo: e.target.value })} />
// // // //       </div>
// // // //       <div className="flex items-end">
// // // //         <button
// // // //           className="text-xs px-3 py-1 border rounded bg-slate-50 text-slate-600"
// // // //           onClick={() => onChange({ company: "", biltyNo: "", truckNo: "", consignor: "", consignee: "", dateFrom: "", dateTo: "" })}
// // // //         >
// // // //           Clear
// // // //         </button>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // // ─── Delete Confirm Modal ─────────────────────────────────────────────────────

// // // // const DeleteConfirmModal: React.FC<{
// // // //   id: number | null;
// // // //   bilty: string;
// // // //   onConfirm: () => void;
// // // //   onCancel: () => void;
// // // // }> = ({ id, bilty, onConfirm, onCancel }) => {
// // // //   if (id === null) return null;
// // // //   return (
// // // //     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
// // // //       <div className="bg-white rounded-2xl border border-slate-200 p-6 w-[340px] shadow-lg">
// // // //         <h3 className="text-[15px] font-medium text-slate-900 mb-2">Delete consignment?</h3>
// // // //         <p className="text-xs text-slate-500 mb-5 leading-relaxed">
// // // //           You are about to permanently delete <strong>{bilty}</strong>. This action cannot be undone and all associated data will be removed.
// // // //         </p>
// // // //         <div className="flex gap-3 justify-end">
// // // //           <button onClick={onCancel} className="text-xs px-4 py-1.5 border border-slate-200 rounded-lg text-slate-600 hover:bg-slate-50 transition-colors">
// // // //             Cancel
// // // //           </button>
// // // //           <button onClick={onConfirm} className="text-xs px-4 py-1.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
// // // //             Delete
// // // //           </button>
// // // //         </div>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // // ─── Main Dashboard ───────────────────────────────────────────────────────────

// // // // const ConsignorDashboard: React.FC = () => {
// // // //   const navigate = useNavigate();
// // // //   const [consignments, setConsignments] = useState<APIConsignment[]>([]);
// // // //   const [loading, setLoading] = useState(false);
// // // //   const [error, setError] = useState<string | null>(null);
// // // //   const [activeFilter, setActiveFilter] = useState<FilterOption>("all");
// // // //   const [resolvedRows, setResolvedRows] = useState<Record<number, ResolvedRow>>({});
// // // //   const [deleteTarget, setDeleteTarget] = useState<{ id: number; bilty: string } | null>(null);
// // // //   const companyCache: Record<number, string> = {};

// // // //   const [filters, setFilters] = useState<FiltersState>({
// // // //     company: "", biltyNo: "", truckNo: "", consignor: "", consignee: "", dateFrom: "", dateTo: "",
// // // //   });

// // // //   async function fetchCompanyName(id: number): Promise<string> {
// // // //     if (companyCache[id]) return companyCache[id];
// // // //     try {
// // // //       const res = await fetch(`${API_BASE}/companyauth/company/${id}`);
// // // //       if (!res.ok) throw new Error();
// // // //       const data = await res.json();
// // // //       companyCache[id] = data.name || data.company_name || `Company#${id}`;
// // // //     } catch {
// // // //       companyCache[id] = `Company#${id}`;
// // // //     }
// // // //     return companyCache[id];
// // // //   }

// // // //   useEffect(() => {
// // // //     setLoading(true);
// // // //     setError(null);

// // // //     fetch(`${API_BASE}/invoiceapi/invoice`)
// // // //       .then((res) => res.json())
// // // //       .then(async (data) => {
// // // //         if (!Array.isArray(data)) { setConsignments([]); return; }

// // // //         const mapped: APIConsignment[] = data.map((c: any) => ({
// // // //           id: c.id,
// // // //           sender: c.sender,
// // // //           company: c.company,
// // // //           receiver: c.receiver,
// // // //           transporter: c.transporter,
// // // //           driver: c.driver,
// // // //           vehicles: c.vehicles,
// // // //           payment: c.payment,
// // // //           source: c.source,
// // // //           destination: c.destination,
// // // //           receiverAmountStatatus: c.receiverAmountStatatus,
// // // //           senderAmountStatatus: c.senderAmountStatatus,
// // // //           transporterAmountStatatus: c.transporterAmountStatatus,
// // // //           paymentStatus: c.paymentStatus,
// // // //           paymentPayableConsignor: c.paymentPayableConsignor,
// // // //           ItemsDescription: c.ItemsDescription,
// // // //           InvoiceNo: c["InvoiceNo"] ?? c["InvoiceNo."] ?? "",
// // // //           "InvoiceNo.": c["InvoiceNo."],
// // // //           EWAYBILLNO: c.EWAYBILLNO,
// // // //           subjects: c.subjects,
// // // //           link: c.link ?? c.invoiceLink,
// // // //           status: c.status ?? undefined,
// // // //           biltyNo: c.biltyNo ?? c["InvoiceNo"] ?? c["InvoiceNo."] ?? "",
// // // //           created_at: c.created_at ?? "",
// // // //           totalamount: c.totalamount ?? null,
// // // //         }));

// // // //         const senderIds   = [...new Set(mapped.map(c => c.sender).filter(Boolean))];
// // // //         const receiverIds = [...new Set(mapped.map(c => c.receiver).filter(Boolean))];
// // // //         const vehicleIds  = [...new Set(mapped.map(c => c.vehicles).filter(Boolean))];
// // // //         const companyIds  = [...new Set(mapped.map(c => c.company).filter(Boolean))];
// // // //         const invoiceDbIds = [...new Set(mapped.map(c => String(c.id)).filter(Boolean))];

// // // //         // Pre-register companies in a stable order so color assignments are
// // // //         // deterministic and don't shift between renders or data fetches.
// // // //         companyColorRegistry.clear();
// // // //         companyIds.forEach(id => paletteForCompany(id));

// // // //         await Promise.allSettled([
// // // //           ...senderIds.map(fetchUserName),
// // // //           ...receiverIds.map(fetchUserName),
// // // //           ...vehicleIds.map(fetchVehicleNumber),
// // // //           ...companyIds.map(fetchCompanyName),
// // // //           ...invoiceDbIds.map(fetchInvoiceItems),
// // // //         ]);

// // // //         const resolved: Record<number, ResolvedRow> = {};
// // // //         for (const c of mapped) {
// // // //           const items = itemsCache[String(c.id)] ?? [];
// // // //           const { totalWeight, biltyRate, totalItemAmount } = computeItemStats(items);
// // // //           resolved[c.id] = {
// // // //             consignorName: c.sender ? userCache[c.sender] || `User#${c.sender}` : "-",
// // // //             consigneeName: c.receiver ? userCache[c.receiver] || `User#${c.receiver}` : "-",
// // // //             truckNo: c.vehicles ? vehicleCache[c.vehicles] || `Vehicle#${c.vehicles}` : "-",
// // // //             companyName: c.company ? companyCache[c.company] || `Company#${c.company}` : "-",
// // // //             totalWeight,
// // // //             biltyRate,
// // // //             totalItemAmount,
// // // //           };
// // // //         }
// // // //         setResolvedRows(resolved);
// // // //         setConsignments(mapped);
// // // //       })
// // // //       .catch(() => setError("Unable to fetch consignments"))
// // // //       .finally(() => setLoading(false));
// // // //   }, []);

// // // //   // ── Invoice action handlers ──
// // // //   const handleViewInvoice = useCallback((c: APIConsignment) => {
// // // //     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
// // // //     if (url) window.open(url, "_blank");
// // // //   }, []);

// // // //   const handleDownloadInvoice = useCallback((c: APIConsignment) => {
// // // //     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
// // // //     if (!url) return;
// // // //     const a = document.createElement("a");
// // // //     a.href = url;
// // // //     a.download = `Invoice_${getInvoiceNo(c) || c.EWAYBILLNO || c.id}`;
// // // //     document.body.appendChild(a);
// // // //     a.click();
// // // //     document.body.removeChild(a);
// // // //   }, []);

// // // //   const handleShareInvoice = useCallback((c: APIConsignment) => {
// // // //     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
// // // //     if (!url) return;
// // // //     if (navigator.share) {
// // // //       navigator.share({ title: `Invoice ${getInvoiceNo(c)}`, url });
// // // //     } else {
// // // //       navigator.clipboard.writeText(url);
// // // //       alert("Invoice link copied!");
// // // //     }
// // // //   }, []);

// // // //   const handleEdit = useCallback((id: number) => {
// // // //     navigate(`/admin/edit/consignments/${id}`);
// // // //   }, [navigate]);

// // // //   const handleDeleteRequest = useCallback((id: number) => {
// // // //     const c = consignments.find(x => x.id === id);
// // // //     setDeleteTarget({ id, bilty: c?.biltyNo || getInvoiceNo(c!) || String(id) });
// // // //   }, [consignments]);

// // // //   const handleDeleteConfirm = useCallback(async () => {
// // // //     if (!deleteTarget) return;
// // // //     const { id } = deleteTarget;
// // // //     setDeleteTarget(null);
// // // //     try {
// // // //       const res = await fetch(`${API_BASE}/invoiceapi/invoice/${id}`, { method: "DELETE" });
// // // //       if (res.ok || res.status === 404) {
// // // //         setConsignments(prev => prev.filter(c => c.id !== id));
// // // //       } else {
// // // //         const err = await res.json();
// // // //         alert(`Failed to delete: ${err.error || "Unknown error"}`);
// // // //       }
// // // //     } catch (e: any) {
// // // //       alert(`Failed to delete: ${e?.message || e}`);
// // // //     }
// // // //   }, [deleteTarget]);

// // // //   // ── Dropdown options ──
// // // //   const companyOptions = [...new Set(Object.values(resolvedRows).map(r => r.companyName).filter(v => v && v !== "-"))];
// // // //   const biltyOptions = [...new Set(consignments.map(c => c.biltyNo || getInvoiceNo(c)).filter(Boolean))];
// // // //   const truckOptions = [...new Set(Object.values(resolvedRows).map(r => r.truckNo).filter(v => v && v !== "-"))];
// // // //   const consignorOptions = [...new Set(Object.values(resolvedRows).map(r => r.consignorName).filter(v => v && v !== "-"))];
// // // //   const consigneeOptions = [...new Set(Object.values(resolvedRows).map(r => r.consigneeName).filter(v => v && v !== "-"))];

// // // //   // ── Filtering + sorting ──
// // // //   const filtered = consignments
// // // //     .filter((c) => {
// // // //       const row = resolvedRows[c.id];
// // // //       if (activeFilter !== "all" && getConsignmentStatus(c) !== activeFilter) return false;
// // // //       if (filters.company && row && row.companyName !== filters.company) return false;
// // // //       if (filters.biltyNo) {
// // // //         const q = filters.biltyNo.toLowerCase();
// // // //         const bn = (c.biltyNo || getInvoiceNo(c) || "").toLowerCase();
// // // //         if (!bn.includes(q)) return false;
// // // //       }
// // // //       if (filters.truckNo && row) {
// // // //         if (!String(row.truckNo || "").toLowerCase().includes(filters.truckNo.toLowerCase())) return false;
// // // //       }
// // // //       if (filters.consignor && row) {
// // // //         if (!String(row.consignorName || "").toLowerCase().includes(filters.consignor.toLowerCase())) return false;
// // // //       }
// // // //       if (filters.consignee && row) {
// // // //         if (!String(row.consigneeName || "").toLowerCase().includes(filters.consignee.toLowerCase())) return false;
// // // //       }
// // // //       if (filters.dateFrom && c.created_at) {
// // // //         if (new Date(c.created_at).toISOString().slice(0, 10) < filters.dateFrom) return false;
// // // //       }
// // // //       if (filters.dateTo && c.created_at) {
// // // //         if (new Date(c.created_at).toISOString().slice(0, 10) > filters.dateTo) return false;
// // // //       }
// // // //       return true;
// // // //     })
// // // //     .sort((a, b) => {
// // // //       const ba = (a.biltyNo || getInvoiceNo(a) || "").toString();
// // // //       const bb = (b.biltyNo || getInvoiceNo(b) || "").toString();
// // // //       const cmp = ba.localeCompare(bb, undefined, { numeric: true, sensitivity: "base" });
// // // //       if (cmp !== 0) return cmp;
// // // //       return (a.created_at ? new Date(a.created_at).getTime() : 0) -
// // // //              (b.created_at ? new Date(b.created_at).getTime() : 0);
// // // //     });

// // // //   const stats = [
// // // //     { label: "Total",      value: consignments.length,                                              color: "#185FA5" },
// // // //     { label: "Pending",    value: consignments.filter(c => getConsignmentStatus(c) === "pending").length,    color: "#854F0B" },
// // // //     { label: "In transit", value: consignments.filter(c => getConsignmentStatus(c) === "in_transit").length, color: "#534AB7" },
// // // //     { label: "Delivered",  value: consignments.filter(c => getConsignmentStatus(c) === "delivered").length,  color: "#3B6D11" },
// // // //   ];

// // // //   // ── Table column headers ──
// // // //   const HEADERS = ["#", "Date · Bilty", "Company", "Route", "Parties", "Truck", "Wt / Rate / Amt", "Status", "Actions"];

// // // //   return (
// // // //     <div className="p-4 md:p-6 space-y-4">
// // // //       {/* Stats */}
// // // //       <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
// // // //         {stats.map(s => <DashboardStatCard key={s.label} {...s} />)}
// // // //       </div>

// // // //       {/* Panel */}
// // // //       <div className="bg-white border border-slate-100 rounded-2xl p-4">
// // // //         <div className="flex items-center justify-between mb-3">
// // // //           <div>
// // // //             <h2 className="text-[16px] font-medium text-slate-900">My Consignments</h2>
// // // //             <p className="text-xs text-slate-400">View and manage your consignments &amp; invoices</p>
// // // //           </div>
// // // //           <button
// // // //             className="text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
// // // //             onClick={() => navigate("/admin/add/consignments")}
// // // //           >
// // // //             + New Consignment
// // // //           </button>
// // // //         </div>

// // // //         {/* Status pills */}
// // // //         <div className="flex flex-wrap gap-1.5 mb-4">
// // // //           {FILTER_OPTIONS.map(({ key, label }) => (
// // // //             <button
// // // //               key={key}
// // // //               onClick={() => setActiveFilter(key)}
// // // //               className={`text-xs px-3 py-1 rounded-full border transition-colors ${
// // // //                 activeFilter === key
// // // //                   ? "bg-slate-900 text-white border-transparent"
// // // //                   : "border-slate-200 text-slate-500 hover:bg-slate-50"
// // // //               }`}
// // // //             >
// // // //               {label}
// // // //             </button>
// // // //           ))}
// // // //         </div>

// // // //         <AdvancedFilters
// // // //           filters={filters}
// // // //           onChange={setFilters}
// // // //           companyOptions={companyOptions}
// // // //           biltyOptions={biltyOptions}
// // // //           truckOptions={truckOptions}
// // // //           consignorOptions={consignorOptions}
// // // //           consigneeOptions={consigneeOptions}
// // // //         />

// // // //         {/* Table */}
// // // //         <div className="overflow-x-auto">
// // // //           <table className="w-full text-[12px]" style={{ minWidth: 820 }}>
// // // //             <thead>
// // // //               <tr className="border-b border-slate-100">
// // // //                 {HEADERS.map(h => (
// // // //                   <th key={h} className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap text-[10px]">{h}</th>
// // // //                 ))}
// // // //               </tr>
// // // //             </thead>
// // // //             <tbody>
// // // //               {loading ? (
// // // //                 <tr><td colSpan={9} className="py-6 text-center text-slate-400">Loading…</td></tr>
// // // //               ) : error ? (
// // // //                 <tr><td colSpan={9} className="py-6 text-center text-red-600">{error}</td></tr>
// // // //               ) : filtered.length === 0 ? (
// // // //                 <tr><td colSpan={9} className="py-8 text-center text-slate-400">No consignments found.</td></tr>
// // // //               ) : (
// // // //                 filtered.map((c, idx) => {
// // // //                   const row = resolvedRows[c.id];
// // // //                   const palKey = paletteForCompany(c.company);
// // // //                   const pal = PALETTE[palKey];
// // // //                   const hasInvoice = !!c.link;

// // // //                   return (
// // // //                     <tr
// // // //                       key={c.id}
// // // //                       className="border-b border-slate-100 transition-all"
// // // //                       style={{ background: pal.row }}
// // // //                     >
// // // //                       {/* # */}
// // // //                       <td className="py-2 px-3 text-slate-400 text-[11px]">{idx + 1}</td>

// // // //                       {/* Date · Bilty */}
// // // //                       <td className="py-2 px-3">
// // // //                         <div className="flex flex-col gap-0.5">
// // // //                           <span className="text-slate-900 font-medium">{c.biltyNo || getInvoiceNo(c) || "-"}</span>
// // // //                           <span className="text-[10px] text-slate-400">
// // // //                             {c.created_at ? new Date(c.created_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "2-digit" }) : "-"}
// // // //                           </span>
// // // //                         </div>
// // // //                       </td>

// // // //                       {/* Company */}
// // // //                       <td className="py-2 px-3">
// // // //                         {row
// // // //                           ? <CompanyTag companyId={c.company} companyName={row.companyName} />
// // // //                           : <LoadingCell />}
// // // //                       </td>

// // // //                       {/* Route */}
// // // //                       <td className="py-2 px-3">
// // // //                         <div className="flex flex-col gap-0.5">
// // // //                           <span className="text-slate-800 text-[11px]">{c.source || "-"}</span>
// // // //                           <span className="text-[10px] text-slate-400">→ {c.destination || "-"}</span>
// // // //                         </div>
// // // //                       </td>

// // // //                       {/* Parties */}
// // // //                       <td className="py-2 px-3">
// // // //                         {row ? (
// // // //                           <div className="flex flex-col gap-1">
// // // //                             <span className="text-[11px] text-slate-700 truncate" title={row.consignorName}>
// // // //                               {row.consignorName}
// // // //                             </span>
// // // //                             <span className="flex items-center mt-0.5">
// // // //                               <span className="inline-block mr-1 text-[13px] text-slate-400">→</span>
// // // //                               <span
// // // //                                 className="font-semibold text-slate-900 text-[15px] leading-tight truncate max-w-[160px]"
// // // //                                 title={row.consigneeName}
// // // //                               >
// // // //                                 {row.consigneeName}
// // // //                               </span>
// // // //                             </span>
// // // //                           </div>
                     
// // // //                         ) : <LoadingCell />}
// // // //                       </td>

// // // //                       {/* Truck */}
// // // //                       <td className="py-2 px-3 text-slate-500 text-[11px] whitespace-nowrap">
// // // //                         {row ? row.truckNo : <LoadingCell />}
// // // //                       </td>

// // // //                       {/* Wt / Rate / Amt */}
// // // //                       <td className="py-2 px-3">
// // // //                         {row ? (
// // // //                           <div className="flex flex-col gap-0.5">
// // // //                             <span className="text-[10px] text-slate-400">
// // // //                               {fmt(row.totalWeight)} kg &nbsp;@&nbsp; ₹{fmt(row.biltyRate, 2)}/kg
// // // //                             </span>
// // // //                             <span className="text-slate-900 font-medium text-[16px]">
// // // //                               {row.totalItemAmount != null
// // // //                                 ? `₹ ${fmt(row.totalItemAmount, 0)} /-`
// // // //                                 : c.totalamount != null
// // // //                                 ? `₹ ${fmt(c.totalamount, 0)} /-`
// // // //                                 : c.payment
// // // //                                 ? `₹ ${fmt(Number(c.payment), 0)} /-`
// // // //                                 : "-"}
// // // //                             </span>
// // // //                           </div>
// // // //                         ) : <LoadingCell />}
// // // //                       </td>

// // // //                       {/* Status */}
// // // //                       <td className="py-2 px-3 whitespace-nowrap">
// // // //                         <StatusBadge status={getConsignmentStatus(c)} />
// // // //                       </td>

// // // //                       {/* Actions — single dropdown */}
// // // //                       <td className="py-2 px-3 whitespace-nowrap">
// // // //                         <ActionMenu
// // // //                           consignment={c}
// // // //                           hasInvoice={hasInvoice}
// // // //                           onEdit={handleEdit}
// // // //                           onDelete={handleDeleteRequest}
// // // //                           onViewInvoice={handleViewInvoice}
// // // //                           onDownloadInvoice={handleDownloadInvoice}
// // // //                           onShareInvoice={handleShareInvoice}
// // // //                         />
// // // //                       </td>
// // // //                     </tr>
// // // //                   );
// // // //                 })
// // // //               )}
// // // //             </tbody>
// // // //           </table>
// // // //         </div>
// // // //       </div>

// // // //       {/* Delete confirm modal */}
// // // //       <DeleteConfirmModal
// // // //         id={deleteTarget?.id ?? null}
// // // //         bilty={deleteTarget?.bilty ?? ""}
// // // //         onConfirm={handleDeleteConfirm}
// // // //         onCancel={() => setDeleteTarget(null)}
// // // //       />
// // // //     </div>
// // // //   );
// // // // };

// // // // export default ConsignorDashboard;

// // // import React, { useState, useEffect, useRef, useCallback } from "react";
// // // import ReactDOM from "react-dom";
// // // import { useNavigate } from "react-router-dom";

// // // // ─── Types ────────────────────────────────────────────────────────────────────

// // // type ShipmentStatus = "pending" | "in_transit" | "delivered" | "draft" | "created" | "dispatched" | "cancelled";
// // // type FilterOption = "all" | ShipmentStatus;

// // // const API_BASE = process.env.REACT_APP_API_URL;

// // // interface APIConsignment {
// // //   id: number;
// // //   sender: number;
// // //   company: number;
// // //   receiver: number;
// // //   transporter: number;
// // //   driver: number;
// // //   vehicles: number;
// // //   payment: string;
// // //   source: string;
// // //   destination: string;
// // //   receiverAmountStatatus: string;
// // //   senderAmountStatatus: string;
// // //   transporterAmountStatatus: string;
// // //   paymentStatus: string;
// // //   paymentPayableConsignor: number;
// // //   ItemsDescription: string;
// // //   "InvoiceNo"?: string;
// // //   "InvoiceNo."?: string;
// // //   EWAYBILLNO: string;
// // //   subjects: string;
// // //   link?: string;
// // //   status?: ShipmentStatus;
// // //   biltyNo?: string;
// // //   created_at?: string;
// // //   totalamount?: number;
// // //   change_log?: string | null;
// // // }

// // // interface InvoiceItem {
// // //   rate: number;
// // //   id: number;
// // //   invoiceId: string;
// // //   description: string;
// // //   hsm_code: string;
// // //   uom: string;
// // //   qty: number;
// // //   amount: number;
// // // }

// // // interface ResolvedRow {
// // //   consignorName: string;
// // //   consigneeName: string;
// // //   truckNo: string;
// // //   companyName: string;
// // //   totalWeight: number | null;
// // //   biltyRate: number | null;
// // //   totalItemAmount: number | null;
// // // }

// // // type FiltersState = {
// // //   company: string;
// // //   biltyNo: string;
// // //   truckNo: string;
// // //   consignor: string;
// // //   consignee: string;
// // //   dateFrom: string;
// // //   dateTo: string;
// // // };

// // // interface ChangeLogEntry {
// // //   field: string;
// // //   from: any;
// // //   to: any;
// // //   changed_at: string;
// // // }

// // // // ─── Caches ───────────────────────────────────────────────────────────────────

// // // const userCache: Record<number, string> = {};
// // // const vehicleCache: Record<number, string> = {};
// // // const itemsCache: Record<string, InvoiceItem[]> = {};

// // // // ─── Helpers ──────────────────────────────────────────────────────────────────

// // // async function fetchUserName(id: number): Promise<string> {
// // //   if (userCache[id]) return userCache[id];
// // //   try {
// // //     const res = await fetch(`${API_BASE}/auth/user/${id}`);
// // //     if (!res.ok) throw new Error();
// // //     const data = await res.json();
// // //     userCache[id] = data.name || `User#${id}`;
// // //   } catch {
// // //     userCache[id] = `User#${id}`;
// // //   }
// // //   return userCache[id];
// // // }

// // // async function fetchVehicleNumber(id: number): Promise<string> {
// // //   if (vehicleCache[id]) return vehicleCache[id];
// // //   try {
// // //     const res = await fetch(`${API_BASE}/auth/vehicles/${id}`);
// // //     if (!res.ok) throw new Error();
// // //     const data = await res.json();
// // //     vehicleCache[id] = data.registration_number || data.vehicle_number || `Vehicle#${id}`;
// // //   } catch {
// // //     vehicleCache[id] = `Vehicle#${id}`;
// // //   }
// // //   return vehicleCache[id];
// // // }

// // // async function fetchInvoiceItems(invoiceDbId: string): Promise<InvoiceItem[]> {
// // //   if (itemsCache[invoiceDbId]) return itemsCache[invoiceDbId];
// // //   try {
// // //     const res = await fetch(`${API_BASE}/invoiceapi/invoice_items/invoice-db/${invoiceDbId}`);
// // //     if (!res.ok) throw new Error();
// // //     const data: InvoiceItem[] = await res.json();
// // //     itemsCache[invoiceDbId] = Array.isArray(data) ? data : [];
// // //   } catch {
// // //     itemsCache[invoiceDbId] = [];
// // //   }
// // //   return itemsCache[invoiceDbId];
// // // }

// // // function computeItemStats(items: InvoiceItem[]) {
// // //   if (!items.length) return { totalWeight: null, biltyRate: null, totalItemAmount: null };
// // //   const totalWeight = items.reduce((s, i) => s + Number(i.qty || 0), 0);
// // //   const totalAmount = items.reduce((s, i) => s + Number(i.amount || 0), 0);
// // //   const totalRates = items.reduce((s, i) => s + Number(i.rate || 0), 0);
// // //   return { totalWeight, biltyRate: totalRates, totalItemAmount: totalAmount };
// // // }

// // // function fmt(val: number | null | undefined, decimals = 2): string {
// // //   if (val == null) return "-";
// // //   return val % 1 === 0 ? String(val) : val.toFixed(decimals);
// // // }

// // // const getInvoiceNo = (c: APIConsignment): string =>
// // //   c.InvoiceNo || (c as any)["InvoiceNo."] || "";

// // // const getConsignmentStatus = (c: APIConsignment): ShipmentStatus => {
// // //   if (c.status) return c.status;
// // //   if (c.paymentStatus === "to_pay" || c.paymentStatus === "credit") return "pending";
// // //   if (c.paymentStatus === "paid") return "delivered";
// // //   return "pending";
// // // };

// // // /** Generate a short abbreviation from a company name, e.g. "Amit Traders & Co." → "ATC" */
// // // function companyAbbr(name: string): string {
// // //   const NOISE = /^(pvt|ltd|co|inc|corp|private|limited|and|the|of|&)$/i;
// // //   const words = name.split(/[\s&,\.]+/).filter(Boolean);
// // //   const meaningful = words.filter((w) => w.length > 1 && !NOISE.test(w));
// // //   const src = meaningful.length >= 2 ? meaningful : words;
// // //   return src
// // //     .map((w) => w[0].toUpperCase())
// // //     .slice(0, 3)
// // //     .join("");
// // // }

// // // function parseChangeLog(raw: string | null | undefined): ChangeLogEntry[] {
// // //   if (!raw) return [];
// // //   try {
// // //     const parsed = JSON.parse(raw);
// // //     return Array.isArray(parsed) ? parsed : [];
// // //   } catch {
// // //     return [];
// // //   }
// // // }

// // // function fmtChangeValue(v: any): string {
// // //   if (v == null) return "—";
// // //   if (typeof v === "object") {
// // //     // e.g. {id, name, address}
// // //     return v.name ? `${v.name}${v.address ? ` (${v.address})` : ""}` : JSON.stringify(v);
// // //   }
// // //   return String(v);
// // // }

// // // function fmtFieldLabel(field: string): string {
// // //   const labels: Record<string, string> = {
// // //     consignee: "Consignee", consignor: "Consignor", sender: "Sender",
// // //     receiver: "Receiver", vehicle: "Vehicle", origin: "Origin",
// // //     destination: "Destination",
// // //   };
// // //   return labels[field] || field.charAt(0).toUpperCase() + field.slice(1);
// // // }

// // // const PALETTE_KEYS = ["blue", "teal", "amber", "red", "purple", "green", 'coral', 'pink'] as const;

// // // type PaletteKey = typeof PALETTE_KEYS[number];

// // // const PALETTE: Record<PaletteKey, { bg: string; text: string; row: string }> = {
// // //   blue:   { bg: "#E6F1FB", text: "#042C53", row: "rgba(55,138,221,0.18)"  },
// // //   teal:   { bg: "#E1F5EE", text: "#04342C", row: "rgba(29,158,117,0.18)"  },
// // //   amber:  { bg: "#FAEEDA", text: "#412402", row: "rgba(186,117,23,0.18)"  },
// // //   red:    { bg: "#FCEBEB", text: "#501313", row: "rgba(226,75,74,0.18)"   },
// // //   purple: { bg: "#EEEDFE", text: "#26215C", row: "rgba(83,74,183,0.18)"   },
// // //   green:  { bg: "#EAF3DE", text: "#173404", row: "rgba(99,153,34,0.18)"   },
// // //   coral:  { bg: "#FEF0E6", text: "#ffffff", row: "rgba(234,120,40,0.18)"  },
// // //   pink:   { bg: "#F0EBE3", text: "#ffffff", row: "rgba(140,90,40,0.18)"   },
// // // };

// // // /**
// // //  * Assigns palette colors by the ORDER companies are first encountered,
// // //  * not by their numeric ID. This guarantees every company gets a distinct
// // //  * color regardless of ID gaps or clustering (e.g. IDs 1, 7, 13 would all
// // //  * collide with % 6 but get unique slots here).
// // //  * The registry is module-level so it persists across re-renders without
// // //  * needing React state.
// // //  */
// // // const companyColorRegistry = new Map<number, PaletteKey>();

// // // function paletteForCompany(companyId: number): PaletteKey {
// // //   if (companyColorRegistry.has(companyId)) {
// // //     return companyColorRegistry.get(companyId)!;
// // //   }
// // //   // Next unseen slot — cycle only after all 8 colors are used
// // //   const idx = companyColorRegistry.size % PALETTE_KEYS.length;
// // //   const key = PALETTE_KEYS[idx];
// // //   companyColorRegistry.set(companyId, key);
// // //   return key;
// // // }

// // // // ─── Constants ────────────────────────────────────────────────────────────────

// // // const FILTER_OPTIONS: { key: FilterOption; label: string }[] = [
// // //   { key: "all", label: "All" },
// // //   { key: "pending", label: "Pending" },
// // //   { key: "in_transit", label: "In transit" },
// // //   { key: "delivered", label: "Delivered" },
// // //   { key: "draft", label: "Draft" },
// // // ];

// // // const STATUS_STYLES: Record<string, string> = {
// // //   pending:    "bg-amber-100 text-amber-900",
// // //   in_transit: "bg-blue-100 text-blue-900",
// // //   delivered:  "bg-green-100 text-green-900",
// // //   draft:      "bg-slate-100 text-slate-600",
// // //   created:    "bg-slate-100 text-slate-900",
// // //   dispatched: "bg-amber-100 text-amber-800",
// // //   cancelled:  "bg-red-100 text-red-900",
// // // };

// // // const STATUS_LABELS: Record<string, string> = {
// // //   pending: "Pending", in_transit: "In transit", delivered: "Delivered",
// // //   draft: "Draft", created: "Created", dispatched: "Dispatched", cancelled: "Cancelled",
// // // };

// // // // ─── Sub-components ───────────────────────────────────────────────────────────

// // // const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
// // //   <span className={`text-[9px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${STATUS_STYLES[status] || "bg-slate-100 text-slate-900"}`}>
// // //     {STATUS_LABELS[status] || status}
// // //   </span>
// // // );

// // // const DashboardStatCard: React.FC<{ label: string; value: number; color: string }> = ({ label, value, color }) => (
// // //   <div className="rounded-xl bg-slate-50 p-4 flex flex-col justify-center items-center">
// // //     <span className="text-[26px] font-semibold mb-1" style={{ color }}>{value}</span>
// // //     <span className="text-xs font-medium text-slate-500">{label}</span>
// // //   </div>
// // // );

// // // const LoadingCell = () => (
// // //   <span className="text-slate-300 animate-pulse text-xs">Loading…</span>
// // // );

// // // // ─── Company Tag ──────────────────────────────────────────────────────────────

// // // const TAG_SOLID: Record<PaletteKey, string> = {
// // //   blue: "#185FA5",
// // //   teal: "#0F6E56",
// // //   amber: "#BA7517",
// // //   red: "#A32D2D",
// // //   purple: "#534AB7",
// // //   green: "#3B6D11",
// // //   coral: "#b85000",
// // //   pink: "#5a3010",
// // // };

// // // const CompanyTag: React.FC<{ companyId: number; companyName: string }> = ({ companyId, companyName }) => {
// // //   const key = paletteForCompany(companyId);
// // //   const abbr = companyAbbr(companyName);
// // //   return (
// // //     <span
// // //       title={companyName}
// // //       className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold cursor-default whitespace-nowrap"
// // //       style={{ background: TAG_SOLID[key], color: "#ffffff" }}
// // //     >
// // //       {abbr}
// // //     </span>
// // //   );
// // // };

// // // // ─── Action Dropdown (portal-based — escapes overflow:auto clipping) ──────────

// // // interface ActionMenuProps {
// // //   consignment: APIConsignment;
// // //   hasInvoice: boolean;
// // //   hasHistory: boolean;
// // //   onEdit: (id: number) => void;
// // //   onDelete: (id: number) => void;
// // //   onViewInvoice: (c: APIConsignment) => void;
// // //   onDownloadInvoice: (c: APIConsignment) => void;
// // //   onShareInvoice: (c: APIConsignment) => void;
// // //   onViewHistory: (c: APIConsignment) => void;
// // // }

// // // /**
// // //  * Measures the trigger button's position and renders the dropdown menu
// // //  * via a React portal into document.body — so it is never clipped by
// // //  * overflow:auto / overflow:hidden ancestors (e.g. the table scroll wrapper).
// // //  * The menu auto-flips above the button when it would overflow the viewport bottom.
// // //  */
// // // const ActionMenu: React.FC<ActionMenuProps> = ({
// // //   consignment, hasInvoice, hasHistory, onEdit, onDelete, onViewInvoice, onDownloadInvoice, onShareInvoice, onViewHistory,
// // // }) => {
// // //   const [open, setOpen] = useState(false);
// // //   const [menuStyle, setMenuStyle] = useState<React.CSSProperties>({});
// // //   const triggerRef = useRef<HTMLButtonElement>(null);
// // //   const menuRef = useRef<HTMLDivElement>(null);

// // //   const MENU_WIDTH = 184;
// // //   const MENU_HEIGHT_APPROX = 270; // used only for flip detection before actual render

// // //   const reposition = useCallback(() => {
// // //     if (!triggerRef.current) return;
// // //     const r = triggerRef.current.getBoundingClientRect();
// // //     const spaceBelow = window.innerHeight - r.bottom;
// // //     const flipUp = spaceBelow < MENU_HEIGHT_APPROX && r.top > MENU_HEIGHT_APPROX;

// // //     // Align right edge of menu with right edge of trigger; clamp to viewport left
// // //     const right = window.innerWidth - r.right;
// // //     setMenuStyle({
// // //       position: "fixed",
// // //       top: flipUp ? r.top - 4 : r.bottom + 4,
// // //       right,
// // //       width: MENU_WIDTH,
// // //       transform: flipUp ? "translateY(-100%)" : "none",
// // //       zIndex: 9999,
// // //     });
// // //   }, []);

// // //   const toggleOpen = () => {
// // //     if (!open) reposition();
// // //     setOpen((v) => !v);
// // //   };

// // //   // Close on outside click or scroll
// // //   useEffect(() => {
// // //     if (!open) return;
// // //     const close = (e: MouseEvent) => {
// // //       if (
// // //         menuRef.current && !menuRef.current.contains(e.target as Node) &&
// // //         triggerRef.current && !triggerRef.current.contains(e.target as Node)
// // //       ) setOpen(false);
// // //     };
// // //     const onScroll = () => {
// // //       reposition();
// // //     };
// // //     document.addEventListener("mousedown", close);
// // //     window.addEventListener("scroll", onScroll, true); // capture phase catches nested scrollers
// // //     return () => {
// // //       document.removeEventListener("mousedown", close);
// // //       window.removeEventListener("scroll", onScroll, true);
// // //     };
// // //   }, [open, reposition]);

// // //   const invoiceDisabled = !hasInvoice;
// // //   const historyDisabled = !hasHistory;
// // //   const btnCls = "flex items-center gap-2 w-full px-3 py-[7px] text-[12px] text-left hover:bg-slate-50 transition-colors whitespace-nowrap";
// // //   const disabledCls = "opacity-40 cursor-not-allowed pointer-events-none";

// // //   const menu = open ? (
// // //     <div
// // //       ref={menuRef}
// // //       style={menuStyle}
// // //       className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-md"
// // //     >
// // //       {/* Invoice section */}
// // //       <div className="border-b border-slate-100 py-1">
// // //         <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1">Invoice</p>
// // //         <button
// // //           className={`${btnCls} text-blue-800 ${invoiceDisabled ? disabledCls : ""}`}
// // //           disabled={invoiceDisabled}
// // //           onClick={() => { setOpen(false); onViewInvoice(consignment); }}
// // //         >
// // //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
// // //           View invoice
// // //           {invoiceDisabled && <span className="ml-auto text-[9px] text-slate-400">No file</span>}
// // //         </button>
// // //         <button
// // //           className={`${btnCls} text-green-800 ${invoiceDisabled ? disabledCls : ""}`}
// // //           disabled={invoiceDisabled}
// // //           onClick={() => { setOpen(false); onDownloadInvoice(consignment); }}
// // //         >
// // //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
// // //           Download PDF
// // //         </button>
// // //         <button
// // //           className={`${btnCls} text-purple-800 ${invoiceDisabled ? disabledCls : ""}`}
// // //           disabled={invoiceDisabled}
// // //           onClick={() => { setOpen(false); onShareInvoice(consignment); }}
// // //         >
// // //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
// // //           Share link
// // //         </button>
// // //       </div>
// // //       {/* Consignment section */}
// // //       <div className="py-1">
// // //         <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1">Consignment</p>
// // //         <button
// // //           className={`${btnCls} text-slate-700 ${historyDisabled ? disabledCls : ""}`}
// // //           disabled={historyDisabled}
// // //           onClick={() => { setOpen(false); onViewHistory(consignment); }}
// // //         >
// // //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
// // //             <circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/>
// // //           </svg>
// // //           View history
// // //           {historyDisabled && <span className="ml-auto text-[9px] text-slate-400">None</span>}
// // //         </button>
// // //         <button
// // //           className={`${btnCls} text-amber-800`}
// // //           onClick={() => { setOpen(false); onEdit(consignment.id); }}
// // //         >
// // //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
// // //           Edit
// // //         </button>
// // //         <button
// // //           className={`${btnCls} text-red-800 hover:!bg-red-50`}
// // //           onClick={() => { setOpen(false); onDelete(consignment.id); }}
// // //         >
// // //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
// // //           Delete
// // //         </button>
// // //       </div>
// // //     </div>
// // //   ) : null;

// // //   return (
// // //     <>
// // //       <button
// // //         ref={triggerRef}
// // //         onClick={toggleOpen}
// // //         className="inline-flex items-center gap-1.5 text-[11px] px-2.5 py-1 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-600 transition-colors"
// // //       >
// // //         <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
// // //           <circle cx="8" cy="3" r="1.4"/><circle cx="8" cy="8" r="1.4"/><circle cx="8" cy="13" r="1.4"/>
// // //         </svg>
// // //         Actions
// // //         <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" className="opacity-50">
// // //           <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
// // //         </svg>
// // //       </button>
// // //       {ReactDOM.createPortal(menu, document.body)}
// // //     </>
// // //   );
// // // };

// // // // ─── Advanced Filters ─────────────────────────────────────────────────────────

// // // const AdvancedFilters: React.FC<{
// // //   filters: FiltersState;
// // //   onChange: (f: FiltersState) => void;
// // //   companyOptions: string[];
// // //   biltyOptions: string[];
// // //   truckOptions: string[];
// // //   consignorOptions: string[];
// // //   consigneeOptions: string[];
// // // }> = ({ filters, onChange, companyOptions, biltyOptions, truckOptions, consignorOptions, consigneeOptions }) => {
// // //   const sel = "border rounded px-2 py-1 text-xs";
// // //   const inp = "border rounded px-2 py-1 text-xs mt-1 block";

// // //   return (
// // //     <div className="flex flex-wrap gap-3 mb-4">
// // //       <div>
// // //         <label className="block text-xs text-slate-500 mb-1">Company</label>
// // //         <select className={`${sel} w-[160px]`} value={filters.company} onChange={e => onChange({ ...filters, company: e.target.value })}>
// // //           <option value="">All companies</option>
// // //           {companyOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // //         </select>
// // //       </div>
// // //       <div>
// // //         <label className="block text-xs text-slate-500 mb-1">Bilty no.</label>
// // //         <select className={`${sel} w-[140px]`} value={filters.biltyNo} onChange={e => onChange({ ...filters, biltyNo: e.target.value })}>
// // //           <option value="">All bilty nos.</option>
// // //           {biltyOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // //         </select>
// // //         <input className={`${inp} w-[140px]`} placeholder="Search bilty" value={filters.biltyNo} onChange={e => onChange({ ...filters, biltyNo: e.target.value })} />
// // //       </div>
// // //       <div>
// // //         <label className="block text-xs text-slate-500 mb-1">Truck no.</label>
// // //         <select className={`${sel} w-[130px]`} value={filters.truckNo} onChange={e => onChange({ ...filters, truckNo: e.target.value })}>
// // //           <option value="">All trucks</option>
// // //           {truckOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // //         </select>
// // //         <input className={`${inp} w-[130px]`} placeholder="Search truck" value={filters.truckNo} onChange={e => onChange({ ...filters, truckNo: e.target.value })} />
// // //       </div>
// // //       <div>
// // //         <label className="block text-xs text-slate-500 mb-1">Consignor</label>
// // //         <select className={`${sel} w-[130px]`} value={filters.consignor} onChange={e => onChange({ ...filters, consignor: e.target.value })}>
// // //           <option value="">All consignors</option>
// // //           {consignorOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // //         </select>
// // //         <input className={`${inp} w-[130px]`} placeholder="Search consignor" value={filters.consignor} onChange={e => onChange({ ...filters, consignor: e.target.value })} />
// // //       </div>
// // //       <div>
// // //         <label className="block text-xs text-slate-500 mb-1">Consignee</label>
// // //         <select className={`${sel} w-[130px]`} value={filters.consignee} onChange={e => onChange({ ...filters, consignee: e.target.value })}>
// // //           <option value="">All consignees</option>
// // //           {consigneeOptions.map(v => <option key={v} value={v}>{v}</option>)}
// // //         </select>
// // //         <input className={`${inp} w-[130px]`} placeholder="Search consignee" value={filters.consignee} onChange={e => onChange({ ...filters, consignee: e.target.value })} />
// // //       </div>
// // //       <div>
// // //         <label className="block text-xs text-slate-500 mb-1">Date from</label>
// // //         <input type="date" className={`${sel}`} value={filters.dateFrom} onChange={e => onChange({ ...filters, dateFrom: e.target.value })} />
// // //       </div>
// // //       <div>
// // //         <label className="block text-xs text-slate-500 mb-1">Date to</label>
// // //         <input type="date" className={`${sel}`} value={filters.dateTo} onChange={e => onChange({ ...filters, dateTo: e.target.value })} />
// // //       </div>
// // //       <div className="flex items-end">
// // //         <button
// // //           className="text-xs px-3 py-1 border rounded bg-slate-50 text-slate-600"
// // //           onClick={() => onChange({ company: "", biltyNo: "", truckNo: "", consignor: "", consignee: "", dateFrom: "", dateTo: "" })}
// // //         >
// // //           Clear
// // //         </button>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // // ─── Delete Confirm Modal ─────────────────────────────────────────────────────

// // // const DeleteConfirmModal: React.FC<{
// // //   id: number | null;
// // //   bilty: string;
// // //   onConfirm: () => void;
// // //   onCancel: () => void;
// // // }> = ({ id, bilty, onConfirm, onCancel }) => {
// // //   if (id === null) return null;
// // //   return (
// // //     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
// // //       <div className="bg-white rounded-2xl border border-slate-200 p-6 w-[340px] shadow-lg">
// // //         <h3 className="text-[15px] font-medium text-slate-900 mb-2">Delete consignment?</h3>
// // //         <p className="text-xs text-slate-500 mb-5 leading-relaxed">
// // //           You are about to permanently delete <strong>{bilty}</strong>. This action cannot be undone and all associated data will be removed.
// // //         </p>
// // //         <div className="flex gap-3 justify-end">
// // //           <button onClick={onCancel} className="text-xs px-4 py-1.5 border border-slate-200 rounded-lg text-slate-600 hover:bg-slate-50 transition-colors">
// // //             Cancel
// // //           </button>
// // //           <button onClick={onConfirm} className="text-xs px-4 py-1.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
// // //             Delete
// // //           </button>
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // // ─── Change Log Modal ──────────────────────────────────────────────────────────

// // // const ChangeLogModal: React.FC<{
// // //   bilty: string;
// // //   entries: ChangeLogEntry[];
// // //   onClose: () => void;
// // // }> = ({ bilty, entries, onClose }) => {
// // //   return (
// // //     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-2">
// // //       <div className="bg-white rounded-2xl border border-slate-200 p-6 w-full max-w-md shadow-lg max-h-[80vh] flex flex-col">
// // //         <div className="flex items-start justify-between mb-1">
// // //           <h3 className="text-[15px] font-medium text-slate-900">Change history</h3>
// // //           <button onClick={onClose} className="text-slate-400 hover:text-slate-700 transition-colors">
// // //             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
// // //               <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
// // //             </svg>
// // //           </button>
// // //         </div>
// // //         <p className="text-xs text-slate-400 mb-4">{bilty}</p>

// // //         <div className="overflow-y-auto space-y-3 pr-1">
// // //           {entries.length === 0 ? (
// // //             <p className="text-sm text-slate-400 text-center py-6">No changes recorded.</p>
// // //           ) : (
// // //             [...entries].reverse().map((entry, i) => (
// // //               <div key={i} className="border border-slate-100 rounded-xl p-3 bg-slate-50/60">
// // //                 <div className="flex items-center justify-between mb-1.5">
// // //                   <span className="text-[11px] font-semibold text-slate-700 uppercase tracking-wide">
// // //                     {fmtFieldLabel(entry.field)}
// // //                   </span>
// // //                   <span className="text-[10px] text-slate-400">
// // //                     {entry.changed_at
// // //                       ? new Date(entry.changed_at).toLocaleString("en-IN", {
// // //                           day: "2-digit", month: "short", year: "2-digit",
// // //                           hour: "2-digit", minute: "2-digit",
// // //                         })
// // //                       : ""}
// // //                   </span>
// // //                 </div>
// // //                 <div className="flex items-center gap-2 text-xs">
// // //                   <span className="px-2 py-1 rounded-md bg-red-50 text-red-700 line-through decoration-red-300">
// // //                     {fmtChangeValue(entry.from)}
// // //                   </span>
// // //                   <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-slate-400 shrink-0">
// // //                     <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
// // //                   </svg>
// // //                   <span className="px-2 py-1 rounded-md bg-green-50 text-green-800 font-medium">
// // //                     {fmtChangeValue(entry.to)}
// // //                   </span>
// // //                 </div>
// // //               </div>
// // //             ))
// // //           )}
// // //         </div>

// // //         <div className="flex justify-end mt-4">
// // //           <button onClick={onClose} className="text-xs px-4 py-1.5 border border-slate-200 rounded-lg text-slate-600 hover:bg-slate-50 transition-colors">
// // //             Close
// // //           </button>
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // // ─── Main Dashboard ───────────────────────────────────────────────────────────

// // // const ConsignorDashboard: React.FC = () => {
// // //   const navigate = useNavigate();
// // //   const [consignments, setConsignments] = useState<APIConsignment[]>([]);
// // //   const [loading, setLoading] = useState(false);
// // //   const [error, setError] = useState<string | null>(null);
// // //   const [activeFilter, setActiveFilter] = useState<FilterOption>("all");
// // //   const [resolvedRows, setResolvedRows] = useState<Record<number, ResolvedRow>>({});
// // //   const [deleteTarget, setDeleteTarget] = useState<{ id: number; bilty: string } | null>(null);
// // //   const [historyTarget, setHistoryTarget] = useState<{ bilty: string; entries: ChangeLogEntry[] } | null>(null);
// // //   const companyCache: Record<number, string> = {};

// // //   const [filters, setFilters] = useState<FiltersState>({
// // //     company: "", biltyNo: "", truckNo: "", consignor: "", consignee: "", dateFrom: "", dateTo: "",
// // //   });

// // //   async function fetchCompanyName(id: number): Promise<string> {
// // //     if (companyCache[id]) return companyCache[id];
// // //     try {
// // //       const res = await fetch(`${API_BASE}/companyauth/company/${id}`);
// // //       if (!res.ok) throw new Error();
// // //       const data = await res.json();
// // //       companyCache[id] = data.name || data.company_name || `Company#${id}`;
// // //     } catch {
// // //       companyCache[id] = `Company#${id}`;
// // //     }
// // //     return companyCache[id];
// // //   }

// // //   useEffect(() => {
// // //     setLoading(true);
// // //     setError(null);

// // //     fetch(`${API_BASE}/invoiceapi/invoice`)
// // //       .then((res) => res.json())
// // //       .then(async (data) => {
// // //         if (!Array.isArray(data)) { setConsignments([]); return; }

// // //         const mapped: APIConsignment[] = data.map((c: any) => ({
// // //           id: c.id,
// // //           sender: c.sender,
// // //           company: c.company,
// // //           receiver: c.receiver,
// // //           transporter: c.transporter,
// // //           driver: c.driver,
// // //           vehicles: c.vehicles,
// // //           payment: c.payment,
// // //           source: c.source,
// // //           destination: c.destination,
// // //           receiverAmountStatatus: c.receiverAmountStatatus,
// // //           senderAmountStatatus: c.senderAmountStatatus,
// // //           transporterAmountStatatus: c.transporterAmountStatatus,
// // //           paymentStatus: c.paymentStatus,
// // //           paymentPayableConsignor: c.paymentPayableConsignor,
// // //           ItemsDescription: c.ItemsDescription,
// // //           InvoiceNo: c["InvoiceNo"] ?? c["InvoiceNo."] ?? "",
// // //           "InvoiceNo.": c["InvoiceNo."],
// // //           EWAYBILLNO: c.EWAYBILLNO,
// // //           subjects: c.subjects,
// // //           link: c.link ?? c.invoiceLink,
// // //           status: c.status ?? undefined,
// // //           biltyNo: c.biltyNo ?? c["InvoiceNo"] ?? c["InvoiceNo."] ?? "",
// // //           created_at: c.created_at ?? "",
// // //           totalamount: c.totalamount ?? null,
// // //           change_log: c.change_log ?? null,
// // //         }));

// // //         const senderIds   = [...new Set(mapped.map(c => c.sender).filter(Boolean))];
// // //         const receiverIds = [...new Set(mapped.map(c => c.receiver).filter(Boolean))];
// // //         const vehicleIds  = [...new Set(mapped.map(c => c.vehicles).filter(Boolean))];
// // //         const companyIds  = [...new Set(mapped.map(c => c.company).filter(Boolean))];
// // //         const invoiceDbIds = [...new Set(mapped.map(c => String(c.id)).filter(Boolean))];

// // //         // Pre-register companies in a stable order so color assignments are
// // //         // deterministic and don't shift between renders or data fetches.
// // //         companyColorRegistry.clear();
// // //         companyIds.forEach(id => paletteForCompany(id));

// // //         await Promise.allSettled([
// // //           ...senderIds.map(fetchUserName),
// // //           ...receiverIds.map(fetchUserName),
// // //           ...vehicleIds.map(fetchVehicleNumber),
// // //           ...companyIds.map(fetchCompanyName),
// // //           ...invoiceDbIds.map(fetchInvoiceItems),
// // //         ]);

// // //         const resolved: Record<number, ResolvedRow> = {};
// // //         for (const c of mapped) {
// // //           const items = itemsCache[String(c.id)] ?? [];
// // //           const { totalWeight, biltyRate, totalItemAmount } = computeItemStats(items);
// // //           resolved[c.id] = {
// // //             consignorName: c.sender ? userCache[c.sender] || `User#${c.sender}` : "-",
// // //             consigneeName: c.receiver ? userCache[c.receiver] || `User#${c.receiver}` : "-",
// // //             truckNo: c.vehicles ? vehicleCache[c.vehicles] || `Vehicle#${c.vehicles}` : "-",
// // //             companyName: c.company ? companyCache[c.company] || `Company#${c.company}` : "-",
// // //             totalWeight,
// // //             biltyRate,
// // //             totalItemAmount,
// // //           };
// // //         }
// // //         setResolvedRows(resolved);
// // //         setConsignments(mapped);
// // //       })
// // //       .catch(() => setError("Unable to fetch consignments"))
// // //       .finally(() => setLoading(false));
// // //   }, []);

// // //   // ── Invoice action handlers ──
// // //   const handleViewInvoice = useCallback((c: APIConsignment) => {
// // //     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
// // //     if (url) window.open(url, "_blank");
// // //   }, []);

// // //   const handleDownloadInvoice = useCallback((c: APIConsignment) => {
// // //     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
// // //     if (!url) return;
// // //     const a = document.createElement("a");
// // //     a.href = url;
// // //     a.download = `Invoice_${getInvoiceNo(c) || c.EWAYBILLNO || c.id}`;
// // //     document.body.appendChild(a);
// // //     a.click();
// // //     document.body.removeChild(a);
// // //   }, []);

// // //   const handleShareInvoice = useCallback((c: APIConsignment) => {
// // //     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
// // //     if (!url) return;
// // //     if (navigator.share) {
// // //       navigator.share({ title: `Invoice ${getInvoiceNo(c)}`, url });
// // //     } else {
// // //       navigator.clipboard.writeText(url);
// // //       alert("Invoice link copied!");
// // //     }
// // //   }, []);

// // //   const handleEdit = useCallback((id: number) => {
// // //     navigate(`/admin/edit/consignments/${id}`);
// // //   }, [navigate]);

// // //   const handleViewHistory = useCallback((c: APIConsignment) => {
// // //     const entries = parseChangeLog(c.change_log);
// // //     setHistoryTarget({ bilty: c.biltyNo || getInvoiceNo(c) || String(c.id), entries });
// // //   }, []);

// // //   const handleDeleteRequest = useCallback((id: number) => {
// // //     const c = consignments.find(x => x.id === id);
// // //     setDeleteTarget({ id, bilty: c?.biltyNo || getInvoiceNo(c!) || String(id) });
// // //   }, [consignments]);

// // //   const handleDeleteConfirm = useCallback(async () => {
// // //     if (!deleteTarget) return;
// // //     const { id } = deleteTarget;
// // //     setDeleteTarget(null);
// // //     try {
// // //       const res = await fetch(`${API_BASE}/invoiceapi/invoice/${id}`, { method: "DELETE" });
// // //       if (res.ok || res.status === 404) {
// // //         setConsignments(prev => prev.filter(c => c.id !== id));
// // //       } else {
// // //         const err = await res.json();
// // //         alert(`Failed to delete: ${err.error || "Unknown error"}`);
// // //       }
// // //     } catch (e: any) {
// // //       alert(`Failed to delete: ${e?.message || e}`);
// // //     }
// // //   }, [deleteTarget]);

// // //   // ── Dropdown options ──
// // //   const companyOptions = [...new Set(Object.values(resolvedRows).map(r => r.companyName).filter(v => v && v !== "-"))];
// // //   const biltyOptions = [...new Set(consignments.map(c => c.biltyNo || getInvoiceNo(c)).filter(Boolean))];
// // //   const truckOptions = [...new Set(Object.values(resolvedRows).map(r => r.truckNo).filter(v => v && v !== "-"))];
// // //   const consignorOptions = [...new Set(Object.values(resolvedRows).map(r => r.consignorName).filter(v => v && v !== "-"))];
// // //   const consigneeOptions = [...new Set(Object.values(resolvedRows).map(r => r.consigneeName).filter(v => v && v !== "-"))];

// // //   // ── Filtering + sorting ──
// // //   const filtered = consignments
// // //     .filter((c) => {
// // //       const row = resolvedRows[c.id];
// // //       if (activeFilter !== "all" && getConsignmentStatus(c) !== activeFilter) return false;
// // //       if (filters.company && row && row.companyName !== filters.company) return false;
// // //       if (filters.biltyNo) {
// // //         const q = filters.biltyNo.toLowerCase();
// // //         const bn = (c.biltyNo || getInvoiceNo(c) || "").toLowerCase();
// // //         if (!bn.includes(q)) return false;
// // //       }
// // //       if (filters.truckNo && row) {
// // //         if (!String(row.truckNo || "").toLowerCase().includes(filters.truckNo.toLowerCase())) return false;
// // //       }
// // //       if (filters.consignor && row) {
// // //         if (!String(row.consignorName || "").toLowerCase().includes(filters.consignor.toLowerCase())) return false;
// // //       }
// // //       if (filters.consignee && row) {
// // //         if (!String(row.consigneeName || "").toLowerCase().includes(filters.consignee.toLowerCase())) return false;
// // //       }
// // //       if (filters.dateFrom && c.created_at) {
// // //         if (new Date(c.created_at).toISOString().slice(0, 10) < filters.dateFrom) return false;
// // //       }
// // //       if (filters.dateTo && c.created_at) {
// // //         if (new Date(c.created_at).toISOString().slice(0, 10) > filters.dateTo) return false;
// // //       }
// // //       return true;
// // //     })
// // //     .sort((a, b) => {
// // //       const ba = (a.biltyNo || getInvoiceNo(a) || "").toString();
// // //       const bb = (b.biltyNo || getInvoiceNo(b) || "").toString();
// // //       const cmp = ba.localeCompare(bb, undefined, { numeric: true, sensitivity: "base" });
// // //       if (cmp !== 0) return cmp;
// // //       return (a.created_at ? new Date(a.created_at).getTime() : 0) -
// // //              (b.created_at ? new Date(b.created_at).getTime() : 0);
// // //     });

// // //   const stats = [
// // //     { label: "Total",      value: consignments.length,                                              color: "#185FA5" },
// // //     { label: "Pending",    value: consignments.filter(c => getConsignmentStatus(c) === "pending").length,    color: "#854F0B" },
// // //     { label: "In transit", value: consignments.filter(c => getConsignmentStatus(c) === "in_transit").length, color: "#534AB7" },
// // //     { label: "Delivered",  value: consignments.filter(c => getConsignmentStatus(c) === "delivered").length,  color: "#3B6D11" },
// // //   ];

// // //   // ── Table column headers ──
// // //   const HEADERS = ["#", "Date · Bilty", "Company", "Route", "Parties", "Truck", "Wt / Rate / Amt", "Status", "Actions"];

// // //   return (
// // //     <div className="p-4 md:p-6 space-y-4">
// // //       {/* Stats */}
// // //       <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
// // //         {stats.map(s => <DashboardStatCard key={s.label} {...s} />)}
// // //       </div>

// // //       {/* Panel */}
// // //       <div className="bg-white border border-slate-100 rounded-2xl p-4">
// // //         <div className="flex items-center justify-between mb-3">
// // //           <div>
// // //             <h2 className="text-[16px] font-medium text-slate-900">My Consignments</h2>
// // //             <p className="text-xs text-slate-400">View and manage your consignments &amp; invoices</p>
// // //           </div>
// // //           <button
// // //             className="text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
// // //             onClick={() => navigate("/admin/add/consignments")}
// // //           >
// // //             + New Consignment
// // //           </button>
// // //         </div>

// // //         {/* Status pills */}
// // //         <div className="flex flex-wrap gap-1.5 mb-4">
// // //           {FILTER_OPTIONS.map(({ key, label }) => (
// // //             <button
// // //               key={key}
// // //               onClick={() => setActiveFilter(key)}
// // //               className={`text-xs px-3 py-1 rounded-full border transition-colors ${
// // //                 activeFilter === key
// // //                   ? "bg-slate-900 text-white border-transparent"
// // //                   : "border-slate-200 text-slate-500 hover:bg-slate-50"
// // //               }`}
// // //             >
// // //               {label}
// // //             </button>
// // //           ))}
// // //         </div>

// // //         <AdvancedFilters
// // //           filters={filters}
// // //           onChange={setFilters}
// // //           companyOptions={companyOptions}
// // //           biltyOptions={biltyOptions}
// // //           truckOptions={truckOptions}
// // //           consignorOptions={consignorOptions}
// // //           consigneeOptions={consigneeOptions}
// // //         />

// // //         {/* Table */}
// // //         <div className="overflow-x-auto">
// // //           <table className="w-full text-[12px]" style={{ minWidth: 820 }}>
// // //             <thead>
// // //               <tr className="border-b border-slate-100">
// // //                 {HEADERS.map(h => (
// // //                   <th key={h} className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap text-[10px]">{h}</th>
// // //                 ))}
// // //               </tr>
// // //             </thead>
// // //             <tbody>
// // //               {loading ? (
// // //                 <tr><td colSpan={9} className="py-6 text-center text-slate-400">Loading…</td></tr>
// // //               ) : error ? (
// // //                 <tr><td colSpan={9} className="py-6 text-center text-red-600">{error}</td></tr>
// // //               ) : filtered.length === 0 ? (
// // //                 <tr><td colSpan={9} className="py-8 text-center text-slate-400">No consignments found.</td></tr>
// // //               ) : (
// // //                 filtered.map((c, idx) => {
// // //                   const row = resolvedRows[c.id];
// // //                   const palKey = paletteForCompany(c.company);
// // //                   const pal = PALETTE[palKey];
// // //                   const hasInvoice = !!c.link;
// // //                   const hasHistory = !!c.change_log;

// // //                   return (
// // //                     <tr
// // //                       key={c.id}
// // //                       className="border-b border-slate-100 transition-all"
// // //                       style={{ background: pal.row }}
// // //                     >
// // //                       {/* # */}
// // //                       <td className="py-2 px-3 text-slate-400 text-[11px]">{idx + 1}</td>

// // //                       {/* Date · Bilty */}
// // //                       <td className="py-2 px-3">
// // //                         <div className="flex flex-col gap-0.5">
// // //                           <span className="text-slate-900 font-medium">{c.biltyNo || getInvoiceNo(c) || "-"}</span>
// // //                           <span className="text-[10px] text-slate-400">
// // //                             {c.created_at ? new Date(c.created_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "2-digit" }) : "-"}
// // //                           </span>
// // //                         </div>
// // //                       </td>

// // //                       {/* Company */}
// // //                       <td className="py-2 px-3">
// // //                         {row
// // //                           ? <CompanyTag companyId={c.company} companyName={row.companyName} />
// // //                           : <LoadingCell />}
// // //                       </td>

// // //                       {/* Route */}
// // //                       <td className="py-2 px-3">
// // //                         <div className="flex flex-col gap-0.5">
// // //                           <span className="text-slate-800 text-[11px]">{c.source || "-"}</span>
// // //                           <span className="text-[10px] text-slate-400">→ {c.destination || "-"}</span>
// // //                         </div>
// // //                       </td>

// // //                       {/* Parties */}
// // //                       <td className="py-2 px-3">
// // //                         {row ? (
// // //                           <div className="flex flex-col gap-1">
// // //                             <span className="text-[11px] text-slate-700 truncate" title={row.consignorName}>
// // //                               {row.consignorName}
// // //                             </span>
// // //                             <span className="flex items-center mt-0.5">
// // //                               <span className="inline-block mr-1 text-[13px] text-slate-400">→</span>
// // //                               <span
// // //                                 className="font-semibold text-slate-900 text-[15px] leading-tight truncate max-w-[160px]"
// // //                                 title={row.consigneeName}
// // //                               >
// // //                                 {row.consigneeName}
// // //                               </span>
// // //                             </span>
// // //                           </div>

// // //                         ) : <LoadingCell />}
// // //                       </td>

// // //                       {/* Truck */}
// // //                       <td className="py-2 px-3 text-slate-500 text-[11px] whitespace-nowrap">
// // //                         {row ? row.truckNo : <LoadingCell />}
// // //                       </td>

// // //                       {/* Wt / Rate / Amt */}
// // //                       <td className="py-2 px-3">
// // //                         {row ? (
// // //                           <div className="flex flex-col gap-0.5">
// // //                             <span className="text-[10px] text-slate-400">
// // //                               {fmt(row.totalWeight)} kg &nbsp;@&nbsp; ₹{fmt(row.biltyRate, 2)}/kg
// // //                             </span>
// // //                             <span className="text-slate-900 font-medium text-[16px]">
// // //                               {row.totalItemAmount != null
// // //                                 ? `₹ ${fmt(row.totalItemAmount, 0)} /-`
// // //                                 : c.totalamount != null
// // //                                 ? `₹ ${fmt(c.totalamount, 0)} /-`
// // //                                 : c.payment
// // //                                 ? `₹ ${fmt(Number(c.payment), 0)} /-`
// // //                                 : "-"}
// // //                             </span>
// // //                           </div>
// // //                         ) : <LoadingCell />}
// // //                       </td>

// // //                       {/* Status */}
// // //                       <td className="py-2 px-3 whitespace-nowrap">
// // //                         <StatusBadge status={getConsignmentStatus(c)} />
// // //                       </td>

// // //                       {/* Actions — single dropdown */}
// // //                       <td className="py-2 px-3 whitespace-nowrap">
// // //                         <ActionMenu
// // //                           consignment={c}
// // //                           hasInvoice={hasInvoice}
// // //                           hasHistory={hasHistory}
// // //                           onEdit={handleEdit}
// // //                           onDelete={handleDeleteRequest}
// // //                           onViewInvoice={handleViewInvoice}
// // //                           onDownloadInvoice={handleDownloadInvoice}
// // //                           onShareInvoice={handleShareInvoice}
// // //                           onViewHistory={handleViewHistory}
// // //                         />
// // //                       </td>
// // //                     </tr>
// // //                   );
// // //                 })
// // //               )}
// // //             </tbody>
// // //           </table>
// // //         </div>
// // //       </div>

// // //       {/* History modal */}
// // //       {historyTarget && (
// // //         <ChangeLogModal
// // //           bilty={historyTarget.bilty}
// // //           entries={historyTarget.entries}
// // //           onClose={() => setHistoryTarget(null)}
// // //         />
// // //       )}

// // //       {/* Delete confirm modal */}
// // //       <DeleteConfirmModal
// // //         id={deleteTarget?.id ?? null}
// // //         bilty={deleteTarget?.bilty ?? ""}
// // //         onConfirm={handleDeleteConfirm}
// // //         onCancel={() => setDeleteTarget(null)}
// // //       />
// // //     </div>
// // //   );
// // // };

// // // export default ConsignorDashboard;

// // import React, { useState, useEffect, useRef, useCallback } from "react";
// // import ReactDOM from "react-dom";
// // import { useNavigate } from "react-router-dom";
// // import jsPDF from "jspdf";
// // import autoTable from "jspdf-autotable";
// // import * as XLSX from "xlsx";
// // import ExcelJS from "exceljs";
// // // ─── Types ────────────────────────────────────────────────────────────────────

// // type ShipmentStatus = "pending" | "in_transit" | "delivered" | "draft" | "created" | "dispatched" | "cancelled";
// // // type FilterOption = "all" | ShipmentStatus | "modified";
// // type FilterOption = "all" | "pending" | "completed" | "modified";

// // const API_BASE = process.env.REACT_APP_API_URL;

// // interface APIConsignment {
// //   id: number;
// //   sender: number;
// //   company: number;
// //   receiver: number;
// //   transporter: number;
// //   driver: number;
// //   vehicles: number;
// //   payment: string;
// //   source: string;
// //   destination: string;
// //   receiverAmountStatatus: string;
// //   senderAmountStatatus: string;
// //   transporterAmountStatatus: string;
// //   paymentStatus: string;
// //   paymentPayableConsignor: number;
// //   ItemsDescription: string;
// //   "InvoiceNo"?: string;
// //   "InvoiceNo."?: string;
// //   EWAYBILLNO: string;
// //   subjects: string;
// //   link?: string;
// //   status?: ShipmentStatus;
// //   biltyNo?: string;
// //   created_at?: string;
// //   totalamount?: number;
// //   change_log?: string | null;
// //   billing_status?: "pending" | "completed";
// //   billing_status_forced?: number;
// // }

// // interface InvoiceItem {
// //   rate: number;
// //   id: number;
// //   invoiceId: string;
// //   description: string;
// //   hsm_code: string;
// //   uom: string;
// //   qty: number;
// //   amount: number;
// // }

// // interface ResolvedRow {
// //   consignorName: string;
// //   consigneeName: string;
// //   truckNo: string;
// //   companyName: string;
// //   totalWeight: number | null;
// //   biltyRate: number | null;
// //   totalItemAmount: number | null;
// // }

// // type FiltersState = {
// //   company: string;
// //   biltyNo: string;
// //   truckNo: string;
// //   consignor: string;
// //   consignee: string;
// //   dateFrom: string;
// //   dateTo: string;
// // };

// // interface ChangeLogEntry {
// //   field: string;
// //   from: any;
// //   to: any;
// //   changed_at: string;
// // }

// // /**
// //  * Letterhead / billing-identity settings — these belong to YOUR firm
// //  * (the transport company issuing the bill), not to any consignment.
// //  * They are fetched once from the backend so the printed bill always
// //  * reflects current PAN, bank details, etc. without a code change.
// //  *
// //  * Expected response shape from `${API_BASE}${LETTERHEAD_ENDPOINT}`:
// //  * {
// //  *   "panNo": "AFRPJ6942A",
// //  *   "mobile": "9829172167",
// //  *   "companyName": "VARDHMAN FREIGHT CARRIER",
// //  *   "addressLine1": "310, NEAR SHANTINATH DIGAMBER JAIN MANDIR, INDIRA NAGAR",
// //  *   "addressLine2": "JAIPUR ROAD, MADANGANJ KISHANGARH",
// //  *   "billNoPrefix": "VFC",
// //  *   "bankName": "IDBI BANK",
// //  *   "accountNo": "0055102000031994",
// //  *   "ifscCode": "IBKL0000055",
// //  *   "branch": "KISHANGARH",
// //  *   "signatoryName": "Nisha Jain",
// //  *   "signatoryTitle": "Prop./Manager",
// //  *   "paymentNote": "Payment Through A/c payee cheque/Draft Only"
// //  * }
// //  */
// // interface BillingLetterhead {
// //   panNo: string;
// //   mobile: string;
// //   companyName: string;
// //   addressLine1: string;
// //   addressLine2: string;
// //   billNoPrefix: string;
// //   bankName: string;
// //   accountNo: string;
// //   ifscCode: string;
// //   branch: string;
// //   signatoryName: string;
// //   signatoryTitle: string;
// //   paymentNote: string;
// // }

// // interface BillItemRow {
// //   consignmentId: number;
// //   date: string;       // formatted DD.MM.YY
// //   consignorName: string;
// //   grNo: string;
// //   vehicleNo: string;
// //   weight: number | null;
// //   rate: number | null;
// //   amount: number | null;
// // }

// // interface BillGroup {
// //   companyId: number;
// //   companyName: string;
// //   companyAddress: string;   // NEW — the sub-line under the billed company name
// //   rows: BillItemRow[];
// // }

// // // ─── Caches ───────────────────────────────────────────────────────────────────

// // const userCache: Record<number, string> = {};
// // const vehicleCache: Record<number, string> = {};
// // const itemsCache: Record<string, InvoiceItem[]> = {};
// // const companyCache: Record<number, string> = {};        // NEW — moved out of component
// // const companyAddressCache: Record<number, string> = {}; 
// // // ─── Letterhead config ─────────────────────────────────────────────────────────

// // // const LETTERHEAD_ENDPOINT = "/companyauth/letterhead";

// // // Used only until the API call resolves (or if it fails) so the bill is
// // // never blank — replace values here only as a last-resort fallback.
// // const DEFAULT_LETTERHEAD: BillingLetterhead = {
// //   panNo: "",
// //   mobile: "",
// //   companyName: "",
// //   addressLine1: "",
// //   addressLine2: "",
// //   billNoPrefix: "BILL",
// //   bankName: "",
// //   accountNo: "",
// //   ifscCode: "",
// //   branch: "",
// //   signatoryName: "",
// //   signatoryTitle: "",
// //   paymentNote: "",
// // };

// // // ─── Helpers ──────────────────────────────────────────────────────────────────

// // async function fetchUserName(id: number): Promise<string> {
// //   if (userCache[id]) return userCache[id];
// //   try {
// //     const res = await fetch(`${API_BASE}/auth/user/${id}`);
// //     if (!res.ok) throw new Error();
// //     const data = await res.json();
// //     userCache[id] = data.name || `User#${id}`;
// //   } catch {
// //     userCache[id] = `User#${id}`;
// //   }
// //   return userCache[id];
// // }
// // async function fetchCompanyDetails(id: number): Promise<{ name: string; address: string }> {
// //   if (companyCache[id] && companyAddressCache[id] !== undefined) {
// //     return { name: companyCache[id], address: companyAddressCache[id] };
// //   }
// //   try {
// //     const res = await fetch(`${API_BASE}/companyAuth/company/${id}`); // note: camelCase, see earlier flag
// //     if (!res.ok) throw new Error();
// //     const data = await res.json();
// //     companyCache[id] = data.company_name || data.name || `Company#${id}`;
// //     companyAddressCache[id] = data.address || "";
// //   } catch {
// //     companyCache[id] = companyCache[id] || `Company#${id}`;
// //     companyAddressCache[id] = companyAddressCache[id] || "";
// //   }
// //   return { name: companyCache[id], address: companyAddressCache[id] };
// // }
// // async function fetchVehicleNumber(id: number): Promise<string> {
// //   if (vehicleCache[id]) return vehicleCache[id];
// //   try {
// //     const res = await fetch(`${API_BASE}/auth/vehicles/${id}`);
// //     if (!res.ok) throw new Error();
// //     const data = await res.json();
// //     vehicleCache[id] = data.registration_number || data.vehicle_number || `Vehicle#${id}`;
// //   } catch {
// //     vehicleCache[id] = `Vehicle#${id}`;
// //   }
// //   return vehicleCache[id];
// // }

// // async function fetchInvoiceItems(invoiceDbId: string): Promise<InvoiceItem[]> {
// //   if (itemsCache[invoiceDbId]) return itemsCache[invoiceDbId];
// //   try {
// //     const res = await fetch(`${API_BASE}/invoiceapi/invoice_items/invoice-db/${invoiceDbId}`);
// //     if (!res.ok) throw new Error();
// //     const data: InvoiceItem[] = await res.json();
// //     itemsCache[invoiceDbId] = Array.isArray(data) ? data : [];
// //   } catch {
// //     itemsCache[invoiceDbId] = [];
// //   }
// //   return itemsCache[invoiceDbId];
// // }

// // function computeItemStats(items: InvoiceItem[]) {
// //   if (!items.length) return { totalWeight: null, biltyRate: null, totalItemAmount: null };
// //   const totalWeight = items.reduce((s, i) => s + Number(i.qty || 0), 0);
// //   const totalAmount = items.reduce((s, i) => s + Number(i.amount || 0), 0);
// //   const totalRates = items.reduce((s, i) => s + Number(i.rate || 0), 0);
// //   return { totalWeight, biltyRate: totalRates, totalItemAmount: totalAmount };
// // }

// // function fmt(val: number | null | undefined, decimals = 2): string {
// //   if (val == null) return "-";
// //   return val % 1 === 0 ? String(val) : val.toFixed(decimals);
// // }

// // const getInvoiceNo = (c: APIConsignment): string =>
// //   c.InvoiceNo || (c as any)["InvoiceNo."] || "";

// // const getConsignmentStatus = (c: APIConsignment): ShipmentStatus => {
// //   if (c.status) return c.status;
// //   if (c.paymentStatus === "to_pay" || c.paymentStatus === "credit") return "pending";
// //   if (c.paymentStatus === "paid") return "delivered";
// //   return "pending";
// // };
// // const getBillingStatus = (c: APIConsignment): "pending" | "completed" =>
// //   c.billing_status === "completed" ? "completed" : "pending";
// // /** Generate a short abbreviation from a company name, e.g. "Amit Traders & Co." → "ATC" */
// // function companyAbbr(name: string): string {
// //   const NOISE = /^(pvt|ltd|co|inc|corp|private|limited|and|the|of|&)$/i;
// //   const words = name.split(/[\s&,\.]+/).filter(Boolean);
// //   const meaningful = words.filter((w) => w.length > 1 && !NOISE.test(w));
// //   const src = meaningful.length >= 2 ? meaningful : words;
// //   return src
// //     .map((w) => w[0].toUpperCase())
// //     .slice(0, 3)
// //     .join("");
// // }

// // function parseChangeLog(raw: string | null | undefined): ChangeLogEntry[] {
// //   if (!raw) return [];
// //   try {
// //     const parsed = JSON.parse(raw);
// //     return Array.isArray(parsed) ? parsed : [];
// //   } catch {
// //     return [];
// //   }
// // }

// // function fmtChangeValue(v: any): string {
// //   if (v == null) return "—";
// //   if (typeof v === "object") {
// //     // e.g. {id, name, address}
// //     return v.name ? `${v.name}${v.address ? ` (${v.address})` : ""}` : JSON.stringify(v);
// //   }
// //   return String(v);
// // }

// // function fmtFieldLabel(field: string): string {
// //   const labels: Record<string, string> = {
// //     consignee: "Consignee", consignor: "Consignor", sender: "Sender",
// //     receiver: "Receiver", vehicle: "Vehicle", origin: "Origin",
// //     destination: "Destination",
// //   };
// //   return labels[field] || field.charAt(0).toUpperCase() + field.slice(1);
// // }

// // // ─── Bill formatting helpers ───────────────────────────────────────────────────

// // function formatBillDate(iso: string | undefined): string {
// //   if (!iso) return "-";
// //   const d = new Date(iso);
// //   if (isNaN(d.getTime())) return "-";
// //   const dd = String(d.getDate()).padStart(2, "0");
// //   const mm = String(d.getMonth() + 1).padStart(2, "0");
// //   const yy = String(d.getFullYear()).slice(-2);
// //   return `${dd}.${mm}.${yy}`;
// // }

// // function todayBillDate(): string {
// //   return formatBillDate(new Date().toISOString());
// // }

// // /** Groups consignments by billed-to company and shapes each row for the bill table. */
// // function buildBillGroups(
// //   items: APIConsignment[],
// //   resolvedRows: Record<number, ResolvedRow>
// // ): BillGroup[] {
// //   const groups = new Map<number, BillGroup>();
// //   for (const c of items) {
// //     const row = resolvedRows[c.id];
// //     if (!groups.has(c.company)) {
// //       groups.set(c.company, {
// //         companyId: c.company,
// //         companyName: row?.companyName && row.companyName !== "-" ? row.companyName : `Company#${c.company}`,
// //         companyAddress: companyAddressCache[c.company] || "",   // NEW

// //         rows: [],
// //       });
// //     }
// //     groups.get(c.company)!.rows.push({
// //       consignmentId: c.id,
// //       date: formatBillDate(c.created_at),
// //       consignorName: row?.consignorName && row.consignorName !== "-" ? row.consignorName : "-",
// //       grNo: c.biltyNo || getInvoiceNo(c) || String(c.id),
// //       vehicleNo: row?.truckNo && row.truckNo !== "-" ? row.truckNo : "-",
// //       weight: row?.totalWeight ?? null,
// //       rate: row?.biltyRate ?? null,
// //       amount: row?.totalItemAmount ?? c.totalamount ?? null,
// //     });
// //   }
// //   // Keep each group's rows sorted by date for a sane bill order
// //   for (const g of groups.values()) {
// //     g.rows.sort((a, b) => a.date.localeCompare(b.date));
// //   }
// //   return Array.from(groups.values());
// // }

// // function generateBillNo(letterhead: BillingLetterhead, seq: number): string {
// //   return `${letterhead.billNoPrefix} ${seq} / ${todayBillDate()}`;
// // }

// // function safeFileSegment(s: string): string {
// //   return s.replace(/[^\w\-]+/g, "_").replace(/^_+|_+$/g, "");
// // }

// // // ─── PDF / Excel generation (Vardhman-style bilty layout) ──────────────────────

// // function drawBillPDF(doc: jsPDF, letterhead: BillingLetterhead, group: BillGroup, billNo: string) {
// //   const marginX = 12;
// //   const pageWidth = doc.internal.pageSize.getWidth();
// //   const boxW = pageWidth - marginX * 2;
// //   const boxTop = 14;
// //   const NAVY: [number, number, number] = [26, 42, 90];
// //   let y = boxTop;

// //   // ── PAN / MOB row ──
// //   doc.setTextColor(0, 0, 0);
// //   doc.setFont("helvetica", "bold");
// //   doc.setFontSize(9);
// //   doc.text(`PAN NO ${letterhead.panNo}`, marginX + 2, y + 5);
// //   doc.text(`MOB:-${letterhead.mobile}`, marginX + boxW - 2, y + 5, { align: "right" });
// //   y += 11;

// //   // ── Big heading: issuing company (navy, bold, centered) ──
// //   doc.setTextColor(...NAVY);
// //   doc.setFont("helvetica", "bold");
// //   doc.setFontSize(17);
// //   doc.text(letterhead.companyName, pageWidth / 2, y, { align: "center" });
// //   y += 5.5;
// //   doc.setFont("helvetica", "normal");
// //   doc.setFontSize(8.5);
// //   doc.text(letterhead.addressLine1, pageWidth / 2, y, { align: "center" });
// //   y += 4;
// //   doc.text(letterhead.addressLine2, pageWidth / 2, y, { align: "center" });
// //   y += 9;

// //   // ── Bill No / To (black, left) ──
// //   doc.setTextColor(0, 0, 0);
// //   doc.setFont("helvetica", "bold");
// //   doc.setFontSize(9);
// //   doc.text(`BILL NO   ${billNo}`, marginX + 2, y);
// //   y += 5;
// //   doc.setFont("helvetica", "normal");
// //   doc.text("To,", marginX + 2, y);
// //   y += 6;

// //   // ── Billed-to company (bold, centered) + sub-line address (centered) ──
// //   doc.setFont("helvetica", "bold");
// //   doc.setFontSize(13);
// //   doc.text(group.companyName.toUpperCase(), pageWidth / 2, y, { align: "center" });
// //   if (group.companyAddress) {
// //     y += 5;
// //     doc.setFont("helvetica", "normal");
// //     doc.setFontSize(9);
// //     doc.text(group.companyAddress.toUpperCase(), pageWidth / 2, y, { align: "center" });
// //   }
// //   y += 6;

// //   const totalWeight = group.rows.reduce((s, r) => s + (r.weight ?? 0), 0);
// //   const totalAmount = group.rows.reduce((s, r) => s + (r.amount ?? 0), 0);

// //   const paddedRowCount = Math.max(group.rows.length, 5);
// //   const body: any[] = [];
// //   for (let i = 0; i < paddedRowCount; i++) {
// //     const r = group.rows[i];
// //     body.push(
// //       r
// //         ? [i + 1, r.date, r.consignorName, r.grNo, r.vehicleNo, fmt(r.weight, 3), fmt(r.rate, 2), fmt(r.amount, 2)]
// //         : [i + 1, "", "", "", "", "", "", "-"]
// //     );
// //   }

// //   autoTable(doc, {
// //     startY: y,
// //     margin: { left: marginX, right: marginX },
// //     theme: "grid",
// //     styles: { fontSize: 8, cellPadding: 1.6, lineColor: [0, 0, 0], lineWidth: 0.1, textColor: 20 },
// //     headStyles: { fillColor: [255, 255, 255], textColor: 0, fontStyle: "bold", halign: "center" },
// //     footStyles: { fillColor: [255, 255, 255], textColor: 0, fontStyle: "bold" },
// //     head: [["SR. NO", "DATE", "CONSIGNOR NAME", "G.R. NO", "VEHICLE NO", "WEIGHT", "RATE", "AMOUNT"]],
// //     body,
// //     foot: [[
// //       { content: "TOTAL AMOUNT", colSpan: 5, styles: { halign: "center", fontStyle: "bold" } },
// //       fmt(totalWeight, 2),
// //       "",
// //       fmt(totalAmount, 2),
// //     ]],
// //     columnStyles: {
// //       0: { cellWidth: 12, halign: "center" },
// //       1: { cellWidth: 18, halign: "center" },
// //       2: { cellWidth: 44 },
// //       3: { cellWidth: 18, halign: "center" },
// //       4: { cellWidth: 26, halign: "center" },
// //       5: { cellWidth: 20, halign: "right" },
// //       6: { cellWidth: 18, halign: "right" },
// //       7: { cellWidth: 26, halign: "right" },
// //     },
// //   });

// //   const finalY = (doc as any).lastAutoTable.finalY as number;

// //   // ── Bottom-left: Bank details ──
// //   let by = finalY + 7;
// //   doc.setFont("helvetica", "bold");
// //   doc.setFontSize(8.5);
// //   doc.text("Bank Detail:", marginX + 2, by);
// //   by += 4;
// //   doc.text(letterhead.bankName, marginX + 2, by);
// //   doc.setFont("helvetica", "normal");
// //   by += 4;
// //   doc.text(`A/C NO :- ${letterhead.accountNo}`, marginX + 2, by);
// //   by += 4;
// //   doc.text(`IFSC CODE :- ${letterhead.ifscCode}`, marginX + 2, by);
// //   by += 4;
// //   doc.text(`Branch :- ${letterhead.branch}`, marginX + 2, by);

// //   // ── Right side: two columns — signature block, and far-right E&OE/company ──
// //   const rightX = marginX + boxW - 2;      // far-right edge (E&OE column)
// //   const signX = marginX + boxW - 46;      // signature block, ~46mm from right edge

// //   let sy = finalY + 7;
// //   doc.setFontSize(8);
// //   doc.setFont("helvetica", "normal");
// //   doc.text(`For ${letterhead.companyName}`, signX, sy, { align: "right" });
// //   doc.text("E. & O.E.", rightX, sy, { align: "right" });
// //   sy += 10;
// //   doc.text(letterhead.signatoryName, signX, sy, { align: "right" });
// //   doc.setFont("helvetica", "bold");
// //   doc.text(letterhead.companyName.toUpperCase(), rightX, sy, { align: "right" });
// //   sy += 4;
// //   doc.text(letterhead.signatoryTitle, signX, sy, { align: "right" });

// //   // ── Bottom-left: Encl / payment note / Accountant ──
// //   let fy = by + 8;
// //   doc.setFont("helvetica", "normal");
// //   doc.text("Encl:", marginX + 2, fy);
// //   fy += 4;
// //   doc.setFont("helvetica", "bold");
// //   doc.text(letterhead.paymentNote, marginX + 2, fy);
// //   doc.setFont("helvetica", "normal");
// //   fy += 6;
// //   doc.text("Accountant", marginX + 20, fy);

// //   const boxBottom = Math.max(fy, sy) + 4;
// //   doc.setLineWidth(0.3);
// //   doc.rect(marginX - 2, boxTop - 4, boxW + 4, boxBottom - (boxTop - 4));
// // }

// // function exportBillToPDF(letterhead: BillingLetterhead, group: BillGroup, billNo: string) {
// //   const doc = new jsPDF({ unit: "mm", format: "a4" });
// //   drawBillPDF(doc, letterhead, group, billNo);
// //   const filename = `Bill_${safeFileSegment(group.companyName)}_${safeFileSegment(billNo)}.pdf`;
// //   doc.save(filename);
// // }



// // async function exportBillToExcel(letterhead: BillingLetterhead, group: BillGroup, billNo: string) {
// //   const wb = new ExcelJS.Workbook();
// //   const ws = wb.addWorksheet("Bill");

// //   ws.columns = [
// //     { width: 6 }, { width: 11 }, { width: 26 }, { width: 11 },
// //     { width: 15 }, { width: 11 }, { width: 10 }, { width: 14 },
// //   ];

// //   const thin: Partial<ExcelJS.Border> = { style: "thin", color: { argb: "FF000000" } };
// //   const borderAll = { top: thin, bottom: thin, left: thin, right: thin };
// //   const NAVY = "FF1A2A5A";

// //   let r = 1;
// //   const merge = (row: number, c1: number, c2: number) => ws.mergeCells(row, c1, row, c2);

// //   // PAN / MOB
// //   ws.getCell(r, 1).value = `PAN NO ${letterhead.panNo}`;
// //   ws.getCell(r, 1).font = { bold: true, size: 9 };
// //   merge(r, 1, 5);
// //   ws.getCell(r, 6).value = `MOB:-${letterhead.mobile}`;
// //   ws.getCell(r, 6).font = { bold: true, size: 9 };
// //   ws.getCell(r, 6).alignment = { horizontal: "right" };
// //   merge(r, 6, 8);
// //   r += 2;

// //   // Big heading — issuing company, navy, bold, centered
// //   ws.getCell(r, 1).value = letterhead.companyName;
// //   ws.getCell(r, 1).font = { bold: true, size: 16, color: { argb: NAVY } };
// //   ws.getCell(r, 1).alignment = { horizontal: "center" };
// //   merge(r, 1, 8); r++;

// //   ws.getCell(r, 1).value = letterhead.addressLine1;
// //   ws.getCell(r, 1).font = { color: { argb: NAVY }, size: 9 };
// //   ws.getCell(r, 1).alignment = { horizontal: "center" };
// //   merge(r, 1, 8); r++;

// //   ws.getCell(r, 1).value = letterhead.addressLine2;
// //   ws.getCell(r, 1).font = { color: { argb: NAVY }, size: 9 };
// //   ws.getCell(r, 1).alignment = { horizontal: "center" };
// //   merge(r, 1, 8); r += 2;

// //   // Bill no / To
// //   ws.getCell(r, 1).value = `BILL NO   ${billNo}`;
// //   ws.getCell(r, 1).font = { bold: true, size: 9 };
// //   merge(r, 1, 8); r++;

// //   ws.getCell(r, 1).value = "To,";
// //   merge(r, 1, 8); r++;

// //   // Billed-to company — bold, centered
// //   ws.getCell(r, 1).value = group.companyName.toUpperCase();
// //   ws.getCell(r, 1).font = { bold: true, size: 12 };
// //   ws.getCell(r, 1).alignment = { horizontal: "center" };
// //   merge(r, 1, 8); r++;

// //   // Billed-to sub-line (city/state)
// //   if (group.companyAddress) {
// //     ws.getCell(r, 1).value = group.companyAddress.toUpperCase();
// //     ws.getCell(r, 1).font = { size: 9 };
// //     ws.getCell(r, 1).alignment = { horizontal: "center" };
// //     merge(r, 1, 8); r++;
// //   }
// //   r++;

// //   // Table
// //   const headerRow = r;
// //   const headers = ["SR. NO", "DATE", "CONSIGNOR NAME", "G.R. NO", "VEHICLE NO", "WEIGHT", "RATE", "AMOUNT"];
// //   headers.forEach((h, i) => {
// //     const cell = ws.getCell(headerRow, i + 1);
// //     cell.value = h;
// //     cell.font = { bold: true };
// //     cell.alignment = { horizontal: "center" };
// //     cell.border = borderAll;
// //   });
// //   r++;

// //   const paddedRowCount = Math.max(group.rows.length, 5);
// //   for (let i = 0; i < paddedRowCount; i++) {
// //     const row = group.rows[i];
// //     const vals = row
// //       ? [i + 1, row.date, row.consignorName, row.grNo, row.vehicleNo, fmt(row.weight, 3), fmt(row.rate, 2), fmt(row.amount, 2)]
// //       : [i + 1, "", "", "", "", "", "", "-"];
// //     vals.forEach((v, ci) => {
// //       const cell = ws.getCell(r, ci + 1);
// //       cell.value = v;
// //       cell.border = borderAll;
// //       if (ci === 0 || ci === 1 || ci === 4) cell.alignment = { horizontal: "center" };
// //       if (ci === 5 || ci === 6 || ci === 7) cell.alignment = { horizontal: "right" };
// //     });
// //     r++;
// //   }

// //   const totalWeight = group.rows.reduce((s, x) => s + (x.weight ?? 0), 0);
// //   const totalAmount = group.rows.reduce((s, x) => s + (x.amount ?? 0), 0);

// //   ws.getCell(r, 1).value = "TOTAL AMOUNT";
// //   ws.getCell(r, 1).font = { bold: true };
// //   ws.getCell(r, 1).alignment = { horizontal: "center" };
// //   merge(r, 1, 5);
// //   for (let c = 1; c <= 5; c++) ws.getCell(r, c).border = borderAll;
// //   ws.getCell(r, 6).value = fmt(totalWeight, 2);
// //   ws.getCell(r, 6).font = { bold: true };
// //   ws.getCell(r, 6).border = borderAll;
// //   ws.getCell(r, 6).alignment = { horizontal: "right" };
// //   ws.getCell(r, 7).border = borderAll;
// //   ws.getCell(r, 8).value = fmt(totalAmount, 2);
// //   ws.getCell(r, 8).font = { bold: true };
// //   ws.getCell(r, 8).border = borderAll;
// //   ws.getCell(r, 8).alignment = { horizontal: "right" };
// //   r += 2;

// //   // Bank details (left) / signature block (right)
// //   const blockStart = r;
// //   ws.getCell(r, 1).value = "Bank Detail:";
// //   ws.getCell(r, 1).font = { bold: true };
// //   ws.getCell(r, 6).value = `For ${letterhead.companyName}`;
// //   ws.getCell(r, 6).alignment = { horizontal: "right" };
// //   merge(r, 6, 7);
// //   ws.getCell(r, 8).value = "E. & O.E.";
// //   ws.getCell(r, 8).alignment = { horizontal: "right" };
// //   r++;

// //   ws.getCell(r, 1).value = letterhead.bankName;
// //   ws.getCell(r, 1).font = { bold: true };
// //   r++;
// //   ws.getCell(r, 1).value = `A/C NO :- ${letterhead.accountNo}`; r++;
// //   ws.getCell(r, 1).value = `IFSC CODE :- ${letterhead.ifscCode}`; r++;
// //   ws.getCell(r, 1).value = `Branch :- ${letterhead.branch}`;

// //   ws.getCell(blockStart + 2, 6).value = letterhead.signatoryName;
// //   ws.getCell(blockStart + 2, 6).alignment = { horizontal: "right" };
// //   merge(blockStart + 2, 6, 7);
// //   ws.getCell(blockStart + 2, 8).value = letterhead.companyName.toUpperCase();
// //   ws.getCell(blockStart + 2, 8).font = { bold: true, size: 8 };
// //   ws.getCell(blockStart + 2, 8).alignment = { horizontal: "right" };

// //   ws.getCell(blockStart + 3, 6).value = letterhead.signatoryTitle;
// //   ws.getCell(blockStart + 3, 6).font = { bold: true };
// //   ws.getCell(blockStart + 3, 6).alignment = { horizontal: "right" };
// //   merge(blockStart + 3, 6, 7);
// //   r += 2;

// //   ws.getCell(r, 1).value = "Encl:"; r++;
// //   ws.getCell(r, 1).value = letterhead.paymentNote;
// //   ws.getCell(r, 1).font = { bold: true };
// //   merge(r, 1, 4); r++;
// //   ws.getCell(r, 2).value = "Accountant";

// //   // Outer border
// //   const lastRow = r;
// //   for (let row = 1; row <= lastRow; row++) {
// //     ws.getCell(row, 1).border = { ...ws.getCell(row, 1).border, left: thin };
// //     ws.getCell(row, 8).border = { ...ws.getCell(row, 8).border, right: thin };
// //   }
// //   for (let col = 1; col <= 8; col++) {
// //     ws.getCell(1, col).border = { ...ws.getCell(1, col).border, top: thin };
// //     ws.getCell(lastRow, col).border = { ...ws.getCell(lastRow, col).border, bottom: thin };
// //   }

// //   const buf = await wb.xlsx.writeBuffer();
// //   const blob = new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
// //   const url = URL.createObjectURL(blob);
// //   const a = document.createElement("a");
// //   a.href = url;
// //   a.download = `Bill_${safeFileSegment(group.companyName)}_${safeFileSegment(billNo)}.xlsx`;
// //   a.click();
// //   URL.revokeObjectURL(url);
// // }

// // /** Generates one bill per billed-to company, for either format. */
// // async  function downloadBills(
// //   letterhead: BillingLetterhead,
// //   groups: BillGroup[],
// //   format: "pdf" | "excel"
// // ) {
// //   groups.forEach((group, i) => {
// //     const billNo = generateBillNo(letterhead, i + 1);
// //     if (format === "pdf") exportBillToPDF(letterhead, group, billNo);
// //     else exportBillToExcel(letterhead, group, billNo);
// //   });
// // }

// // const PALETTE_KEYS = ["blue", "teal", "amber", "red", "purple", "green", 'coral', 'pink'] as const;

// // type PaletteKey = typeof PALETTE_KEYS[number];

// // const PALETTE: Record<PaletteKey, { bg: string; text: string; row: string }> = {
// //   blue:   { bg: "#E6F1FB", text: "#042C53", row: "rgba(55,138,221,0.18)"  },
// //   teal:   { bg: "#E1F5EE", text: "#04342C", row: "rgba(29,158,117,0.18)"  },
// //   amber:  { bg: "#FAEEDA", text: "#412402", row: "rgba(186,117,23,0.18)"  },
// //   red:    { bg: "#FCEBEB", text: "#501313", row: "rgba(226,75,74,0.18)"   },
// //   purple: { bg: "#EEEDFE", text: "#26215C", row: "rgba(83,74,183,0.18)"   },
// //   green:  { bg: "#EAF3DE", text: "#173404", row: "rgba(99,153,34,0.18)"   },
// //   coral:  { bg: "#FEF0E6", text: "#ffffff", row: "rgba(234,120,40,0.18)"  },
// //   pink:   { bg: "#F0EBE3", text: "#ffffff", row: "rgba(140,90,40,0.18)"   },
// // };

// // /**
// //  * Assigns palette colors by the ORDER companies are first encountered,
// //  * not by their numeric ID. This guarantees every company gets a distinct
// //  * color regardless of ID gaps or clustering (e.g. IDs 1, 7, 13 would all
// //  * collide with % 6 but get unique slots here).
// //  * The registry is module-level so it persists across re-renders without
// //  * needing React state.
// //  */
// // const companyColorRegistry = new Map<number, PaletteKey>();

// // function paletteForCompany(companyId: number): PaletteKey {
// //   if (companyColorRegistry.has(companyId)) {
// //     return companyColorRegistry.get(companyId)!;
// //   }
// //   // Next unseen slot — cycle only after all 8 colors are used
// //   const idx = companyColorRegistry.size % PALETTE_KEYS.length;
// //   const key = PALETTE_KEYS[idx];
// //   companyColorRegistry.set(companyId, key);
// //   return key;
// // }

// // // ─── Constants ────────────────────────────────────────────────────────────────

// // const FILTER_OPTIONS: { key: FilterOption; label: string }[] = [
// //   { key: "all",       label: "All" },
// //   { key: "pending",   label: "Pending" },
// //   { key: "completed", label: "Completed" },
// //   { key: "modified",  label: "Modified" },
// // ];

// // // const STATUS_STYLES: Record<string, string> = {
// // //   pending:    "bg-amber-100 text-amber-900",
// // //   in_transit: "bg-blue-100 text-blue-900",
// // //   delivered:  "bg-green-100 text-green-900",
// // //   draft:      "bg-slate-100 text-slate-600",
// // //   created:    "bg-slate-100 text-slate-900",
// // //   dispatched: "bg-amber-100 text-amber-800",
// // //   cancelled:  "bg-red-100 text-red-900",
// // // };

// // // const STATUS_LABELS: Record<string, string> = {
// // //   pending: "Pending", in_transit: "In transit", delivered: "Delivered",
// // //   draft: "Draft", created: "Created", dispatched: "Dispatched", cancelled: "Cancelled",
// // // };
// // const STATUS_STYLES: Record<string, string> = {
// //   pending:   "bg-amber-100 text-amber-900",
// //   completed: "bg-green-100 text-green-900",
// // };

// // const STATUS_LABELS: Record<string, string> = {
// //   pending: "Pending", completed: "Completed",
// // };
// // // ─── Sub-components ───────────────────────────────────────────────────────────

// // const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
// //   <span className={`text-[9px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${STATUS_STYLES[status] || "bg-slate-100 text-slate-900"}`}>
// //     {STATUS_LABELS[status] || status}
// //   </span>
// // );

// // const DashboardStatCard: React.FC<{ label: string; value: number; color: string }> = ({ label, value, color }) => (
// //   <div className="rounded-xl bg-slate-50 p-4 flex flex-col justify-center items-center">
// //     <span className="text-[26px] font-semibold mb-1" style={{ color }}>{value}</span>
// //     <span className="text-xs font-medium text-slate-500">{label}</span>
// //   </div>
// // );

// // const LoadingCell = () => (
// //   <span className="text-slate-300 animate-pulse text-xs">Loading…</span>
// // );

// // // ─── Company Tag ──────────────────────────────────────────────────────────────

// // const TAG_SOLID: Record<PaletteKey, string> = {
// //   blue: "#185FA5",
// //   teal: "#0F6E56",
// //   amber: "#BA7517",
// //   red: "#A32D2D",
// //   purple: "#534AB7",
// //   green: "#3B6D11",
// //   coral: "#b85000",
// //   pink: "#5a3010",
// // };

// // const CompanyTag: React.FC<{ companyId: number; companyName: string }> = ({ companyId, companyName }) => {
// //   const key = paletteForCompany(companyId);
// //   const abbr = companyAbbr(companyName);
// //   return (
// //     <span
// //       title={companyName}
// //       className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold cursor-default whitespace-nowrap"
// //       style={{ background: TAG_SOLID[key], color: "#ffffff" }}
// //     >
// //       {abbr}
// //     </span>
// //   );
// // };

// // // ─── Action Dropdown (portal-based — escapes overflow:auto clipping) ──────────

// // interface ActionMenuProps {
// //   consignment: APIConsignment;
// //   hasInvoice: boolean;
// //   hasHistory: boolean;
// //   onEdit: (id: number) => void;
// //   onDelete: (id: number) => void;
// //   onViewInvoice: (c: APIConsignment) => void;
// //   onDownloadInvoice: (c: APIConsignment) => void;
// //   onShareInvoice: (c: APIConsignment) => void;
// //   onViewHistory: (c: APIConsignment) => void;
// // }

// // /**
// //  * Measures the trigger button's position and renders the dropdown menu
// //  * via a React portal into document.body — so it is never clipped by
// //  * overflow:auto / overflow:hidden ancestors (e.g. the table scroll wrapper).
// //  * The menu auto-flips above the button when it would overflow the viewport bottom.
// //  */
// // const ActionMenu: React.FC<ActionMenuProps> = ({
// //   consignment, hasInvoice, hasHistory, onEdit, onDelete, onViewInvoice, onDownloadInvoice, onShareInvoice, onViewHistory,
// // }) => {
// //   const [open, setOpen] = useState(false);
// //   const [menuStyle, setMenuStyle] = useState<React.CSSProperties>({});
// //   const triggerRef = useRef<HTMLButtonElement>(null);
// //   const menuRef = useRef<HTMLDivElement>(null);

// //   const MENU_WIDTH = 184;
// //   const MENU_HEIGHT_APPROX = 270; // used only for flip detection before actual render

// //   const reposition = useCallback(() => {
// //     if (!triggerRef.current) return;
// //     const r = triggerRef.current.getBoundingClientRect();
// //     const spaceBelow = window.innerHeight - r.bottom;
// //     const flipUp = spaceBelow < MENU_HEIGHT_APPROX && r.top > MENU_HEIGHT_APPROX;

// //     // Align right edge of menu with right edge of trigger; clamp to viewport left
// //     const right = window.innerWidth - r.right;
// //     setMenuStyle({
// //       position: "fixed",
// //       top: flipUp ? r.top - 4 : r.bottom + 4,
// //       right,
// //       width: MENU_WIDTH,
// //       transform: flipUp ? "translateY(-100%)" : "none",
// //       zIndex: 9999,
// //     });
// //   }, []);

// //   const toggleOpen = () => {
// //     if (!open) reposition();
// //     setOpen((v) => !v);
// //   };

// //   // Close on outside click or scroll
// //   useEffect(() => {
// //     if (!open) return;
// //     const close = (e: MouseEvent) => {
// //       if (
// //         menuRef.current && !menuRef.current.contains(e.target as Node) &&
// //         triggerRef.current && !triggerRef.current.contains(e.target as Node)
// //       ) setOpen(false);
// //     };
// //     const onScroll = () => {
// //       reposition();
// //     };
// //     document.addEventListener("mousedown", close);
// //     window.addEventListener("scroll", onScroll, true); // capture phase catches nested scrollers
// //     return () => {
// //       document.removeEventListener("mousedown", close);
// //       window.removeEventListener("scroll", onScroll, true);
// //     };
// //   }, [open, reposition]);

// //   const invoiceDisabled = !hasInvoice;
// //   const historyDisabled = !hasHistory;
// //   const btnCls = "flex items-center gap-2 w-full px-3 py-[7px] text-[12px] text-left hover:bg-slate-50 transition-colors whitespace-nowrap";
// //   const disabledCls = "opacity-40 cursor-not-allowed pointer-events-none";

// //   const menu = open ? (
// //     <div
// //       ref={menuRef}
// //       style={menuStyle}
// //       className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-md"
// //     >
// //       {/* Invoice section */}
// //       <div className="border-b border-slate-100 py-1">
// //         <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1">Invoice</p>
// //         <button
// //           className={`${btnCls} text-blue-800 ${invoiceDisabled ? disabledCls : ""}`}
// //           disabled={invoiceDisabled}
// //           onClick={() => { setOpen(false); onViewInvoice(consignment); }}
// //         >
// //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
// //           View invoice
// //           {invoiceDisabled && <span className="ml-auto text-[9px] text-slate-400">No file</span>}
// //         </button>
// //         <button
// //           className={`${btnCls} text-green-800 ${invoiceDisabled ? disabledCls : ""}`}
// //           disabled={invoiceDisabled}
// //           onClick={() => { setOpen(false); onDownloadInvoice(consignment); }}
// //         >
// //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
// //           Download PDF
// //         </button>
// //         <button
// //           className={`${btnCls} text-purple-800 ${invoiceDisabled ? disabledCls : ""}`}
// //           disabled={invoiceDisabled}
// //           onClick={() => { setOpen(false); onShareInvoice(consignment); }}
// //         >
// //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
// //           Share link
// //         </button>
// //       </div>
// //       {/* Consignment section */}
// //       <div className="py-1">
// //         <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1">Consignment</p>
// //         <button
// //           className={`${btnCls} text-slate-700 ${historyDisabled ? disabledCls : ""}`}
// //           disabled={historyDisabled}
// //           onClick={() => { setOpen(false); onViewHistory(consignment); }}
// //         >
// //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
// //             <circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/>
// //           </svg>
// //           View history
// //           {historyDisabled && <span className="ml-auto text-[9px] text-slate-400">None</span>}
// //         </button>
// //         <button
// //           className={`${btnCls} text-amber-800`}
// //           onClick={() => { setOpen(false); onEdit(consignment.id); }}
// //         >
// //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
// //           Edit
// //         </button>
// //         <button
// //           className={`${btnCls} text-red-800 hover:!bg-red-50`}
// //           onClick={() => { setOpen(false); onDelete(consignment.id); }}
// //         >
// //           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
// //           Delete
// //         </button>
// //       </div>
// //     </div>
// //   ) : null;

// //   return (
// //     <>
// //       <button
// //         ref={triggerRef}
// //         onClick={toggleOpen}
// //         className="inline-flex items-center gap-1.5 text-[11px] px-2.5 py-1 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-600 transition-colors"
// //       >
// //         <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
// //           <circle cx="8" cy="3" r="1.4"/><circle cx="8" cy="8" r="1.4"/><circle cx="8" cy="13" r="1.4"/>
// //         </svg>
// //         Actions
// //         <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" className="opacity-50">
// //           <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
// //         </svg>
// //       </button>
// //       {ReactDOM.createPortal(menu, document.body)}
// //     </>
// //   );
// // };

// // // ─── Download Menu (PDF / Excel, selected / filtered) ──────────────────────────

// // interface DownloadMenuProps {
// //   selectedCount: number;
// //   filteredCount: number;
// //   onDownload: (scope: "selected" | "filtered", format: "pdf" | "excel") => void;
// // }

// // const DownloadMenu: React.FC<DownloadMenuProps> = ({ selectedCount, filteredCount, onDownload }) => {
// //   const [open, setOpen] = useState(false);
// //   const [menuStyle, setMenuStyle] = useState<React.CSSProperties>({});
// //   const triggerRef = useRef<HTMLButtonElement>(null);
// //   const menuRef = useRef<HTMLDivElement>(null);

// //   const reposition = useCallback(() => {
// //     if (!triggerRef.current) return;
// //     const r = triggerRef.current.getBoundingClientRect();
// //     setMenuStyle({
// //       position: "fixed",
// //       top: r.bottom + 4,
// //       right: window.innerWidth - r.right,
// //       width: 220,
// //       zIndex: 9999,
// //     });
// //   }, []);

// //   const toggleOpen = () => {
// //     if (!open) reposition();
// //     setOpen((v) => !v);
// //   };

// //   useEffect(() => {
// //     if (!open) return;
// //     const close = (e: MouseEvent) => {
// //       if (
// //         menuRef.current && !menuRef.current.contains(e.target as Node) &&
// //         triggerRef.current && !triggerRef.current.contains(e.target as Node)
// //       ) setOpen(false);
// //     };
// //     document.addEventListener("mousedown", close);
// //     return () => document.removeEventListener("mousedown", close);
// //   }, [open]);

// //   const disabledCls = "opacity-40 cursor-not-allowed pointer-events-none";
// //   const itemCls = "flex items-center justify-between w-full px-3 py-[7px] text-[12px] text-left hover:bg-slate-50 transition-colors whitespace-nowrap text-slate-700";

// //   const menu = open ? (
// //     <div ref={menuRef} style={menuStyle} className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-md">
// //       <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1.5 border-b border-slate-100">
// //         Selected ({selectedCount})
// //       </p>
// //       <button
// //         className={`${itemCls} ${selectedCount === 0 ? disabledCls : ""}`}
// //         disabled={selectedCount === 0}
// //         onClick={() => { setOpen(false); onDownload("selected", "pdf"); }}
// //       >
// //         Download as PDF
// //       </button>
// //       <button
// //         className={`${itemCls} ${selectedCount === 0 ? disabledCls : ""}`}
// //         disabled={selectedCount === 0}
// //         onClick={() => { setOpen(false); onDownload("selected", "excel"); }}
// //       >
// //         Download as Excel
// //       </button>
// //       <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1.5 border-y border-slate-100 mt-1">
// //         All filtered ({filteredCount})
// //       </p>
// //       <button
// //         className={`${itemCls} ${filteredCount === 0 ? disabledCls : ""}`}
// //         disabled={filteredCount === 0}
// //         onClick={() => { setOpen(false); onDownload("filtered", "pdf"); }}
// //       >
// //         Download as PDF
// //       </button>
// //       <button
// //         className={`${itemCls} ${filteredCount === 0 ? disabledCls : ""}`}
// //         disabled={filteredCount === 0}
// //         onClick={() => { setOpen(false); onDownload("filtered", "excel"); }}
// //       >
// //         Download as Excel
// //       </button>
// //     </div>
// //   ) : null;

// //   return (
// //     <>
// //       <button
// //         ref={triggerRef}
// //         onClick={toggleOpen}
// //         className="inline-flex items-center gap-1.5 text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
// //       >
// //         <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //           <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
// //         </svg>
// //         Download
// //         <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" className="opacity-50">
// //           <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
// //         </svg>
// //       </button>
// //       {ReactDOM.createPortal(menu, document.body)}
// //     </>
// //   );
// // };

// // // ─── Advanced Filters ─────────────────────────────────────────────────────────

// // const AdvancedFilters: React.FC<{
// //   filters: FiltersState;
// //   onChange: (f: FiltersState) => void;
// //   companyOptions: string[];
// //   biltyOptions: string[];
// //   truckOptions: string[];
// //   consignorOptions: string[];
// //   consigneeOptions: string[];
// // }> = ({ filters, onChange, companyOptions, biltyOptions, truckOptions, consignorOptions, consigneeOptions }) => {
// //   const sel = "border rounded px-2 py-1 text-xs";
// //   const inp = "border rounded px-2 py-1 text-xs mt-1 block";

// //   return (
// //     <div className="flex flex-wrap gap-3 mb-4">
// //       <div>
// //         <label className="block text-xs text-slate-500 mb-1">Company</label>
// //         <select className={`${sel} w-[160px]`} value={filters.company} onChange={e => onChange({ ...filters, company: e.target.value })}>
// //           <option value="">All companies</option>
// //           {companyOptions.map(v => <option key={v} value={v}>{v}</option>)}
// //         </select>
// //       </div>
// //       <div>
// //         <label className="block text-xs text-slate-500 mb-1">Bilty no.</label>
// //         <select className={`${sel} w-[140px]`} value={filters.biltyNo} onChange={e => onChange({ ...filters, biltyNo: e.target.value })}>
// //           <option value="">All bilty nos.</option>
// //           {biltyOptions.map(v => <option key={v} value={v}>{v}</option>)}
// //         </select>
// //         <input className={`${inp} w-[140px]`} placeholder="Search bilty" value={filters.biltyNo} onChange={e => onChange({ ...filters, biltyNo: e.target.value })} />
// //       </div>
// //       <div>
// //         <label className="block text-xs text-slate-500 mb-1">Truck no.</label>
// //         <select className={`${sel} w-[130px]`} value={filters.truckNo} onChange={e => onChange({ ...filters, truckNo: e.target.value })}>
// //           <option value="">All trucks</option>
// //           {truckOptions.map(v => <option key={v} value={v}>{v}</option>)}
// //         </select>
// //         <input className={`${inp} w-[130px]`} placeholder="Search truck" value={filters.truckNo} onChange={e => onChange({ ...filters, truckNo: e.target.value })} />
// //       </div>
// //       <div>
// //         <label className="block text-xs text-slate-500 mb-1">Consignor</label>
// //         <select className={`${sel} w-[130px]`} value={filters.consignor} onChange={e => onChange({ ...filters, consignor: e.target.value })}>
// //           <option value="">All consignors</option>
// //           {consignorOptions.map(v => <option key={v} value={v}>{v}</option>)}
// //         </select>
// //         <input className={`${inp} w-[130px]`} placeholder="Search consignor" value={filters.consignor} onChange={e => onChange({ ...filters, consignor: e.target.value })} />
// //       </div>
// //       <div>
// //         <label className="block text-xs text-slate-500 mb-1">Consignee</label>
// //         <select className={`${sel} w-[130px]`} value={filters.consignee} onChange={e => onChange({ ...filters, consignee: e.target.value })}>
// //           <option value="">All consignees</option>
// //           {consigneeOptions.map(v => <option key={v} value={v}>{v}</option>)}
// //         </select>
// //         <input className={`${inp} w-[130px]`} placeholder="Search consignee" value={filters.consignee} onChange={e => onChange({ ...filters, consignee: e.target.value })} />
// //       </div>
// //       <div>
// //         <label className="block text-xs text-slate-500 mb-1">Date from</label>
// //         <input type="date" className={`${sel}`} value={filters.dateFrom} onChange={e => onChange({ ...filters, dateFrom: e.target.value })} />
// //       </div>
// //       <div>
// //         <label className="block text-xs text-slate-500 mb-1">Date to</label>
// //         <input type="date" className={`${sel}`} value={filters.dateTo} onChange={e => onChange({ ...filters, dateTo: e.target.value })} />
// //       </div>
// //       <div className="flex items-end">
// //         <button
// //           className="text-xs px-3 py-1 border rounded bg-slate-50 text-slate-600"
// //           onClick={() => onChange({ company: "", biltyNo: "", truckNo: "", consignor: "", consignee: "", dateFrom: "", dateTo: "" })}
// //         >
// //           Clear
// //         </button>
// //       </div>
// //     </div>
// //   );
// // };

// // // ─── Delete Confirm Modal ─────────────────────────────────────────────────────

// // const DeleteConfirmModal: React.FC<{
// //   id: number | null;
// //   bilty: string;
// //   onConfirm: () => void;
// //   onCancel: () => void;
// // }> = ({ id, bilty, onConfirm, onCancel }) => {
// //   if (id === null) return null;
// //   return (
// //     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
// //       <div className="bg-white rounded-2xl border border-slate-200 p-6 w-[340px] shadow-lg">
// //         <h3 className="text-[15px] font-medium text-slate-900 mb-2">Delete consignment?</h3>
// //         <p className="text-xs text-slate-500 mb-5 leading-relaxed">
// //           You are about to permanently delete <strong>{bilty}</strong>. This action cannot be undone and all associated data will be removed.
// //         </p>
// //         <div className="flex gap-3 justify-end">
// //           <button onClick={onCancel} className="text-xs px-4 py-1.5 border border-slate-200 rounded-lg text-slate-600 hover:bg-slate-50 transition-colors">
// //             Cancel
// //           </button>
// //           <button onClick={onConfirm} className="text-xs px-4 py-1.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
// //             Delete
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // // ─── Change Log Modal ──────────────────────────────────────────────────────────

// // const ChangeLogModal: React.FC<{
// //   bilty: string;
// //   entries: ChangeLogEntry[];
// //   onClose: () => void;
// // }> = ({ bilty, entries, onClose }) => {
// //   return (
// //     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-2">
// //       <div className="bg-white rounded-2xl border border-slate-200 p-6 w-full max-w-md shadow-lg max-h-[80vh] flex flex-col">
// //         <div className="flex items-start justify-between mb-1">
// //           <h3 className="text-[15px] font-medium text-slate-900">Change history</h3>
// //           <button onClick={onClose} className="text-slate-400 hover:text-slate-700 transition-colors">
// //             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
// //               <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
// //             </svg>
// //           </button>
// //         </div>
// //         <p className="text-xs text-slate-400 mb-4">{bilty}</p>

// //         <div className="overflow-y-auto space-y-3 pr-1">
// //           {entries.length === 0 ? (
// //             <p className="text-sm text-slate-400 text-center py-6">No changes recorded.</p>
// //           ) : (
// //             [...entries].reverse().map((entry, i) => (
// //               <div key={i} className="border border-slate-100 rounded-xl p-3 bg-slate-50/60">
// //                 <div className="flex items-center justify-between mb-1.5">
// //                   <span className="text-[11px] font-semibold text-slate-700 uppercase tracking-wide">
// //                     {fmtFieldLabel(entry.field)}
// //                   </span>
// //                   <span className="text-[10px] text-slate-400">
// //                     {entry.changed_at
// //                       ? new Date(entry.changed_at).toLocaleString("en-IN", {
// //                           day: "2-digit", month: "short", year: "2-digit",
// //                           hour: "2-digit", minute: "2-digit",
// //                         })
// //                       : ""}
// //                   </span>
// //                 </div>
// //                 <div className="flex items-center gap-2 text-xs">
// //                   <span className="px-2 py-1 rounded-md bg-red-50 text-red-700 line-through decoration-red-300">
// //                     {fmtChangeValue(entry.from)}
// //                   </span>
// //                   <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-slate-400 shrink-0">
// //                     <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
// //                   </svg>
// //                   <span className="px-2 py-1 rounded-md bg-green-50 text-green-800 font-medium">
// //                     {fmtChangeValue(entry.to)}
// //                   </span>
// //                 </div>
// //               </div>
// //             ))
// //           )}
// //         </div>

// //         <div className="flex justify-end mt-4">
// //           <button onClick={onClose} className="text-xs px-4 py-1.5 border border-slate-200 rounded-lg text-slate-600 hover:bg-slate-50 transition-colors">
// //             Close
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // // ─── Main Dashboard ───────────────────────────────────────────────────────────

// // const ConsignorDashboard: React.FC = () => {
// //   const navigate = useNavigate();
// //   const [consignments, setConsignments] = useState<APIConsignment[]>([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState<string | null>(null);
// //   const [activeFilter, setActiveFilter] = useState<FilterOption>("all");
// //   const [resolvedRows, setResolvedRows] = useState<Record<number, ResolvedRow>>({});
// //   const [deleteTarget, setDeleteTarget] = useState<{ id: number; bilty: string } | null>(null);
// //   const [historyTarget, setHistoryTarget] = useState<{ bilty: string; entries: ChangeLogEntry[] } | null>(null);
// //   const [selectedIds, setSelectedIds] = useState<Set<number>>(new Set());
// //   // const [letterhead, setLetterhead] = useState<BillingLetterhead>(DEFAULT_LETTERHEAD);
// //   // const companyCache: Record<number, string> = {};

// //   const [filters, setFilters] = useState<FiltersState>({
// //     company: "", biltyNo: "", truckNo: "", consignor: "", consignee: "", dateFrom: "", dateTo: "",
// //   });

// //   // Fetch the firm's billing letterhead once. Falls back to blank/default
// //   // values if the endpoint isn't available yet, so the rest of the page
// //   // // still works while the backend route is being added.
// //   // useEffect(() => {
// //   //   fetch(`${API_BASE}${LETTERHEAD_ENDPOINT}`)
// //   //     .then((res) => (res.ok ? res.json() : Promise.reject()))
// //   //     .then((data) => setLetterhead({ ...DEFAULT_LETTERHEAD, ...data }))
// //   //     .catch(() => setLetterhead(DEFAULT_LETTERHEAD));
// //   // }, []);

// //   async function fetchCompanyName(id: number): Promise<string> {
// //     if (companyCache[id]) return companyCache[id];
// //     try {
// //       const res = await fetch(`${API_BASE}/companyauth/company/${id}`);
// //       if (!res.ok) throw new Error();
// //       const data = await res.json();
// //       companyCache[id] = data.name || data.company_name || `Company#${id}`;
// //     } catch {
// //       companyCache[id] = `Company#${id}`;
// //     }
// //     return companyCache[id];
// //   }
// //   // const companyAddressCache: Record<number, string> = {};


// //   const letterheadCache: Record<number, BillingLetterhead> = {};

// //   async function fetchLetterhead(companyId: number): Promise<BillingLetterhead> {
// //     if (letterheadCache[companyId]) return letterheadCache[companyId];
// //     try {
// //       const res = await fetch(`${API_BASE}/companyAuth/company/${companyId}/letterhead`);
// //       if (!res.ok) throw new Error();
// //       const data = await res.json();
// //       letterheadCache[companyId] = { ...DEFAULT_LETTERHEAD, ...data };
// //     } catch {
// //       letterheadCache[companyId] = DEFAULT_LETTERHEAD;
// //     }
// //     return letterheadCache[companyId];
// //   }
  
// //   async function fetchNextBillSeq(companyId: number): Promise<number> {
// //     try {
// //       const res = await fetch(`${API_BASE}/companyAuth/company/${companyId}/next-bill-no`, { method: "POST" });
// //       const data = await res.json();
// //       return data.seq ?? 1;
// //     } catch {
// //       return 1;
// //     }
// //   }
// //   useEffect(() => {
// //     setLoading(true);
// //     setError(null);

// //     fetch(`${API_BASE}/invoiceapi/invoice`)
// //       .then((res) => res.json())
// //       .then(async (data) => {
// //         if (!Array.isArray(data)) { setConsignments([]); return; }

// //         const mapped: APIConsignment[] = data.map((c: any) => ({
// //           id: c.id,
// //           sender: c.sender,
// //           company: c.company,
// //           receiver: c.receiver,
// //           transporter: c.transporter,
// //           driver: c.driver,
// //           vehicles: c.vehicles,
// //           payment: c.payment,
// //           source: c.source,
// //           destination: c.destination,
// //           receiverAmountStatatus: c.receiverAmountStatatus,
// //           senderAmountStatatus: c.senderAmountStatatus,
// //           transporterAmountStatatus: c.transporterAmountStatatus,
// //           paymentStatus: c.paymentStatus,
// //           paymentPayableConsignor: c.paymentPayableConsignor,
// //           ItemsDescription: c.ItemsDescription,
// //           InvoiceNo: c["InvoiceNo"] ?? c["InvoiceNo."] ?? "",
// //           "InvoiceNo.": c["InvoiceNo."],
// //           EWAYBILLNO: c.EWAYBILLNO,
// //           subjects: c.subjects,
// //           link: c.link ?? c.invoiceLink,
// //           status: c.status ?? undefined,
// //           biltyNo: c.biltyNo ?? c["InvoiceNo"] ?? c["InvoiceNo."] ?? "",
// //           created_at: c.created_at ?? "",
// //           totalamount: c.totalamount ?? null,
// //           change_log: c.change_log ?? null,
// //           billing_status: c.billing_status === "completed" ? "completed" : "pending",
// //   billing_status_forced: c.billing_status_forced ?? 0,
// //         }));

// //         const senderIds   = [...new Set(mapped.map(c => c.sender).filter(Boolean))];
// //         const receiverIds = [...new Set(mapped.map(c => c.receiver).filter(Boolean))];
// //         const vehicleIds  = [...new Set(mapped.map(c => c.vehicles).filter(Boolean))];
// //         const companyIds  = [...new Set(mapped.map(c => c.company).filter(Boolean))];
// //         const invoiceDbIds = [...new Set(mapped.map(c => String(c.id)).filter(Boolean))];

// //         // Pre-register companies in a stable order so color assignments are
// //         // deterministic and don't shift between renders or data fetches.
// //         companyColorRegistry.clear();
// //         companyIds.forEach(id => paletteForCompany(id));

// //         await Promise.allSettled([
// //           ...senderIds.map(fetchUserName),
// //           ...receiverIds.map(fetchUserName),
// //           ...vehicleIds.map(fetchVehicleNumber),
// //           ...companyIds.map(fetchCompanyDetails),  
// //           ...invoiceDbIds.map(fetchInvoiceItems),
// //         ]);

// //         const resolved: Record<number, ResolvedRow> = {};
// //         for (const c of mapped) {
// //           const items = itemsCache[String(c.id)] ?? [];
// //           const { totalWeight, biltyRate, totalItemAmount } = computeItemStats(items);
// //           resolved[c.id] = {
// //             consignorName: c.sender ? userCache[c.sender] || `User#${c.sender}` : "-",
// //             consigneeName: c.receiver ? userCache[c.receiver] || `User#${c.receiver}` : "-",
// //             truckNo: c.vehicles ? vehicleCache[c.vehicles] || `Vehicle#${c.vehicles}` : "-",
// //             companyName: c.company ? companyCache[c.company] || `Company#${c.company}` : "-",
// //             totalWeight,
// //             biltyRate,
// //             totalItemAmount,
// //           };
// //         }
// //         setResolvedRows(resolved);
// //         setConsignments(mapped);
// //       })
// //       .catch(() => setError("Unable to fetch consignments"))
// //       .finally(() => setLoading(false));
// //   }, []);

// //   // ── Invoice action handlers ──
// //   const handleViewInvoice = useCallback((c: APIConsignment) => {
// //     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
// //     if (url) window.open(url, "_blank");
// //   }, []);

// //   const handleDownloadInvoice = useCallback((c: APIConsignment) => {
// //     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
// //     if (!url) return;
// //     const a = document.createElement("a");
// //     a.href = url;
// //     a.download = `Invoice_${getInvoiceNo(c) || c.EWAYBILLNO || c.id}`;
// //     document.body.appendChild(a);
// //     a.click();
// //     document.body.removeChild(a);
// //   }, []);

// //   function getLastChange(raw: string | null | undefined): ChangeLogEntry | null {
// //     const entries = parseChangeLog(raw);
// //     return entries.length ? entries[entries.length - 1] : null;
// //   }
  
// //   function timeAgo(iso: string): string {
// //     const diff = Date.now() - new Date(iso).getTime();
// //     const m = Math.floor(diff / 60000);
// //     if (m < 60) return `${m}m ago`;
// //     const h = Math.floor(m / 60);
// //     if (h < 24) return `${h}h ago`;
// //     return `${Math.floor(h / 24)}d ago`;
// //   }
// //   const handleShareInvoice = useCallback((c: APIConsignment) => {
// //     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
// //     if (!url) return;
// //     if (navigator.share) {
// //       navigator.share({ title: `Invoice ${getInvoiceNo(c)}`, url });
// //     } else {
// //       navigator.clipboard.writeText(url);
// //       alert("Invoice link copied!");
// //     }
// //   }, []);

// //   const handleEdit = useCallback((id: number) => {
// //     navigate(`/admin/edit/consignments/${id}`);
// //   }, [navigate]);

// //   const handleViewHistory = useCallback((c: APIConsignment) => {
// //     const entries = parseChangeLog(c.change_log);
// //     setHistoryTarget({ bilty: c.biltyNo || getInvoiceNo(c) || String(c.id), entries });
// //   }, []);

// //   const handleDeleteRequest = useCallback((id: number) => {
// //     const c = consignments.find(x => x.id === id);
// //     setDeleteTarget({ id, bilty: c?.biltyNo || getInvoiceNo(c!) || String(id) });
// //   }, [consignments]);

// //   const handleDeleteConfirm = useCallback(async () => {
// //     if (!deleteTarget) return;
// //     const { id } = deleteTarget;
// //     setDeleteTarget(null);
// //     try {
// //       const res = await fetch(`${API_BASE}/invoiceapi/invoice/${id}`, { method: "DELETE" });
// //       if (res.ok || res.status === 404) {
// //         setConsignments(prev => prev.filter(c => c.id !== id));
// //         setSelectedIds(prev => {
// //           const next = new Set(prev);
// //           next.delete(id);
// //           return next;
// //         });
// //       } else {
// //         const err = await res.json();
// //         alert(`Failed to delete: ${err.error || "Unknown error"}`);
// //       }
// //     } catch (e: any) {
// //       alert(`Failed to delete: ${e?.message || e}`);
// //     }
// //   }, [deleteTarget]);

// //   // ── Selection handlers ──
// //   const toggleSelectRow = useCallback((id: number) => {
// //     setSelectedIds(prev => {
// //       const next = new Set(prev);
// //       if (next.has(id)) next.delete(id); else next.add(id);
// //       return next;
// //     });
// //   }, []);

// //   const toggleSelectAllFiltered = useCallback((filteredIds: number[]) => {
// //     setSelectedIds(prev => {
// //       const allSelected = filteredIds.length > 0 && filteredIds.every(id => prev.has(id));
// //       if (allSelected) {
// //         const next = new Set(prev);
// //         filteredIds.forEach(id => next.delete(id));
// //         return next;
// //       }
// //       const next = new Set(prev);
// //       filteredIds.forEach(id => next.add(id));
// //       return next;
// //     });
// //   }, []);

// //   // ── Download handler ──
// //   // const handleDownload = useCallback((scope: "selected" | "filtered", format: "pdf" | "excel", filteredList: APIConsignment[]) => {
// //   //   const source = scope === "selected"
// //   //     ? consignments.filter(c => selectedIds.has(c.id))
// //   //     : filteredList;
// //   //   if (source.length === 0) return;
// //   //   const groups = buildBillGroups(source, resolvedRows);
// //   //   downloadBills(letterhead, groups, format);
// //   // }, [consignments, selectedIds, resolvedRows, letterhead]);
// //   const handleDownload = useCallback(async (scope: "selected" | "filtered", format: "pdf" | "excel", filteredList: APIConsignment[]) => {
// //     const source = scope === "selected" ? consignments.filter(c => selectedIds.has(c.id)) : filteredList;
// //     if (source.length === 0) return;
// //     const groups = buildBillGroups(source, resolvedRows);
// //     for (const group of groups) {
// //       const lh = await fetchLetterhead(group.companyId);
// //       const seq = await fetchNextBillSeq(group.companyId);
// //       const billNo = generateBillNo(lh, seq);
// //       if (format === "pdf") exportBillToPDF(lh, group, billNo);
// //       else await exportBillToExcel(lh, group, billNo);
// //     }
// //   }, [consignments, selectedIds, resolvedRows]);
// //   // ── Dropdown options ──
// //   const companyOptions = [...new Set(Object.values(resolvedRows).map(r => r.companyName).filter(v => v && v !== "-"))];
// //   const biltyOptions = [...new Set(consignments.map(c => c.biltyNo || getInvoiceNo(c)).filter(Boolean))];
// //   const truckOptions = [...new Set(Object.values(resolvedRows).map(r => r.truckNo).filter(v => v && v !== "-"))];
// //   const consignorOptions = [...new Set(Object.values(resolvedRows).map(r => r.consignorName).filter(v => v && v !== "-"))];
// //   const consigneeOptions = [...new Set(Object.values(resolvedRows).map(r => r.consigneeName).filter(v => v && v !== "-"))];

// //   // ── Filtering + sorting ──
// //   const filtered = consignments
// //     .filter((c) => {
// //       const row = resolvedRows[c.id];
// //       // if (activeFilter !== "all" && getConsignmentStatus(c) !== activeFilter) return false;
// //       if (activeFilter === "pending" && getBillingStatus(c) !== "pending") return false;
// // if (activeFilter === "completed" && getBillingStatus(c) !== "completed") return false;
// // if (activeFilter === "modified" && !c.change_log) return false;
// //       if (filters.company && row && row.companyName !== filters.company) return false;
// //       if (filters.biltyNo) {
// //         const q = filters.biltyNo.toLowerCase();
// //         const bn = (c.biltyNo || getInvoiceNo(c) || "").toLowerCase();
// //         if (!bn.includes(q)) return false;
// //       }
// //       if (filters.truckNo && row) {
// //         if (!String(row.truckNo || "").toLowerCase().includes(filters.truckNo.toLowerCase())) return false;
// //       }
// //       if (filters.consignor && row) {
// //         if (!String(row.consignorName || "").toLowerCase().includes(filters.consignor.toLowerCase())) return false;
// //       }
// //       if (filters.consignee && row) {
// //         if (!String(row.consigneeName || "").toLowerCase().includes(filters.consignee.toLowerCase())) return false;
// //       }
// //       if (filters.dateFrom && c.created_at) {
// //         if (new Date(c.created_at).toISOString().slice(0, 10) < filters.dateFrom) return false;
// //       }
// //       if (filters.dateTo && c.created_at) {
// //         if (new Date(c.created_at).toISOString().slice(0, 10) > filters.dateTo) return false;
// //       }
// //       return true;
// //     })
// //     .sort((a, b) => {
// //       const ba = (a.biltyNo || getInvoiceNo(a) || "").toString();
// //       const bb = (b.biltyNo || getInvoiceNo(b) || "").toString();
// //       const cmp = ba.localeCompare(bb, undefined, { numeric: true, sensitivity: "base" });
// //       if (cmp !== 0) return cmp;
// //       return (a.created_at ? new Date(a.created_at).getTime() : 0) -
// //              (b.created_at ? new Date(b.created_at).getTime() : 0);
// //     });

// //   const filteredIds = filtered.map(c => c.id);
// //   const allFilteredSelected = filteredIds.length > 0 && filteredIds.every(id => selectedIds.has(id));

// //   // const stats = [
// //   //   { label: "Total",      value: consignments.length,                                              color: "#185FA5" },
// //   //   { label: "Pending",    value: consignments.filter(c => getConsignmentStatus(c) === "pending").length,    color: "#854F0B" },
// //   //   { label: "In transit", value: consignments.filter(c => getConsignmentStatus(c) === "in_transit").length, color: "#534AB7" },
// //   //   { label: "Delivered",  value: consignments.filter(c => getConsignmentStatus(c) === "delivered").length,  color: "#3B6D11" },
// //   // ];
// //   const stats = [
// //     { label: "Total",     value: consignments.length, color: "#185FA5" },
// //     { label: "Pending",   value: consignments.filter(c => getBillingStatus(c) === "pending").length,   color: "#854F0B" },
// //     { label: "Completed", value: consignments.filter(c => getBillingStatus(c) === "completed").length, color: "#3B6D11" },
// //     { label: "Modified",  value: consignments.filter(c => !!c.change_log).length,                       color: "#7c3aed" },
// //   ];

// //   // ── Table column headers ──
// //   const HEADERS = ["", "#", "Date · Bilty", "Company", "Route", "Parties", "Truck", "Wt / Rate / Amt", "Status", "Actions"];

// //   return (
// //     <div className="p-4 md:p-6 space-y-4">
// //       {/* Stats */}
// //       <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
// //         {stats.map(s => <DashboardStatCard key={s.label} {...s} />)}
// //       </div>

// //       {/* Panel */}
// //       <div className="bg-white border border-slate-100 rounded-2xl p-4">
// //         <div className="flex items-center justify-between mb-3">
// //           <div>
// //             <h2 className="text-[16px] font-medium text-slate-900">My Consignments</h2>
// //             <p className="text-xs text-slate-400">View and manage your consignments &amp; invoices</p>
// //           </div>
// //           <div className="flex items-center gap-2">
// //             <DownloadMenu
// //               selectedCount={selectedIds.size}
// //               filteredCount={filtered.length}
// //               onDownload={(scope, format) => handleDownload(scope, format, filtered)}
// //             />
// //             <button
// //               className="text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
// //               onClick={() => navigate("/admin/add/consignments")}
// //             >
// //               + New Consignment
// //             </button>
// //           </div>
// //         </div>

// //         {/* Status pills */}
// //         <div className="flex flex-wrap gap-1.5 mb-4">
// //           {FILTER_OPTIONS.map(({ key, label }) => (
// //             <button
// //               key={key}
// //               onClick={() => setActiveFilter(key)}
// //               className={`text-xs px-3 py-1 rounded-full border transition-colors ${
// //                 activeFilter === key
// //                   ? "bg-slate-900 text-white border-transparent"
// //                   : "border-slate-200 text-slate-500 hover:bg-slate-50"
// //               }`}
// //             >
// //               {label}
// //             </button>
// //           ))}
// //         </div>

// //         <AdvancedFilters
// //           filters={filters}
// //           onChange={setFilters}
// //           companyOptions={companyOptions}
// //           biltyOptions={biltyOptions}
// //           truckOptions={truckOptions}
// //           consignorOptions={consignorOptions}
// //           consigneeOptions={consigneeOptions}
// //         />

// //         {/* Table */}
// //         <div className="overflow-x-auto">
// //           <table className="w-full text-[12px]" style={{ minWidth: 860 }}>
// //             <thead>
// //               <tr className="border-b border-slate-100">
// //                 {HEADERS.map((h, i) => (
// //                   i === 0 ? (
// //                     <th key="select-all" className="py-2 px-3 w-8">
// //                       <input
// //                         type="checkbox"
// //                         checked={allFilteredSelected}
// //                         onChange={() => toggleSelectAllFiltered(filteredIds)}
// //                         className="w-3.5 h-3.5 rounded border-slate-300 cursor-pointer"
// //                       />
// //                     </th>
// //                   ) : (
// //                     <th key={h} className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap text-[10px]">{h}</th>
// //                   )
// //                 ))}
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {loading ? (
// //                 <tr><td colSpan={10} className="py-6 text-center text-slate-400">Loading…</td></tr>
// //               ) : error ? (
// //                 <tr><td colSpan={10} className="py-6 text-center text-red-600">{error}</td></tr>
// //               ) : filtered.length === 0 ? (
// //                 <tr><td colSpan={10} className="py-8 text-center text-slate-400">No consignments found.</td></tr>
// //               ) : (
// //                 filtered.map((c, idx) => {
// //                   const row = resolvedRows[c.id];
// //                   const palKey = paletteForCompany(c.company);
// //                   const pal = PALETTE[palKey];
// //                   const hasInvoice = !!c.link;
// //                   const hasHistory = !!c.change_log;
// //                   const isSelected = selectedIds.has(c.id);

// //                   return (
// //                     <tr
// //                       key={c.id}
// //                       className="border-b border-slate-100 transition-all"
// //                       // style={{ background: isSelected ? "rgba(24,95,165,0.12)" : pal.row }}
// //                       style={{
// //                         background: isSelected ? "rgba(24,95,165,0.12)" : pal.row,
// //                         borderLeft: hasHistory ? "3px solid #7c3aed" : "3px solid transparent",
// //                       }}
                      
// //                     >
// //                       {/* Select */}
// //                       <td className="py-2 px-3">
// //                         <input
// //                           type="checkbox"
// //                           checked={isSelected}
// //                           onChange={() => toggleSelectRow(c.id)}
// //                           className="w-3.5 h-3.5 rounded border-slate-300 cursor-pointer"
// //                         />
// //                       </td>

// //                       {/* # */}
// //                       <td className="py-2 px-3 text-slate-400 text-[11px]">{idx + 1}</td>

// //                       {/* Date · Bilty */}
// //                       {/* Date · Bilty */}
// // {/* <td className="py-2 px-3">
// //   <div className="flex flex-col gap-0.5">
// //     <span className="flex items-center gap-1.5">
// //       <span className="text-slate-900 font-medium">{c.biltyNo || getInvoiceNo(c) || "-"}</span>
// //       {hasHistory && (
// //         <span
// //           title="Has change history"
// //           className="inline-flex items-center justify-center w-3.5 h-3.5 rounded-full bg-violet-100 text-violet-600 shrink-0"
// //         >
// //           <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
// //             <circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/>
// //           </svg>
// //         </span>
// //       )}
// //     </span>
// //     <span className="text-[11px] font-extrabold text-black-900">
// //       {c.created_at ? new Date(c.created_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "2-digit" }) : "-"}
// //     </span>
// //   </div>
// // </td> */}
// // {/* Date · Bilty */}
// // {(() => {
// //   const lastChange = getLastChange(c.change_log);
// //   return (
// //     <td className="py-2 px-3">
// //       <div className="flex flex-col gap-1">
// //         <span className="text-slate-900 font-medium">
// //           {c.biltyNo || getInvoiceNo(c) || "-"}
// //         </span>
// //         <span className="text-[11px] font-extrabold text-slate-800">
// //           {c.created_at
// //             ? new Date(c.created_at).toLocaleDateString("en-IN", {
// //                 day: "2-digit", month: "short", year: "2-digit",
// //               })
// //             : "-"}
// //         </span>
// //         {lastChange && (
// //           <button
// //             onClick={() => handleViewHistory(c)}
// //             title="Click to view full history"
// //             className="inline-flex items-center gap-1 w-fit mt-0.5 px-1.5 py-0.5 rounded-md
// //                        bg-violet-50 border border-violet-100 text-violet-700
// //                        hover:bg-violet-100 transition-colors group"
// //           >
// //             {/* clock icon */}
// //             <svg width="9" height="9" viewBox="0 0 24 24" fill="none"
// //               stroke="currentColor" strokeWidth="2.2"
// //               strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
// //               <circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/>
// //             </svg>
// //             <span className="text-[10px] leading-tight">
// //               <span className="font-semibold">{fmtFieldLabel(lastChange.field)}</span>
// //               {" · "}
// //               <span className="opacity-70">{timeAgo(lastChange.changed_at)}</span>
// //             </span>
// //             {/* chevron hint */}
// //             <svg width="8" height="8" viewBox="0 0 10 10" fill="currentColor"
// //               className="opacity-30 group-hover:opacity-60 transition-opacity ml-0.5">
// //               <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor"
// //                 strokeWidth="1.4" fill="none" strokeLinecap="round"/>
// //             </svg>
// //           </button>
// //         )}
// //       </div>
// //     </td>
// //   );
// // })()}

// //                       {/* Company */}
// //                       <td className="py-2 px-3">
// //                         {row
// //                           ? <CompanyTag companyId={c.company} companyName={row.companyName} />
// //                           : <LoadingCell />}
// //                       </td>

// //                       {/* Route */}
// //                       <td className="py-2 px-3">
// //                         <div className="flex flex-col gap-0.5">
// //                           <span className="text-slate-800 text-[11px]">{c.source || "-"}</span>
// //                           <span className="text-[10px] text-slate-400">→ {c.destination || "-"}</span>
// //                         </div>
// //                       </td>

// //                       {/* Parties */}
// //                       <td className="py-2 px-3">
// //                         {row ? (
// //                           <div className="flex flex-col gap-1">
// //                             <span className="text-[11px] text-slate-700 truncate" title={row.consignorName}>
// //                               {row.consignorName}
// //                             </span>
// //                             <span className="flex items-center mt-0.5">
// //                               <span className="inline-block mr-1 text-[13px] text-slate-400">→</span>
// //                               <span
// //                                 className="font-semibold text-slate-900 text-[15px] leading-tight truncate max-w-[160px]"
// //                                 title={row.consigneeName}
// //                               >
// //                                 {row.consigneeName}
// //                               </span>
// //                             </span>
// //                           </div>

// //                         ) : <LoadingCell />}
// //                       </td>

// //                       {/* Truck */}
// //                       <td className="py-2 px-3 text-slate-700 text-[13px] whitespace-nowrap">
// //                         {row ? row.truckNo : <LoadingCell />}
// //                       </td>

// //                       {/* Wt / Rate / Amt */}
// //                       <td className="py-2 px-3">
// //                         {row ? (
// //                           <div className="flex flex-col gap-0.5">
// //                             <span className="text-[10px] text-slate-400">
// //                               {fmt(row.totalWeight)} kg &nbsp;@&nbsp; ₹{fmt(row.biltyRate, 2)}/kg
// //                             </span>
// //                             <span className="text-slate-900 font-medium text-[16px]">
// //                               {row.totalItemAmount != null
// //                                 ? `₹ ${fmt(row.totalItemAmount, 0)} /-`
// //                                 : c.totalamount != null
// //                                 ? `₹ ${fmt(c.totalamount, 0)} /-`
// //                                 : c.payment
// //                                 ? `₹ ${fmt(Number(c.payment), 0)} /-`
// //                                 : "-"}
// //                             </span>
// //                           </div>
// //                         ) : <LoadingCell />}
// //                       </td>

// //                       {/* Status */}
// //                       <td className="py-2 px-3 whitespace-nowrap">
// //   <StatusBadge status={getBillingStatus(c)} />
// // </td>

// //                       {/* Actions — single dropdown */}
// //                       <td className="py-2 px-3 whitespace-nowrap">
// //                         <ActionMenu
// //                           consignment={c}
// //                           hasInvoice={hasInvoice}
// //                           hasHistory={hasHistory}
// //                           onEdit={handleEdit}
// //                           onDelete={handleDeleteRequest}
// //                           onViewInvoice={handleViewInvoice}
// //                           onDownloadInvoice={handleDownloadInvoice}
// //                           onShareInvoice={handleShareInvoice}
// //                           onViewHistory={handleViewHistory}
// //                         />
// //                       </td>
// //                     </tr>
// //                   );
// //                 })
// //               )}
// //             </tbody>
// //           </table>
// //         </div>
// //       </div>

// //       {/* History modal */}
// //       {historyTarget && (
// //         <ChangeLogModal
// //           bilty={historyTarget.bilty}
// //           entries={historyTarget.entries}
// //           onClose={() => setHistoryTarget(null)}
// //         />
// //       )}

// //       {/* Delete confirm modal */}
// //       <DeleteConfirmModal
// //         id={deleteTarget?.id ?? null}
// //         bilty={deleteTarget?.bilty ?? ""}
// //         onConfirm={handleDeleteConfirm}
// //         onCancel={() => setDeleteTarget(null)}
// //       />
// //     </div>
// //   );
// // };

// // export default ConsignorDashboard;

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import ReactDOM from "react-dom";
// import { useNavigate } from "react-router-dom";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import ExcelJS from "exceljs";

// // ─── Types ────────────────────────────────────────────────────────────────────

// type ShipmentStatus = "pending" | "in_transit" | "delivered" | "draft" | "created" | "dispatched" | "cancelled";
// type FilterOption = "all" | "pending" | "completed" | "modified";

// const API_BASE = process.env.REACT_APP_API_URL;

// interface APIConsignment {
//   id: number;
//   sender: number;
//   company: number;
//   receiver: number;
//   transporter: number;
//   driver: number;
//   vehicles: number;
//   payment: string;
//   source: string;
//   destination: string;
//   receiverAmountStatatus: string;
//   senderAmountStatatus: string;
//   transporterAmountStatatus: string;
//   paymentStatus: string;
//   paymentPayableConsignor: number;
//   ItemsDescription: string;
//   "InvoiceNo"?: string;
//   "InvoiceNo."?: string;
//   EWAYBILLNO: string;
//   subjects: string;
//   link?: string;
//   status?: ShipmentStatus;
//   biltyNo?: string;
//   created_at?: string;
//   totalamount?: number;
//   change_log?: string | null;
//   billing_status?: "pending" | "completed";
//   billing_status_forced?: number;
// }

// interface InvoiceItem {
//   rate: number;
//   id: number;
//   invoiceId: string;
//   description: string;
//   hsm_code: string;
//   uom: string;
//   qty: number;
//   amount: number;
// }

// interface ResolvedRow {
//   consignorName: string;
//   consigneeName: string;
//   consigneeAddress: string;
//   truckNo: string;
//   companyName: string;
//   totalWeight: number | null;
//   biltyRate: number | null;
//   totalItemAmount: number | null;
// }

// type FiltersState = {
//   company: string;
//   biltyNo: string;
//   truckNo: string;
//   consignor: string;
//   consignee: string;
//   dateFrom: string;
//   dateTo: string;
// };

// interface ChangeLogEntry {
//   field: string;
//   from: any;
//   to: any;
//   changed_at: string;
// }

// /**
//  * Letterhead / billing-identity settings — these belong to the ISSUING
//  * company (the `company` on each consignment), not the app globally.
//  * Fetched per-company from `${API_BASE}/companyAuth/company/:id/letterhead`.
//  */
// interface BillingLetterhead {
//   panNo: string;
//   mobile: string;
//   companyName: string;
//   addressLine1: string;
//   addressLine2: string;
//   billNoPrefix: string;
//   bankName: string;
//   accountNo: string;
//   ifscCode: string;
//   branch: string;
//   signatoryName: string;
//   signatoryTitle: string;
//   paymentNote: string;
// }

// interface BillItemRow {
//   consignmentId: number;
//   date: string; // formatted DD.MM.YY
//   consignorName: string;
//   grNo: string;
//   vehicleNo: string;
//   weight: number | null;
//   rate: number | null;
//   amount: number | null;
// }

// interface BillGroup {
//   companyId: number;
//   companyName: string;
//   companyAddress: string;
//   consigneeName: string;
//   consigneeAddress: string;
//   rows: BillItemRow[];
// }

// // ─── Caches (module-level — persist across renders, NOT re-created each render) ─

// const userCache: Record<number, string> = {};
// const userAddressCache: Record<number, string> = {};
// const vehicleCache: Record<number, string> = {};
// const itemsCache: Record<string, InvoiceItem[]> = {};
// const companyCache: Record<number, string> = {};
// const companyAddressCache: Record<number, string> = {};
// const letterheadCache: Record<number, BillingLetterhead> = {};

// // ─── Letterhead defaults ────────────────────────────────────────────────────

// // Used only until the per-company API call resolves (or if it fails) so the
// // bill is never blank — replace values here only as a last-resort fallback.
// const DEFAULT_LETTERHEAD: BillingLetterhead = {
//   panNo: "",
//   mobile: "",
//   companyName: "",
//   addressLine1: "",
//   addressLine2: "",
//   billNoPrefix: "BILL",
//   bankName: "",
//   accountNo: "",
//   ifscCode: "",
//   branch: "",
//   signatoryName: "",
//   signatoryTitle: "",
//   paymentNote: "",
// };

// // ─── Helpers ──────────────────────────────────────────────────────────────────

// async function fetchUserName(id: number): Promise<string> {
//   if (userCache[id]) return userCache[id];
//   try {
//     const res = await fetch(`${API_BASE}/auth/user/${id}`);
//     if (!res.ok) throw new Error();
//     const data = await res.json();
//     userCache[id] = data.name || `User#${id}`;
//   } catch {
//     userCache[id] = `User#${id}`;
//   }
//   return userCache[id];
// }

// async function fetchUserAddress(id: number): Promise<string> {
//   if (userAddressCache[id] !== undefined) return userAddressCache[id];
//   try {
//     const res = await fetch(`${API_BASE}/auth/user/${id}`);
//     if (!res.ok) throw new Error();
//     const data = await res.json();
//     userAddressCache[id] = data.address || "";
//   } catch {
//     userAddressCache[id] = "";
//   }
//   return userAddressCache[id];
// }

// async function fetchVehicleNumber(id: number): Promise<string> {
//   if (vehicleCache[id]) return vehicleCache[id];
//   try {
//     const res = await fetch(`${API_BASE}/auth/vehicles/${id}`);
//     if (!res.ok) throw new Error();
//     const data = await res.json();
//     vehicleCache[id] = data.registration_number || data.vehicle_number || `Vehicle#${id}`;
//   } catch {
//     vehicleCache[id] = `Vehicle#${id}`;
//   }
//   return vehicleCache[id];
// }

// async function fetchInvoiceItems(invoiceDbId: string): Promise<InvoiceItem[]> {
//   if (itemsCache[invoiceDbId]) return itemsCache[invoiceDbId];
//   try {
//     const res = await fetch(`${API_BASE}/invoiceapi/invoice_items/invoice-db/${invoiceDbId}`);
//     if (!res.ok) throw new Error();
//     const data: InvoiceItem[] = await res.json();
//     itemsCache[invoiceDbId] = Array.isArray(data) ? data : [];
//   } catch {
//     itemsCache[invoiceDbId] = [];
//   }
//   return itemsCache[invoiceDbId];
// }

// /** Fetches billed-to company name + address in one call (replaces old name-only fetch). */
// async function fetchCompanyDetails(id: number): Promise<{ name: string; address: string }> {
//   if (companyCache[id] && companyAddressCache[id] !== undefined) {
//     return { name: companyCache[id], address: companyAddressCache[id] };
//   }
//   try {
//     const res = await fetch(`${API_BASE}/companyAuth/company/${id}`);
//     if (!res.ok) throw new Error();
//     const data = await res.json();
//     companyCache[id] = data.company_name || data.name || `Company#${id}`;
//     companyAddressCache[id] = data.address || "";
//   } catch {
//     companyCache[id] = companyCache[id] || `Company#${id}`;
//     companyAddressCache[id] = companyAddressCache[id] || "";
//   }
//   return { name: companyCache[id], address: companyAddressCache[id] };
// }

// /** Fetches the issuing company's billing letterhead (PAN, bank, signatory, etc). */
// async function fetchLetterhead(companyId: number): Promise<BillingLetterhead> {
//   if (letterheadCache[companyId]) return letterheadCache[companyId];
//   try {
//     const res = await fetch(`${API_BASE}/companyAuth/company/${companyId}/letterhead`);
//     if (!res.ok) throw new Error(`Letterhead fetch failed: ${res.status}`);
//     const data = await res.json();
//     letterheadCache[companyId] = { ...DEFAULT_LETTERHEAD, ...data };
//   } catch (e) {
//     console.error("fetchLetterhead error for company", companyId, e);
//     letterheadCache[companyId] = DEFAULT_LETTERHEAD;
//   }
//   return letterheadCache[companyId];
// }

// /** Reserves and returns the next sequential bill number for a company. */
// async function fetchNextBillSeq(companyId: number): Promise<number> {
//   try {
//     const res = await fetch(`${API_BASE}/companyAuth/company/${companyId}/next-bill-no`, { method: "POST" });
//     const data = await res.json();
//     return data.seq ?? 1;
//   } catch {
//     return 1;
//   }
// }

// function computeItemStats(items: InvoiceItem[]) {
//   if (!items.length) return { totalWeight: null, biltyRate: null, totalItemAmount: null };
//   const totalWeight = items.reduce((s, i) => s + Number(i.qty || 0), 0);
//   const totalAmount = items.reduce((s, i) => s + Number(i.amount || 0), 0);
//   const totalRates = items.reduce((s, i) => s + Number(i.rate || 0), 0);
//   return { totalWeight, biltyRate: totalRates, totalItemAmount: totalAmount };
// }

// function fmt(val: number | null | undefined, decimals = 2): string {
//   if (val == null) return "-";
//   return val % 1 === 0 ? String(val) : val.toFixed(decimals);
// }

// const getInvoiceNo = (c: APIConsignment): string =>
//   c.InvoiceNo || (c as any)["InvoiceNo."] || "";

// const getBillingStatus = (c: APIConsignment): "pending" | "completed" =>
//   c.billing_status === "completed" ? "completed" : "pending";

// /** Generate a short abbreviation from a company name, e.g. "Amit Traders & Co." → "ATC" */
// function companyAbbr(name: string): string {
//   const NOISE = /^(pvt|ltd|co|inc|corp|private|limited|and|the|of|&)$/i;
//   const words = name.split(/[\s&,\.]+/).filter(Boolean);
//   const meaningful = words.filter((w) => w.length > 1 && !NOISE.test(w));
//   const src = meaningful.length >= 2 ? meaningful : words;
//   return src
//     .map((w) => w[0].toUpperCase())
//     .slice(0, 3)
//     .join("");
// }

// function parseChangeLog(raw: string | null | undefined): ChangeLogEntry[] {
//   if (!raw) return [];
//   try {
//     const parsed = JSON.parse(raw);
//     return Array.isArray(parsed) ? parsed : [];
//   } catch {
//     return [];
//   }
// }

// function fmtChangeValue(v: any): string {
//   if (v == null) return "—";
//   if (typeof v === "object") {
//     return v.name ? `${v.name}${v.address ? ` (${v.address})` : ""}` : JSON.stringify(v);
//   }
//   return String(v);
// }

// function fmtFieldLabel(field: string): string {
//   const labels: Record<string, string> = {
//     consignee: "Consignee", consignor: "Consignor", sender: "Sender",
//     receiver: "Receiver", vehicle: "Vehicle", origin: "Origin",
//     destination: "Destination",
//   };
//   return labels[field] || field.charAt(0).toUpperCase() + field.slice(1);
// }

// // ─── Bill formatting helpers ───────────────────────────────────────────────────

// function formatBillDate(iso: string | undefined): string {
//   if (!iso) return "-";
//   const d = new Date(iso);
//   if (isNaN(d.getTime())) return "-";
//   const dd = String(d.getDate()).padStart(2, "0");
//   const mm = String(d.getMonth() + 1).padStart(2, "0");
//   const yy = String(d.getFullYear()).slice(-2);
//   return `${dd}.${mm}.${yy}`;
// }

// function todayBillDate(): string {
//   return formatBillDate(new Date().toISOString());
// }

// /** Groups consignments by billed-to company and shapes each row for the bill table. */
// function buildBillGroups(
//   items: APIConsignment[],
//   resolvedRows: Record<number, ResolvedRow>
// ): BillGroup[] {
//   const groups = new Map<number, BillGroup>();
//   for (const c of items) {
//     const row = resolvedRows[c.id];
//     if (!groups.has(c.company)) {
//       groups.set(c.company, {
//         companyId: c.company,
//         companyName: row?.companyName && row.companyName !== "-" ? row.companyName : `Company#${c.company}`,
//         companyAddress: companyAddressCache[c.company] || "",
//         consigneeName: row?.consigneeName && row.consigneeName !== "-" ? row.consigneeName : "",
//         consigneeAddress: row?.consigneeAddress || "",
//         rows: [],
//       });
//     } else {
//       // If a later consignment in the same company group has a different
//       // consignee, flag it rather than silently showing the wrong one.
//       const g = groups.get(c.company)!;
//       if (row?.consigneeName && g.consigneeName && row.consigneeName !== g.consigneeName) {
//         g.consigneeName = "Multiple consignees";
//         g.consigneeAddress = "";
//       }
//     }
//     groups.get(c.company)!.rows.push({
//       consignmentId: c.id,
//       date: formatBillDate(c.created_at),
//       consignorName: row?.consignorName && row.consignorName !== "-" ? row.consignorName : "-",
//       grNo: c.biltyNo || getInvoiceNo(c) || String(c.id),
//       vehicleNo: row?.truckNo && row.truckNo !== "-" ? row.truckNo : "-",
//       weight: row?.totalWeight ?? null,
//       rate: row?.biltyRate ?? null,
//       amount: row?.totalItemAmount ?? c.totalamount ?? null,
//     });
//   }
//   for (const g of groups.values()) {
//     g.rows.sort((a, b) => a.date.localeCompare(b.date));
//   }
//   return Array.from(groups.values());
// }

// function generateBillNo(letterhead: BillingLetterhead, seq: number): string {
//   return `${letterhead.billNoPrefix} ${seq} / ${todayBillDate()}`;
// }

// function safeFileSegment(s: string): string {
//   return s.replace(/[^\w\-]+/g, "_").replace(/^_+|_+$/g, "");
// }

// // ─── PDF generation (Vardhman-style bilty layout) ──────────────────────────────

// /** Draws word-wrapped, centered text and returns the Y position after the last line. */
// function drawWrappedCenteredText(
//   doc: jsPDF, text: string, centerX: number, startY: number, maxWidth: number, lineHeight: number
// ): number {
//   if (!text) return startY;
//   const lines = doc.splitTextToSize(text, maxWidth);
//   lines.forEach((line: string, i: number) => doc.text(line, centerX, startY + i * lineHeight, { align: "center" }));
//   return startY + lines.length * lineHeight;
// }

// function drawBillPDF(doc: jsPDF, letterhead: BillingLetterhead, group: BillGroup, billNo: string) {
//   const marginX = 12;
//   const pageWidth = doc.internal.pageSize.getWidth();
//   const boxW = pageWidth - marginX * 2;
//   const textMaxWidth = boxW - 20; // keeps wrapped lines clear of the outer border
//   const boxTop = 14;
//   const NAVY: [number, number, number] = [26, 42, 90];
//   let y = boxTop;

//   // ── PAN / MOB row ──
//   doc.setTextColor(0, 0, 0);
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(9);
//   doc.text(`PAN NO ${letterhead.panNo}`, marginX + 2, y + 5);
//   doc.text(`MOB:-${letterhead.mobile}`, marginX + boxW - 2, y + 5, { align: "right" });
//   y += 11;

//   // ── Big heading: issuing company (navy, bold, centered, wrapped) ──
//   doc.setTextColor(...NAVY);
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(17);
//   y = drawWrappedCenteredText(doc, letterhead.companyName, pageWidth / 2, y, textMaxWidth, 6);
//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(8.5);
//   y = drawWrappedCenteredText(doc, letterhead.addressLine1, pageWidth / 2, y, textMaxWidth, 4);
//   y = drawWrappedCenteredText(doc, letterhead.addressLine2, pageWidth / 2, y, textMaxWidth, 4);
//   y += 5;

//   // ── Bill No / To (black, left) ──
//   doc.setTextColor(0, 0, 0);
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(9);
//   doc.text(`BILL NO   ${billNo}`, marginX + 2, y);
//   y += 5;
//   doc.setFont("helvetica", "normal");
//   doc.text("To,", marginX + 2, y);
//   y += 6;

//   // ── Billed-to company (bold, centered, wrapped) ──
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(13);
//   y = drawWrappedCenteredText(doc, group.companyName.toUpperCase(), pageWidth / 2, y, textMaxWidth, 5.5);

//   if (group.companyAddress) {
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(9);
//     y = drawWrappedCenteredText(doc, group.companyAddress.toUpperCase(), pageWidth / 2, y, textMaxWidth, 4);
//   }

//   // ── Consignee block, directly below company ──
//   if (group.consigneeName) {
//     y += 3;
//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(10);
//     y = drawWrappedCenteredText(doc, `${group.consigneeName.toUpperCase()}`, pageWidth / 2, y, textMaxWidth, 4.5);
//     if (group.consigneeAddress) {
//       doc.setFont("helvetica", "normal");
//       doc.setFontSize(8.5);
//       y = drawWrappedCenteredText(doc, group.consigneeAddress.toUpperCase(), pageWidth / 2, y, textMaxWidth, 4);
//     }
//   }
//   y += 6;

//   const totalWeight = group.rows.reduce((s, r) => s + (r.weight ?? 0), 0);
//   const totalAmount = group.rows.reduce((s, r) => s + (r.amount ?? 0), 0);

//   const paddedRowCount = Math.max(group.rows.length, 5);
//   const body: any[] = [];
//   for (let i = 0; i < paddedRowCount; i++) {
//     const r = group.rows[i];
//     body.push(
//       r
//         ? [i + 1, r.date, r.consignorName, r.grNo, r.vehicleNo, fmt(r.weight, 3), fmt(r.rate, 2), fmt(r.amount, 2)]
//         : [i + 1, "", "", "", "", "", "", "-"]
//     );
//   }

//   autoTable(doc, {
//     startY: y,
//     margin: { left: marginX, right: marginX },
//     theme: "grid",
//     styles: { fontSize: 8, cellPadding: 1.6, lineColor: [0, 0, 0], lineWidth: 0.1, textColor: 20 },
//     headStyles: { fillColor: [255, 255, 255], textColor: 0, fontStyle: "bold", halign: "center" },
//     footStyles: { fillColor: [255, 255, 255], textColor: 0, fontStyle: "bold" },
//     head: [["SR. NO", "DATE", "CONSIGNOR NAME", "G.R. NO", "VEHICLE NO", "WEIGHT", "RATE", "AMOUNT"]],
//     body,
//     foot: [[
//       { content: "TOTAL AMOUNT", colSpan: 5, styles: { halign: "center", fontStyle: "bold" } },
//       fmt(totalWeight, 2),
//       "",
//       fmt(totalAmount, 2),
//     ]],
//     columnStyles: {
//       0: { cellWidth: 12, halign: "center" },
//       1: { cellWidth: 18, halign: "center" },
//       2: { cellWidth: 44 },
//       3: { cellWidth: 18, halign: "center" },
//       4: { cellWidth: 26, halign: "center" },
//       5: { cellWidth: 20, halign: "right" },
//       6: { cellWidth: 18, halign: "right" },
//       7: { cellWidth: 26, halign: "right" },
//     },
//   });

//   const finalY = (doc as any).lastAutoTable.finalY as number;

//   // ── Bottom-left: Bank details ──
//   let by = finalY + 7;
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(8.5);
//   doc.text("Bank Detail:", marginX + 2, by);
//   by += 4;
//   doc.text(letterhead.bankName, marginX + 2, by);
//   doc.setFont("helvetica", "normal");
//   by += 4;
//   doc.text(`A/C NO :- ${letterhead.accountNo}`, marginX + 2, by);
//   by += 4;
//   doc.text(`IFSC CODE :- ${letterhead.ifscCode}`, marginX + 2, by);
//   by += 4;
//   doc.text(`Branch :- ${letterhead.branch}`, marginX + 2, by);

//   // ── Right side: signature block + far-right E&OE/company ──
//   const rightX = marginX + boxW - 2;
//   const signX = marginX + boxW - 46;

//   let sy = finalY + 7;
//   doc.setFontSize(8);
//   doc.setFont("helvetica", "normal");
//   doc.text(`For ${letterhead.companyName}`, signX, sy, { align: "right" });
//   doc.text("E. & O.E.", rightX, sy, { align: "right" });
//   sy += 10;
//   doc.text(letterhead.signatoryName, signX, sy, { align: "right" });
//   doc.setFont("helvetica", "bold");
//   doc.text(letterhead.companyName.toUpperCase(), rightX, sy, { align: "right" });
//   sy += 4;
//   doc.text(letterhead.signatoryTitle, signX, sy, { align: "right" });

//   // ── Bottom-left: Encl / payment note / Accountant ──
//   let fy = by + 8;
//   doc.setFont("helvetica", "normal");
//   doc.text("Encl:", marginX + 2, fy);
//   fy += 4;
//   doc.setFont("helvetica", "bold");
//   doc.text(letterhead.paymentNote, marginX + 2, fy);
//   doc.setFont("helvetica", "normal");
//   fy += 6;
//   doc.text("Accountant", marginX + 20, fy);

//   const boxBottom = Math.max(fy, sy) + 4;
//   doc.setLineWidth(0.3);
//   doc.rect(marginX - 2, boxTop - 4, boxW + 4, boxBottom - (boxTop - 4));
// }

// function exportBillToPDF(letterhead: BillingLetterhead, group: BillGroup, billNo: string) {
//   const doc = new jsPDF({ unit: "mm", format: "a4" });
//   drawBillPDF(doc, letterhead, group, billNo);
//   const filename = `Bill_${safeFileSegment(group.companyName)}_${safeFileSegment(billNo)}.pdf`;
//   doc.save(filename);
// }

// // ─── Excel generation (ExcelJS — supports real cell styling/borders/merges) ────

// async function exportBillToExcel(letterhead: BillingLetterhead, group: BillGroup, billNo: string) {
//   const wb = new ExcelJS.Workbook();
//   const ws = wb.addWorksheet("Bill");

//   ws.columns = [
//     { width: 6 }, { width: 11 }, { width: 26 }, { width: 11 },
//     { width: 15 }, { width: 11 }, { width: 10 }, { width: 14 },
//   ];

//   const thin: Partial<ExcelJS.Border> = { style: "thin", color: { argb: "FF000000" } };
//   const borderAll = { top: thin, bottom: thin, left: thin, right: thin };
//   const NAVY = "FF1A2A5A";

//   let r = 1;
//   const merge = (row: number, c1: number, c2: number) => ws.mergeCells(row, c1, row, c2);

//   // PAN / MOB
//   ws.getCell(r, 1).value = `PAN NO ${letterhead.panNo}`;
//   ws.getCell(r, 1).font = { bold: true, size: 9 };
//   merge(r, 1, 5);
//   ws.getCell(r, 6).value = `MOB:-${letterhead.mobile}`;
//   ws.getCell(r, 6).font = { bold: true, size: 9 };
//   ws.getCell(r, 6).alignment = { horizontal: "right" };
//   merge(r, 6, 8);
//   r += 2;

//   // Big heading — issuing company, navy, bold, centered
//   ws.getCell(r, 1).value = letterhead.companyName;
//   ws.getCell(r, 1).font = { bold: true, size: 16, color: { argb: NAVY } };
//   ws.getCell(r, 1).alignment = { horizontal: "center" };
//   merge(r, 1, 8); r++;

//   ws.getCell(r, 1).value = letterhead.addressLine1;
//   ws.getCell(r, 1).font = { color: { argb: NAVY }, size: 9 };
//   ws.getCell(r, 1).alignment = { horizontal: "center" };
//   merge(r, 1, 8); r++;

//   ws.getCell(r, 1).value = letterhead.addressLine2;
//   ws.getCell(r, 1).font = { color: { argb: NAVY }, size: 9 };
//   ws.getCell(r, 1).alignment = { horizontal: "center" };
//   merge(r, 1, 8); r += 2;

//   // Bill no / To
//   ws.getCell(r, 1).value = `BILL NO   ${billNo}`;
//   ws.getCell(r, 1).font = { bold: true, size: 9 };
//   merge(r, 1, 8); r++;

//   ws.getCell(r, 1).value = "To,";
//   merge(r, 1, 8); r++;

//   // Billed-to company — bold, centered
//   ws.getCell(r, 1).value = group.companyName.toUpperCase();
//   ws.getCell(r, 1).font = { bold: true, size: 12 };
//   ws.getCell(r, 1).alignment = { horizontal: "center" };
//   merge(r, 1, 8); r++;

//   // Billed-to sub-line (city/state)
//   if (group.companyAddress) {
//     ws.getCell(r, 1).value = group.companyAddress.toUpperCase();
//     ws.getCell(r, 1).font = { size: 9 };
//     ws.getCell(r, 1).alignment = { horizontal: "center" };
//     merge(r, 1, 8); r++;
//   }

//   // Consignee block
//   if (group.consigneeName) {
//     ws.getCell(r, 1).value = `Consignee: ${group.consigneeName.toUpperCase()}`;
//     ws.getCell(r, 1).font = { bold: true, size: 10 };
//     ws.getCell(r, 1).alignment = { horizontal: "center" };
//     merge(r, 1, 8); r++;

//     if (group.consigneeAddress) {
//       ws.getCell(r, 1).value = group.consigneeAddress.toUpperCase();
//       ws.getCell(r, 1).font = { size: 9 };
//       ws.getCell(r, 1).alignment = { horizontal: "center" };
//       merge(r, 1, 8); r++;
//     }
//   }
//   r++;

//   // Table
//   const headerRow = r;
//   const headers = ["SR. NO", "DATE", "CONSIGNOR NAME", "G.R. NO", "VEHICLE NO", "WEIGHT", "RATE", "AMOUNT"];
//   headers.forEach((h, i) => {
//     const cell = ws.getCell(headerRow, i + 1);
//     cell.value = h;
//     cell.font = { bold: true };
//     cell.alignment = { horizontal: "center" };
//     cell.border = borderAll;
//   });
//   r++;

//   const paddedRowCount = Math.max(group.rows.length, 5);
//   for (let i = 0; i < paddedRowCount; i++) {
//     const row = group.rows[i];
//     const vals = row
//       ? [i + 1, row.date, row.consignorName, row.grNo, row.vehicleNo, fmt(row.weight, 3), fmt(row.rate, 2), fmt(row.amount, 2)]
//       : [i + 1, "", "", "", "", "", "", "-"];
//     vals.forEach((v, ci) => {
//       const cell = ws.getCell(r, ci + 1);
//       cell.value = v;
//       cell.border = borderAll;
//       if (ci === 0 || ci === 1 || ci === 4) cell.alignment = { horizontal: "center" };
//       if (ci === 5 || ci === 6 || ci === 7) cell.alignment = { horizontal: "right" };
//     });
//     r++;
//   }

//   const totalWeight = group.rows.reduce((s, x) => s + (x.weight ?? 0), 0);
//   const totalAmount = group.rows.reduce((s, x) => s + (x.amount ?? 0), 0);

//   ws.getCell(r, 1).value = "TOTAL AMOUNT";
//   ws.getCell(r, 1).font = { bold: true };
//   ws.getCell(r, 1).alignment = { horizontal: "center" };
//   merge(r, 1, 5);
//   for (let c = 1; c <= 5; c++) ws.getCell(r, c).border = borderAll;
//   ws.getCell(r, 6).value = fmt(totalWeight, 2);
//   ws.getCell(r, 6).font = { bold: true };
//   ws.getCell(r, 6).border = borderAll;
//   ws.getCell(r, 6).alignment = { horizontal: "right" };
//   ws.getCell(r, 7).border = borderAll;
//   ws.getCell(r, 8).value = fmt(totalAmount, 2);
//   ws.getCell(r, 8).font = { bold: true };
//   ws.getCell(r, 8).border = borderAll;
//   ws.getCell(r, 8).alignment = { horizontal: "right" };
//   r += 2;

//   // Bank details (left) / signature block (right)
//   const blockStart = r;
//   ws.getCell(r, 1).value = "Bank Detail:";
//   ws.getCell(r, 1).font = { bold: true };
//   ws.getCell(r, 6).value = `For ${letterhead.companyName}`;
//   ws.getCell(r, 6).alignment = { horizontal: "right" };
//   merge(r, 6, 7);
//   ws.getCell(r, 8).value = "E. & O.E.";
//   ws.getCell(r, 8).alignment = { horizontal: "right" };
//   r++;

//   ws.getCell(r, 1).value = letterhead.bankName;
//   ws.getCell(r, 1).font = { bold: true };
//   r++;
//   ws.getCell(r, 1).value = `A/C NO :- ${letterhead.accountNo}`; r++;
//   ws.getCell(r, 1).value = `IFSC CODE :- ${letterhead.ifscCode}`; r++;
//   ws.getCell(r, 1).value = `Branch :- ${letterhead.branch}`;

//   ws.getCell(blockStart + 2, 6).value = letterhead.signatoryName;
//   ws.getCell(blockStart + 2, 6).alignment = { horizontal: "right" };
//   merge(blockStart + 2, 6, 7);
//   ws.getCell(blockStart + 2, 8).value = letterhead.companyName.toUpperCase();
//   ws.getCell(blockStart + 2, 8).font = { bold: true, size: 8 };
//   ws.getCell(blockStart + 2, 8).alignment = { horizontal: "right" };

//   ws.getCell(blockStart + 3, 6).value = letterhead.signatoryTitle;
//   ws.getCell(blockStart + 3, 6).font = { bold: true };
//   ws.getCell(blockStart + 3, 6).alignment = { horizontal: "right" };
//   merge(blockStart + 3, 6, 7);
//   r += 2;

//   ws.getCell(r, 1).value = "Encl:"; r++;
//   ws.getCell(r, 1).value = letterhead.paymentNote;
//   ws.getCell(r, 1).font = { bold: true };
//   merge(r, 1, 4); r++;
//   ws.getCell(r, 2).value = "Accountant";

//   // Outer border
//   const lastRow = r;
//   for (let row = 1; row <= lastRow; row++) {
//     ws.getCell(row, 1).border = { ...ws.getCell(row, 1).border, left: thin };
//     ws.getCell(row, 8).border = { ...ws.getCell(row, 8).border, right: thin };
//   }
//   for (let col = 1; col <= 8; col++) {
//     ws.getCell(1, col).border = { ...ws.getCell(1, col).border, top: thin };
//     ws.getCell(lastRow, col).border = { ...ws.getCell(lastRow, col).border, bottom: thin };
//   }

//   const buf = await wb.xlsx.writeBuffer();
//   const blob = new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
//   const url = URL.createObjectURL(blob);
//   const a = document.createElement("a");
//   a.href = url;
//   a.download = `Bill_${safeFileSegment(group.companyName)}_${safeFileSegment(billNo)}.xlsx`;
//   a.click();
//   URL.revokeObjectURL(url);
// }

// // ─── Company color palette ──────────────────────────────────────────────────

// const PALETTE_KEYS = ["blue", "teal", "amber", "red", "purple", "green", "coral", "pink"] as const;

// type PaletteKey = typeof PALETTE_KEYS[number];

// const PALETTE: Record<PaletteKey, { bg: string; text: string; row: string }> = {
//   blue:   { bg: "#E6F1FB", text: "#042C53", row: "rgba(55,138,221,0.18)"  },
//   teal:   { bg: "#E1F5EE", text: "#04342C", row: "rgba(29,158,117,0.18)"  },
//   amber:  { bg: "#FAEEDA", text: "#412402", row: "rgba(186,117,23,0.18)"  },
//   red:    { bg: "#FCEBEB", text: "#501313", row: "rgba(226,75,74,0.18)"   },
//   purple: { bg: "#EEEDFE", text: "#26215C", row: "rgba(83,74,183,0.18)"   },
//   green:  { bg: "#EAF3DE", text: "#173404", row: "rgba(99,153,34,0.18)"   },
//   coral:  { bg: "#FEF0E6", text: "#ffffff", row: "rgba(234,120,40,0.18)"  },
//   pink:   { bg: "#F0EBE3", text: "#ffffff", row: "rgba(140,90,40,0.18)"   },
// };

// /**
//  * Assigns palette colors by the ORDER companies are first encountered,
//  * not by their numeric ID. This guarantees every company gets a distinct
//  * color regardless of ID gaps or clustering. The registry is module-level
//  * so it persists across re-renders without needing React state.
//  */
// const companyColorRegistry = new Map<number, PaletteKey>();

// function paletteForCompany(companyId: number): PaletteKey {
//   if (companyColorRegistry.has(companyId)) {
//     return companyColorRegistry.get(companyId)!;
//   }
//   const idx = companyColorRegistry.size % PALETTE_KEYS.length;
//   const key = PALETTE_KEYS[idx];
//   companyColorRegistry.set(companyId, key);
//   return key;
// }

// // ─── Constants ────────────────────────────────────────────────────────────────

// const FILTER_OPTIONS: { key: FilterOption; label: string }[] = [
//   { key: "all",       label: "All" },
//   { key: "pending",   label: "Pending" },
//   { key: "completed", label: "Completed" },
//   { key: "modified",  label: "Modified" },
// ];

// const STATUS_STYLES: Record<string, string> = {
//   pending:   "bg-amber-100 text-amber-900",
//   completed: "bg-green-100 text-green-900",
// };

// const STATUS_LABELS: Record<string, string> = {
//   pending: "Pending", completed: "Completed",
// };

// // ─── Sub-components ───────────────────────────────────────────────────────────

// const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
//   <span className={`text-[9px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${STATUS_STYLES[status] || "bg-slate-100 text-slate-900"}`}>
//     {STATUS_LABELS[status] || status}
//   </span>
// );

// const DashboardStatCard: React.FC<{ label: string; value: number; color: string }> = ({ label, value, color }) => (
//   <div className="rounded-xl bg-slate-50 p-4 flex flex-col justify-center items-center">
//     <span className="text-[26px] font-semibold mb-1" style={{ color }}>{value}</span>
//     <span className="text-xs font-medium text-slate-500">{label}</span>
//   </div>
// );

// const LoadingCell = () => (
//   <span className="text-slate-300 animate-pulse text-xs">Loading…</span>
// );

// // ─── Company Tag ──────────────────────────────────────────────────────────────

// const TAG_SOLID: Record<PaletteKey, string> = {
//   blue: "#185FA5",
//   teal: "#0F6E56",
//   amber: "#BA7517",
//   red: "#A32D2D",
//   purple: "#534AB7",
//   green: "#3B6D11",
//   coral: "#b85000",
//   pink: "#5a3010",
// };

// const CompanyTag: React.FC<{ companyId: number; companyName: string }> = ({ companyId, companyName }) => {
//   const key = paletteForCompany(companyId);
//   const abbr = companyAbbr(companyName);
//   return (
//     <span
//       title={companyName}
//       className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold cursor-default whitespace-nowrap"
//       style={{ background: TAG_SOLID[key], color: "#ffffff" }}
//     >
//       {abbr}
//     </span>
//   );
// };

// // ─── Action Dropdown (portal-based — escapes overflow:auto clipping) ──────────

// interface ActionMenuProps {
//   consignment: APIConsignment;
//   hasInvoice: boolean;
//   hasHistory: boolean;
//   onEdit: (id: number) => void;
//   onDelete: (id: number) => void;
//   onViewInvoice: (c: APIConsignment) => void;
//   onDownloadInvoice: (c: APIConsignment) => void;
//   onShareInvoice: (c: APIConsignment) => void;
//   onViewHistory: (c: APIConsignment) => void;
// }

// const ActionMenu: React.FC<ActionMenuProps> = ({
//   consignment, hasInvoice, hasHistory, onEdit, onDelete, onViewInvoice, onDownloadInvoice, onShareInvoice, onViewHistory,
// }) => {
//   const [open, setOpen] = useState(false);
//   const [menuStyle, setMenuStyle] = useState<React.CSSProperties>({});
//   const triggerRef = useRef<HTMLButtonElement>(null);
//   const menuRef = useRef<HTMLDivElement>(null);

//   const MENU_WIDTH = 184;
//   const MENU_HEIGHT_APPROX = 270;

//   const reposition = useCallback(() => {
//     if (!triggerRef.current) return;
//     const r = triggerRef.current.getBoundingClientRect();
//     const spaceBelow = window.innerHeight - r.bottom;
//     const flipUp = spaceBelow < MENU_HEIGHT_APPROX && r.top > MENU_HEIGHT_APPROX;
//     const right = window.innerWidth - r.right;
//     setMenuStyle({
//       position: "fixed",
//       top: flipUp ? r.top - 4 : r.bottom + 4,
//       right,
//       width: MENU_WIDTH,
//       transform: flipUp ? "translateY(-100%)" : "none",
//       zIndex: 9999,
//     });
//   }, []);

//   const toggleOpen = () => {
//     if (!open) reposition();
//     setOpen((v) => !v);
//   };

//   useEffect(() => {
//     if (!open) return;
//     const close = (e: MouseEvent) => {
//       if (
//         menuRef.current && !menuRef.current.contains(e.target as Node) &&
//         triggerRef.current && !triggerRef.current.contains(e.target as Node)
//       ) setOpen(false);
//     };
//     const onScroll = () => reposition();
//     document.addEventListener("mousedown", close);
//     window.addEventListener("scroll", onScroll, true);
//     return () => {
//       document.removeEventListener("mousedown", close);
//       window.removeEventListener("scroll", onScroll, true);
//     };
//   }, [open, reposition]);

//   const invoiceDisabled = !hasInvoice;
//   const historyDisabled = !hasHistory;
//   const btnCls = "flex items-center gap-2 w-full px-3 py-[7px] text-[12px] text-left hover:bg-slate-50 transition-colors whitespace-nowrap";
//   const disabledCls = "opacity-40 cursor-not-allowed pointer-events-none";

//   const menu = open ? (
//     <div ref={menuRef} style={menuStyle} className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-md">
//       <div className="border-b border-slate-100 py-1">
//         <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1">Invoice</p>
//         <button
//           className={`${btnCls} text-blue-800 ${invoiceDisabled ? disabledCls : ""}`}
//           disabled={invoiceDisabled}
//           onClick={() => { setOpen(false); onViewInvoice(consignment); }}
//         >
//           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
//           View invoice
//           {invoiceDisabled && <span className="ml-auto text-[9px] text-slate-400">No file</span>}
//         </button>
//         <button
//           className={`${btnCls} text-green-800 ${invoiceDisabled ? disabledCls : ""}`}
//           disabled={invoiceDisabled}
//           onClick={() => { setOpen(false); onDownloadInvoice(consignment); }}
//         >
//           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
//           Download PDF
//         </button>
//         <button
//           className={`${btnCls} text-purple-800 ${invoiceDisabled ? disabledCls : ""}`}
//           disabled={invoiceDisabled}
//           onClick={() => { setOpen(false); onShareInvoice(consignment); }}
//         >
//           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
//           Share link
//         </button>
//       </div>
//       <div className="py-1">
//         <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1">Consignment</p>
//         <button
//           className={`${btnCls} text-slate-700 ${historyDisabled ? disabledCls : ""}`}
//           disabled={historyDisabled}
//           onClick={() => { setOpen(false); onViewHistory(consignment); }}
//         >
//           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//             <circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/>
//           </svg>
//           View history
//           {historyDisabled && <span className="ml-auto text-[9px] text-slate-400">None</span>}
//         </button>
//         <button
//           className={`${btnCls} text-amber-800`}
//           onClick={() => { setOpen(false); onEdit(consignment.id); }}
//         >
//           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
//           Edit
//         </button>
//         <button
//           className={`${btnCls} text-red-800 hover:!bg-red-50`}
//           onClick={() => { setOpen(false); onDelete(consignment.id); }}
//         >
//           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
//           Delete
//         </button>
//       </div>
//     </div>
//   ) : null;

//   return (
//     <>
//       <button
//         ref={triggerRef}
//         onClick={toggleOpen}
//         className="inline-flex items-center gap-1.5 text-[11px] px-2.5 py-1 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-600 transition-colors"
//       >
//         <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
//           <circle cx="8" cy="3" r="1.4"/><circle cx="8" cy="8" r="1.4"/><circle cx="8" cy="13" r="1.4"/>
//         </svg>
//         Actions
//         <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" className="opacity-50">
//           <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
//         </svg>
//       </button>
//       {ReactDOM.createPortal(menu, document.body)}
//     </>
//   );
// };

// // ─── Download Menu (PDF / Excel, selected / filtered) ──────────────────────────

// interface DownloadMenuProps {
//   selectedCount: number;
//   filteredCount: number;
//   onDownload: (scope: "selected" | "filtered", format: "pdf" | "excel") => void;
// }

// const DownloadMenu: React.FC<DownloadMenuProps> = ({ selectedCount, filteredCount, onDownload }) => {
//   const [open, setOpen] = useState(false);
//   const [menuStyle, setMenuStyle] = useState<React.CSSProperties>({});
//   const triggerRef = useRef<HTMLButtonElement>(null);
//   const menuRef = useRef<HTMLDivElement>(null);

//   const reposition = useCallback(() => {
//     if (!triggerRef.current) return;
//     const r = triggerRef.current.getBoundingClientRect();
//     setMenuStyle({
//       position: "fixed",
//       top: r.bottom + 4,
//       right: window.innerWidth - r.right,
//       width: 220,
//       zIndex: 9999,
//     });
//   }, []);

//   const toggleOpen = () => {
//     if (!open) reposition();
//     setOpen((v) => !v);
//   };

//   useEffect(() => {
//     if (!open) return;
//     const close = (e: MouseEvent) => {
//       if (
//         menuRef.current && !menuRef.current.contains(e.target as Node) &&
//         triggerRef.current && !triggerRef.current.contains(e.target as Node)
//       ) setOpen(false);
//     };
//     document.addEventListener("mousedown", close);
//     return () => document.removeEventListener("mousedown", close);
//   }, [open]);

//   const disabledCls = "opacity-40 cursor-not-allowed pointer-events-none";
//   const itemCls = "flex items-center justify-between w-full px-3 py-[7px] text-[12px] text-left hover:bg-slate-50 transition-colors whitespace-nowrap text-slate-700";

//   const menu = open ? (
//     <div ref={menuRef} style={menuStyle} className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-md">
//       <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1.5 border-b border-slate-100">
//         Selected ({selectedCount})
//       </p>
//       <button
//         className={`${itemCls} ${selectedCount === 0 ? disabledCls : ""}`}
//         disabled={selectedCount === 0}
//         onClick={() => { setOpen(false); onDownload("selected", "pdf"); }}
//       >
//         Download as PDF
//       </button>
//       <button
//         className={`${itemCls} ${selectedCount === 0 ? disabledCls : ""}`}
//         disabled={selectedCount === 0}
//         onClick={() => { setOpen(false); onDownload("selected", "excel"); }}
//       >
//         Download as Excel
//       </button>
//       <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1.5 border-y border-slate-100 mt-1">
//         All filtered ({filteredCount})
//       </p>
//       <button
//         className={`${itemCls} ${filteredCount === 0 ? disabledCls : ""}`}
//         disabled={filteredCount === 0}
//         onClick={() => { setOpen(false); onDownload("filtered", "pdf"); }}
//       >
//         Download as PDF
//       </button>
//       <button
//         className={`${itemCls} ${filteredCount === 0 ? disabledCls : ""}`}
//         disabled={filteredCount === 0}
//         onClick={() => { setOpen(false); onDownload("filtered", "excel"); }}
//       >
//         Download as Excel
//       </button>
//     </div>
//   ) : null;

//   return (
//     <>
//       <button
//         ref={triggerRef}
//         onClick={toggleOpen}
//         className="inline-flex items-center gap-1.5 text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
//       >
//         <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//           <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
//         </svg>
//         Download
//         <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" className="opacity-50">
//           <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
//         </svg>
//       </button>
//       {ReactDOM.createPortal(menu, document.body)}
//     </>
//   );
// };

// // ─── Advanced Filters ─────────────────────────────────────────────────────────

// const AdvancedFilters: React.FC<{
//   filters: FiltersState;
//   onChange: (f: FiltersState) => void;
//   companyOptions: string[];
//   biltyOptions: string[];
//   truckOptions: string[];
//   consignorOptions: string[];
//   consigneeOptions: string[];
// }> = ({ filters, onChange, companyOptions, biltyOptions, truckOptions, consignorOptions, consigneeOptions }) => {
//   const sel = "border rounded px-2 py-1 text-xs";
//   const inp = "border rounded px-2 py-1 text-xs mt-1 block";

//   return (
//     <div className="flex flex-wrap gap-3 mb-4">
//       <div>
//         <label className="block text-xs text-slate-500 mb-1">Company</label>
//         <select className={`${sel} w-[160px]`} value={filters.company} onChange={e => onChange({ ...filters, company: e.target.value })}>
//           <option value="">All companies</option>
//           {companyOptions.map(v => <option key={v} value={v}>{v}</option>)}
//         </select>
//       </div>
//       <div>
//         <label className="block text-xs text-slate-500 mb-1">Bilty no.</label>
//         <select className={`${sel} w-[140px]`} value={filters.biltyNo} onChange={e => onChange({ ...filters, biltyNo: e.target.value })}>
//           <option value="">All bilty nos.</option>
//           {biltyOptions.map(v => <option key={v} value={v}>{v}</option>)}
//         </select>
//         <input className={`${inp} w-[140px]`} placeholder="Search bilty" value={filters.biltyNo} onChange={e => onChange({ ...filters, biltyNo: e.target.value })} />
//       </div>
//       <div>
//         <label className="block text-xs text-slate-500 mb-1">Truck no.</label>
//         <select className={`${sel} w-[130px]`} value={filters.truckNo} onChange={e => onChange({ ...filters, truckNo: e.target.value })}>
//           <option value="">All trucks</option>
//           {truckOptions.map(v => <option key={v} value={v}>{v}</option>)}
//         </select>
//         <input className={`${inp} w-[130px]`} placeholder="Search truck" value={filters.truckNo} onChange={e => onChange({ ...filters, truckNo: e.target.value })} />
//       </div>
//       <div>
//         <label className="block text-xs text-slate-500 mb-1">Consignor</label>
//         <select className={`${sel} w-[130px]`} value={filters.consignor} onChange={e => onChange({ ...filters, consignor: e.target.value })}>
//           <option value="">All consignors</option>
//           {consignorOptions.map(v => <option key={v} value={v}>{v}</option>)}
//         </select>
//         <input className={`${inp} w-[130px]`} placeholder="Search consignor" value={filters.consignor} onChange={e => onChange({ ...filters, consignor: e.target.value })} />
//       </div>
//       <div>
//         <label className="block text-xs text-slate-500 mb-1">Consignee</label>
//         <select className={`${sel} w-[130px]`} value={filters.consignee} onChange={e => onChange({ ...filters, consignee: e.target.value })}>
//           <option value="">All consignees</option>
//           {consigneeOptions.map(v => <option key={v} value={v}>{v}</option>)}
//         </select>
//         <input className={`${inp} w-[130px]`} placeholder="Search consignee" value={filters.consignee} onChange={e => onChange({ ...filters, consignee: e.target.value })} />
//       </div>
//       <div>
//         <label className="block text-xs text-slate-500 mb-1">Date from</label>
//         <input type="date" className={`${sel}`} value={filters.dateFrom} onChange={e => onChange({ ...filters, dateFrom: e.target.value })} />
//       </div>
//       <div>
//         <label className="block text-xs text-slate-500 mb-1">Date to</label>
//         <input type="date" className={`${sel}`} value={filters.dateTo} onChange={e => onChange({ ...filters, dateTo: e.target.value })} />
//       </div>
//       <div className="flex items-end">
//         <button
//           className="text-xs px-3 py-1 border rounded bg-slate-50 text-slate-600"
//           onClick={() => onChange({ company: "", biltyNo: "", truckNo: "", consignor: "", consignee: "", dateFrom: "", dateTo: "" })}
//         >
//           Clear
//         </button>
//       </div>
//     </div>
//   );
// };

// // ─── Delete Confirm Modal ─────────────────────────────────────────────────────

// const DeleteConfirmModal: React.FC<{
//   id: number | null;
//   bilty: string;
//   onConfirm: () => void;
//   onCancel: () => void;
// }> = ({ id, bilty, onConfirm, onCancel }) => {
//   if (id === null) return null;
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
//       <div className="bg-white rounded-2xl border border-slate-200 p-6 w-[340px] shadow-lg">
//         <h3 className="text-[15px] font-medium text-slate-900 mb-2">Delete consignment?</h3>
//         <p className="text-xs text-slate-500 mb-5 leading-relaxed">
//           You are about to permanently delete <strong>{bilty}</strong>. This action cannot be undone and all associated data will be removed.
//         </p>
//         <div className="flex gap-3 justify-end">
//           <button onClick={onCancel} className="text-xs px-4 py-1.5 border border-slate-200 rounded-lg text-slate-600 hover:bg-slate-50 transition-colors">
//             Cancel
//           </button>
//           <button onClick={onConfirm} className="text-xs px-4 py-1.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
//             Delete
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ─── Change Log Modal ──────────────────────────────────────────────────────────

// const ChangeLogModal: React.FC<{
//   bilty: string;
//   entries: ChangeLogEntry[];
//   onClose: () => void;
// }> = ({ bilty, entries, onClose }) => {
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-2">
//       <div className="bg-white rounded-2xl border border-slate-200 p-6 w-full max-w-md shadow-lg max-h-[80vh] flex flex-col">
//         <div className="flex items-start justify-between mb-1">
//           <h3 className="text-[15px] font-medium text-slate-900">Change history</h3>
//           <button onClick={onClose} className="text-slate-400 hover:text-slate-700 transition-colors">
//             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//               <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
//             </svg>
//           </button>
//         </div>
//         <p className="text-xs text-slate-400 mb-4">{bilty}</p>

//         <div className="overflow-y-auto space-y-3 pr-1">
//           {entries.length === 0 ? (
//             <p className="text-sm text-slate-400 text-center py-6">No changes recorded.</p>
//           ) : (
//             [...entries].reverse().map((entry, i) => (
//               <div key={i} className="border border-slate-100 rounded-xl p-3 bg-slate-50/60">
//                 <div className="flex items-center justify-between mb-1.5">
//                   <span className="text-[11px] font-semibold text-slate-700 uppercase tracking-wide">
//                     {fmtFieldLabel(entry.field)}
//                   </span>
//                   <span className="text-[10px] text-slate-400">
//                     {entry.changed_at
//                       ? new Date(entry.changed_at).toLocaleString("en-IN", {
//                           day: "2-digit", month: "short", year: "2-digit",
//                           hour: "2-digit", minute: "2-digit",
//                         })
//                       : ""}
//                   </span>
//                 </div>
//                 <div className="flex items-center gap-2 text-xs">
//                   <span className="px-2 py-1 rounded-md bg-red-50 text-red-700 line-through decoration-red-300">
//                     {fmtChangeValue(entry.from)}
//                   </span>
//                   <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-slate-400 shrink-0">
//                     <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
//                   </svg>
//                   <span className="px-2 py-1 rounded-md bg-green-50 text-green-800 font-medium">
//                     {fmtChangeValue(entry.to)}
//                   </span>
//                 </div>
//               </div>
//             ))
//           )}
//         </div>

//         <div className="flex justify-end mt-4">
//           <button onClick={onClose} className="text-xs px-4 py-1.5 border border-slate-200 rounded-lg text-slate-600 hover:bg-slate-50 transition-colors">
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ─── Main Dashboard ───────────────────────────────────────────────────────────

// const ConsignorDashboard: React.FC = () => {
//   const navigate = useNavigate();
//   const [consignments, setConsignments] = useState<APIConsignment[]>([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState<string | null>(null);
//   const [activeFilter, setActiveFilter] = useState<FilterOption>("all");
//   const [resolvedRows, setResolvedRows] = useState<Record<number, ResolvedRow>>({});
//   const [deleteTarget, setDeleteTarget] = useState<{ id: number; bilty: string } | null>(null);
//   const [historyTarget, setHistoryTarget] = useState<{ bilty: string; entries: ChangeLogEntry[] } | null>(null);
//   const [selectedIds, setSelectedIds] = useState<Set<number>>(new Set());

//   const [filters, setFilters] = useState<FiltersState>({
//     company: "", biltyNo: "", truckNo: "", consignor: "", consignee: "", dateFrom: "", dateTo: "",
//   });

//   useEffect(() => {
//     setLoading(true);
//     setError(null);

//     fetch(`${API_BASE}/invoiceapi/invoice`)
//       .then((res) => res.json())
//       .then(async (data) => {
//         if (!Array.isArray(data)) { setConsignments([]); return; }

//         const mapped: APIConsignment[] = data.map((c: any) => ({
//           id: c.id,
//           sender: c.sender,
//           company: c.company,
//           receiver: c.receiver,
//           transporter: c.transporter,
//           driver: c.driver,
//           vehicles: c.vehicles,
//           payment: c.payment,
//           source: c.source,
//           destination: c.destination,
//           receiverAmountStatatus: c.receiverAmountStatatus,
//           senderAmountStatatus: c.senderAmountStatatus,
//           transporterAmountStatatus: c.transporterAmountStatatus,
//           paymentStatus: c.paymentStatus,
//           paymentPayableConsignor: c.paymentPayableConsignor,
//           ItemsDescription: c.ItemsDescription,
//           InvoiceNo: c["InvoiceNo"] ?? c["InvoiceNo."] ?? "",
//           "InvoiceNo.": c["InvoiceNo."],
//           EWAYBILLNO: c.EWAYBILLNO,
//           subjects: c.subjects,
//           link: c.link ?? c.invoiceLink,
//           status: c.status ?? undefined,
//           biltyNo: c.biltyNo ?? c["InvoiceNo"] ?? c["InvoiceNo."] ?? "",
//           created_at: c.created_at ?? "",
//           totalamount: c.totalamount ?? null,
//           change_log: c.change_log ?? null,
//           billing_status: c.billing_status === "completed" ? "completed" : "pending",
//           billing_status_forced: c.billing_status_forced ?? 0,
//         }));

//         const senderIds    = [...new Set(mapped.map(c => c.sender).filter(Boolean))];
//         const receiverIds  = [...new Set(mapped.map(c => c.receiver).filter(Boolean))];
//         const vehicleIds   = [...new Set(mapped.map(c => c.vehicles).filter(Boolean))];
//         const companyIds   = [...new Set(mapped.map(c => c.company).filter(Boolean))];
//         const invoiceDbIds = [...new Set(mapped.map(c => String(c.id)).filter(Boolean))];

//         // Pre-register companies in a stable order so color assignments are
//         // deterministic and don't shift between renders or data fetches.
//         companyColorRegistry.clear();
//         companyIds.forEach(id => paletteForCompany(id));

//         await Promise.allSettled([
//           ...senderIds.map(fetchUserName),
//           ...receiverIds.map(fetchUserName),
//           ...receiverIds.map(fetchUserAddress),
//           ...vehicleIds.map(fetchVehicleNumber),
//           ...companyIds.map(fetchCompanyDetails),
//           ...invoiceDbIds.map(fetchInvoiceItems),
//         ]);

//         const resolved: Record<number, ResolvedRow> = {};
//         for (const c of mapped) {
//           const items = itemsCache[String(c.id)] ?? [];
//           const { totalWeight, biltyRate, totalItemAmount } = computeItemStats(items);
//           resolved[c.id] = {
//             consignorName: c.sender ? userCache[c.sender] || `User#${c.sender}` : "-",
//             consigneeName: c.receiver ? userCache[c.receiver] || `User#${c.receiver}` : "-",
//             consigneeAddress: c.receiver ? userAddressCache[c.receiver] || "" : "",
//             truckNo: c.vehicles ? vehicleCache[c.vehicles] || `Vehicle#${c.vehicles}` : "-",
//             companyName: c.company ? companyCache[c.company] || `Company#${c.company}` : "-",
//             totalWeight,
//             biltyRate,
//             totalItemAmount,
//           };
//         }
//         setResolvedRows(resolved);
//         setConsignments(mapped);
//       })
//       .catch(() => setError("Unable to fetch consignments"))
//       .finally(() => setLoading(false));
//   }, []);

//   // ── Invoice action handlers ──
//   const handleViewInvoice = useCallback((c: APIConsignment) => {
//     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
//     if (url) window.open(url, "_blank");
//   }, []);

//   const handleDownloadInvoice = useCallback((c: APIConsignment) => {
//     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
//     if (!url) return;
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `Invoice_${getInvoiceNo(c) || c.EWAYBILLNO || c.id}`;
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//   }, []);

//   function getLastChange(raw: string | null | undefined): ChangeLogEntry | null {
//     const entries = parseChangeLog(raw);
//     return entries.length ? entries[entries.length - 1] : null;
//   }

//   function timeAgo(iso: string): string {
//     const diff = Date.now() - new Date(iso).getTime();
//     const m = Math.floor(diff / 60000);
//     if (m < 60) return `${m}m ago`;
//     const h = Math.floor(m / 60);
//     if (h < 24) return `${h}h ago`;
//     return `${Math.floor(h / 24)}d ago`;
//   }

//   const handleShareInvoice = useCallback((c: APIConsignment) => {
//     const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
//     if (!url) return;
//     if (navigator.share) {
//       navigator.share({ title: `Invoice ${getInvoiceNo(c)}`, url });
//     } else {
//       navigator.clipboard.writeText(url);
//       alert("Invoice link copied!");
//     }
//   }, []);

//   const handleEdit = useCallback((id: number) => {
//     navigate(`/admin/edit/consignments/${id}`);
//   }, [navigate]);

//   const handleViewHistory = useCallback((c: APIConsignment) => {
//     const entries = parseChangeLog(c.change_log);
//     setHistoryTarget({ bilty: c.biltyNo || getInvoiceNo(c) || String(c.id), entries });
//   }, []);

//   const handleDeleteRequest = useCallback((id: number) => {
//     const c = consignments.find(x => x.id === id);
//     setDeleteTarget({ id, bilty: c?.biltyNo || getInvoiceNo(c!) || String(id) });
//   }, [consignments]);

//   const handleDeleteConfirm = useCallback(async () => {
//     if (!deleteTarget) return;
//     const { id } = deleteTarget;
//     setDeleteTarget(null);
//     try {
//       const res = await fetch(`${API_BASE}/invoiceapi/invoice/${id}`, { method: "DELETE" });
//       if (res.ok || res.status === 404) {
//         setConsignments(prev => prev.filter(c => c.id !== id));
//         setSelectedIds(prev => {
//           const next = new Set(prev);
//           next.delete(id);
//           return next;
//         });
//       } else {
//         const err = await res.json();
//         alert(`Failed to delete: ${err.error || "Unknown error"}`);
//       }
//     } catch (e: any) {
//       alert(`Failed to delete: ${e?.message || e}`);
//     }
//   }, [deleteTarget]);

//   // ── Selection handlers ──
//   const toggleSelectRow = useCallback((id: number) => {
//     setSelectedIds(prev => {
//       const next = new Set(prev);
//       if (next.has(id)) next.delete(id); else next.add(id);
//       return next;
//     });
//   }, []);

//   const toggleSelectAllFiltered = useCallback((filteredIds: number[]) => {
//     setSelectedIds(prev => {
//       const allSelected = filteredIds.length > 0 && filteredIds.every(id => prev.has(id));
//       if (allSelected) {
//         const next = new Set(prev);
//         filteredIds.forEach(id => next.delete(id));
//         return next;
//       }
//       const next = new Set(prev);
//       filteredIds.forEach(id => next.add(id));
//       return next;
//     });
//   }, []);

//   // ── Download handler — fetches letterhead PER company, sequences bill numbers ──
//   const handleDownload = useCallback(async (
//     scope: "selected" | "filtered",
//     format: "pdf" | "excel",
//     filteredList: APIConsignment[]
//   ) => {
//     const source = scope === "selected"
//       ? consignments.filter(c => selectedIds.has(c.id))
//       : filteredList;
//     if (source.length === 0) return;

//     const groups = buildBillGroups(source, resolvedRows);
//     for (const group of groups) {
//       const lh = await fetchLetterhead(group.companyId);
//       const seq = await fetchNextBillSeq(group.companyId);
//       const billNo = generateBillNo(lh, seq);
//       if (format === "pdf") exportBillToPDF(lh, group, billNo);
//       else await exportBillToExcel(lh, group, billNo);
//     }
//   }, [consignments, selectedIds, resolvedRows]);

//   // ── Dropdown options ──
//   const companyOptions = [...new Set(Object.values(resolvedRows).map(r => r.companyName).filter(v => v && v !== "-"))];
//   const biltyOptions = [...new Set(consignments.map(c => c.biltyNo || getInvoiceNo(c)).filter(Boolean))];
//   const truckOptions = [...new Set(Object.values(resolvedRows).map(r => r.truckNo).filter(v => v && v !== "-"))];
//   const consignorOptions = [...new Set(Object.values(resolvedRows).map(r => r.consignorName).filter(v => v && v !== "-"))];
//   const consigneeOptions = [...new Set(Object.values(resolvedRows).map(r => r.consigneeName).filter(v => v && v !== "-"))];

//   // ── Filtering + sorting ──
//   const filtered = consignments
//     .filter((c) => {
//       const row = resolvedRows[c.id];
//       if (activeFilter === "pending" && getBillingStatus(c) !== "pending") return false;
//       if (activeFilter === "completed" && getBillingStatus(c) !== "completed") return false;
//       if (activeFilter === "modified" && !c.change_log) return false;
//       if (filters.company && row && row.companyName !== filters.company) return false;
//       if (filters.biltyNo) {
//         const q = filters.biltyNo.toLowerCase();
//         const bn = (c.biltyNo || getInvoiceNo(c) || "").toLowerCase();
//         if (!bn.includes(q)) return false;
//       }
//       if (filters.truckNo && row) {
//         if (!String(row.truckNo || "").toLowerCase().includes(filters.truckNo.toLowerCase())) return false;
//       }
//       if (filters.consignor && row) {
//         if (!String(row.consignorName || "").toLowerCase().includes(filters.consignor.toLowerCase())) return false;
//       }
//       if (filters.consignee && row) {
//         if (!String(row.consigneeName || "").toLowerCase().includes(filters.consignee.toLowerCase())) return false;
//       }
//       if (filters.dateFrom && c.created_at) {
//         if (new Date(c.created_at).toISOString().slice(0, 10) < filters.dateFrom) return false;
//       }
//       if (filters.dateTo && c.created_at) {
//         if (new Date(c.created_at).toISOString().slice(0, 10) > filters.dateTo) return false;
//       }
//       return true;
//     })
//     .sort((a, b) => {
//       const ba = (a.biltyNo || getInvoiceNo(a) || "").toString();
//       const bb = (b.biltyNo || getInvoiceNo(b) || "").toString();
//       const cmp = ba.localeCompare(bb, undefined, { numeric: true, sensitivity: "base" });
//       if (cmp !== 0) return cmp;
//       return (a.created_at ? new Date(a.created_at).getTime() : 0) -
//              (b.created_at ? new Date(b.created_at).getTime() : 0);
//     });

//   const filteredIds = filtered.map(c => c.id);
//   const allFilteredSelected = filteredIds.length > 0 && filteredIds.every(id => selectedIds.has(id));

//   const stats = [
//     { label: "Total",     value: consignments.length, color: "#185FA5" },
//     { label: "Pending",   value: consignments.filter(c => getBillingStatus(c) === "pending").length,   color: "#854F0B" },
//     { label: "Completed", value: consignments.filter(c => getBillingStatus(c) === "completed").length, color: "#3B6D11" },
//     { label: "Modified",  value: consignments.filter(c => !!c.change_log).length,                       color: "#7c3aed" },
//   ];

//   // ── Table column headers ──
//   const HEADERS = ["", "#", "Date · Bilty", "Company", "Route", "Parties", "Truck", "Wt / Rate / Amt", "Status", "Actions"];

//   return (
//     <div className="p-4 md:p-6 space-y-4">
//       {/* Stats */}
//       <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
//         {stats.map(s => <DashboardStatCard key={s.label} {...s} />)}
//       </div>

//       {/* Panel */}
//       <div className="bg-white border border-slate-100 rounded-2xl p-4">
//         <div className="flex items-center justify-between mb-3">
//           <div>
//             <h2 className="text-[16px] font-medium text-slate-900">My Consignments</h2>
//             <p className="text-xs text-slate-400">View and manage your consignments &amp; invoices</p>
//           </div>
//           <div className="flex items-center gap-2">
//             <DownloadMenu
//               selectedCount={selectedIds.size}
//               filteredCount={filtered.length}
//               onDownload={(scope, format) => handleDownload(scope, format, filtered)}
//             />
//             <button
//               className="text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
//               onClick={() => navigate("/admin/add/consignments")}
//             >
//               + New Consignment
//             </button>
//           </div>
//         </div>

//         {/* Status pills */}
//         <div className="flex flex-wrap gap-1.5 mb-4">
//           {FILTER_OPTIONS.map(({ key, label }) => (
//             <button
//               key={key}
//               onClick={() => setActiveFilter(key)}
//               className={`text-xs px-3 py-1 rounded-full border transition-colors ${
//                 activeFilter === key
//                   ? "bg-slate-900 text-white border-transparent"
//                   : "border-slate-200 text-slate-500 hover:bg-slate-50"
//               }`}
//             >
//               {label}
//             </button>
//           ))}
//         </div>

//         <AdvancedFilters
//           filters={filters}
//           onChange={setFilters}
//           companyOptions={companyOptions}
//           biltyOptions={biltyOptions}
//           truckOptions={truckOptions}
//           consignorOptions={consignorOptions}
//           consigneeOptions={consigneeOptions}
//         />

//         {/* Table */}
//         <div className="overflow-x-auto">
//           <table className="w-full text-[12px]" style={{ minWidth: 860 }}>
//             <thead>
//               <tr className="border-b border-slate-100">
//                 {HEADERS.map((h, i) => (
//                   i === 0 ? (
//                     <th key="select-all" className="py-2 px-3 w-8">
//                       <input
//                         type="checkbox"
//                         checked={allFilteredSelected}
//                         onChange={() => toggleSelectAllFiltered(filteredIds)}
//                         className="w-3.5 h-3.5 rounded border-slate-300 cursor-pointer"
//                       />
//                     </th>
//                   ) : (
//                     <th key={h} className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap text-[10px]">{h}</th>
//                   )
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 <tr><td colSpan={10} className="py-6 text-center text-slate-400">Loading…</td></tr>
//               ) : error ? (
//                 <tr><td colSpan={10} className="py-6 text-center text-red-600">{error}</td></tr>
//               ) : filtered.length === 0 ? (
//                 <tr><td colSpan={10} className="py-8 text-center text-slate-400">No consignments found.</td></tr>
//               ) : (
//                 filtered.map((c, idx) => {
//                   const row = resolvedRows[c.id];
//                   const palKey = paletteForCompany(c.company);
//                   const pal = PALETTE[palKey];
//                   const hasInvoice = !!c.link;
//                   const hasHistory = !!c.change_log;
//                   const isSelected = selectedIds.has(c.id);
//                   const lastChange = getLastChange(c.change_log);

//                   return (
//                     <tr
//                       key={c.id}
//                       className="border-b border-slate-100 transition-all"
//                       style={{
//                         background: isSelected ? "rgba(24,95,165,0.12)" : pal.row,
//                         borderLeft: hasHistory ? "3px solid #7c3aed" : "3px solid transparent",
//                       }}
//                     >
//                       {/* Select */}
//                       <td className="py-2 px-3">
//                         <input
//                           type="checkbox"
//                           checked={isSelected}
//                           onChange={() => toggleSelectRow(c.id)}
//                           className="w-3.5 h-3.5 rounded border-slate-300 cursor-pointer"
//                         />
//                       </td>

//                       {/* # */}
//                       <td className="py-2 px-3 text-slate-400 text-[11px]">{idx + 1}</td>

//                       {/* Date · Bilty */}
//                       <td className="py-2 px-3">
//                         <div className="flex flex-col gap-1">
//                           <span className="text-slate-900 font-medium">
//                             {c.biltyNo || getInvoiceNo(c) || "-"}
//                           </span>
//                           <span className="text-[11px] font-extrabold text-slate-800">
//                             {c.created_at
//                               ? new Date(c.created_at).toLocaleDateString("en-IN", {
//                                   day: "2-digit", month: "short", year: "2-digit",
//                                 })
//                               : "-"}
//                           </span>
//                           {lastChange && (
//                             <button
//                               onClick={() => handleViewHistory(c)}
//                               title="Click to view full history"
//                               className="inline-flex items-center gap-1 w-fit mt-0.5 px-1.5 py-0.5 rounded-md
//                                          bg-violet-50 border border-violet-100 text-violet-700
//                                          hover:bg-violet-100 transition-colors group"
//                             >
//                               <svg width="9" height="9" viewBox="0 0 24 24" fill="none"
//                                 stroke="currentColor" strokeWidth="2.2"
//                                 strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
//                                 <circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/>
//                               </svg>
//                               <span className="text-[10px] leading-tight">
//                                 <span className="font-semibold">{fmtFieldLabel(lastChange.field)}</span>
//                                 {" · "}
//                                 <span className="opacity-70">{timeAgo(lastChange.changed_at)}</span>
//                               </span>
//                               <svg width="8" height="8" viewBox="0 0 10 10" fill="currentColor"
//                                 className="opacity-30 group-hover:opacity-60 transition-opacity ml-0.5">
//                                 <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor"
//                                   strokeWidth="1.4" fill="none" strokeLinecap="round"/>
//                               </svg>
//                             </button>
//                           )}
//                         </div>
//                       </td>

//                       {/* Company */}
//                       <td className="py-2 px-3">
//                         {row
//                           ? <CompanyTag companyId={c.company} companyName={row.companyName} />
//                           : <LoadingCell />}
//                       </td>

//                       {/* Route */}
//                       <td className="py-2 px-3">
//                         <div className="flex flex-col gap-0.5">
//                           <span className="text-slate-800 text-[11px]">{c.source || "-"}</span>
//                           <span className="text-[10px] text-slate-400">→ {c.destination || "-"}</span>
//                         </div>
//                       </td>

//                       {/* Parties */}
//                       <td className="py-2 px-3">
//                         {row ? (
//                           <div className="flex flex-col gap-1">
//                             <span className="text-[11px] text-slate-700 truncate" title={row.consignorName}>
//                               {row.consignorName}
//                             </span>
//                             <span className="flex items-center mt-0.5">
//                               <span className="inline-block mr-1 text-[13px] text-slate-400">→</span>
//                               <span
//                                 className="font-semibold text-slate-900 text-[15px] leading-tight truncate max-w-[160px]"
//                                 title={row.consigneeName}
//                               >
//                                 {row.consigneeName}
//                               </span>
//                             </span>
//                           </div>
//                         ) : <LoadingCell />}
//                       </td>

//                       {/* Truck */}
//                       <td className="py-2 px-3 text-slate-700 text-[13px] whitespace-nowrap">
//                         {row ? row.truckNo : <LoadingCell />}
//                       </td>

//                       {/* Wt / Rate / Amt */}
//                       <td className="py-2 px-3">
//                         {row ? (
//                           <div className="flex flex-col gap-0.5">
//                             <span className="text-[10px] text-slate-400">
//                               {fmt(row.totalWeight)} kg &nbsp;@&nbsp; ₹{fmt(row.biltyRate, 2)}/kg
//                             </span>
//                             <span className="text-slate-900 font-medium text-[16px]">
//                               {row.totalItemAmount != null
//                                 ? `₹ ${fmt(row.totalItemAmount, 0)} /-`
//                                 : c.totalamount != null
//                                 ? `₹ ${fmt(c.totalamount, 0)} /-`
//                                 : c.payment
//                                 ? `₹ ${fmt(Number(c.payment), 0)} /-`
//                                 : "-"}
//                             </span>
//                           </div>
//                         ) : <LoadingCell />}
//                       </td>

//                       {/* Status */}
//                       <td className="py-2 px-3 whitespace-nowrap">
//                         <StatusBadge status={getBillingStatus(c)} />
//                       </td>

//                       {/* Actions — single dropdown */}
//                       <td className="py-2 px-3 whitespace-nowrap">
//                         <ActionMenu
//                           consignment={c}
//                           hasInvoice={hasInvoice}
//                           hasHistory={hasHistory}
//                           onEdit={handleEdit}
//                           onDelete={handleDeleteRequest}
//                           onViewInvoice={handleViewInvoice}
//                           onDownloadInvoice={handleDownloadInvoice}
//                           onShareInvoice={handleShareInvoice}
//                           onViewHistory={handleViewHistory}
//                         />
//                       </td>
//                     </tr>
//                   );
//                 })
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* History modal */}
//       {historyTarget && (
//         <ChangeLogModal
//           bilty={historyTarget.bilty}
//           entries={historyTarget.entries}
//           onClose={() => setHistoryTarget(null)}
//         />
//       )}

//       {/* Delete confirm modal */}
//       <DeleteConfirmModal
//         id={deleteTarget?.id ?? null}
//         bilty={deleteTarget?.bilty ?? ""}
//         onConfirm={handleDeleteConfirm}
//         onCancel={() => setDeleteTarget(null)}
//       />
//     </div>
//   );
// };

// export default ConsignorDashboard;

import React, { useState, useEffect, useRef, useCallback } from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";

// ─── Types ────────────────────────────────────────────────────────────────────

type ShipmentStatus = "pending" | "in_transit" | "delivered" | "draft" | "created" | "dispatched" | "cancelled";
type FilterOption = "all" | "pending" | "completed" | "modified";

const API_BASE = process.env.REACT_APP_API_URL;

interface APIConsignment {
  id: number;
  sender: number;
  company: number;
  receiver: number;
  transporter: number;
  driver: number;
  vehicles: number;
  payment: string;
  source: string;
  destination: string;
  receiverAmountStatatus: string;
  senderAmountStatatus: string;
  transporterAmountStatatus: string;
  paymentStatus: string;
  paymentPayableConsignor: number;
  ItemsDescription: string;
  "InvoiceNo"?: string;
  "InvoiceNo."?: string;
  EWAYBILLNO: string;
  subjects: string;
  link?: string;
  status?: ShipmentStatus;
  biltyNo?: string;
  created_at?: string;
  totalamount?: number;
  change_log?: string | null;
  billing_status?: "pending" | "completed";
  billing_status_forced?: number;

  items?: InvoiceItem[]; // NEW
}

interface InvoiceItem {
  rate: number;
  id: number;
  invoiceId: string;
  description: string;
  hsm_code: string;
  uom: string;
  qty: number;
  amount: number;
}

interface ResolvedRow {
  consignorName: string;
  consigneeName: string;
  consigneeAddress: string;
  truckNo: string;
  companyName: string;
  totalWeight: number | null;
  biltyRate: number | null;
  totalItemAmount: number | null;
}

type FiltersState = {
  company: string;
  biltyNo: string;
  truckNo: string;
  consignor: string;
  consignee: string;
  dateFrom: string;
  dateTo: string;
};

interface ChangeLogEntry {
  field: string;
  from: any;
  to: any;
  changed_at: string;
}

/**
 * Letterhead / billing-identity settings — these belong to the ISSUING
 * company (the `company` on each consignment), not the app globally.
 * Fetched per-company from `${API_BASE}/companyAuth/company/:id/letterhead`.
 */
interface BillingLetterhead {
  panNo: string;
  mobile: string;
  companyName: string;
  addressLine1: string;
  addressLine2: string;
  billNoPrefix: string;
  bankName: string;
  accountNo: string;
  ifscCode: string;
  branch: string;
  signatoryName: string;
  signatoryTitle: string;
  paymentNote: string;
}

interface BillItemRow {
  consignmentId: number;
  date: string; // formatted DD.MM.YY
  consignorName: string;
  grNo: string;
  vehicleNo: string;
  weight: number | null;
  rate: number | null;
  amount: number | null;
}

interface BillGroup {
  companyId: number;
  companyName: string;
  companyAddress: string;
  consigneeName: string;
  consigneeAddress: string;
  rows: BillItemRow[];
}

// ─── Caches (module-level — persist across renders, NOT re-created each render) ─

const userCache: Record<number, string> = {};
const userAddressCache: Record<number, string> = {};
const vehicleCache: Record<number, string> = {};
const itemsCache: Record<string, InvoiceItem[]> = {};
const companyCache: Record<number, string> = {};
const companyAddressCache: Record<number, string> = {};
const letterheadCache: Record<number, BillingLetterhead> = {};

// ─── Letterhead defaults ────────────────────────────────────────────────────

// Used only until the per-company API call resolves (or if it fails) so the
// bill is never blank — replace values here only as a last-resort fallback.
const DEFAULT_LETTERHEAD: BillingLetterhead = {
  panNo: "",
  mobile: "",
  companyName: "",
  addressLine1: "",
  addressLine2: "",
  billNoPrefix: "BILL",
  bankName: "",
  accountNo: "",
  ifscCode: "",
  branch: "",
  signatoryName: "",
  signatoryTitle: "",
  paymentNote: "",
};

// ─── Helpers ──────────────────────────────────────────────────────────────────

async function fetchUserName(id: number): Promise<string> {
  if (userCache[id]) return userCache[id];
  try {
    const res = await fetch(`${API_BASE}/auth/user/${id}`);
    if (!res.ok) throw new Error();
    const data = await res.json();
    userCache[id] = data.name || `User#${id}`;
  } catch {
    userCache[id] = `User#${id}`;
  }
  return userCache[id];
}

async function fetchUserAddress(id: number): Promise<string> {
  if (userAddressCache[id] !== undefined) return userAddressCache[id];
  try {
    const res = await fetch(`${API_BASE}/auth/user/${id}`);
    if (!res.ok) throw new Error();
    const data = await res.json();
    userAddressCache[id] = data.address || "";
  } catch {
    userAddressCache[id] = "";
  }
  return userAddressCache[id];
}

async function fetchVehicleNumber(id: number): Promise<string> {
  if (vehicleCache[id]) return vehicleCache[id];
  try {
    const res = await fetch(`${API_BASE}/auth/vehicles/${id}`);
    if (!res.ok) throw new Error();
    const data = await res.json();
    vehicleCache[id] = data.registration_number || data.vehicle_number || `Vehicle#${id}`;
  } catch {
    vehicleCache[id] = `Vehicle#${id}`;
  }
  return vehicleCache[id];
}

async function fetchInvoiceItems(invoiceDbId: string): Promise<InvoiceItem[]> {
  if (itemsCache[invoiceDbId]) return itemsCache[invoiceDbId];
  try {
    const res = await fetch(`${API_BASE}/invoiceapi/invoice_items/invoice-db/${invoiceDbId}`);
    if (!res.ok) throw new Error();
    const data: InvoiceItem[] = await res.json();
    itemsCache[invoiceDbId] = Array.isArray(data) ? data : [];
  } catch {
    itemsCache[invoiceDbId] = [];
  }
  return itemsCache[invoiceDbId];
}

/** Fetches billed-to company name + address in one call (replaces old name-only fetch). */
async function fetchCompanyDetails(id: number): Promise<{ name: string; address: string }> {
  if (companyCache[id] && companyAddressCache[id] !== undefined) {
    return { name: companyCache[id], address: companyAddressCache[id] };
  }
  try {
    const res = await fetch(`${API_BASE}/companyAuth/company/${id}`);
    if (!res.ok) throw new Error();
    const data = await res.json();
    companyCache[id] = data.company_name || data.name || `Company#${id}`;
    companyAddressCache[id] = data.address || "";
  } catch {
    companyCache[id] = companyCache[id] || `Company#${id}`;
    companyAddressCache[id] = companyAddressCache[id] || "";
  }
  return { name: companyCache[id], address: companyAddressCache[id] };
}

async function fetchUsersBatch(ids: number[]): Promise<void> {
  const uncached = ids.filter(id => id && !(id in userCache));
  if (!uncached.length) return;
  try {
    const res = await fetch(`${API_BASE}/auth/users/batch?ids=${uncached.join(",")}`);
    if (!res.ok) throw new Error();
    const data = await res.json();
    uncached.forEach(id => {
      userCache[id] = data[id]?.name || `User#${id}`;
      userAddressCache[id] = data[id]?.address || "";
    });
  } catch {
    uncached.forEach(id => {
      userCache[id] = userCache[id] || `User#${id}`;
      userAddressCache[id] = userAddressCache[id] ?? "";
    });
  }
}

async function fetchVehiclesBatch(ids: number[]): Promise<void> {
  const uncached = ids.filter(id => id && !(id in vehicleCache));
  if (!uncached.length) return;
  try {
    const res = await fetch(`${API_BASE}/auth/vehicles/batch?ids=${uncached.join(",")}`);
    if (!res.ok) throw new Error();
    const data = await res.json();
    uncached.forEach(id => {
      vehicleCache[id] = data[id] || `Vehicle#${id}`;
    });
  } catch {
    uncached.forEach(id => { vehicleCache[id] = vehicleCache[id] || `Vehicle#${id}`; });
  }
}

async function fetchCompaniesBatch(ids: number[]): Promise<void> {
  const uncached = ids.filter(id => id && !(id in companyCache));
  if (!uncached.length) return;
  try {
    const res = await fetch(`${API_BASE}/companyAuth/company/batch?ids=${uncached.join(",")}`);
    if (!res.ok) throw new Error();
    const data = await res.json();
    uncached.forEach(id => {
      companyCache[id] = data[id]?.name || `Company#${id}`;
      companyAddressCache[id] = data[id]?.address || "";
    });
  } catch {
    uncached.forEach(id => {
      companyCache[id] = companyCache[id] || `Company#${id}`;
      companyAddressCache[id] = companyAddressCache[id] ?? "";
    });
  }
}
/** Fetches the issuing company's billing letterhead (PAN, bank, signatory, etc). */
async function fetchLetterhead(companyId: number): Promise<BillingLetterhead> {
  if (letterheadCache[companyId]) return letterheadCache[companyId];
  try {
    const res = await fetch(`${API_BASE}/companyAuth/company/${companyId}/letterhead`);
    if (!res.ok) throw new Error(`Letterhead fetch failed: ${res.status}`);
    const data = await res.json();
    letterheadCache[companyId] = { ...DEFAULT_LETTERHEAD, ...data };
  } catch (e) {
    console.error("fetchLetterhead error for company", companyId, e);
    letterheadCache[companyId] = DEFAULT_LETTERHEAD;
  }
  return letterheadCache[companyId];
}

/** Reserves and returns the next sequential bill number for a company. */
async function fetchNextBillSeq(companyId: number): Promise<number> {
  try {
    const res = await fetch(`${API_BASE}/companyAuth/company/${companyId}/next-bill-no`, { method: "POST" });
    const data = await res.json();
    return data.seq ?? 1;
  } catch {
    return 1;
  }
}

function computeItemStats(items: InvoiceItem[]) {
  if (!items.length) return { totalWeight: null, biltyRate: null, totalItemAmount: null };
  const totalWeight = items.reduce((s, i) => s + Number(i.qty || 0), 0);
  const totalAmount = items.reduce((s, i) => s + Number(i.amount || 0), 0);
  const totalRates = items.reduce((s, i) => s + Number(i.rate || 0), 0);
  return { totalWeight, biltyRate: totalRates, totalItemAmount: totalAmount };
}

function fmt(val: number | null | undefined, decimals = 2): string {
  if (val == null) return "-";
  return val % 1 === 0 ? String(val) : val.toFixed(decimals);
}

const getInvoiceNo = (c: APIConsignment): string =>
  c.InvoiceNo || (c as any)["InvoiceNo."] || "";

const getBillingStatus = (c: APIConsignment): "pending" | "completed" =>
  c.billing_status === "completed" ? "completed" : "pending";

/** Generate a short abbreviation from a company name, e.g. "Amit Traders & Co." → "ATC" */
function companyAbbr(name: string): string {
  const NOISE = /^(pvt|ltd|co|inc|corp|private|limited|and|the|of|&)$/i;
  const words = name.split(/[\s&,\.]+/).filter(Boolean);
  const meaningful = words.filter((w) => w.length > 1 && !NOISE.test(w));
  const src = meaningful.length >= 2 ? meaningful : words;
  return src
    .map((w) => w[0].toUpperCase())
    .slice(0, 3)
    .join("");
}

function parseChangeLog(raw: string | null | undefined): ChangeLogEntry[] {
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function fmtChangeValue(v: any): string {
  if (v == null) return "—";
  if (typeof v === "object") {
    return v.name ? `${v.name}${v.address ? ` (${v.address})` : ""}` : JSON.stringify(v);
  }
  return String(v);
}

function fmtFieldLabel(field: string): string {
  const labels: Record<string, string> = {
    consignee: "Consignee", consignor: "Consignor", sender: "Sender",
    receiver: "Receiver", vehicle: "Vehicle", origin: "Origin",
    destination: "Destination",
  };
  return labels[field] || field.charAt(0).toUpperCase() + field.slice(1);
}

// ─── Bill formatting helpers ───────────────────────────────────────────────────

function formatBillDate(iso: string | undefined): string {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "-";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = String(d.getFullYear()).slice(-2);
  return `${dd}.${mm}.${yy}`;
}

function todayBillDate(): string {
  return formatBillDate(new Date().toISOString());
}

/** Groups consignments by billed-to company and shapes each row for the bill table. */
function buildBillGroups(
  items: APIConsignment[],
  resolvedRows: Record<number, ResolvedRow>
): BillGroup[] {
  const groups = new Map<number, BillGroup>();
  for (const c of items) {
    const row = resolvedRows[c.id];
    if (!groups.has(c.company)) {
      groups.set(c.company, {
        companyId: c.company,
        companyName: row?.companyName && row.companyName !== "-" ? row.companyName : `Company#${c.company}`,
        companyAddress: companyAddressCache[c.company] || "",
        consigneeName: row?.consigneeName && row.consigneeName !== "-" ? row.consigneeName : "",
        consigneeAddress: row?.consigneeAddress || "",
        rows: [],
      });
    } else {
      // If a later consignment in the same company group has a different
      // consignee, flag it rather than silently showing the wrong one.
      const g = groups.get(c.company)!;
      if (row?.consigneeName && g.consigneeName && row.consigneeName !== g.consigneeName) {
        g.consigneeName = "Multiple consignees";
        g.consigneeAddress = "";
      }
    }
    groups.get(c.company)!.rows.push({
      consignmentId: c.id,
      date: formatBillDate(c.created_at),
      consignorName: row?.consignorName && row.consignorName !== "-" ? row.consignorName : "-",
      grNo: c.biltyNo || getInvoiceNo(c) || String(c.id),
      vehicleNo: row?.truckNo && row.truckNo !== "-" ? row.truckNo : "-",
      weight: row?.totalWeight ?? null,
      rate: row?.biltyRate ?? null,
      amount: row?.totalItemAmount ?? c.totalamount ?? null,
    });
  }
  for (const g of groups.values()) {
    g.rows.sort((a, b) => a.date.localeCompare(b.date));
  }
  return Array.from(groups.values());
}

function generateBillNo(letterhead: BillingLetterhead, seq: number): string {
  return `${letterhead.billNoPrefix} ${seq} / ${todayBillDate()}`;
}

function safeFileSegment(s: string): string {
  return s.replace(/[^\w\-]+/g, "_").replace(/^_+|_+$/g, "");
}

// ─── PDF generation (Vardhman-style bilty layout) ──────────────────────────────

/** Draws word-wrapped, centered text and returns the Y position after the last line. */
function drawWrappedCenteredText(
  doc: jsPDF, text: string, centerX: number, startY: number, maxWidth: number, lineHeight: number
): number {
  if (!text) return startY;
  const lines = doc.splitTextToSize(text, maxWidth);
  lines.forEach((line: string, i: number) => doc.text(line, centerX, startY + i * lineHeight, { align: "center" }));
  return startY + lines.length * lineHeight;
}

function drawBillPDF(doc: jsPDF, letterhead: BillingLetterhead, group: BillGroup, billNo: string) {
  const marginX = 12;
  const pageWidth = doc.internal.pageSize.getWidth();
  const boxW = pageWidth - marginX * 2;
  const textMaxWidth = boxW - 20; // keeps wrapped lines clear of the outer border
  const boxTop = 14;
  const NAVY: [number, number, number] = [26, 42, 90];
  let y = boxTop;

  // ── PAN / MOB row ──
  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text(`PAN NO ${letterhead.panNo}`, marginX + 2, y + 5);
  doc.text(`MOB:-${letterhead.mobile}`, marginX + boxW - 2, y + 5, { align: "right" });
  y += 11;

  // ── Big heading: issuing company (navy, bold, centered, wrapped) ──
  doc.setTextColor(...NAVY);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(17);
  y = drawWrappedCenteredText(doc, letterhead.companyName, pageWidth / 2, y, textMaxWidth, 6);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8.5);
  y = drawWrappedCenteredText(doc, letterhead.addressLine1, pageWidth / 2, y, textMaxWidth, 4);
  y = drawWrappedCenteredText(doc, letterhead.addressLine2, pageWidth / 2, y, textMaxWidth, 4);
  y += 5;

  // ── Bill No / To (black, left) ──
  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text(`BILL NO   ${billNo}`, marginX + 2, y);
  y += 5;
  doc.setFont("helvetica", "normal");
  doc.text("To,", marginX + 2, y);
  y += 6;

  // ── Billed-to company (bold, centered, wrapped) ──
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  y = drawWrappedCenteredText(doc, group.companyName.toUpperCase(), pageWidth / 2, y, textMaxWidth, 5.5);

  if (group.companyAddress) {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    y = drawWrappedCenteredText(doc, group.companyAddress.toUpperCase(), pageWidth / 2, y, textMaxWidth, 4);
  }

  // ── Consignee block, directly below company ──
  if (group.consigneeName) {
    y += 3;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    y = drawWrappedCenteredText(doc, `${group.consigneeName.toUpperCase()}`, pageWidth / 2, y, textMaxWidth, 4.5);
    if (group.consigneeAddress) {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.5);
      y = drawWrappedCenteredText(doc, group.consigneeAddress.toUpperCase(), pageWidth / 2, y, textMaxWidth, 4);
    }
  }
  y += 6;

  const totalWeight = group.rows.reduce((s, r) => s + (r.weight ?? 0), 0);
  const totalAmount = group.rows.reduce((s, r) => s + (r.amount ?? 0), 0);

  const paddedRowCount = Math.max(group.rows.length, 5);
  const body: any[] = [];
  for (let i = 0; i < paddedRowCount; i++) {
    const r = group.rows[i];
    body.push(
      r
        ? [i + 1, r.date, r.consignorName, r.grNo, r.vehicleNo, fmt(r.weight, 3), fmt(r.rate, 2), fmt(r.amount, 2)]
        : [i + 1, "", "", "", "", "", "", "-"]
    );
  }

  autoTable(doc, {
    startY: y,
    margin: { left: marginX, right: marginX },
    theme: "grid",
    styles: { fontSize: 8, cellPadding: 1.6, lineColor: [0, 0, 0], lineWidth: 0.1, textColor: 20 },
    headStyles: { fillColor: [255, 255, 255], textColor: 0, fontStyle: "bold", halign: "center" },
    footStyles: { fillColor: [255, 255, 255], textColor: 0, fontStyle: "bold" },
    head: [["SR. NO", "DATE", "CONSIGNOR NAME", "G.R. NO", "VEHICLE NO", "WEIGHT", "RATE", "AMOUNT"]],
    body,
    foot: [[
      { content: "TOTAL AMOUNT", colSpan: 5, styles: { halign: "center", fontStyle: "bold" } },
      fmt(totalWeight, 2),
      "",
      fmt(totalAmount, 2),
    ]],
    columnStyles: {
      0: { cellWidth: 12, halign: "center" },
      1: { cellWidth: 18, halign: "center" },
      2: { cellWidth: 44 },
      3: { cellWidth: 18, halign: "center" },
      4: { cellWidth: 26, halign: "center" },
      5: { cellWidth: 20, halign: "right" },
      6: { cellWidth: 18, halign: "right" },
      7: { cellWidth: 26, halign: "right" },
    },
  });

  const finalY = (doc as any).lastAutoTable.finalY as number;

  // ── Bottom-left: Bank details ──
  let by = finalY + 7;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8.5);
  doc.text("Bank Detail:", marginX + 2, by);
  by += 4;
  doc.text(letterhead.bankName, marginX + 2, by);
  doc.setFont("helvetica", "normal");
  by += 4;
  doc.text(`A/C NO :- ${letterhead.accountNo}`, marginX + 2, by);
  by += 4;
  doc.text(`IFSC CODE :- ${letterhead.ifscCode}`, marginX + 2, by);
  by += 4;
  doc.text(`Branch :- ${letterhead.branch}`, marginX + 2, by);

  // ── Right side: signature block + far-right E&OE/company ──
  const rightX = marginX + boxW - 2;
  const signX = marginX + boxW - 46;

  let sy = finalY + 7;
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  doc.text(`For ${letterhead.companyName}`, signX, sy, { align: "right" });
  doc.text("E. & O.E.", rightX, sy, { align: "right" });
  sy += 10;
  doc.text(letterhead.signatoryName, signX, sy, { align: "right" });
  doc.setFont("helvetica", "bold");
  doc.text(letterhead.companyName.toUpperCase(), rightX, sy, { align: "right" });
  sy += 4;
  doc.text(letterhead.signatoryTitle, signX, sy, { align: "right" });

  // ── Bottom-left: Encl / payment note / Accountant ──
  let fy = by + 8;
  doc.setFont("helvetica", "normal");
  doc.text("Encl:", marginX + 2, fy);
  fy += 4;
  doc.setFont("helvetica", "bold");
  doc.text(letterhead.paymentNote, marginX + 2, fy);
  doc.setFont("helvetica", "normal");
  fy += 6;
  doc.text("Accountant", marginX + 20, fy);

  const boxBottom = Math.max(fy, sy) + 4;
  doc.setLineWidth(0.3);
  doc.rect(marginX - 2, boxTop - 4, boxW + 4, boxBottom - (boxTop - 4));
}

function exportBillToPDF(letterhead: BillingLetterhead, group: BillGroup, billNo: string) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  drawBillPDF(doc, letterhead, group, billNo);
  const filename = `Bill_${safeFileSegment(group.companyName)}_${safeFileSegment(billNo)}.pdf`;
  doc.save(filename);
}

// ─── Excel generation (ExcelJS — supports real cell styling/borders/merges) ────

async function exportBillToExcel(letterhead: BillingLetterhead, group: BillGroup, billNo: string) {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Bill");

  ws.columns = [
    { width: 6 }, { width: 11 }, { width: 26 }, { width: 11 },
    { width: 15 }, { width: 11 }, { width: 10 }, { width: 14 },
  ];

  const thin: Partial<ExcelJS.Border> = { style: "thin", color: { argb: "FF000000" } };
  const borderAll = { top: thin, bottom: thin, left: thin, right: thin };
  const NAVY = "FF1A2A5A";

  let r = 1;
  const merge = (row: number, c1: number, c2: number) => ws.mergeCells(row, c1, row, c2);

  // PAN / MOB
  ws.getCell(r, 1).value = `PAN NO ${letterhead.panNo}`;
  ws.getCell(r, 1).font = { bold: true, size: 9 };
  merge(r, 1, 5);
  ws.getCell(r, 6).value = `MOB:-${letterhead.mobile}`;
  ws.getCell(r, 6).font = { bold: true, size: 9 };
  ws.getCell(r, 6).alignment = { horizontal: "right" };
  merge(r, 6, 8);
  r += 2;

  // Big heading — issuing company, navy, bold, centered
  ws.getCell(r, 1).value = letterhead.companyName;
  ws.getCell(r, 1).font = { bold: true, size: 16, color: { argb: NAVY } };
  ws.getCell(r, 1).alignment = { horizontal: "center" };
  merge(r, 1, 8); r++;

  ws.getCell(r, 1).value = letterhead.addressLine1;
  ws.getCell(r, 1).font = { color: { argb: NAVY }, size: 9 };
  ws.getCell(r, 1).alignment = { horizontal: "center" };
  merge(r, 1, 8); r++;

  ws.getCell(r, 1).value = letterhead.addressLine2;
  ws.getCell(r, 1).font = { color: { argb: NAVY }, size: 9 };
  ws.getCell(r, 1).alignment = { horizontal: "center" };
  merge(r, 1, 8); r += 2;

  // Bill no / To
  ws.getCell(r, 1).value = `BILL NO   ${billNo}`;
  ws.getCell(r, 1).font = { bold: true, size: 9 };
  merge(r, 1, 8); r++;

  ws.getCell(r, 1).value = "To,";
  merge(r, 1, 8); r++;

  // Billed-to company — bold, centered
  ws.getCell(r, 1).value = group.companyName.toUpperCase();
  ws.getCell(r, 1).font = { bold: true, size: 12 };
  ws.getCell(r, 1).alignment = { horizontal: "center" };
  merge(r, 1, 8); r++;

  // Billed-to sub-line (city/state)
  if (group.companyAddress) {
    ws.getCell(r, 1).value = group.companyAddress.toUpperCase();
    ws.getCell(r, 1).font = { size: 9 };
    ws.getCell(r, 1).alignment = { horizontal: "center" };
    merge(r, 1, 8); r++;
  }

  // Consignee block
  if (group.consigneeName) {
    ws.getCell(r, 1).value = `Consignee: ${group.consigneeName.toUpperCase()}`;
    ws.getCell(r, 1).font = { bold: true, size: 10 };
    ws.getCell(r, 1).alignment = { horizontal: "center" };
    merge(r, 1, 8); r++;

    if (group.consigneeAddress) {
      ws.getCell(r, 1).value = group.consigneeAddress.toUpperCase();
      ws.getCell(r, 1).font = { size: 9 };
      ws.getCell(r, 1).alignment = { horizontal: "center" };
      merge(r, 1, 8); r++;
    }
  }
  r++;

  // Table
  const headerRow = r;
  const headers = ["SR. NO", "DATE", "CONSIGNOR NAME", "G.R. NO", "VEHICLE NO", "WEIGHT", "RATE", "AMOUNT"];
  headers.forEach((h, i) => {
    const cell = ws.getCell(headerRow, i + 1);
    cell.value = h;
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.border = borderAll;
  });
  r++;

  const paddedRowCount = Math.max(group.rows.length, 5);
  for (let i = 0; i < paddedRowCount; i++) {
    const row = group.rows[i];
    const vals = row
      ? [i + 1, row.date, row.consignorName, row.grNo, row.vehicleNo, fmt(row.weight, 3), fmt(row.rate, 2), fmt(row.amount, 2)]
      : [i + 1, "", "", "", "", "", "", "-"];
    vals.forEach((v, ci) => {
      const cell = ws.getCell(r, ci + 1);
      cell.value = v;
      cell.border = borderAll;
      if (ci === 0 || ci === 1 || ci === 4) cell.alignment = { horizontal: "center" };
      if (ci === 5 || ci === 6 || ci === 7) cell.alignment = { horizontal: "right" };
    });
    r++;
  }

  const totalWeight = group.rows.reduce((s, x) => s + (x.weight ?? 0), 0);
  const totalAmount = group.rows.reduce((s, x) => s + (x.amount ?? 0), 0);

  ws.getCell(r, 1).value = "TOTAL AMOUNT";
  ws.getCell(r, 1).font = { bold: true };
  ws.getCell(r, 1).alignment = { horizontal: "center" };
  merge(r, 1, 5);
  for (let c = 1; c <= 5; c++) ws.getCell(r, c).border = borderAll;
  ws.getCell(r, 6).value = fmt(totalWeight, 2);
  ws.getCell(r, 6).font = { bold: true };
  ws.getCell(r, 6).border = borderAll;
  ws.getCell(r, 6).alignment = { horizontal: "right" };
  ws.getCell(r, 7).border = borderAll;
  ws.getCell(r, 8).value = fmt(totalAmount, 2);
  ws.getCell(r, 8).font = { bold: true };
  ws.getCell(r, 8).border = borderAll;
  ws.getCell(r, 8).alignment = { horizontal: "right" };
  r += 2;

  // Bank details (left) / signature block (right)
  const blockStart = r;
  ws.getCell(r, 1).value = "Bank Detail:";
  ws.getCell(r, 1).font = { bold: true };
  ws.getCell(r, 6).value = `For ${letterhead.companyName}`;
  ws.getCell(r, 6).alignment = { horizontal: "right" };
  merge(r, 6, 7);
  ws.getCell(r, 8).value = "E. & O.E.";
  ws.getCell(r, 8).alignment = { horizontal: "right" };
  r++;

  ws.getCell(r, 1).value = letterhead.bankName;
  ws.getCell(r, 1).font = { bold: true };
  r++;
  ws.getCell(r, 1).value = `A/C NO :- ${letterhead.accountNo}`; r++;
  ws.getCell(r, 1).value = `IFSC CODE :- ${letterhead.ifscCode}`; r++;
  ws.getCell(r, 1).value = `Branch :- ${letterhead.branch}`;

  ws.getCell(blockStart + 2, 6).value = letterhead.signatoryName;
  ws.getCell(blockStart + 2, 6).alignment = { horizontal: "right" };
  merge(blockStart + 2, 6, 7);
  ws.getCell(blockStart + 2, 8).value = letterhead.companyName.toUpperCase();
  ws.getCell(blockStart + 2, 8).font = { bold: true, size: 8 };
  ws.getCell(blockStart + 2, 8).alignment = { horizontal: "right" };

  ws.getCell(blockStart + 3, 6).value = letterhead.signatoryTitle;
  ws.getCell(blockStart + 3, 6).font = { bold: true };
  ws.getCell(blockStart + 3, 6).alignment = { horizontal: "right" };
  merge(blockStart + 3, 6, 7);
  r += 2;

  ws.getCell(r, 1).value = "Encl:"; r++;
  ws.getCell(r, 1).value = letterhead.paymentNote;
  ws.getCell(r, 1).font = { bold: true };
  merge(r, 1, 4); r++;
  ws.getCell(r, 2).value = "Accountant";

  // Outer border
  const lastRow = r;
  for (let row = 1; row <= lastRow; row++) {
    ws.getCell(row, 1).border = { ...ws.getCell(row, 1).border, left: thin };
    ws.getCell(row, 8).border = { ...ws.getCell(row, 8).border, right: thin };
  }
  for (let col = 1; col <= 8; col++) {
    ws.getCell(1, col).border = { ...ws.getCell(1, col).border, top: thin };
    ws.getCell(lastRow, col).border = { ...ws.getCell(lastRow, col).border, bottom: thin };
  }

  const buf = await wb.xlsx.writeBuffer();
  const blob = new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `Bill_${safeFileSegment(group.companyName)}_${safeFileSegment(billNo)}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
}

// ─── Company color palette ──────────────────────────────────────────────────

const PALETTE_KEYS = ["blue", "teal", "amber", "red", "purple", "green", "coral", "pink"] as const;

type PaletteKey = typeof PALETTE_KEYS[number];

const PALETTE: Record<PaletteKey, { bg: string; text: string; row: string }> = {
  blue:   { bg: "#E6F1FB", text: "#042C53", row: "rgba(55,138,221,0.18)"  },
  teal:   { bg: "#E1F5EE", text: "#04342C", row: "rgba(29,158,117,0.18)"  },
  amber:  { bg: "#FAEEDA", text: "#412402", row: "rgba(186,117,23,0.18)"  },
  red:    { bg: "#FCEBEB", text: "#501313", row: "rgba(226,75,74,0.18)"   },
  purple: { bg: "#EEEDFE", text: "#26215C", row: "rgba(83,74,183,0.18)"   },
  green:  { bg: "#EAF3DE", text: "#173404", row: "rgba(99,153,34,0.18)"   },
  coral:  { bg: "#FEF0E6", text: "#ffffff", row: "rgba(234,120,40,0.18)"  },
  pink:   { bg: "#F0EBE3", text: "#ffffff", row: "rgba(140,90,40,0.18)"   },
};

/**
 * Assigns palette colors by the ORDER companies are first encountered,
 * not by their numeric ID. This guarantees every company gets a distinct
 * color regardless of ID gaps or clustering. The registry is module-level
 * so it persists across re-renders without needing React state.
 */
const companyColorRegistry = new Map<number, PaletteKey>();

function paletteForCompany(companyId: number): PaletteKey {
  if (companyColorRegistry.has(companyId)) {
    return companyColorRegistry.get(companyId)!;
  }
  const idx = companyColorRegistry.size % PALETTE_KEYS.length;
  const key = PALETTE_KEYS[idx];
  companyColorRegistry.set(companyId, key);
  return key;
}

// ─── Constants ────────────────────────────────────────────────────────────────

const FILTER_OPTIONS: { key: FilterOption; label: string }[] = [
  { key: "all",       label: "All" },
  { key: "pending",   label: "Pending" },
  { key: "completed", label: "Completed" },
  { key: "modified",  label: "Modified" },
];

const STATUS_STYLES: Record<string, string> = {
  pending:   "bg-amber-100 text-amber-900",
  completed: "bg-green-100 text-green-900",
};

const STATUS_LABELS: Record<string, string> = {
  pending: "Pending", completed: "Completed",
};

// ─── Sub-components ───────────────────────────────────────────────────────────

const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
  <span className={`text-[9px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${STATUS_STYLES[status] || "bg-slate-100 text-slate-900"}`}>
    {STATUS_LABELS[status] || status}
  </span>
);

const DashboardStatCard: React.FC<{ label: string; value: number; color: string }> = ({ label, value, color }) => (
  <div className="rounded-xl bg-slate-50 p-4 flex flex-col justify-center items-center">
    <span className="text-[26px] font-semibold mb-1" style={{ color }}>{value}</span>
    <span className="text-xs font-medium text-slate-500">{label}</span>
  </div>
);

const LoadingCell = () => (
  <span className="text-slate-300 animate-pulse text-xs">Loading…</span>
);

// ─── Company Tag ──────────────────────────────────────────────────────────────

const TAG_SOLID: Record<PaletteKey, string> = {
  blue: "#185FA5",
  teal: "#0F6E56",
  amber: "#BA7517",
  red: "#A32D2D",
  purple: "#534AB7",
  green: "#3B6D11",
  coral: "#b85000",
  pink: "#5a3010",
};

const CompanyTag: React.FC<{ companyId: number; companyName: string }> = ({ companyId, companyName }) => {
  const key = paletteForCompany(companyId);
  const abbr = companyAbbr(companyName);
  return (
    <span
      title={companyName}
      className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold cursor-default whitespace-nowrap"
      style={{ background: TAG_SOLID[key], color: "#ffffff" }}
    >
      {abbr}
    </span>
  );
};

// ─── Action Dropdown (portal-based — escapes overflow:auto clipping) ──────────

interface ActionMenuProps {
  consignment: APIConsignment;
  hasInvoice: boolean;
  hasHistory: boolean;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  onViewInvoice: (c: APIConsignment) => void;
  onDownloadInvoice: (c: APIConsignment) => void;
  onShareInvoice: (c: APIConsignment) => void;
  onViewHistory: (c: APIConsignment) => void;
}

const ActionMenu: React.FC<ActionMenuProps> = ({
  consignment, hasInvoice, hasHistory, onEdit, onDelete, onViewInvoice, onDownloadInvoice, onShareInvoice, onViewHistory,
}) => {
  const [open, setOpen] = useState(false);
  const [menuStyle, setMenuStyle] = useState<React.CSSProperties>({});
  const triggerRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);

  const MENU_WIDTH = 184;
  const MENU_HEIGHT_APPROX = 270;

  const reposition = useCallback(() => {
    if (!triggerRef.current) return;
    const r = triggerRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - r.bottom;
    const flipUp = spaceBelow < MENU_HEIGHT_APPROX && r.top > MENU_HEIGHT_APPROX;
    const right = window.innerWidth - r.right;
    setMenuStyle({
      position: "fixed",
      top: flipUp ? r.top - 4 : r.bottom + 4,
      right,
      width: MENU_WIDTH,
      transform: flipUp ? "translateY(-100%)" : "none",
      zIndex: 9999,
    });
  }, []);

  const toggleOpen = () => {
    if (!open) reposition();
    setOpen((v) => !v);
  };

  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => {
      if (
        menuRef.current && !menuRef.current.contains(e.target as Node) &&
        triggerRef.current && !triggerRef.current.contains(e.target as Node)
      ) setOpen(false);
    };
    const onScroll = () => reposition();
    document.addEventListener("mousedown", close);
    window.addEventListener("scroll", onScroll, true);
    return () => {
      document.removeEventListener("mousedown", close);
      window.removeEventListener("scroll", onScroll, true);
    };
  }, [open, reposition]);

  const invoiceDisabled = !hasInvoice;
  const historyDisabled = !hasHistory;
  const btnCls = "flex items-center gap-2 w-full px-3 py-[7px] text-[12px] text-left hover:bg-slate-50 transition-colors whitespace-nowrap";
  const disabledCls = "opacity-40 cursor-not-allowed pointer-events-none";

  const menu = open ? (
    <div ref={menuRef} style={menuStyle} className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-md">
      <div className="border-b border-slate-100 py-1">
        <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1">Invoice</p>
        <button
          className={`${btnCls} text-blue-800 ${invoiceDisabled ? disabledCls : ""}`}
          disabled={invoiceDisabled}
          onClick={() => { setOpen(false); onViewInvoice(consignment); }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
          View invoice
          {invoiceDisabled && <span className="ml-auto text-[9px] text-slate-400">No file</span>}
        </button>
        <button
          className={`${btnCls} text-green-800 ${invoiceDisabled ? disabledCls : ""}`}
          disabled={invoiceDisabled}
          onClick={() => { setOpen(false); onDownloadInvoice(consignment); }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
          Download PDF
        </button>
        <button
          className={`${btnCls} text-purple-800 ${invoiceDisabled ? disabledCls : ""}`}
          disabled={invoiceDisabled}
          onClick={() => { setOpen(false); onShareInvoice(consignment); }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
          Share link
        </button>
      </div>
      <div className="py-1">
        <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1">Consignment</p>
        <button
          className={`${btnCls} text-slate-700 ${historyDisabled ? disabledCls : ""}`}
          disabled={historyDisabled}
          onClick={() => { setOpen(false); onViewHistory(consignment); }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/>
          </svg>
          View history
          {historyDisabled && <span className="ml-auto text-[9px] text-slate-400">None</span>}
        </button>
        <button
          className={`${btnCls} text-amber-800`}
          onClick={() => { setOpen(false); onEdit(consignment.id); }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
          Edit
        </button>
        <button
          className={`${btnCls} text-red-800 hover:!bg-red-50`}
          onClick={() => { setOpen(false); onDelete(consignment.id); }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
          Delete
        </button>
      </div>
    </div>
  ) : null;

  return (
    <>
      <button
        ref={triggerRef}
        onClick={toggleOpen}
        className="inline-flex items-center gap-1.5 text-[11px] px-2.5 py-1 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-600 transition-colors"
      >
        <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
          <circle cx="8" cy="3" r="1.4"/><circle cx="8" cy="8" r="1.4"/><circle cx="8" cy="13" r="1.4"/>
        </svg>
        Actions
        <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" className="opacity-50">
          <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
        </svg>
      </button>
      {ReactDOM.createPortal(menu, document.body)}
    </>
  );
};

// ─── Download Menu (PDF / Excel, selected / filtered) ──────────────────────────

interface DownloadMenuProps {
  selectedCount: number;
  filteredCount: number;
  onDownload: (scope: "selected" | "filtered", format: "pdf" | "excel") => void;
}

const DownloadMenu: React.FC<DownloadMenuProps> = ({ selectedCount, filteredCount, onDownload }) => {
  const [open, setOpen] = useState(false);
  const [menuStyle, setMenuStyle] = useState<React.CSSProperties>({});
  const triggerRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);

  const reposition = useCallback(() => {
    if (!triggerRef.current) return;
    const r = triggerRef.current.getBoundingClientRect();
    setMenuStyle({
      position: "fixed",
      top: r.bottom + 4,
      right: window.innerWidth - r.right,
      width: 220,
      zIndex: 9999,
    });
  }, []);

  const toggleOpen = () => {
    if (!open) reposition();
    setOpen((v) => !v);
  };

  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => {
      if (
        menuRef.current && !menuRef.current.contains(e.target as Node) &&
        triggerRef.current && !triggerRef.current.contains(e.target as Node)
      ) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  const disabledCls = "opacity-40 cursor-not-allowed pointer-events-none";
  const itemCls = "flex items-center justify-between w-full px-3 py-[7px] text-[12px] text-left hover:bg-slate-50 transition-colors whitespace-nowrap text-slate-700";

  const menu = open ? (
    <div ref={menuRef} style={menuStyle} className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-md">
      <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1.5 border-b border-slate-100">
        Selected ({selectedCount})
      </p>
      <button
        className={`${itemCls} ${selectedCount === 0 ? disabledCls : ""}`}
        disabled={selectedCount === 0}
        onClick={() => { setOpen(false); onDownload("selected", "pdf"); }}
      >
        Download as PDF
      </button>
      <button
        className={`${itemCls} ${selectedCount === 0 ? disabledCls : ""}`}
        disabled={selectedCount === 0}
        onClick={() => { setOpen(false); onDownload("selected", "excel"); }}
      >
        Download as Excel
      </button>
      <p className="text-[9px] font-medium text-slate-400 uppercase tracking-wider px-3 py-1.5 border-y border-slate-100 mt-1">
        All filtered ({filteredCount})
      </p>
      <button
        className={`${itemCls} ${filteredCount === 0 ? disabledCls : ""}`}
        disabled={filteredCount === 0}
        onClick={() => { setOpen(false); onDownload("filtered", "pdf"); }}
      >
        Download as PDF
      </button>
      <button
        className={`${itemCls} ${filteredCount === 0 ? disabledCls : ""}`}
        disabled={filteredCount === 0}
        onClick={() => { setOpen(false); onDownload("filtered", "excel"); }}
      >
        Download as Excel
      </button>
    </div>
  ) : null;

  return (
    <>
      <button
        ref={triggerRef}
        onClick={toggleOpen}
        className="inline-flex items-center gap-1.5 text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
        Download
        <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" className="opacity-50">
          <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
        </svg>
      </button>
      {ReactDOM.createPortal(menu, document.body)}
    </>
  );
};

// ─── Advanced Filters ─────────────────────────────────────────────────────────

const AdvancedFilters: React.FC<{
  filters: FiltersState;
  onChange: (f: FiltersState) => void;
  companyOptions: string[];
  biltyOptions: string[];
  truckOptions: string[];
  consignorOptions: string[];
  consigneeOptions: string[];
}> = ({ filters, onChange, companyOptions, biltyOptions, truckOptions, consignorOptions, consigneeOptions }) => {
  const sel = "border rounded px-2 py-1 text-xs";
  const inp = "border rounded px-2 py-1 text-xs mt-1 block";

  return (
    <div className="flex flex-wrap gap-3 mb-4">
      <div>
        <label className="block text-xs text-slate-500 mb-1">Company</label>
        <select className={`${sel} w-[160px]`} value={filters.company} onChange={e => onChange({ ...filters, company: e.target.value })}>
          <option value="">All companies</option>
          {companyOptions.map(v => <option key={v} value={v}>{v}</option>)}
        </select>
      </div>
      <div>
        <label className="block text-xs text-slate-500 mb-1">Bilty no.</label>
        <select className={`${sel} w-[140px]`} value={filters.biltyNo} onChange={e => onChange({ ...filters, biltyNo: e.target.value })}>
          <option value="">All bilty nos.</option>
          {biltyOptions.map(v => <option key={v} value={v}>{v}</option>)}
        </select>
        <input className={`${inp} w-[140px]`} placeholder="Search bilty" value={filters.biltyNo} onChange={e => onChange({ ...filters, biltyNo: e.target.value })} />
      </div>
      <div>
        <label className="block text-xs text-slate-500 mb-1">Truck no.</label>
        <select className={`${sel} w-[130px]`} value={filters.truckNo} onChange={e => onChange({ ...filters, truckNo: e.target.value })}>
          <option value="">All trucks</option>
          {truckOptions.map(v => <option key={v} value={v}>{v}</option>)}
        </select>
        <input className={`${inp} w-[130px]`} placeholder="Search truck" value={filters.truckNo} onChange={e => onChange({ ...filters, truckNo: e.target.value })} />
      </div>
      <div>
        <label className="block text-xs text-slate-500 mb-1">Consignor</label>
        <select className={`${sel} w-[130px]`} value={filters.consignor} onChange={e => onChange({ ...filters, consignor: e.target.value })}>
          <option value="">All consignors</option>
          {consignorOptions.map(v => <option key={v} value={v}>{v}</option>)}
        </select>
        <input className={`${inp} w-[130px]`} placeholder="Search consignor" value={filters.consignor} onChange={e => onChange({ ...filters, consignor: e.target.value })} />
      </div>
      <div>
        <label className="block text-xs text-slate-500 mb-1">Consignee</label>
        <select className={`${sel} w-[130px]`} value={filters.consignee} onChange={e => onChange({ ...filters, consignee: e.target.value })}>
          <option value="">All consignees</option>
          {consigneeOptions.map(v => <option key={v} value={v}>{v}</option>)}
        </select>
        <input className={`${inp} w-[130px]`} placeholder="Search consignee" value={filters.consignee} onChange={e => onChange({ ...filters, consignee: e.target.value })} />
      </div>
      <div>
        <label className="block text-xs text-slate-500 mb-1">Date from</label>
        <input type="date" className={`${sel}`} value={filters.dateFrom} onChange={e => onChange({ ...filters, dateFrom: e.target.value })} />
      </div>
      <div>
        <label className="block text-xs text-slate-500 mb-1">Date to</label>
        <input type="date" className={`${sel}`} value={filters.dateTo} onChange={e => onChange({ ...filters, dateTo: e.target.value })} />
      </div>
      <div className="flex items-end">
        <button
          className="text-xs px-3 py-1 border rounded bg-slate-50 text-slate-600"
          onClick={() => onChange({ company: "", biltyNo: "", truckNo: "", consignor: "", consignee: "", dateFrom: "", dateTo: "" })}
        >
          Clear
        </button>
      </div>
    </div>
  );
};

// ─── Delete Confirm Modal ─────────────────────────────────────────────────────

const DeleteConfirmModal: React.FC<{
  id: number | null;
  bilty: string;
  onConfirm: () => void;
  onCancel: () => void;
}> = ({ id, bilty, onConfirm, onCancel }) => {
  if (id === null) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-2xl border border-slate-200 p-6 w-[340px] shadow-lg">
        <h3 className="text-[15px] font-medium text-slate-900 mb-2">Delete consignment?</h3>
        <p className="text-xs text-slate-500 mb-5 leading-relaxed">
          You are about to permanently delete <strong>{bilty}</strong>. This action cannot be undone and all associated data will be removed.
        </p>
        <div className="flex gap-3 justify-end">
          <button onClick={onCancel} className="text-xs px-4 py-1.5 border border-slate-200 rounded-lg text-slate-600 hover:bg-slate-50 transition-colors">
            Cancel
          </button>
          <button onClick={onConfirm} className="text-xs px-4 py-1.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

// ─── Change Log Modal ──────────────────────────────────────────────────────────

const ChangeLogModal: React.FC<{
  bilty: string;
  entries: ChangeLogEntry[];
  onClose: () => void;
}> = ({ bilty, entries, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-2">
      <div className="bg-white rounded-2xl border border-slate-200 p-6 w-full max-w-md shadow-lg max-h-[80vh] flex flex-col">
        <div className="flex items-start justify-between mb-1">
          <h3 className="text-[15px] font-medium text-slate-900">Change history</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-700 transition-colors">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        <p className="text-xs text-slate-400 mb-4">{bilty}</p>

        <div className="overflow-y-auto space-y-3 pr-1">
          {entries.length === 0 ? (
            <p className="text-sm text-slate-400 text-center py-6">No changes recorded.</p>
          ) : (
            [...entries].reverse().map((entry, i) => (
              <div key={i} className="border border-slate-100 rounded-xl p-3 bg-slate-50/60">
                <div className="flex items-center justify-between mb-1.5">
                  <span className="text-[11px] font-semibold text-slate-700 uppercase tracking-wide">
                    {fmtFieldLabel(entry.field)}
                  </span>
                  <span className="text-[10px] text-slate-400">
                    {entry.changed_at
                      ? new Date(entry.changed_at).toLocaleString("en-IN", {
                          day: "2-digit", month: "short", year: "2-digit",
                          hour: "2-digit", minute: "2-digit",
                        })
                      : ""}
                  </span>
                </div>
                <div className="flex items-center gap-2 text-xs">
                  <span className="px-2 py-1 rounded-md bg-red-50 text-red-700 line-through decoration-red-300">
                    {fmtChangeValue(entry.from)}
                  </span>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-slate-400 shrink-0">
                    <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
                  </svg>
                  <span className="px-2 py-1 rounded-md bg-green-50 text-green-800 font-medium">
                    {fmtChangeValue(entry.to)}
                  </span>
                </div>
              </div>
            ))
          )}
        </div>

        <div className="flex justify-end mt-4">
          <button onClick={onClose} className="text-xs px-4 py-1.5 border border-slate-200 rounded-lg text-slate-600 hover:bg-slate-50 transition-colors">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

// ─── Main Dashboard ───────────────────────────────────────────────────────────

const ConsignorDashboard: React.FC = () => {
  const navigate = useNavigate();
  const [consignments, setConsignments] = useState<APIConsignment[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [activeFilter, setActiveFilter] = useState<FilterOption>("all");
  const [resolvedRows, setResolvedRows] = useState<Record<number, ResolvedRow>>({});
  const [deleteTarget, setDeleteTarget] = useState<{ id: number; bilty: string } | null>(null);
  const [historyTarget, setHistoryTarget] = useState<{ bilty: string; entries: ChangeLogEntry[] } | null>(null);
  const [selectedIds, setSelectedIds] = useState<Set<number>>(new Set());

  const [filters, setFilters] = useState<FiltersState>({
    company: "", biltyNo: "", truckNo: "", consignor: "", consignee: "", dateFrom: "", dateTo: "",
  });

  useEffect(() => {
    setLoading(true);
    setError(null);

    fetch(`${API_BASE}/invoiceapi/invoice`)
      .then((res) => res.json())
      .then(async (data) => {
        if (!Array.isArray(data)) { setConsignments([]); return; }

        const mapped: APIConsignment[] = data.map((c: any) => ({
          id: c.id,
          sender: c.sender,
          company: c.company,
          receiver: c.receiver,
          transporter: c.transporter,
          driver: c.driver,
          vehicles: c.vehicles,
          payment: c.payment,
          source: c.source,
          destination: c.destination,
          receiverAmountStatatus: c.receiverAmountStatatus,
          senderAmountStatatus: c.senderAmountStatatus,
          transporterAmountStatatus: c.transporterAmountStatatus,
          paymentStatus: c.paymentStatus,
          paymentPayableConsignor: c.paymentPayableConsignor,
          ItemsDescription: c.ItemsDescription,
          InvoiceNo: c["InvoiceNo"] ?? c["InvoiceNo."] ?? "",
          "InvoiceNo.": c["InvoiceNo."],
          EWAYBILLNO: c.EWAYBILLNO,
          subjects: c.subjects,
          link: c.link ?? c.invoiceLink,
          status: c.status ?? undefined,
          biltyNo: c.biltyNo ?? c["InvoiceNo"] ?? c["InvoiceNo."] ?? "",
          created_at: c.created_at ?? "",
          totalamount: c.totalamount ?? null,
          change_log: c.change_log ?? null,
          billing_status: c.billing_status === "completed" ? "completed" : "pending",
          billing_status_forced: c.billing_status_forced ?? 0,
          items: Array.isArray(c.items) ? c.items : [], // NEW

        }));

        const senderIds    = [...new Set(mapped.map(c => c.sender).filter(Boolean))];
        const receiverIds  = [...new Set(mapped.map(c => c.receiver).filter(Boolean))];
        const vehicleIds   = [...new Set(mapped.map(c => c.vehicles).filter(Boolean))];
        const companyIds   = [...new Set(mapped.map(c => c.company).filter(Boolean))];
        
        // Pre-register companies in a stable order so color assignments are
        // deterministic and don't shift between renders or data fetches.
        companyColorRegistry.clear();
        companyIds.forEach(id => paletteForCompany(id));
        
        // Items already came back attached to each invoice — no per-row fetch needed.
        for (const c of mapped) {
          itemsCache[String(c.id)] = c.items ?? [];
        }
        
        await Promise.allSettled([
          fetchUsersBatch([...new Set([...senderIds, ...receiverIds])]),
          fetchVehiclesBatch(vehicleIds),
          fetchCompaniesBatch(companyIds),
        ]);
        const resolved: Record<number, ResolvedRow> = {};
        for (const c of mapped) {
          const items = itemsCache[String(c.id)] ?? [];
          const { totalWeight, biltyRate, totalItemAmount } = computeItemStats(items);
          resolved[c.id] = {
            consignorName: c.sender ? userCache[c.sender] || `User#${c.sender}` : "-",
            consigneeName: c.receiver ? userCache[c.receiver] || `User#${c.receiver}` : "-",
            consigneeAddress: c.receiver ? userAddressCache[c.receiver] || "" : "",
            truckNo: c.vehicles ? vehicleCache[c.vehicles] || `Vehicle#${c.vehicles}` : "-",
            companyName: c.company ? companyCache[c.company] || `Company#${c.company}` : "-",
            totalWeight,
            biltyRate,
            totalItemAmount,
          };
        }
        setResolvedRows(resolved);
        setConsignments(mapped);
      })
      .catch(() => setError("Unable to fetch consignments"))
      .finally(() => setLoading(false));
  }, []);

  // ── Invoice action handlers ──
  const handleViewInvoice = useCallback((c: APIConsignment) => {
    const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
    if (url) window.open(url, "_blank");
  }, []);

  const handleDownloadInvoice = useCallback((c: APIConsignment) => {
    const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
    if (!url) return;
    const a = document.createElement("a");
    a.href = url;
    a.download = `Invoice_${getInvoiceNo(c) || c.EWAYBILLNO || c.id}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }, []);

  function getLastChange(raw: string | null | undefined): ChangeLogEntry | null {
    const entries = parseChangeLog(raw);
    return entries.length ? entries[entries.length - 1] : null;
  }

  function timeAgo(iso: string): string {
    const diff = Date.now() - new Date(iso).getTime();
    const m = Math.floor(diff / 60000);
    if (m < 60) return `${m}m ago`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h}h ago`;
    return `${Math.floor(h / 24)}d ago`;
  }

  const handleShareInvoice = useCallback((c: APIConsignment) => {
    const url = c.link?.startsWith("http") ? c.link : c.link ? `${API_BASE}${c.link}` : "";
    if (!url) return;
    if (navigator.share) {
      navigator.share({ title: `Invoice ${getInvoiceNo(c)}`, url });
    } else {
      navigator.clipboard.writeText(url);
      alert("Invoice link copied!");
    }
  }, []);

  const handleEdit = useCallback((id: number) => {
    navigate(`/admin/edit/consignments/${id}`);
  }, [navigate]);

  const handleViewHistory = useCallback((c: APIConsignment) => {
    const entries = parseChangeLog(c.change_log);
    setHistoryTarget({ bilty: c.biltyNo || getInvoiceNo(c) || String(c.id), entries });
  }, []);

  const handleDeleteRequest = useCallback((id: number) => {
    const c = consignments.find(x => x.id === id);
    setDeleteTarget({ id, bilty: c?.biltyNo || getInvoiceNo(c!) || String(id) });
  }, [consignments]);

  const handleDeleteConfirm = useCallback(async () => {
    if (!deleteTarget) return;
    const { id } = deleteTarget;
    setDeleteTarget(null);
    try {
      const res = await fetch(`${API_BASE}/invoiceapi/invoice/${id}`, { method: "DELETE" });
      if (res.ok || res.status === 404) {
        setConsignments(prev => prev.filter(c => c.id !== id));
        setSelectedIds(prev => {
          const next = new Set(prev);
          next.delete(id);
          return next;
        });
      } else {
        const err = await res.json();
        alert(`Failed to delete: ${err.error || "Unknown error"}`);
      }
    } catch (e: any) {
      alert(`Failed to delete: ${e?.message || e}`);
    }
  }, [deleteTarget]);

  // ── Selection handlers ──
  const toggleSelectRow = useCallback((id: number) => {
    setSelectedIds(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  }, []);

  const toggleSelectAllFiltered = useCallback((filteredIds: number[]) => {
    setSelectedIds(prev => {
      const allSelected = filteredIds.length > 0 && filteredIds.every(id => prev.has(id));
      if (allSelected) {
        const next = new Set(prev);
        filteredIds.forEach(id => next.delete(id));
        return next;
      }
      const next = new Set(prev);
      filteredIds.forEach(id => next.add(id));
      return next;
    });
  }, []);

  // ── Download handler — fetches letterhead PER company, sequences bill numbers ──
  const handleDownload = useCallback(async (
    scope: "selected" | "filtered",
    format: "pdf" | "excel",
    filteredList: APIConsignment[]
  ) => {
    const source = scope === "selected"
      ? consignments.filter(c => selectedIds.has(c.id))
      : filteredList;
    if (source.length === 0) return;

    const groups = buildBillGroups(source, resolvedRows);
    for (const group of groups) {
      const lh = await fetchLetterhead(group.companyId);
      const seq = await fetchNextBillSeq(group.companyId);
      const billNo = generateBillNo(lh, seq);
      if (format === "pdf") exportBillToPDF(lh, group, billNo);
      else await exportBillToExcel(lh, group, billNo);
    }
  }, [consignments, selectedIds, resolvedRows]);

  // ── Dropdown options ──
  const companyOptions = [...new Set(Object.values(resolvedRows).map(r => r.companyName).filter(v => v && v !== "-"))];
  const biltyOptions = [...new Set(consignments.map(c => c.biltyNo || getInvoiceNo(c)).filter(Boolean))];
  const truckOptions = [...new Set(Object.values(resolvedRows).map(r => r.truckNo).filter(v => v && v !== "-"))];
  const consignorOptions = [...new Set(Object.values(resolvedRows).map(r => r.consignorName).filter(v => v && v !== "-"))];
  const consigneeOptions = [...new Set(Object.values(resolvedRows).map(r => r.consigneeName).filter(v => v && v !== "-"))];

  // ── Filtering + sorting ──
  const filtered = consignments
    .filter((c) => {
      const row = resolvedRows[c.id];
      if (activeFilter === "pending" && getBillingStatus(c) !== "pending") return false;
      if (activeFilter === "completed" && getBillingStatus(c) !== "completed") return false;
      if (activeFilter === "modified" && !c.change_log) return false;
      if (filters.company && row && row.companyName !== filters.company) return false;
      if (filters.biltyNo) {
        const q = filters.biltyNo.toLowerCase();
        const bn = (c.biltyNo || getInvoiceNo(c) || "").toLowerCase();
        if (!bn.includes(q)) return false;
      }
      if (filters.truckNo && row) {
        if (!String(row.truckNo || "").toLowerCase().includes(filters.truckNo.toLowerCase())) return false;
      }
      if (filters.consignor && row) {
        if (!String(row.consignorName || "").toLowerCase().includes(filters.consignor.toLowerCase())) return false;
      }
      if (filters.consignee && row) {
        if (!String(row.consigneeName || "").toLowerCase().includes(filters.consignee.toLowerCase())) return false;
      }
      if (filters.dateFrom && c.created_at) {
        if (new Date(c.created_at).toISOString().slice(0, 10) < filters.dateFrom) return false;
      }
      if (filters.dateTo && c.created_at) {
        if (new Date(c.created_at).toISOString().slice(0, 10) > filters.dateTo) return false;
      }
      return true;
    })
    .sort((a, b) => {
      const ba = (a.biltyNo || getInvoiceNo(a) || "").toString();
      const bb = (b.biltyNo || getInvoiceNo(b) || "").toString();
      const cmp = ba.localeCompare(bb, undefined, { numeric: true, sensitivity: "base" });
      if (cmp !== 0) return cmp;
      return (a.created_at ? new Date(a.created_at).getTime() : 0) -
             (b.created_at ? new Date(b.created_at).getTime() : 0);
    });

  const filteredIds = filtered.map(c => c.id);
  const allFilteredSelected = filteredIds.length > 0 && filteredIds.every(id => selectedIds.has(id));

  const stats = [
    { label: "Total",     value: consignments.length, color: "#185FA5" },
    { label: "Pending",   value: consignments.filter(c => getBillingStatus(c) === "pending").length,   color: "#854F0B" },
    { label: "Completed", value: consignments.filter(c => getBillingStatus(c) === "completed").length, color: "#3B6D11" },
    { label: "Modified",  value: consignments.filter(c => !!c.change_log).length,                       color: "#7c3aed" },
  ];

  // ── Table column headers ──
  const HEADERS = ["", "#", "Date · Bilty", "Company", "Route", "Parties", "Truck", "Wt / Rate / Amt", "Status", "Actions"];

  return (
    <div className="p-4 md:p-6 space-y-4">
      {/* Stats */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {stats.map(s => <DashboardStatCard key={s.label} {...s} />)}
      </div>

      {/* Panel */}
      <div className="bg-white border border-slate-100 rounded-2xl p-4">
        <div className="flex items-center justify-between mb-3">
          <div>
            <h2 className="text-[16px] font-medium text-slate-900">My Consignments</h2>
            <p className="text-xs text-slate-400">View and manage your consignments &amp; invoices</p>
          </div>
          <div className="flex items-center gap-2">
            <DownloadMenu
              selectedCount={selectedIds.size}
              filteredCount={filtered.length}
              onDownload={(scope, format) => handleDownload(scope, format, filtered)}
            />
            <button
              className="text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
              onClick={() => navigate("/admin/add/consignments")}
            >
              + New Consignment
            </button>
          </div>
        </div>

        {/* Status pills */}
        <div className="flex flex-wrap gap-1.5 mb-4">
          {FILTER_OPTIONS.map(({ key, label }) => (
            <button
              key={key}
              onClick={() => setActiveFilter(key)}
              className={`text-xs px-3 py-1 rounded-full border transition-colors ${
                activeFilter === key
                  ? "bg-slate-900 text-white border-transparent"
                  : "border-slate-200 text-slate-500 hover:bg-slate-50"
              }`}
            >
              {label}
            </button>
          ))}
        </div>

        <AdvancedFilters
          filters={filters}
          onChange={setFilters}
          companyOptions={companyOptions}
          biltyOptions={biltyOptions}
          truckOptions={truckOptions}
          consignorOptions={consignorOptions}
          consigneeOptions={consigneeOptions}
        />

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="w-full text-[12px]" style={{ minWidth: 860 }}>
            <thead>
              <tr className="border-b border-slate-100">
                {HEADERS.map((h, i) => (
                  i === 0 ? (
                    <th key="select-all" className="py-2 px-3 w-8">
                      <input
                        type="checkbox"
                        checked={allFilteredSelected}
                        onChange={() => toggleSelectAllFiltered(filteredIds)}
                        className="w-3.5 h-3.5 rounded border-slate-300 cursor-pointer"
                      />
                    </th>
                  ) : (
                    <th key={h} className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap text-[10px]">{h}</th>
                  )
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={10} className="py-6 text-center text-slate-400">Loading…</td></tr>
              ) : error ? (
                <tr><td colSpan={10} className="py-6 text-center text-red-600">{error}</td></tr>
              ) : filtered.length === 0 ? (
                <tr><td colSpan={10} className="py-8 text-center text-slate-400">No consignments found.</td></tr>
              ) : (
                filtered.map((c, idx) => {
                  const row = resolvedRows[c.id];
                  const palKey = paletteForCompany(c.company);
                  const pal = PALETTE[palKey];
                  const hasInvoice = !!c.link;
                  const hasHistory = !!c.change_log;
                  const isSelected = selectedIds.has(c.id);
                  const lastChange = getLastChange(c.change_log);

                  return (
                    <tr
                      key={c.id}
                      className="border-b border-slate-100 transition-all"
                      style={{
                        background: isSelected ? "rgba(24,95,165,0.12)" : pal.row,
                        borderLeft: hasHistory ? "3px solid #7c3aed" : "3px solid transparent",
                      }}
                    >
                      {/* Select */}
                      <td className="py-2 px-3">
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => toggleSelectRow(c.id)}
                          className="w-3.5 h-3.5 rounded border-slate-300 cursor-pointer"
                        />
                      </td>

                      {/* # */}
                      <td className="py-2 px-3 text-slate-400 text-[11px]">{idx + 1}</td>

                      {/* Date · Bilty */}
                      <td className="py-2 px-3">
                        <div className="flex flex-col gap-1">
                          <span className="text-slate-900 font-medium">
                            {c.biltyNo || getInvoiceNo(c) || "-"}
                          </span>
                          <span className="text-[11px] font-extrabold text-slate-800">
                            {c.created_at
                              ? new Date(c.created_at).toLocaleDateString("en-IN", {
                                  day: "2-digit", month: "short", year: "2-digit",
                                })
                              : "-"}
                          </span>
                          {lastChange && (
                            <button
                              onClick={() => handleViewHistory(c)}
                              title="Click to view full history"
                              className="inline-flex items-center gap-1 w-fit mt-0.5 px-1.5 py-0.5 rounded-md
                                         bg-violet-50 border border-violet-100 text-violet-700
                                         hover:bg-violet-100 transition-colors group"
                            >
                              <svg width="9" height="9" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" strokeWidth="2.2"
                                strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
                                <circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/>
                              </svg>
                              <span className="text-[10px] leading-tight">
                                <span className="font-semibold">{fmtFieldLabel(lastChange.field)}</span>
                                {" · "}
                                <span className="opacity-70">{timeAgo(lastChange.changed_at)}</span>
                              </span>
                              <svg width="8" height="8" viewBox="0 0 10 10" fill="currentColor"
                                className="opacity-30 group-hover:opacity-60 transition-opacity ml-0.5">
                                <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor"
                                  strokeWidth="1.4" fill="none" strokeLinecap="round"/>
                              </svg>
                            </button>
                          )}
                        </div>
                      </td>

                      {/* Company */}
                      <td className="py-2 px-3">
                        {row
                          ? <CompanyTag companyId={c.company} companyName={row.companyName} />
                          : <LoadingCell />}
                      </td>

                      {/* Route */}
                      <td className="py-2 px-3">
                        <div className="flex flex-col gap-0.5">
                          <span className="text-slate-800 text-[11px]">{c.source || "-"}</span>
                          <span className="text-[10px] text-slate-400">→ {c.destination || "-"}</span>
                        </div>
                      </td>

                      {/* Parties */}
                      <td className="py-2 px-3">
                        {row ? (
                          <div className="flex flex-col gap-1">
                            <span className="text-[11px] text-slate-700 truncate" title={row.consignorName}>
                              {row.consignorName}
                            </span>
                            <span className="flex items-center mt-0.5">
                              <span className="inline-block mr-1 text-[13px] text-slate-400">→</span>
                              <span
                                className="font-semibold text-slate-900 text-[15px] leading-tight truncate max-w-[160px]"
                                title={row.consigneeName}
                              >
                                {row.consigneeName}
                              </span>
                            </span>
                          </div>
                        ) : <LoadingCell />}
                      </td>

                      {/* Truck */}
                      <td className="py-2 px-3 text-slate-700 text-[13px] whitespace-nowrap">
                        {row ? row.truckNo : <LoadingCell />}
                      </td>

                      {/* Wt / Rate / Amt */}
                      <td className="py-2 px-3">
                        {row ? (
                          <div className="flex flex-col gap-0.5">
                            <span className="text-[10px] text-slate-400">
                              {fmt(row.totalWeight)} kg &nbsp;@&nbsp; ₹{fmt(row.biltyRate, 2)}/kg
                            </span>
                            <span className="text-slate-900 font-medium text-[16px]">
                              {row.totalItemAmount != null
                                ? `₹ ${fmt(row.totalItemAmount, 0)} /-`
                                : c.totalamount != null
                                ? `₹ ${fmt(c.totalamount, 0)} /-`
                                : c.payment
                                ? `₹ ${fmt(Number(c.payment), 0)} /-`
                                : "-"}
                            </span>
                          </div>
                        ) : <LoadingCell />}
                      </td>

                      {/* Status */}
                      <td className="py-2 px-3 whitespace-nowrap">
                        <StatusBadge status={getBillingStatus(c)} />
                      </td>

                      {/* Actions — single dropdown */}
                      <td className="py-2 px-3 whitespace-nowrap">
                        <ActionMenu
                          consignment={c}
                          hasInvoice={hasInvoice}
                          hasHistory={hasHistory}
                          onEdit={handleEdit}
                          onDelete={handleDeleteRequest}
                          onViewInvoice={handleViewInvoice}
                          onDownloadInvoice={handleDownloadInvoice}
                          onShareInvoice={handleShareInvoice}
                          onViewHistory={handleViewHistory}
                        />
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* History modal */}
      {historyTarget && (
        <ChangeLogModal
          bilty={historyTarget.bilty}
          entries={historyTarget.entries}
          onClose={() => setHistoryTarget(null)}
        />
      )}

      {/* Delete confirm modal */}
      <DeleteConfirmModal
        id={deleteTarget?.id ?? null}
        bilty={deleteTarget?.bilty ?? ""}
        onConfirm={handleDeleteConfirm}
        onCancel={() => setDeleteTarget(null)}
      />
    </div>
  );
};

export default ConsignorDashboard;